// shape
// eslint-disable-next-line id-length
export const w = '=width';
// eslint-disable-next-line id-length
export const h = '=height';
// eslint-disable-next-line id-length
export const s = '=MIN(width, height)';

// eslint-disable-next-line id-length
export const a = '=V.hc';
// eslint-disable-next-line id-length
export const b = '=V.vc';
// eslint-disable-next-line id-length
export const c = '=V.x1';
// eslint-disable-next-line id-length
export const d = '=V.x2';
// eslint-disable-next-line id-length
export const e = '=V.y1';
// eslint-disable-next-line id-length
export const f = '=V.y2';

// eslint-disable-next-line id-length
export const A = 3437746.770784939;
// eslint-disable-next-line id-length
export const B = 10800000;
// eslint-disable-next-line id-length
export const C = 5400000;
// eslint-disable-next-line id-length
export const D = 16200000;
// eslint-disable-next-line id-length
export const E = '=width/2';
// eslint-disable-next-line id-length
export const F = '=height/2';
// 预设操作集合
export const PresetShapeModels = {
    none: {
        variables: {
            l: 0,
            t: 0,
            r: w,
            b: h,
        },
        connectionPoints: [{
            x: 0,
            y: 0,
        }, {
            x: w,
            y: h,
        },
        ],
        path: [[['M', 0, 0], ['L', w, h], {},
        ]],
    },
    rectangle: {
        variables: {
            hc: E,
            t: 0,
            l: 0,
            vc: F,
            b: h,
            r: w,
        },
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {},
        ]],
    },
    parallelogram: {
        variables: {
            adj: 25000,
            ss: s,
            maxAdj: '=100000 * width / V.ss',
            a: '=MIN(MAX(0, V.adj), V.maxAdj)',
            x1: '=V.ss * V.a / 200000',
            x2: '=V.ss * V.a / 100000',
            r: w,
            x6: '=width - V.x1',
            x5: '=width - V.x2',
            x3: '=V.x5 / 2',
            x4: '=width - V.x3',
            wd2: E,
            il: '=V.wd2 * V.a / V.maxAdj',
            q1: '=5 * V.a / V.maxAdj',
            q2: '=(1 + V.q1) / 12',
            _il: '=V.q2 * width',
            it: '=V.q2 * height',
            ir: '=width - V._il',
            b: h,
            ib: '=height - V.it',
            hc: E,
            q3: '=height * V.hc / V.x2',
            y1: '=MIN(MAX(0, V.q3), height)',
            y2: '=height - V.y1',
            t: 0,
            vc: F,
            l: 0,
        },
        adjustInfo: [['adj', 25000]],
        connectionPoints: [{
            x: a,
            y: f,
        }, {
            x: '=V.x4',
            y: 0,
        }, {
            x: '=V.x6',
            y: b,
        }, {
            x: '=V.x3',
            y: h,
        }, {
            x: a,
            y: e,
        }, {
            x: c,
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj',
            minX: 0,
            maxX: 'maxAdj',
            position: {
                x: 'x2',
                y: 't',
            },
            point: [d, 0],
        },
        ],
        path: [[['M', 0, h], ['L', d, 0], ['L', w, 0], ['L', '=V.x5', h], ['Z'], {},
        ]],
        textRect: {
            left: '=V._il',
            top: '=V.it',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    trapezoid: {
        variables: {
            adj: 25000,
            ss: s,
            maxAdj: '=50000 * width / V.ss',
            a: '=MIN(MAX(0, V.adj), V.maxAdj)',
            x1: '=V.ss * V.a / 200000',
            x2: '=V.ss * V.a / 100000',
            r: w,
            x3: '=width - V.x2',
            x4: '=width - V.x1',
            wd3: '=width/3',
            il: '=V.wd3 * V.a / V.maxAdj',
            hd3: '=height/3',
            it: '=V.hd3 * V.a / V.maxAdj',
            ir: '=width - V.il',
            hc: E,
            t: 0,
            vc: F,
            b: h,
            l: 0,
        },
        adjustInfo: [['adj', 25000]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: c,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: '=V.x4',
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj',
            minX: 0,
            maxX: 'maxAdj',
            position: {
                x: 'x2',
                y: 't',
            },
            point: [d, 0],
        },
        ],
        path: [[['M', 0, h], ['L', d, 0], ['L', '=V.x3', 0], ['L', w, h], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.it',
            right: '=V.ir',
            bottom: h,
        },
    },
    diamond: {
        variables: {
            ir: '=width * 3 / 4',
            ib: '=height * 3 / 4',
            hc: E,
            t: 0,
            l: 0,
            vc: F,
            b: h,
            r: w,
            wd4: '=width/4',
            hd4: '=height/4',
        },
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        path: [[['M', 0, b], ['L', a, 0], ['L', w, b], ['L', a, h], ['Z'], {},
        ]],
        textRect: {
            left: '=V.wd4',
            top: '=V.hd4',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    roundedRectangle: {
        variables: {
            adj: 16667,
            a: '=MIN(MAX(0, V.adj), 50000)',
            ss: s,
            x1: '=V.ss * V.a / 100000',
            r: w,
            x2: '=width - V.x1',
            b: h,
            y2: '=height - V.x1',
            il: '=V.x1 * 29289 / 100000',
            ir: '=width - V.il',
            ib: '=height - V.il',
            hc: E,
            t: 0,
            l: 0,
            vc: F,
            cd2: B,
            cd4: C,
            cx1: '=C(V.x1,V.l,A(V.x1,V.x1,V.cd2),true)',
            cy1: '=C(V.x1,V.x1,A(V.x1,V.x1,V.cd2))',
            _3cd4: D,
            cx2: '=C(V.x1,V.x2,A(V.x1,V.x1,V._3cd4),true)',
            cy2: '=C(V.x1,V.t,A(V.x1,V.x1,V._3cd4))',
            cx3: '=C(V.x1,V.r,A(V.x1,V.x1,0),true)',
            cy3: '=C(V.x1,V.y2,A(V.x1,V.x1,0))',
            cx4: '=C(V.x1,V.x1,A(V.x1,V.x1,V.cd4),true)',
            cy4: '=C(V.x1,V.b,A(V.x1,V.x1,V.cd4))',
        },
        adjustInfo: [['adj', 16667]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj',
            minX: 0,
            maxX: 50000,
            position: {
                x: 'x1',
                y: 't',
            },
            point: [c, 0],
        },
        ],
        path: [[['M', 0, c], ['E', '=V.cx1', '=V.cy1', c, c, 0, '=A(V.x1,V.x1,V.cd2)', '=A(V.x1,V.x1,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', d, 0], ['E', '=V.cx2', '=V.cy2', c, c, 0, '=A(V.x1,V.x1,V._3cd4)', '=A(V.x1,V.x1,(V._3cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', w, f], ['E', '=V.cx3', '=V.cy3', c, c, 0, '=A(V.x1,V.x1,0)', '=A(V.x1,V.x1,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', c, h], ['E', '=V.cx4', '=V.cy4', c, c, 0, '=A(V.x1,V.x1,V.cd4)', '=A(V.x1,V.x1,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.il',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    octagon: {
        variables: {
            adj: 29289,
            a: '=MIN(MAX(0, V.adj), 50000)',
            ss: s,
            x1: '=V.ss * V.a / 100000',
            r: w,
            x2: '=width - V.x1',
            b: h,
            y2: '=height - V.x1',
            il: '=V.x1 / 2',
            ir: '=width - V.il',
            ib: '=height - V.il',
            l: 0,
            t: 0,
        },
        adjustInfo: [['adj', 29289]],
        connectionPoints: [{
            x: w,
            y: c,
        }, {
            x: w,
            y: f,
        }, {
            x: d,
            y: h,
        }, {
            x: c,
            y: h,
        }, {
            x: 0,
            y: f,
        }, {
            x: 0,
            y: c,
        }, {
            x: c,
            y: 0,
        }, {
            x: d,
            y: 0,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj',
            minX: 0,
            maxX: 50000,
            position: {
                x: 'x1',
                y: 't',
            },
            point: [c, 0],
        },
        ],
        path: [[['M', 0, c], ['L', c, 0], ['L', d, 0], ['L', w, c], ['L', w, f], ['L', d, h], ['L', c, h], ['L', 0, f], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.il',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    isoscelesTriangle: {
        variables: {
            adj: 50000,
            a: '=MIN(MAX(0, V.adj), 100000)',
            x1: '=width * V.a / 200000',
            x2: '=width * V.a / 100000',
            wd2: E,
            x3: '=V.x1 + V.wd2',
            t: 0,
            vc: F,
            l: 0,
            b: h,
            r: w,
        },
        adjustInfo: [['adj', 50000]],
        connectionPoints: [{
            x: d,
            y: 0,
        }, {
            x: c,
            y: b,
        }, {
            x: 0,
            y: h,
        }, {
            x: d,
            y: h,
        }, {
            x: w,
            y: h,
        }, {
            x: '=V.x3',
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj',
            minX: 0,
            maxX: 100000,
            position: {
                x: 'x2',
                y: 't',
            },
            point: [d, 0],
        },
        ],
        path: [[['M', 0, h], ['L', d, 0], ['L', w, h], ['Z'], {},
        ]],
        textRect: {
            left: c,
            top: b,
            right: '=V.x3',
            bottom: h,
        },
    },
    rightTriangle: {
        variables: {
            it: '=height * 7 / 12',
            ir: '=width * 7 / 12',
            ib: '=height * 11 / 12',
            l: 0,
            t: 0,
            vc: F,
            b: h,
            hc: E,
            r: w,
            wd12: '=width/12',
        },
        connectionPoints: [{
            x: 0,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: 0,
            y: h,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: h,
        }, {
            x: a,
            y: b,
        },
        ],
        path: [[['M', 0, h], ['L', 0, 0], ['L', w, h], ['Z'], {},
        ]],
        textRect: {
            left: '=V.wd12',
            top: '=V.it',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    oval: {
        variables: {
            wd2: E,
            d2r: A,
            idx: '=V.wd2 * COS(2700000 / V.d2r)',
            hd2: F,
            idy: '=V.hd2 * SIN(2700000 / V.d2r)',
            hc: E,
            il: '=V.hc - V.idx',
            ir: '=V.hc + V.idx',
            vc: F,
            it: '=V.vc - V.idy',
            ib: '=V.vc + V.idy',
            t: 0,
            l: 0,
            b: h,
            r: w,
            cd2: B,
            cd4: C,
            cx1: '=C(V.wd2,V.l,A(V.wd2,V.hd2,V.cd2),true)',
            cy1: '=C(V.hd2,V.vc,A(V.wd2,V.hd2,V.cd2))',
            _3cd4: D,
            cx2: '=C(V.wd2,P(V.cx1,V.wd2,A(V.wd2,V.hd2,(V.cd2 + V.cd4)),true),A(V.wd2,V.hd2,V._3cd4),true)',
            cy2: '=C(V.hd2,P(V.cy1,V.hd2,A(V.wd2,V.hd2,(V.cd2 + V.cd4))),A(V.wd2,V.hd2,V._3cd4))',
            cx3: '=C(V.wd2,P(V.cx2,V.wd2,A(V.wd2,V.hd2,(V._3cd4 + V.cd4)),true),A(V.wd2,V.hd2,0),true)',
            cy3: '=C(V.hd2,P(V.cy2,V.hd2,A(V.wd2,V.hd2,(V._3cd4 + V.cd4))),A(V.wd2,V.hd2,0))',
            cx4: '=C(V.wd2,P(V.cx3,V.wd2,A(V.wd2,V.hd2,(V.cd4)),true),A(V.wd2,V.hd2,V.cd4),true)',
            cy4: '=C(V.hd2,P(V.cy3,V.hd2,A(V.wd2,V.hd2,(V.cd4))),A(V.wd2,V.hd2,V.cd4))',
        },
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: '=V.il',
            y: '=V.it',
        }, {
            x: 0,
            y: b,
        }, {
            x: '=V.il',
            y: '=V.ib',
        }, {
            x: a,
            y: h,
        }, {
            x: '=V.ir',
            y: '=V.ib',
        }, {
            x: w,
            y: b,
        }, {
            x: '=V.ir',
            y: '=V.it',
        },
        ],
        path: [[['M', 0, b], ['E', '=V.cx1', '=V.cy1', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V.cd2)', '=A(V.wd2,V.hd2,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx2', '=V.cy2', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V._3cd4)', '=A(V.wd2,V.hd2,(V._3cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx3', '=V.cy3', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,0)', '=A(V.wd2,V.hd2,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx4', '=V.cy4', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V.cd4)', '=A(V.wd2,V.hd2,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.it',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    hexagon: {
        variables: {
            adj: 25000,
            vf: 115470,
            ss: s,
            maxAdj: '=50000 * width / V.ss',
            a: '=MIN(MAX(0, V.adj), V.maxAdj)',
            hd2: F,
            shd2: '=V.hd2 * V.vf / 100000',
            x1: '=V.ss * V.a / 100000',
            r: w,
            x2: '=width - V.x1',
            d2r: A,
            dy1: '=V.shd2 * SIN(3600000 / V.d2r)',
            vc: F,
            y1: '=V.vc - V.dy1',
            y2: '=V.vc + V.dy1',
            q1: '=V.maxAdj * -1 / 2',
            q2: '=V.a + V.q1',
            q3: '=IF(V.q2 > 0, 4, 2)',
            q4: '=IF(V.q2 > 0, 3, 2)',
            q5: '=IF(V.q2 > 0, V.q1, 0)',
            q6: '=(V.a + V.q5) / V.q1',
            q7: '=V.q6 * V.q4 / -1',
            q8: '=V.q3 + V.q7',
            il: '=width * V.q8 / 24',
            it: '=height * V.q8 / 24',
            ir: '=width - V.il',
            b: h,
            ib: '=height - V.it',
            l: 0,
            t: 0,
        },
        adjustInfo: [['adj', 25000], ['vf', 115470]],
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: d,
            y: f,
        }, {
            x: c,
            y: f,
        }, {
            x: 0,
            y: b,
        }, {
            x: c,
            y: e,
        }, {
            x: d,
            y: e,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj',
            minX: 0,
            maxX: 'maxAdj',
            position: {
                x: 'x1',
                y: 't',
            },
            point: [c, 0],
        },
        ],
        path: [[['M', 0, b], ['L', c, e], ['L', d, e], ['L', w, b], ['L', d, f], ['L', c, f], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.it',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    cross: {
        variables: {
            adj: 25000,
            a: '=MIN(MAX(0, V.adj), 50000)',
            ss: s,
            x1: '=V.ss * V.a / 100000',
            r: w,
            x2: '=width - V.x1',
            b: h,
            y2: '=height - V.x1',
            d: '=width - height',
            l: 0,
            il: '=IF(V.d > 0, V.l, V.x1)',
            ir: '=IF(V.d > 0, V.r, V.x2)',
            t: 0,
            it: '=IF(V.d > 0, V.x1, V.t)',
            ib: '=IF(V.d > 0, V.y2, V.b)',
            hc: E,
            vc: F,
        },
        adjustInfo: [['adj', 25000]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj',
            minX: 0,
            maxX: 50000,
            position: {
                x: 'x1',
                y: 't',
            },
            point: [c, 0],
        },
        ],
        path: [[['M', 0, c], ['L', c, c], ['L', c, 0], ['L', d, 0], ['L', d, c], ['L', w, c], ['L', w, f], ['L', d, f], ['L', d, h], ['L', c, h], ['L', c, f], ['L', 0, f], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.it',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    regularPentagon: {
        variables: {
            hf: 105146,
            vf: 110557,
            wd2: E,
            swd2: '=V.wd2 * V.hf / 100000',
            hd2: F,
            shd2: '=V.hd2 * V.vf / 100000',
            vc: F,
            svc: '=V.vc * V.vf / 100000',
            d2r: A,
            dx1: '=V.swd2 * COS(1080000 / V.d2r)',
            dx2: '=V.swd2 * COS(18360000 / V.d2r)',
            dy1: '=V.shd2 * SIN(1080000 / V.d2r)',
            dy2: '=V.shd2 * SIN(18360000 / V.d2r)',
            hc: E,
            x1: '=V.hc - V.dx1',
            x2: '=V.hc - V.dx2',
            x3: '=V.hc + V.dx2',
            x4: '=V.hc + V.dx1',
            y1: '=V.svc - V.dy1',
            y2: '=V.svc - V.dy2',
            it: '=V.y1 * V.dx2 / V.dx1',
            t: 0,
            b: h,
        },
        adjustInfo: [['hf', 105146], ['vf', 110557]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: c,
            y: e,
        }, {
            x: d,
            y: f,
        }, {
            x: a,
            y: h,
        }, {
            x: '=V.x3',
            y: f,
        }, {
            x: '=V.x4',
            y: e,
        },
        ],
        path: [[['M', c, e], ['L', a, 0], ['L', '=V.x4', e], ['L', '=V.x3', f], ['L', d, f], ['Z'], {},
        ]],
        textRect: {
            left: d,
            top: '=V.it',
            right: '=V.x3',
            bottom: f,
        },
    },
    can: {
        variables: {
            adj: 25000,
            ss: s,
            maxAdj: '=50000 * height / V.ss',
            a: '=MIN(MAX(0, V.adj), V.maxAdj)',
            y1: '=V.ss * V.a / 200000',
            y2: '=V.y1 + V.y1',
            b: h,
            y3: '=height - V.y1',
            hc: E,
            t: 0,
            l: 0,
            vc: F,
            r: w,
            wd2: E,
            cd2: B,
            cx1: '=C(V.wd2,V.l,A(V.wd2,V.y1,V.cd2),true)',
            cy1: '=C(V.y1,V.y1,A(V.wd2,V.y1,V.cd2))',
            cx2: '=C(V.wd2,V.r,A(V.wd2,V.y1,0),true)',
            cy2: '=C(V.y1,V.y3,A(V.wd2,V.y1,0))',
            cx3: '=C(V.wd2,V.l,A(V.wd2,V.y1,V.cd2),true)',
            cy3: '=C(V.y1,V.y1,A(V.wd2,V.y1,V.cd2))',
            cx4: '=C(V.wd2,P(V.cx3,V.wd2,A(V.wd2,V.y1,(V.cd2 + V.cd2)),true),A(V.wd2,V.y1,0),true)',
            cy4: '=C(V.y1,P(V.cy3,V.y1,A(V.wd2,V.y1,(V.cd2 + V.cd2))),A(V.wd2,V.y1,0))',
            cx5: '=C(V.wd2,V.r,A(V.wd2,V.y1,0),true)',
            cy5: '=C(V.y1,V.y1,A(V.wd2,V.y1,0))',
            cx6: '=C(V.wd2,P(V.cx5,V.wd2,A(V.wd2,V.y1,(V.cd2)),true),A(V.wd2,V.y1,V.cd2),true)',
            cy6: '=C(V.y1,P(V.cy5,V.y1,A(V.wd2,V.y1,(V.cd2))),A(V.wd2,V.y1,V.cd2))',
            cx7: '=C(V.wd2,V.r,A(V.wd2,V.y1,0),true)',
            cy7: '=C(V.y1,V.y3,A(V.wd2,V.y1,0))',
        },
        adjustInfo: [['adj', 25000]],
        connectionPoints: [{
            x: a,
            y: f,
        }, {
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj',
            minY: 0,
            maxY: 'maxAdj',
            position: {
                x: 'hc',
                y: 'y2',
            },
            point: [a, f],
        },
        ],
        path: [[['M', 0, e], ['E', '=V.cx1', '=V.cy1', '=V.wd2', e, 0, '=A(V.wd2,V.y1,V.cd2)', '=A(V.wd2,V.y1,(V.cd2 + -10800000))', '=IF(-10800000 > 0, FALSE, TRUE)'], ['L', w, '=V.y3'], ['E', '=V.cx2', '=V.cy2', '=V.wd2', e, 0, '=A(V.wd2,V.y1,0)', '=A(V.wd2,V.y1,(V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', 0, e], ['E', '=V.cx3', '=V.cy3', '=V.wd2', e, 0, '=A(V.wd2,V.y1,V.cd2)', '=A(V.wd2,V.y1,(V.cd2 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['E', '=V.cx4', '=V.cy4', '=V.wd2', e, 0, '=A(V.wd2,V.y1,0)', '=A(V.wd2,V.y1,(V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['Z'], {
            fillMode: 'lighten',
            strokeMode: 'false',
        },
        ], [['M', w, e], ['E', '=V.cx5', '=V.cy5', '=V.wd2', e, 0, '=A(V.wd2,V.y1,0)', '=A(V.wd2,V.y1,(V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['E', '=V.cx6', '=V.cy6', '=V.wd2', e, 0, '=A(V.wd2,V.y1,V.cd2)', '=A(V.wd2,V.y1,(V.cd2 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['L', w, '=V.y3'], ['E', '=V.cx7', '=V.cy7', '=V.wd2', e, 0, '=A(V.wd2,V.y1,0)', '=A(V.wd2,V.y1,(V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['L', 0, e], {
            fillMode: 'none',
        },
        ]],
        textRect: {
            left: 0,
            top: f,
            right: w,
            bottom: '=V.y3',
        },
    },
    cube: {
        variables: {
            adj: 25000,
            a: '=MIN(MAX(0, V.adj), 100000)',
            ss: s,
            y1: '=V.ss * V.a / 100000',
            b: h,
            y4: '=height - V.y1',
            y2: '=V.y4 / 2',
            y3: '=(V.y1 + V.b) / 2',
            r: w,
            x4: '=width - V.y1',
            x2: '=V.x4 / 2',
            x3: '=(V.y1 + V.r) / 2',
            t: 0,
            l: 0,
        },
        adjustInfo: [['adj', 25000]],
        connectionPoints: [{
            x: '=V.x3',
            y: 0,
        }, {
            x: d,
            y: e,
        }, {
            x: 0,
            y: '=V.y3',
        }, {
            x: d,
            y: h,
        }, {
            x: '=V.x4',
            y: '=V.y3',
        }, {
            x: w,
            y: f,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj',
            minY: 0,
            maxY: 100000,
            position: {
                x: 'l',
                y: 'y1',
            },
            point: [0, e],
        },
        ],
        path: [[['M', 0, e], ['L', '=V.x4', e], ['L', '=V.x4', h], ['L', 0, h], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', '=V.x4', e], ['L', w, 0], ['L', w, '=V.y4'], ['L', '=V.x4', h], ['Z'], {
            fillMode: 'darkenLess',
            strokeMode: 'false',
        },
        ], [['M', 0, e], ['L', e, 0], ['L', w, 0], ['L', '=V.x4', e], ['Z'], {
            fillMode: 'lightenLess',
            strokeMode: 'false',
        },
        ], [['M', 0, e], ['L', e, 0], ['L', w, 0], ['L', w, '=V.y4'], ['L', '=V.x4', h], ['L', 0, h], ['Z'], ['M', 0, e], ['L', '=V.x4', e], ['L', w, 0], ['M', '=V.x4', e], ['L', '=V.x4', h], {
            fillMode: 'none',
        },
        ]],
        textRect: {
            left: 0,
            top: e,
            right: '=V.x4',
            bottom: h,
        },
    },
    bevel: {
        variables: {
            adj: 12500,
            a: '=MIN(MAX(0, V.adj), 50000)',
            ss: s,
            x1: '=V.ss * V.a / 100000',
            r: w,
            x2: '=width - V.x1',
            b: h,
            y2: '=height - V.x1',
            vc: F,
            hc: E,
            l: 0,
            t: 0,
        },
        adjustInfo: [['adj', 12500]],
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: d,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: a,
            y: f,
        }, {
            x: 0,
            y: b,
        }, {
            x: c,
            y: b,
        }, {
            x: a,
            y: 0,
        }, {
            x: a,
            y: c,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj',
            minX: 0,
            maxX: 50000,
            position: {
                x: 'x1',
                y: 't',
            },
            point: [c, 0],
        },
        ],
        path: [[['M', c, c], ['L', d, c], ['L', d, f], ['L', c, f], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', 0, 0], ['L', w, 0], ['L', d, c], ['L', c, c], ['Z'], {
            fillMode: 'lightenLess',
            strokeMode: 'false',
        },
        ], [['M', 0, h], ['L', c, f], ['L', d, f], ['L', w, h], ['Z'], {
            fillMode: 'darkenLess',
            strokeMode: 'false',
        },
        ], [['M', 0, 0], ['L', c, c], ['L', c, f], ['L', 0, h], ['Z'], {
            fillMode: 'lighten',
            strokeMode: 'false',
        },
        ], [['M', w, 0], ['L', w, h], ['L', d, f], ['L', d, c], ['Z'], {
            fillMode: 'darken',
            strokeMode: 'false',
        },
        ], [['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], ['M', c, c], ['L', d, c], ['L', d, f], ['L', c, f], ['Z'], ['M', 0, 0], ['L', c, c], ['M', 0, h], ['L', c, f], ['M', w, 0], ['L', d, c], ['M', w, h], ['L', d, f], {
            fillMode: 'none',
        },
        ]],
        textRect: {
            left: c,
            top: c,
            right: d,
            bottom: f,
        },
    },
    foldedCorner: {
        variables: {
            adj: 16667,
            a: '=MIN(MAX(0, V.adj), 50000)',
            ss: s,
            dy2: '=V.ss * V.a / 100000',
            dy1: '=V.dy2 / 5',
            r: w,
            x1: '=width - V.dy2',
            x2: '=V.x1 + V.dy1',
            b: h,
            y2: '=height - V.dy2',
            y1: '=V.y2 + V.dy1',
            hc: E,
            t: 0,
            l: 0,
            vc: F,
        },
        adjustInfo: [['adj', 16667]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj',
            minX: 0,
            maxX: 50000,
            position: {
                x: 'x1',
                y: 'b',
            },
            point: [c, h],
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, f], ['L', c, h], ['L', 0, h], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', c, h], ['L', d, e], ['L', w, f], ['Z'], {
            fillMode: 'darkenLess',
            strokeMode: 'false',
        },
        ], [['M', c, h], ['L', d, e], ['L', w, f], ['L', c, h], ['L', 0, h], ['L', 0, 0], ['L', w, 0], ['L', w, f], {
            fillMode: 'none',
        },
        ]],
        textRect: {
            left: 0,
            top: 0,
            right: w,
            bottom: f,
        },
    },
    smileyFace: {
        variables: {
            adj: 4653,
            a: '=MIN(MAX(-4653, V.adj), 4653)',
            x1: '=width * 4969 / 21699',
            x2: '=width * 6215 / 21600',
            x3: '=width * 13135 / 21600',
            x4: '=width * 16640 / 21600',
            y1: '=height * 7570 / 21600',
            y3: '=height * 16515 / 21600',
            dy2: '=height * V.a / 100000',
            y2: '=V.y3 - V.dy2',
            y4: '=V.y3 + V.dy2',
            dy3: '=height * V.a / 50000',
            y5: '=V.y4 + V.dy3',
            wd2: E,
            d2r: A,
            idx: '=V.wd2 * COS(2700000 / V.d2r)',
            hd2: F,
            idy: '=V.hd2 * SIN(2700000 / V.d2r)',
            hc: E,
            il: '=V.hc - V.idx',
            ir: '=V.hc + V.idx',
            vc: F,
            it: '=V.vc - V.idy',
            ib: '=V.vc + V.idy',
            wR: '=width * 1125 / 21600',
            hR: '=height * 1125 / 21600',
            t: 0,
            l: 0,
            b: h,
            r: w,
            cd2: B,
            cx1: '=C(V.wd2,V.l,A(V.wd2,V.hd2,V.cd2),true)',
            cy1: '=C(V.hd2,V.vc,A(V.wd2,V.hd2,V.cd2))',
            cx2: '=C(V.wR,V.x2,A(V.wR,V.hR,V.cd2),true)',
            cy2: '=C(V.hR,V.y1,A(V.wR,V.hR,V.cd2))',
            cx3: '=C(V.wR,V.x3,A(V.wR,V.hR,V.cd2),true)',
            cy3: '=C(V.hR,V.y1,A(V.wR,V.hR,V.cd2))',
            cx4: '=C(V.wd2,V.l,A(V.wd2,V.hd2,V.cd2),true)',
            cy4: '=C(V.hd2,V.vc,A(V.wd2,V.hd2,V.cd2))',
        },
        adjustInfo: [['adj', 4653]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: '=V.il',
            y: '=V.it',
        }, {
            x: 0,
            y: b,
        }, {
            x: '=V.il',
            y: '=V.ib',
        }, {
            x: a,
            y: h,
        }, {
            x: '=V.ir',
            y: '=V.ib',
        }, {
            x: w,
            y: b,
        }, {
            x: '=V.ir',
            y: '=V.it',
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj',
            minY: -4653,
            maxY: 4653,
            position: {
                x: 'hc',
                y: 'y4',
            },
            point: [a, '=V.y4'],
        },
        ],
        path: [[['M', 0, b], ['E', '=V.cx1', '=V.cy1', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V.cd2)', '=(A(V.wd2,V.hd2,V.cd2)+ 2*PI())', '=IF(21600000 > 0, FALSE, TRUE)'], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', d, e], ['E', '=V.cx2', '=V.cy2', '=V.wR', '=V.hR', 0, '=A(V.wR,V.hR,V.cd2)', '=(A(V.wR,V.hR,V.cd2)+ 2*PI())', '=IF(21600000 > 0, FALSE, TRUE)'], ['M', '=V.x3', e], ['E', '=V.cx3', '=V.cy3', '=V.wR', '=V.hR', 0, '=A(V.wR,V.hR,V.cd2)', '=(A(V.wR,V.hR,V.cd2)+ 2*PI())', '=IF(21600000 > 0, FALSE, TRUE)'], {
            fillMode: 'darkenLess',
        },
        ], [['M', c, f], ['Q', a, '=V.y5', '=V.x4', f], {
            fillMode: 'none',
        },
        ], [['M', 0, b], ['E', '=V.cx4', '=V.cy4', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V.cd2)', '=(A(V.wd2,V.hd2,V.cd2)+ 2*PI())', '=IF(21600000 > 0, FALSE, TRUE)'], ['Z'], {
            fillMode: 'none',
        },
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.it',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    donut: {
        variables: {
            adj: 25000,
            a: '=MIN(MAX(0, V.adj), 50000)',
            ss: s,
            dr: '=V.ss * V.a / 100000',
            wd2: E,
            iwd2: '=V.wd2 - V.dr',
            hd2: F,
            ihd2: '=V.hd2 - V.dr',
            d2r: A,
            idx: '=V.wd2 * COS(2700000 / V.d2r)',
            idy: '=V.hd2 * SIN(2700000 / V.d2r)',
            hc: E,
            il: '=V.hc - V.idx',
            ir: '=V.hc + V.idx',
            vc: F,
            it: '=V.vc - V.idy',
            ib: '=V.vc + V.idy',
            t: 0,
            l: 0,
            b: h,
            r: w,
            cd2: B,
            cd4: C,
            cx1: '=C(V.wd2,V.l,A(V.wd2,V.hd2,V.cd2),true)',
            cy1: '=C(V.hd2,V.vc,A(V.wd2,V.hd2,V.cd2))',
            _3cd4: D,
            cx2: '=C(V.wd2,P(V.cx1,V.wd2,A(V.wd2,V.hd2,(V.cd2 + V.cd4)),true),A(V.wd2,V.hd2,V._3cd4),true)',
            cy2: '=C(V.hd2,P(V.cy1,V.hd2,A(V.wd2,V.hd2,(V.cd2 + V.cd4))),A(V.wd2,V.hd2,V._3cd4))',
            cx3: '=C(V.wd2,P(V.cx2,V.wd2,A(V.wd2,V.hd2,(V._3cd4 + V.cd4)),true),A(V.wd2,V.hd2,0),true)',
            cy3: '=C(V.hd2,P(V.cy2,V.hd2,A(V.wd2,V.hd2,(V._3cd4 + V.cd4))),A(V.wd2,V.hd2,0))',
            cx4: '=C(V.wd2,P(V.cx3,V.wd2,A(V.wd2,V.hd2,(V.cd4)),true),A(V.wd2,V.hd2,V.cd4),true)',
            cy4: '=C(V.hd2,P(V.cy3,V.hd2,A(V.wd2,V.hd2,(V.cd4))),A(V.wd2,V.hd2,V.cd4))',
            cx5: '=C(V.iwd2,V.dr,A(V.iwd2,V.ihd2,V.cd2),true)',
            cy5: '=C(V.ihd2,V.vc,A(V.iwd2,V.ihd2,V.cd2))',
            cx6: '=C(V.iwd2,P(V.cx5,V.iwd2,A(V.iwd2,V.ihd2,(V.cd2 + -5400000)),true),A(V.iwd2,V.ihd2,V.cd4),true)',
            cy6: '=C(V.ihd2,P(V.cy5,V.ihd2,A(V.iwd2,V.ihd2,(V.cd2 + -5400000))),A(V.iwd2,V.ihd2,V.cd4))',
            cx7: '=C(V.iwd2,P(V.cx6,V.iwd2,A(V.iwd2,V.ihd2,(V.cd4 + -5400000)),true),A(V.iwd2,V.ihd2,0),true)',
            cy7: '=C(V.ihd2,P(V.cy6,V.ihd2,A(V.iwd2,V.ihd2,(V.cd4 + -5400000))),A(V.iwd2,V.ihd2,0))',
            cx8: '=C(V.iwd2,P(V.cx7,V.iwd2,A(V.iwd2,V.ihd2,(-5400000)),true),A(V.iwd2,V.ihd2,V._3cd4),true)',
            cy8: '=C(V.ihd2,P(V.cy7,V.ihd2,A(V.iwd2,V.ihd2,(-5400000))),A(V.iwd2,V.ihd2,V._3cd4))',
        },
        adjustInfo: [['adj', 25000]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: '=V.il',
            y: '=V.it',
        }, {
            x: 0,
            y: b,
        }, {
            x: '=V.il',
            y: '=V.ib',
        }, {
            x: a,
            y: h,
        }, {
            x: '=V.ir',
            y: '=V.ib',
        }, {
            x: w,
            y: b,
        }, {
            x: '=V.ir',
            y: '=V.it',
        },
        ],
        controlsInfo: [{
            type: 'ahPolar',
            gdRefR: 'adj',
            minR: 0,
            maxR: 50000,
            position: {
                x: 'dr',
                y: 'vc',
            },
            point: ['=V.dr', b],
        },
        ],
        path: [[['M', 0, b], ['E', '=V.cx1', '=V.cy1', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V.cd2)', '=A(V.wd2,V.hd2,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx2', '=V.cy2', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V._3cd4)', '=A(V.wd2,V.hd2,(V._3cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx3', '=V.cy3', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,0)', '=A(V.wd2,V.hd2,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx4', '=V.cy4', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V.cd4)', '=A(V.wd2,V.hd2,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['Z'], ['M', '=V.dr', b], ['E', '=V.cx5', '=V.cy5', '=V.iwd2', '=V.ihd2', 0, '=A(V.iwd2,V.ihd2,V.cd2)', '=A(V.iwd2,V.ihd2,(V.cd2 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['E', '=V.cx6', '=V.cy6', '=V.iwd2', '=V.ihd2', 0, '=A(V.iwd2,V.ihd2,V.cd4)', '=A(V.iwd2,V.ihd2,(V.cd4 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['E', '=V.cx7', '=V.cy7', '=V.iwd2', '=V.ihd2', 0, '=A(V.iwd2,V.ihd2,0)', '=A(V.iwd2,V.ihd2,(-5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['E', '=V.cx8', '=V.cy8', '=V.iwd2', '=V.ihd2', 0, '=A(V.iwd2,V.ihd2,V._3cd4)', '=A(V.iwd2,V.ihd2,(V._3cd4 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.it',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    noSymbol: {
        variables: {
            adj: 18750,
            a: '=MIN(MAX(0, V.adj), 50000)',
            ss: s,
            dr: '=V.ss * V.a / 100000',
            wd2: E,
            iwd2: '=V.wd2 - V.dr',
            hd2: F,
            ihd2: '=V.hd2 - V.dr',
            d2r: A,
            ang: '=(ATAN2(width,height) * V.d2r)',
            ct: '=V.ihd2 * COS(V.ang / V.d2r)',
            st: '=V.iwd2 * SIN(V.ang / V.d2r)',
            m: '=SQRT(V.ct*V.ct + V.st*V.st)',
            n: '=V.iwd2 * V.ihd2 / V.m',
            drd2: '=V.dr / 2',
            dang: '=(ATAN2(V.n,V.drd2) * V.d2r)',
            '2dang': '=V.dang * 2',
            swAng: '=-10800000 + V.2dang',
            t3: '=(ATAN2(width,height) * V.d2r)',
            stAng1: '=V.t3 - V.dang',
            cd2: B,
            stAng2: '=V.stAng1 - V.cd2',
            ct1: '=V.ihd2 * COS(V.stAng1 / V.d2r)',
            st1: '=V.iwd2 * SIN(V.stAng1 / V.d2r)',
            m1: '=SQRT(V.ct1*V.ct1 + V.st1*V.st1)',
            n1: '=V.iwd2 * V.ihd2 / V.m1',
            dx1: '=V.n1 * COS(V.stAng1 / V.d2r)',
            dy1: '=V.n1 * SIN(V.stAng1 / V.d2r)',
            hc: E,
            x1: '=V.hc + V.dx1',
            vc: F,
            y1: '=V.vc + V.dy1',
            x2: '=V.hc - V.dx1',
            y2: '=V.vc - V.dy1',
            idx: '=V.wd2 * COS(2700000 / V.d2r)',
            idy: '=V.hd2 * SIN(2700000 / V.d2r)',
            il: '=V.hc - V.idx',
            ir: '=V.hc + V.idx',
            it: '=V.vc - V.idy',
            ib: '=V.vc + V.idy',
            t: 0,
            l: 0,
            b: h,
            r: w,
            cd4: C,
            cx1: '=C(V.wd2,V.l,A(V.wd2,V.hd2,V.cd2),true)',
            cy1: '=C(V.hd2,V.vc,A(V.wd2,V.hd2,V.cd2))',
            _3cd4: D,
            cx2: '=C(V.wd2,P(V.cx1,V.wd2,A(V.wd2,V.hd2,(V.cd2 + V.cd4)),true),A(V.wd2,V.hd2,V._3cd4),true)',
            cy2: '=C(V.hd2,P(V.cy1,V.hd2,A(V.wd2,V.hd2,(V.cd2 + V.cd4))),A(V.wd2,V.hd2,V._3cd4))',
            cx3: '=C(V.wd2,P(V.cx2,V.wd2,A(V.wd2,V.hd2,(V._3cd4 + V.cd4)),true),A(V.wd2,V.hd2,0),true)',
            cy3: '=C(V.hd2,P(V.cy2,V.hd2,A(V.wd2,V.hd2,(V._3cd4 + V.cd4))),A(V.wd2,V.hd2,0))',
            cx4: '=C(V.wd2,P(V.cx3,V.wd2,A(V.wd2,V.hd2,(V.cd4)),true),A(V.wd2,V.hd2,V.cd4),true)',
            cy4: '=C(V.hd2,P(V.cy3,V.hd2,A(V.wd2,V.hd2,(V.cd4))),A(V.wd2,V.hd2,V.cd4))',
            cx5: '=C(V.iwd2,V.x1,A(V.iwd2,V.ihd2,V.stAng1),true)',
            cy5: '=C(V.ihd2,V.y1,A(V.iwd2,V.ihd2,V.stAng1))',
            cx6: '=C(V.iwd2,V.x2,A(V.iwd2,V.ihd2,V.stAng2),true)',
            cy6: '=C(V.ihd2,V.y2,A(V.iwd2,V.ihd2,V.stAng2))',
        },
        adjustInfo: [['adj', 18750]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: '=V.il',
            y: '=V.it',
        }, {
            x: 0,
            y: b,
        }, {
            x: '=V.il',
            y: '=V.ib',
        }, {
            x: a,
            y: h,
        }, {
            x: '=V.ir',
            y: '=V.ib',
        }, {
            x: w,
            y: b,
        }, {
            x: '=V.ir',
            y: '=V.it',
        },
        ],
        controlsInfo: [{
            type: 'ahPolar',
            gdRefR: 'adj',
            minR: 0,
            maxR: 50000,
            position: {
                x: 'dr',
                y: 'vc',
            },
            point: ['=V.dr', b],
        },
        ],
        path: [[['M', 0, b], ['E', '=V.cx1', '=V.cy1', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V.cd2)', '=A(V.wd2,V.hd2,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx2', '=V.cy2', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V._3cd4)', '=A(V.wd2,V.hd2,(V._3cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx3', '=V.cy3', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,0)', '=A(V.wd2,V.hd2,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx4', '=V.cy4', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V.cd4)', '=A(V.wd2,V.hd2,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['Z'], ['M', c, e], ['E', '=V.cx5', '=V.cy5', '=V.iwd2', '=V.ihd2', 0, '=A(V.iwd2,V.ihd2,V.stAng1)', '=A(V.iwd2,V.ihd2,(V.stAng1 + V.swAng))', '=IF(V.swAng > 0, FALSE, TRUE)'], ['Z'], ['M', d, f], ['E', '=V.cx6', '=V.cy6', '=V.iwd2', '=V.ihd2', 0, '=A(V.iwd2,V.ihd2,V.stAng2)', '=A(V.iwd2,V.ihd2,(V.stAng2 + V.swAng))', '=IF(V.swAng > 0, FALSE, TRUE)'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.it',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    blockArc: {
        variables: {
            adj1: B,
            adj2: 0,
            adj3: 25000,
            stAng: '=MIN(MAX(0, V.adj1), 21599999)',
            istAng: '=MIN(MAX(0, V.adj2), 21599999)',
            a3: '=MIN(MAX(0, V.adj3), 50000)',
            sw11: '=V.istAng - V.stAng',
            sw12: '=V.sw11 + 21600000',
            swAng: '=IF(V.sw11 > 0, V.sw11, V.sw12)',
            iswAng: '=0 - V.swAng',
            wd2: E,
            d2r: A,
            wt1: '=V.wd2 * SIN(V.stAng / V.d2r)',
            hd2: F,
            ht1: '=V.hd2 * COS(V.stAng / V.d2r)',
            wt3: '=V.wd2 * SIN(V.istAng / V.d2r)',
            ht3: '=V.hd2 * COS(V.istAng / V.d2r)',
            dx1: '=V.wd2 * COS(ATAN2(V.ht1,V.wt1))',
            dy1: '=V.hd2 * SIN(ATAN2(V.ht1,V.wt1))',
            dx3: '=V.wd2 * COS(ATAN2(V.ht3,V.wt3))',
            dy3: '=V.hd2 * SIN(ATAN2(V.ht3,V.wt3))',
            hc: E,
            x1: '=V.hc + V.dx1',
            vc: F,
            y1: '=V.vc + V.dy1',
            x3: '=V.hc + V.dx3',
            y3: '=V.vc + V.dy3',
            ss: s,
            dr: '=V.ss * V.a3 / 100000',
            iwd2: '=V.wd2 - V.dr',
            ihd2: '=V.hd2 - V.dr',
            wt2: '=V.iwd2 * SIN(V.istAng / V.d2r)',
            ht2: '=V.ihd2 * COS(V.istAng / V.d2r)',
            wt4: '=V.iwd2 * SIN(V.stAng / V.d2r)',
            ht4: '=V.ihd2 * COS(V.stAng / V.d2r)',
            dx2: '=V.iwd2 * COS(ATAN2(V.ht2,V.wt2))',
            dy2: '=V.ihd2 * SIN(ATAN2(V.ht2,V.wt2))',
            dx4: '=V.iwd2 * COS(ATAN2(V.ht4,V.wt4))',
            dy4: '=V.ihd2 * SIN(ATAN2(V.ht4,V.wt4))',
            x2: '=V.hc + V.dx2',
            y2: '=V.vc + V.dy2',
            x4: '=V.hc + V.dx4',
            y4: '=V.vc + V.dy4',
            sw0: '=21600000 - V.stAng',
            da1: '=V.swAng - V.sw0',
            g1: '=MAX(V.x1, V.x2)',
            g2: '=MAX(V.x3, V.x4)',
            g3: '=MAX(V.g1, V.g2)',
            r: w,
            ir: '=IF(V.da1 > 0, V.r, V.g3)',
            cd4: C,
            sw1: '=V.cd4 - V.stAng',
            sw2: '=27000000 - V.stAng',
            sw3: '=IF(V.sw1 > 0, V.sw1, V.sw2)',
            da2: '=V.swAng - V.sw3',
            g5: '=MAX(V.y1, V.y2)',
            g6: '=MAX(V.y3, V.y4)',
            g7: '=MAX(V.g5, V.g6)',
            b: h,
            ib: '=IF(V.da2 > 0, V.b, V.g7)',
            cd2: B,
            sw4: '=V.cd2 - V.stAng',
            sw5: '=32400000 - V.stAng',
            sw6: '=IF(V.sw4 > 0, V.sw4, V.sw5)',
            da3: '=V.swAng - V.sw6',
            g9: '=MIN(V.x1, V.x2)',
            g10: '=MIN(V.x3, V.x4)',
            g11: '=MIN(V.g9, V.g10)',
            l: 0,
            il: '=IF(V.da3 > 0, V.l, V.g11)',
            _3cd4: D,
            sw7: '=V._3cd4 - V.stAng',
            sw8: '=37800000 - V.stAng',
            sw9: '=IF(V.sw7 > 0, V.sw7, V.sw8)',
            da4: '=V.swAng - V.sw9',
            g13: '=MIN(V.y1, V.y2)',
            g14: '=MIN(V.y3, V.y4)',
            g15: '=MIN(V.g13, V.g14)',
            t: 0,
            it: '=IF(V.da4 > 0, V.t, V.g15)',
            x5: '=(V.x1 + V.x4) / 2',
            y5: '=(V.y1 + V.y4) / 2',
            x6: '=(V.x3 + V.x2) / 2',
            y6: '=(V.y3 + V.y2) / 2',
            cang1: '=V.stAng - V.cd4',
            cang2: '=V.istAng + V.cd4',
            cang3: '=(V.cang1 + V.cang2) / 2',
            cx1: '=C(V.wd2,V.x1,A(V.wd2,V.hd2,V.stAng),true)',
            cy1: '=C(V.hd2,V.y1,A(V.wd2,V.hd2,V.stAng))',
            cx2: '=C(V.iwd2,V.x2,A(V.iwd2,V.ihd2,V.istAng),true)',
            cy2: '=C(V.ihd2,V.y2,A(V.iwd2,V.ihd2,V.istAng))',
        },
        adjustInfo: [['adj1', 10800000], ['adj2', 0], ['adj3', 25000]],
        connectionPoints: [{
            x: '=V.x5',
            y: '=V.y5',
        }, {
            x: '=V.x6',
            y: '=V.y6',
        }, {
            x: a,
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahPolar',
            gdRefAng: 'adj1',
            minAng: 0,
            maxAng: 21599999,
            position: {
                x: 'x1',
                y: 'y1',
            },
            point: [c, e],
        }, {
            type: 'ahPolar',
            gdRefR: 'adj3',
            minR: 0,
            maxR: 50000,
            gdRefAng: 'adj2',
            minAng: 0,
            maxAng: 21599999,
            position: {
                x: 'x2',
                y: 'y2',
            },
            point: [d, f],
        },
        ],
        path: [[['M', c, e], ['E', '=V.cx1', '=V.cy1', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V.stAng)', '=A(V.wd2,V.hd2,(V.stAng + V.swAng))', '=IF(V.swAng > 0, FALSE, TRUE)'], ['L', d, f], ['E', '=V.cx2', '=V.cy2', '=V.iwd2', '=V.ihd2', 0, '=A(V.iwd2,V.ihd2,V.istAng)', '=A(V.iwd2,V.ihd2,(V.istAng + V.iswAng))', '=IF(V.iswAng > 0, FALSE, TRUE)'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.it',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    heart: {
        variables: {
            dx1: '=width * 49 / 48',
            dx2: '=width * 10 / 48',
            hc: E,
            x1: '=V.hc - V.dx1',
            x2: '=V.hc - V.dx2',
            x3: '=V.hc + V.dx2',
            x4: '=V.hc + V.dx1',
            t: 0,
            hd3: '=height/3',
            y1: '=0 - V.hd3',
            il: '=width / 6',
            ir: '=width * 5 / 6',
            ib: '=height * 2 / 3',
            hd4: '=height/4',
            b: h,
        },
        connectionPoints: [{
            x: a,
            y: '=V.hd4',
        }, {
            x: a,
            y: h,
        },
        ],
        path: [[['M', a, '=V.hd4'], ['B', '=V.x3', e, '=V.x4', '=V.hd4', a, h], ['B', c, '=V.hd4', d, e, a, '=V.hd4'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.hd4',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    lightningBolt: {
        variables: {
            x1: '=width * 5022 / 21600',
            x3: '=width * 8472 / 21600',
            x4: '=width * 8757 / 21600',
            x5: '=width * 10012 / 21600',
            x8: '=width * 12860 / 21600',
            x9: '=width * 13917 / 21600',
            x11: '=width * 16577 / 21600',
            y1: '=height * 3890 / 21600',
            y2: '=height * 6080 / 21600',
            y4: '=height * 7437 / 21600',
            y6: '=height * 9705 / 21600',
            y7: '=height * 12007 / 21600',
            y10: '=height * 14277 / 21600',
            y11: '=height * 14915 / 21600',
            t: 0,
            l: 0,
            r: w,
            b: h,
            _scaleX1: '= width / 21600',
            _scaleY1: '= height / 21600',
        },
        connectionPoints: [{
            x: '=V.x3',
            y: 0,
        }, {
            x: 0,
            y: e,
        }, {
            x: c,
            y: '=V.y6',
        }, {
            x: '=V.x5',
            y: '=V.y11',
        }, {
            x: w,
            y: h,
        }, {
            x: '=V.x11',
            y: '=V.y7',
        }, {
            x: '=V.x8',
            y: f,
        },
        ],
        path: [[['M', '=8472 * V._scaleX1', 0], ['L', '=12860 * V._scaleX1', '=6080 * V._scaleY1'], ['L', '=11050 * V._scaleX1', '=6797 * V._scaleY1'], ['L', '=16577 * V._scaleX1', '=12007 * V._scaleY1'], ['L', '=14767 * V._scaleX1', '=12877 * V._scaleY1'], ['L', w, h], ['L', '=10012 * V._scaleX1', '=14915 * V._scaleY1'], ['L', '=12222 * V._scaleX1', '=13987 * V._scaleY1'], ['L', '=5022 * V._scaleX1', '=9705 * V._scaleY1'], ['L', '=7602 * V._scaleX1', '=8382 * V._scaleY1'], ['L', 0, '=3890 * V._scaleY1'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.x4',
            top: '=V.y4',
            right: '=V.x9',
            bottom: '=V.y10',
        },
    },
    sun: {
        variables: {
            adj: 25000,
            a: '=MIN(MAX(12500, V.adj), 46875)',
            g0: '=50000 - V.a',
            g1: '=V.g0 * 30274 / 32768',
            g2: '=V.g0 * 12540 / 32768',
            g3: '=V.g1 + 50000',
            g4: '=V.g2 + 50000',
            g5: '=50000 - V.g1',
            g6: '=50000 - V.g2',
            g7: '=V.g0 * 23170 / 32768',
            g8: '=50000 + V.g7',
            g9: '=50000 - V.g7',
            g10: '=V.g5 * 3 / 4',
            g11: '=V.g6 * 3 / 4',
            g12: '=V.g10 + 3662',
            g13: '=V.g11 + 3662',
            g14: '=V.g11 + 12500',
            g15: '=100000 - V.g10',
            g16: '=100000 - V.g12',
            g17: '=100000 - V.g13',
            g18: '=100000 - V.g14',
            ox1: '=width * 18436 / 21600',
            oy1: '=height * 3163 / 21600',
            ox2: '=width * 3163 / 21600',
            oy2: '=height * 18436 / 21600',
            x8: '=width * V.g8 / 100000',
            x9: '=width * V.g9 / 100000',
            x10: '=width * V.g10 / 100000',
            x12: '=width * V.g12 / 100000',
            x13: '=width * V.g13 / 100000',
            x14: '=width * V.g14 / 100000',
            x15: '=width * V.g15 / 100000',
            x16: '=width * V.g16 / 100000',
            x17: '=width * V.g17 / 100000',
            x18: '=width * V.g18 / 100000',
            x19: '=width * V.a / 100000',
            wR: '=width * V.g0 / 100000',
            hR: '=height * V.g0 / 100000',
            y8: '=height * V.g8 / 100000',
            y9: '=height * V.g9 / 100000',
            y10: '=height * V.g10 / 100000',
            y12: '=height * V.g12 / 100000',
            y13: '=height * V.g13 / 100000',
            y14: '=height * V.g14 / 100000',
            y15: '=height * V.g15 / 100000',
            y16: '=height * V.g16 / 100000',
            y17: '=height * V.g17 / 100000',
            y18: '=height * V.g18 / 100000',
            hc: E,
            t: 0,
            l: 0,
            vc: F,
            b: h,
            r: w,
            cd2: B,
            cx1: '=C(V.wR,V.x19,A(V.wR,V.hR,V.cd2),true)',
            cy1: '=C(V.hR,V.vc,A(V.wR,V.hR,V.cd2))',
        },
        adjustInfo: [['adj', 25000]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj',
            minX: 12500,
            maxX: 46875,
            position: {
                x: 'x19',
                y: 'vc',
            },
            point: ['=V.x19', b],
        },
        ],
        path: [[['M', w, b], ['L', '=V.x15', '=V.y18'], ['L', '=V.x15', '=V.y14'], ['Z'], ['M', '=V.ox1', '=V.oy1'], ['L', '=V.x16', '=V.y13'], ['L', '=V.x17', '=V.y12'], ['Z'], ['M', a, 0], ['L', '=V.x18', '=V.y10'], ['L', '=V.x14', '=V.y10'], ['Z'], ['M', '=V.ox2', '=V.oy1'], ['L', '=V.x13', '=V.y12'], ['L', '=V.x12', '=V.y13'], ['Z'], ['M', 0, b], ['L', '=V.x10', '=V.y14'], ['L', '=V.x10', '=V.y18'], ['Z'], ['M', '=V.ox2', '=V.oy2'], ['L', '=V.x12', '=V.y17'], ['L', '=V.x13', '=V.y16'], ['Z'], ['M', a, h], ['L', '=V.x14', '=V.y15'], ['L', '=V.x18', '=V.y15'], ['Z'], ['M', '=V.ox1', '=V.oy2'], ['L', '=V.x17', '=V.y16'], ['L', '=V.x16', '=V.y17'], ['Z'], ['M', '=V.x19', b], ['E', '=V.cx1', '=V.cy1', '=V.wR', '=V.hR', 0, '=A(V.wR,V.hR,V.cd2)', '=(A(V.wR,V.hR,V.cd2)+ 2*PI())', '=IF(21600000 > 0, FALSE, TRUE)'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.x9',
            top: '=V.y9',
            right: '=V.x8',
            bottom: '=V.y8',
        },
    },
    moon: {
        variables: {
            adj: 50000,
            a: '=MIN(MAX(0, V.adj), 87500)',
            ss: s,
            g0: '=V.ss * V.a / 100000',
            g0w: '=V.g0 * width / V.ss',
            g1: '=V.ss - V.g0',
            g2: '=V.g0 * V.g0 / V.g1',
            g3: '=V.ss * V.ss / V.g1',
            g4: '=V.g3 * 2',
            g5: '=V.g4 - V.g2',
            g6: '=V.g5 - V.g0',
            g6w: '=V.g6 * width / V.ss',
            g7: '=V.g5 / 2',
            g8: '=V.g7 - V.g0',
            hd2: F,
            dy1: '=V.g8 * V.hd2 / V.ss',
            vc: F,
            g10h: '=V.vc - V.dy1',
            g11h: '=V.vc + V.dy1',
            g12: '=V.g0 * 9598 / 32768',
            g12w: '=V.g12 * width / V.ss',
            g13: '=V.ss - V.g12',
            q1: '=V.ss * V.ss',
            q2: '=V.g13 * V.g13',
            q3: '=V.q1 - V.q2',
            q4: '=SQRT(V.q3)',
            dy4: '=V.q4 * V.hd2 / V.ss',
            g15h: '=V.vc - V.dy4',
            g16h: '=V.vc + V.dy4',
            g17w: '=V.g6w - V.g0w',
            g18w: '=V.g17w / 2',
            dx2p: '=V.g0w + V.g18w - width',
            dx2: '=V.dx2p * -1',
            dy2: '=V.hd2 * -1',
            d2r: A,
            stAng1: '=(ATAN2(V.dx2,V.dy2) * V.d2r)',
            enAngp1: '=(ATAN2(V.dx2,V.hd2) * V.d2r)',
            enAng1: '=V.enAngp1 - 21600000',
            swAng1: '=V.enAng1 - V.stAng1',
            r: w,
            t: 0,
            l: 0,
            b: h,
            cd4: C,
            cd2: B,
            cx1: '=C(width,V.r,A(width,V.hd2,V.cd4),true)',
            cy1: '=C(V.hd2,V.b,A(width,V.hd2,V.cd4))',
            cx2: '=C(V.g18w,P(V.cx1,width,A(width,V.hd2,(V.cd4 + V.cd2)),true),A(V.g18w,V.dy1,V.stAng1),true)',
            cy2: '=C(V.dy1,P(V.cy1,V.hd2,A(width,V.hd2,(V.cd4 + V.cd2))),A(V.g18w,V.dy1,V.stAng1))',
        },
        adjustInfo: [['adj', 50000]],
        connectionPoints: [{
            x: w,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: w,
            y: h,
        }, {
            x: '=V.g0w',
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj',
            minX: 0,
            maxX: 87500,
            position: {
                x: 'g0w',
                y: 'vc',
            },
            point: ['=V.g0w', b],
        },
        ],
        path: [[['M', w, h], ['E', '=V.cx1', '=V.cy1', w, '=V.hd2', 0, '=A(width,V.hd2,V.cd4)', '=A(width,V.hd2,(V.cd4 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['E', '=V.cx2', '=V.cy2', '=V.g18w', '=V.dy1', 0, '=A(V.g18w,V.dy1,V.stAng1)', '=A(V.g18w,V.dy1,(V.stAng1 + V.swAng1))', '=IF(V.swAng1 > 0, FALSE, TRUE)'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.g12w',
            top: '=V.g15h',
            right: '=V.g0w',
            bottom: '=V.g16h',
        },
    },
    arc: {
        variables: {
            adj1: D,
            adj2: 0,
            stAng: '=MIN(MAX(0, V.adj1), 21599999)',
            enAng: '=MIN(MAX(0, V.adj2), 21599999)',
            sw11: '=V.enAng - V.stAng',
            sw12: '=V.sw11 + 21600000',
            swAng: '=IF(V.sw11 > 0, V.sw11, V.sw12)',
            wd2: E,
            d2r: A,
            wt1: '=V.wd2 * SIN(V.stAng / V.d2r)',
            hd2: F,
            ht1: '=V.hd2 * COS(V.stAng / V.d2r)',
            dx1: '=V.wd2 * COS(ATAN2(V.ht1,V.wt1))',
            dy1: '=V.hd2 * SIN(ATAN2(V.ht1,V.wt1))',
            wt2: '=V.wd2 * SIN(V.enAng / V.d2r)',
            ht2: '=V.hd2 * COS(V.enAng / V.d2r)',
            dx2: '=V.wd2 * COS(ATAN2(V.ht2,V.wt2))',
            dy2: '=V.hd2 * SIN(ATAN2(V.ht2,V.wt2))',
            hc: E,
            x1: '=V.hc + V.dx1',
            vc: F,
            y1: '=V.vc + V.dy1',
            x2: '=V.hc + V.dx2',
            y2: '=V.vc + V.dy2',
            sw0: '=21600000 - V.stAng',
            da1: '=V.swAng - V.sw0',
            g1: '=MAX(V.x1, V.x2)',
            r: w,
            ir: '=IF(V.da1 > 0, V.r, V.g1)',
            cd4: C,
            sw1: '=V.cd4 - V.stAng',
            sw2: '=27000000 - V.stAng',
            sw3: '=IF(V.sw1 > 0, V.sw1, V.sw2)',
            da2: '=V.swAng - V.sw3',
            g5: '=MAX(V.y1, V.y2)',
            b: h,
            ib: '=IF(V.da2 > 0, V.b, V.g5)',
            cd2: B,
            sw4: '=V.cd2 - V.stAng',
            sw5: '=32400000 - V.stAng',
            sw6: '=IF(V.sw4 > 0, V.sw4, V.sw5)',
            da3: '=V.swAng - V.sw6',
            g9: '=MIN(V.x1, V.x2)',
            l: 0,
            il: '=IF(V.da3 > 0, V.l, V.g9)',
            _3cd4: D,
            sw7: '=V._3cd4 - V.stAng',
            sw8: '=37800000 - V.stAng',
            sw9: '=IF(V.sw7 > 0, V.sw7, V.sw8)',
            da4: '=V.swAng - V.sw9',
            g13: '=MIN(V.y1, V.y2)',
            t: 0,
            it: '=IF(V.da4 > 0, V.t, V.g13)',
            cang1: '=V.stAng - V.cd4',
            cang2: '=V.enAng + V.cd4',
            cang3: '=(V.cang1 + V.cang2) / 2',
            cx1: '=C(V.wd2,V.x1,A(V.wd2,V.hd2,V.stAng),true)',
            cy1: '=C(V.hd2,V.y1,A(V.wd2,V.hd2,V.stAng))',
            cx2: '=C(V.wd2,V.x1,A(V.wd2,V.hd2,V.stAng),true)',
            cy2: '=C(V.hd2,V.y1,A(V.wd2,V.hd2,V.stAng))',
        },
        adjustInfo: [['adj1', 16200000], ['adj2', 0]],
        connectionPoints: [{
            x: c,
            y: e,
        }, {
            x: a,
            y: b,
        }, {
            x: d,
            y: f,
        },
        ],
        controlsInfo: [{
            type: 'ahPolar',
            gdRefAng: 'adj1',
            minAng: 0,
            maxAng: 21599999,
            position: {
                x: 'x1',
                y: 'y1',
            },
            point: [c, e],
        }, {
            type: 'ahPolar',
            gdRefAng: 'adj2',
            minAng: 0,
            maxAng: 21599999,
            position: {
                x: 'x2',
                y: 'y2',
            },
            point: [d, f],
        },
        ],
        path: [[['M', c, e], ['E', '=V.cx1', '=V.cy1', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V.stAng)', '=A(V.wd2,V.hd2,(V.stAng + V.swAng))', '=IF(V.swAng > 0, FALSE, TRUE)'], ['L', a, b], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', c, e], ['E', '=V.cx2', '=V.cy2', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V.stAng)', '=A(V.wd2,V.hd2,(V.stAng + V.swAng))', '=IF(V.swAng > 0, FALSE, TRUE)'], {
            fillMode: 'none',
        },
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.it',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    doubleBracket: {
        variables: {
            adj: 16667,
            a: '=MIN(MAX(0, V.adj), 50000)',
            ss: s,
            x1: '=V.ss * V.a / 100000',
            r: w,
            x2: '=width - V.x1',
            b: h,
            y2: '=height - V.x1',
            il: '=V.x1 * 29289 / 100000',
            ir: '=width - V.il',
            ib: '=height - V.il',
            hc: E,
            t: 0,
            l: 0,
            vc: F,
            cd2: B,
            cd4: C,
            cx1: '=C(V.x1,V.l,A(V.x1,V.x1,V.cd2),true)',
            cy1: '=C(V.x1,V.x1,A(V.x1,V.x1,V.cd2))',
            _3cd4: D,
            cx2: '=C(V.x1,V.x2,A(V.x1,V.x1,V._3cd4),true)',
            cy2: '=C(V.x1,V.t,A(V.x1,V.x1,V._3cd4))',
            cx3: '=C(V.x1,V.r,A(V.x1,V.x1,0),true)',
            cy3: '=C(V.x1,V.y2,A(V.x1,V.x1,0))',
            cx4: '=C(V.x1,V.x1,A(V.x1,V.x1,V.cd4),true)',
            cy4: '=C(V.x1,V.b,A(V.x1,V.x1,V.cd4))',
            cx5: '=C(V.x1,V.x1,A(V.x1,V.x1,V.cd4),true)',
            cy5: '=C(V.x1,V.b,A(V.x1,V.x1,V.cd4))',
            cx6: '=C(V.x1,V.l,A(V.x1,V.x1,V.cd2),true)',
            cy6: '=C(V.x1,V.x1,A(V.x1,V.x1,V.cd2))',
            cx7: '=C(V.x1,V.x2,A(V.x1,V.x1,V._3cd4),true)',
            cy7: '=C(V.x1,V.t,A(V.x1,V.x1,V._3cd4))',
            cx8: '=C(V.x1,V.r,A(V.x1,V.x1,0),true)',
            cy8: '=C(V.x1,V.y2,A(V.x1,V.x1,0))',
        },
        adjustInfo: [['adj', 16667]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj',
            minY: 0,
            maxY: 50000,
            position: {
                x: 'l',
                y: 'x1',
            },
            point: [0, c],
        },
        ],
        path: [[['M', 0, c], ['E', '=V.cx1', '=V.cy1', c, c, 0, '=A(V.x1,V.x1,V.cd2)', '=A(V.x1,V.x1,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', d, 0], ['E', '=V.cx2', '=V.cy2', c, c, 0, '=A(V.x1,V.x1,V._3cd4)', '=A(V.x1,V.x1,(V._3cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', w, f], ['E', '=V.cx3', '=V.cy3', c, c, 0, '=A(V.x1,V.x1,0)', '=A(V.x1,V.x1,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', c, h], ['E', '=V.cx4', '=V.cy4', c, c, 0, '=A(V.x1,V.x1,V.cd4)', '=A(V.x1,V.x1,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', c, h], ['E', '=V.cx5', '=V.cy5', c, c, 0, '=A(V.x1,V.x1,V.cd4)', '=A(V.x1,V.x1,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', 0, c], ['E', '=V.cx6', '=V.cy6', c, c, 0, '=A(V.x1,V.x1,V.cd2)', '=A(V.x1,V.x1,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['M', d, 0], ['E', '=V.cx7', '=V.cy7', c, c, 0, '=A(V.x1,V.x1,V._3cd4)', '=A(V.x1,V.x1,(V._3cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', w, f], ['E', '=V.cx8', '=V.cy8', c, c, 0, '=A(V.x1,V.x1,0)', '=A(V.x1,V.x1,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], {
            fillMode: 'none',
        },
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.il',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    doubleBrace: {
        variables: {
            adj: 8333,
            a: '=MIN(MAX(0, V.adj), 25000)',
            ss: s,
            x1: '=V.ss * V.a / 100000',
            x2: '=V.ss * V.a / 50000',
            r: w,
            x3: '=width - V.x2',
            x4: '=width - V.x1',
            vc: F,
            y2: '=V.vc - V.x1',
            y3: '=V.vc + V.x1',
            b: h,
            y4: '=height - V.x1',
            it: '=V.x1 * 29289 / 100000',
            il: '=V.x1 + V.it',
            ir: '=width - V.il',
            ib: '=height - V.it',
            hc: E,
            t: 0,
            l: 0,
            cd4: C,
            cx1: '=C(V.x1,V.x2,A(V.x1,V.x1,V.cd4),true)',
            cy1: '=C(V.x1,V.b,A(V.x1,V.x1,V.cd4))',
            cx2: '=C(V.x1,V.x1,A(V.x1,V.x1,0),true)',
            cy2: '=C(V.x1,V.y3,A(V.x1,V.x1,0))',
            cx3: '=C(V.x1,P(V.cx2,V.x1,A(V.x1,V.x1,(-5400000)),true),A(V.x1,V.x1,V.cd4),true)',
            cy3: '=C(V.x1,P(V.cy2,V.x1,A(V.x1,V.x1,(-5400000))),A(V.x1,V.x1,V.cd4))',
            cd2: B,
            cx4: '=C(V.x1,V.x1,A(V.x1,V.x1,V.cd2),true)',
            cy4: '=C(V.x1,V.x1,A(V.x1,V.x1,V.cd2))',
            _3cd4: D,
            cx5: '=C(V.x1,V.x3,A(V.x1,V.x1,V._3cd4),true)',
            cy5: '=C(V.x1,V.t,A(V.x1,V.x1,V._3cd4))',
            cx6: '=C(V.x1,V.x4,A(V.x1,V.x1,V.cd2),true)',
            cy6: '=C(V.x1,V.y2,A(V.x1,V.x1,V.cd2))',
            cx7: '=C(V.x1,P(V.cx6,V.x1,A(V.x1,V.x1,(V.cd2 + -5400000)),true),A(V.x1,V.x1,V._3cd4),true)',
            cy7: '=C(V.x1,P(V.cy6,V.x1,A(V.x1,V.x1,(V.cd2 + -5400000))),A(V.x1,V.x1,V._3cd4))',
            cx8: '=C(V.x1,V.x4,A(V.x1,V.x1,0),true)',
            cy8: '=C(V.x1,V.y4,A(V.x1,V.x1,0))',
            cx9: '=C(V.x1,V.x2,A(V.x1,V.x1,V.cd4),true)',
            cy9: '=C(V.x1,V.b,A(V.x1,V.x1,V.cd4))',
            cx10: '=C(V.x1,V.x1,A(V.x1,V.x1,0),true)',
            cy10: '=C(V.x1,V.y3,A(V.x1,V.x1,0))',
            cx11: '=C(V.x1,P(V.cx10,V.x1,A(V.x1,V.x1,(-5400000)),true),A(V.x1,V.x1,V.cd4),true)',
            cy11: '=C(V.x1,P(V.cy10,V.x1,A(V.x1,V.x1,(-5400000))),A(V.x1,V.x1,V.cd4))',
            cx12: '=C(V.x1,V.x1,A(V.x1,V.x1,V.cd2),true)',
            cy12: '=C(V.x1,V.x1,A(V.x1,V.x1,V.cd2))',
            cx13: '=C(V.x1,V.x3,A(V.x1,V.x1,V._3cd4),true)',
            cy13: '=C(V.x1,V.t,A(V.x1,V.x1,V._3cd4))',
            cx14: '=C(V.x1,V.x4,A(V.x1,V.x1,V.cd2),true)',
            cy14: '=C(V.x1,V.y2,A(V.x1,V.x1,V.cd2))',
            cx15: '=C(V.x1,P(V.cx14,V.x1,A(V.x1,V.x1,(V.cd2 + -5400000)),true),A(V.x1,V.x1,V._3cd4),true)',
            cy15: '=C(V.x1,P(V.cy14,V.x1,A(V.x1,V.x1,(V.cd2 + -5400000))),A(V.x1,V.x1,V._3cd4))',
            cx16: '=C(V.x1,V.x4,A(V.x1,V.x1,0),true)',
            cy16: '=C(V.x1,V.y4,A(V.x1,V.x1,0))',
        },
        adjustInfo: [['adj', 8333]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj',
            minY: 0,
            maxY: 25000,
            position: {
                x: 'l',
                y: 'x1',
            },
            point: [0, c],
        },
        ],
        path: [[['M', d, h], ['E', '=V.cx1', '=V.cy1', c, c, 0, '=A(V.x1,V.x1,V.cd4)', '=A(V.x1,V.x1,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', c, '=V.y3'], ['E', '=V.cx2', '=V.cy2', c, c, 0, '=A(V.x1,V.x1,0)', '=A(V.x1,V.x1,(-5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['E', '=V.cx3', '=V.cy3', c, c, 0, '=A(V.x1,V.x1,V.cd4)', '=A(V.x1,V.x1,(V.cd4 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['L', c, c], ['E', '=V.cx4', '=V.cy4', c, c, 0, '=A(V.x1,V.x1,V.cd2)', '=A(V.x1,V.x1,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', '=V.x3', 0], ['E', '=V.cx5', '=V.cy5', c, c, 0, '=A(V.x1,V.x1,V._3cd4)', '=A(V.x1,V.x1,(V._3cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', '=V.x4', f], ['E', '=V.cx6', '=V.cy6', c, c, 0, '=A(V.x1,V.x1,V.cd2)', '=A(V.x1,V.x1,(V.cd2 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['E', '=V.cx7', '=V.cy7', c, c, 0, '=A(V.x1,V.x1,V._3cd4)', '=A(V.x1,V.x1,(V._3cd4 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['L', '=V.x4', '=V.y4'], ['E', '=V.cx8', '=V.cy8', c, c, 0, '=A(V.x1,V.x1,0)', '=A(V.x1,V.x1,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', d, h], ['E', '=V.cx9', '=V.cy9', c, c, 0, '=A(V.x1,V.x1,V.cd4)', '=A(V.x1,V.x1,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', c, '=V.y3'], ['E', '=V.cx10', '=V.cy10', c, c, 0, '=A(V.x1,V.x1,0)', '=A(V.x1,V.x1,(-5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['E', '=V.cx11', '=V.cy11', c, c, 0, '=A(V.x1,V.x1,V.cd4)', '=A(V.x1,V.x1,(V.cd4 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['L', c, c], ['E', '=V.cx12', '=V.cy12', c, c, 0, '=A(V.x1,V.x1,V.cd2)', '=A(V.x1,V.x1,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['M', '=V.x3', 0], ['E', '=V.cx13', '=V.cy13', c, c, 0, '=A(V.x1,V.x1,V._3cd4)', '=A(V.x1,V.x1,(V._3cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', '=V.x4', f], ['E', '=V.cx14', '=V.cy14', c, c, 0, '=A(V.x1,V.x1,V.cd2)', '=A(V.x1,V.x1,(V.cd2 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['E', '=V.cx15', '=V.cy15', c, c, 0, '=A(V.x1,V.x1,V._3cd4)', '=A(V.x1,V.x1,(V._3cd4 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['L', '=V.x4', '=V.y4'], ['E', '=V.cx16', '=V.cy16', c, c, 0, '=A(V.x1,V.x1,0)', '=A(V.x1,V.x1,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], {
            fillMode: 'none',
        },
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.il',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    plaque: {
        variables: {
            adj: 16667,
            a: '=MIN(MAX(0, V.adj), 50000)',
            ss: s,
            x1: '=V.ss * V.a / 100000',
            r: w,
            x2: '=width - V.x1',
            b: h,
            y2: '=height - V.x1',
            il: '=V.x1 * 70711 / 100000',
            ir: '=width - V.il',
            ib: '=height - V.il',
            hc: E,
            t: 0,
            l: 0,
            vc: F,
            cd4: C,
            cx1: '=C(V.x1,V.l,A(V.x1,V.x1,V.cd4),true)',
            cy1: '=C(V.x1,V.x1,A(V.x1,V.x1,V.cd4))',
            cd2: B,
            cx2: '=C(V.x1,V.x2,A(V.x1,V.x1,V.cd2),true)',
            cy2: '=C(V.x1,V.t,A(V.x1,V.x1,V.cd2))',
            _3cd4: D,
            cx3: '=C(V.x1,V.r,A(V.x1,V.x1,V._3cd4),true)',
            cy3: '=C(V.x1,V.y2,A(V.x1,V.x1,V._3cd4))',
            cx4: '=C(V.x1,V.x1,A(V.x1,V.x1,0),true)',
            cy4: '=C(V.x1,V.b,A(V.x1,V.x1,0))',
        },
        adjustInfo: [['adj', 16667]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj',
            minX: 0,
            maxX: 50000,
            position: {
                x: 'x1',
                y: 't',
            },
            point: [c, 0],
        },
        ],
        path: [[['M', 0, c], ['E', '=V.cx1', '=V.cy1', c, c, 0, '=A(V.x1,V.x1,V.cd4)', '=A(V.x1,V.x1,(V.cd4 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['L', d, 0], ['E', '=V.cx2', '=V.cy2', c, c, 0, '=A(V.x1,V.x1,V.cd2)', '=A(V.x1,V.x1,(V.cd2 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['L', w, f], ['E', '=V.cx3', '=V.cy3', c, c, 0, '=A(V.x1,V.x1,V._3cd4)', '=A(V.x1,V.x1,(V._3cd4 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['L', c, h], ['E', '=V.cx4', '=V.cy4', c, c, 0, '=A(V.x1,V.x1,0)', '=A(V.x1,V.x1,(-5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.il',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    leftBracket: {
        variables: {
            adj: 8333,
            ss: s,
            maxAdj: '=50000 * height / V.ss',
            a: '=MIN(MAX(0, V.adj), V.maxAdj)',
            y1: '=V.ss * V.a / 100000',
            b: h,
            y2: '=height - V.y1',
            d2r: A,
            dx1: '=width * COS(2700000 / V.d2r)',
            dy1: '=V.y1 * SIN(2700000 / V.d2r)',
            r: w,
            il: '=width - V.dx1',
            it: '=V.y1 - V.dy1',
            ib: '=height + V.dy1 - V.y1',
            t: 0,
            l: 0,
            vc: F,
            cd4: C,
            cx1: '=C(width,V.r,A(width,V.y1,V.cd4),true)',
            cy1: '=C(V.y1,V.b,A(width,V.y1,V.cd4))',
            cd2: B,
            cx2: '=C(width,V.l,A(width,V.y1,V.cd2),true)',
            cy2: '=C(V.y1,V.y1,A(width,V.y1,V.cd2))',
            cx3: '=C(width,V.r,A(width,V.y1,V.cd4),true)',
            cy3: '=C(V.y1,V.b,A(width,V.y1,V.cd4))',
            cx4: '=C(width,V.l,A(width,V.y1,V.cd2),true)',
            cy4: '=C(V.y1,V.y1,A(width,V.y1,V.cd2))',
        },
        adjustInfo: [['adj', 8333]],
        connectionPoints: [{
            x: w,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: w,
            y: h,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj',
            minY: 0,
            maxY: 'maxAdj',
            position: {
                x: 'l',
                y: 'y1',
            },
            point: [0, e],
        },
        ],
        path: [[['M', w, h], ['E', '=V.cx1', '=V.cy1', w, e, 0, '=A(width,V.y1,V.cd4)', '=A(width,V.y1,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', 0, e], ['E', '=V.cx2', '=V.cy2', w, e, 0, '=A(width,V.y1,V.cd2)', '=A(width,V.y1,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', w, h], ['E', '=V.cx3', '=V.cy3', w, e, 0, '=A(width,V.y1,V.cd4)', '=A(width,V.y1,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', 0, e], ['E', '=V.cx4', '=V.cy4', w, e, 0, '=A(width,V.y1,V.cd2)', '=A(width,V.y1,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], {
            fillMode: 'none',
        },
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.it',
            right: w,
            bottom: '=V.ib',
        },
    },
    rightBracket: {
        variables: {
            adj: 8333,
            ss: s,
            maxAdj: '=50000 * height / V.ss',
            a: '=MIN(MAX(0, V.adj), V.maxAdj)',
            y1: '=V.ss * V.a / 100000',
            b: h,
            y2: '=height - V.y1',
            d2r: A,
            dx1: '=width * COS(2700000 / V.d2r)',
            dy1: '=V.y1 * SIN(2700000 / V.d2r)',
            l: 0,
            ir: '=V.dx1',
            it: '=V.y1 - V.dy1',
            ib: '=height + V.dy1 - V.y1',
            t: 0,
            r: w,
            vc: F,
            _3cd4: D,
            cd4: C,
            cx1: '=C(width,V.l,A(width,V.y1,V._3cd4),true)',
            cy1: '=C(V.y1,V.t,A(width,V.y1,V._3cd4))',
            cx2: '=C(width,V.r,A(width,V.y1,0),true)',
            cy2: '=C(V.y1,V.y2,A(width,V.y1,0))',
            cx3: '=C(width,V.l,A(width,V.y1,V._3cd4),true)',
            cy3: '=C(V.y1,V.t,A(width,V.y1,V._3cd4))',
            cx4: '=C(width,V.r,A(width,V.y1,0),true)',
            cy4: '=C(V.y1,V.y2,A(width,V.y1,0))',
        },
        adjustInfo: [['adj', 8333]],
        connectionPoints: [{
            x: 0,
            y: 0,
        }, {
            x: 0,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj',
            minY: 0,
            maxY: 'maxAdj',
            position: {
                x: 'r',
                y: 'y1',
            },
            point: [w, e],
        },
        ],
        path: [[['M', 0, 0], ['E', '=V.cx1', '=V.cy1', w, e, 0, '=A(width,V.y1,V._3cd4)', '=A(width,V.y1,(V._3cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', w, f], ['E', '=V.cx2', '=V.cy2', w, e, 0, '=A(width,V.y1,0)', '=A(width,V.y1,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', 0, 0], ['E', '=V.cx3', '=V.cy3', w, e, 0, '=A(width,V.y1,V._3cd4)', '=A(width,V.y1,(V._3cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', w, f], ['E', '=V.cx4', '=V.cy4', w, e, 0, '=A(width,V.y1,0)', '=A(width,V.y1,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], {
            fillMode: 'none',
        },
        ]],
        textRect: {
            left: 0,
            top: '=V.it',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    leftBrace: {
        variables: {
            adj1: 8333,
            adj2: 50000,
            a2: '=MIN(MAX(0, V.adj2), 100000)',
            q1: '=100000 - V.a2',
            q2: '=MIN(V.q1, V.a2)',
            q3: '=V.q2 / 2',
            ss: s,
            maxAdj1: '=V.q3 * height / V.ss',
            a1: '=MIN(MAX(0, V.adj1), V.maxAdj1)',
            y1: '=V.ss * V.a1 / 100000',
            y3: '=height * V.a2 / 100000',
            y4: '=V.y3 + V.y1',
            wd2: E,
            d2r: A,
            dx1: '=V.wd2 * COS(2700000 / V.d2r)',
            dy1: '=V.y1 * SIN(2700000 / V.d2r)',
            r: w,
            il: '=width - V.dx1',
            it: '=V.y1 - V.dy1',
            b: h,
            ib: '=height + V.dy1 - V.y1',
            t: 0,
            l: 0,
            hc: E,
            cd4: C,
            cx1: '=C(V.wd2,V.r,A(V.wd2,V.y1,V.cd4),true)',
            cy1: '=C(V.y1,V.b,A(V.wd2,V.y1,V.cd4))',
            cx2: '=C(V.wd2,V.hc,A(V.wd2,V.y1,0),true)',
            cy2: '=C(V.y1,V.y4,A(V.wd2,V.y1,0))',
            cx3: '=C(V.wd2,P(V.cx2,V.wd2,A(V.wd2,V.y1,(-5400000)),true),A(V.wd2,V.y1,V.cd4),true)',
            cy3: '=C(V.y1,P(V.cy2,V.y1,A(V.wd2,V.y1,(-5400000))),A(V.wd2,V.y1,V.cd4))',
            cd2: B,
            cx4: '=C(V.wd2,V.hc,A(V.wd2,V.y1,V.cd2),true)',
            cy4: '=C(V.y1,V.y1,A(V.wd2,V.y1,V.cd2))',
            cx5: '=C(V.wd2,V.r,A(V.wd2,V.y1,V.cd4),true)',
            cy5: '=C(V.y1,V.b,A(V.wd2,V.y1,V.cd4))',
            cx6: '=C(V.wd2,V.hc,A(V.wd2,V.y1,0),true)',
            cy6: '=C(V.y1,V.y4,A(V.wd2,V.y1,0))',
            cx7: '=C(V.wd2,P(V.cx6,V.wd2,A(V.wd2,V.y1,(-5400000)),true),A(V.wd2,V.y1,V.cd4),true)',
            cy7: '=C(V.y1,P(V.cy6,V.y1,A(V.wd2,V.y1,(-5400000))),A(V.wd2,V.y1,V.cd4))',
            cx8: '=C(V.wd2,V.hc,A(V.wd2,V.y1,V.cd2),true)',
            cy8: '=C(V.y1,V.y1,A(V.wd2,V.y1,V.cd2))',
        },
        adjustInfo: [['adj1', 8333], ['adj2', 50000]],
        connectionPoints: [{
            x: w,
            y: 0,
        }, {
            x: 0,
            y: '=V.y3',
        }, {
            x: w,
            y: h,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj1',
            minY: 0,
            maxY: 'maxAdj1',
            position: {
                x: 'hc',
                y: 'y1',
            },
            point: [a, e],
        }, {
            type: 'ahXY',
            gdRefY: 'adj2',
            minY: 0,
            maxY: 100000,
            position: {
                x: 'l',
                y: 'y3',
            },
            point: [0, '=V.y3'],
        },
        ],
        path: [[['M', w, h], ['E', '=V.cx1', '=V.cy1', '=V.wd2', e, 0, '=A(V.wd2,V.y1,V.cd4)', '=A(V.wd2,V.y1,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', a, '=V.y4'], ['E', '=V.cx2', '=V.cy2', '=V.wd2', e, 0, '=A(V.wd2,V.y1,0)', '=A(V.wd2,V.y1,(-5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['E', '=V.cx3', '=V.cy3', '=V.wd2', e, 0, '=A(V.wd2,V.y1,V.cd4)', '=A(V.wd2,V.y1,(V.cd4 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['L', a, e], ['E', '=V.cx4', '=V.cy4', '=V.wd2', e, 0, '=A(V.wd2,V.y1,V.cd2)', '=A(V.wd2,V.y1,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', w, h], ['E', '=V.cx5', '=V.cy5', '=V.wd2', e, 0, '=A(V.wd2,V.y1,V.cd4)', '=A(V.wd2,V.y1,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', a, '=V.y4'], ['E', '=V.cx6', '=V.cy6', '=V.wd2', e, 0, '=A(V.wd2,V.y1,0)', '=A(V.wd2,V.y1,(-5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['E', '=V.cx7', '=V.cy7', '=V.wd2', e, 0, '=A(V.wd2,V.y1,V.cd4)', '=A(V.wd2,V.y1,(V.cd4 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['L', a, e], ['E', '=V.cx8', '=V.cy8', '=V.wd2', e, 0, '=A(V.wd2,V.y1,V.cd2)', '=A(V.wd2,V.y1,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], {
            fillMode: 'none',
        },
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.it',
            right: w,
            bottom: '=V.ib',
        },
    },
    rightBrace: {
        variables: {
            adj1: 8333,
            adj2: 50000,
            a2: '=MIN(MAX(0, V.adj2), 100000)',
            q1: '=100000 - V.a2',
            q2: '=MIN(V.q1, V.a2)',
            q3: '=V.q2 / 2',
            ss: s,
            maxAdj1: '=V.q3 * height / V.ss',
            a1: '=MIN(MAX(0, V.adj1), V.maxAdj1)',
            y1: '=V.ss * V.a1 / 100000',
            y3: '=height * V.a2 / 100000',
            y2: '=V.y3 - V.y1',
            b: h,
            y4: '=height - V.y1',
            wd2: E,
            d2r: A,
            dx1: '=V.wd2 * COS(2700000 / V.d2r)',
            dy1: '=V.y1 * SIN(2700000 / V.d2r)',
            l: 0,
            ir: '=V.dx1',
            it: '=V.y1 - V.dy1',
            ib: '=height + V.dy1 - V.y1',
            t: 0,
            r: w,
            hc: E,
            _3cd4: D,
            cd4: C,
            cx1: '=C(V.wd2,V.l,A(V.wd2,V.y1,V._3cd4),true)',
            cy1: '=C(V.y1,V.t,A(V.wd2,V.y1,V._3cd4))',
            cd2: B,
            cx2: '=C(V.wd2,V.hc,A(V.wd2,V.y1,V.cd2),true)',
            cy2: '=C(V.y1,V.y2,A(V.wd2,V.y1,V.cd2))',
            cx3: '=C(V.wd2,P(V.cx2,V.wd2,A(V.wd2,V.y1,(V.cd2 + -5400000)),true),A(V.wd2,V.y1,V._3cd4),true)',
            cy3: '=C(V.y1,P(V.cy2,V.y1,A(V.wd2,V.y1,(V.cd2 + -5400000))),A(V.wd2,V.y1,V._3cd4))',
            cx4: '=C(V.wd2,V.hc,A(V.wd2,V.y1,0),true)',
            cy4: '=C(V.y1,V.y4,A(V.wd2,V.y1,0))',
            cx5: '=C(V.wd2,V.l,A(V.wd2,V.y1,V._3cd4),true)',
            cy5: '=C(V.y1,V.t,A(V.wd2,V.y1,V._3cd4))',
            cx6: '=C(V.wd2,V.hc,A(V.wd2,V.y1,V.cd2),true)',
            cy6: '=C(V.y1,V.y2,A(V.wd2,V.y1,V.cd2))',
            cx7: '=C(V.wd2,P(V.cx6,V.wd2,A(V.wd2,V.y1,(V.cd2 + -5400000)),true),A(V.wd2,V.y1,V._3cd4),true)',
            cy7: '=C(V.y1,P(V.cy6,V.y1,A(V.wd2,V.y1,(V.cd2 + -5400000))),A(V.wd2,V.y1,V._3cd4))',
            cx8: '=C(V.wd2,V.hc,A(V.wd2,V.y1,0),true)',
            cy8: '=C(V.y1,V.y4,A(V.wd2,V.y1,0))',
        },
        adjustInfo: [['adj1', 8333], ['adj2', 50000]],
        connectionPoints: [{
            x: 0,
            y: 0,
        }, {
            x: w,
            y: '=V.y3',
        }, {
            x: 0,
            y: h,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj1',
            minY: 0,
            maxY: 'maxAdj1',
            position: {
                x: 'hc',
                y: 'y1',
            },
            point: [a, e],
        }, {
            type: 'ahXY',
            gdRefY: 'adj2',
            minY: 0,
            maxY: 100000,
            position: {
                x: 'r',
                y: 'y3',
            },
            point: [w, '=V.y3'],
        },
        ],
        path: [[['M', 0, 0], ['E', '=V.cx1', '=V.cy1', '=V.wd2', e, 0, '=A(V.wd2,V.y1,V._3cd4)', '=A(V.wd2,V.y1,(V._3cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', a, f], ['E', '=V.cx2', '=V.cy2', '=V.wd2', e, 0, '=A(V.wd2,V.y1,V.cd2)', '=A(V.wd2,V.y1,(V.cd2 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['E', '=V.cx3', '=V.cy3', '=V.wd2', e, 0, '=A(V.wd2,V.y1,V._3cd4)', '=A(V.wd2,V.y1,(V._3cd4 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['L', a, '=V.y4'], ['E', '=V.cx4', '=V.cy4', '=V.wd2', e, 0, '=A(V.wd2,V.y1,0)', '=A(V.wd2,V.y1,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', 0, 0], ['E', '=V.cx5', '=V.cy5', '=V.wd2', e, 0, '=A(V.wd2,V.y1,V._3cd4)', '=A(V.wd2,V.y1,(V._3cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', a, f], ['E', '=V.cx6', '=V.cy6', '=V.wd2', e, 0, '=A(V.wd2,V.y1,V.cd2)', '=A(V.wd2,V.y1,(V.cd2 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['E', '=V.cx7', '=V.cy7', '=V.wd2', e, 0, '=A(V.wd2,V.y1,V._3cd4)', '=A(V.wd2,V.y1,(V._3cd4 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['L', a, '=V.y4'], ['E', '=V.cx8', '=V.cy8', '=V.wd2', e, 0, '=A(V.wd2,V.y1,0)', '=A(V.wd2,V.y1,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], {
            fillMode: 'none',
        },
        ]],
        textRect: {
            left: 0,
            top: '=V.it',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    rightArrow: {
        variables: {
            adj1: 50000,
            adj2: 50000,
            ss: s,
            maxAdj2: '=100000 * width / V.ss',
            a1: '=MIN(MAX(0, V.adj1), 100000)',
            a2: '=MIN(MAX(0, V.adj2), V.maxAdj2)',
            dx1: '=V.ss * V.a2 / 100000',
            r: w,
            x1: '=width - V.dx1',
            dy1: '=height * V.a1 / 200000',
            vc: F,
            y1: '=V.vc - V.dy1',
            y2: '=V.vc + V.dy1',
            hd2: F,
            dx2: '=V.y1 * V.dx1 / V.hd2',
            x2: '=V.x1 + V.dx2',
            t: 0,
            l: 0,
            b: h,
        },
        adjustInfo: [['adj1', 50000], ['adj2', 50000]],
        connectionPoints: [{
            x: c,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: c,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj1',
            minY: 0,
            maxY: 100000,
            position: {
                x: 'l',
                y: 'y1',
            },
            point: [0, e],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: 0,
            maxX: 'maxAdj2',
            position: {
                x: 'x1',
                y: 't',
            },
            point: [c, 0],
        },
        ],
        path: [[['M', 0, e], ['L', c, e], ['L', c, 0], ['L', w, b], ['L', c, h], ['L', c, f], ['L', 0, f], ['Z'], {},
        ]],
        textRect: {
            left: 0,
            top: e,
            right: d,
            bottom: f,
        },
    },
    leftArrow: {
        variables: {
            adj1: 50000,
            adj2: 50000,
            ss: s,
            maxAdj2: '=100000 * width / V.ss',
            a1: '=MIN(MAX(0, V.adj1), 100000)',
            a2: '=MIN(MAX(0, V.adj2), V.maxAdj2)',
            dx2: '=V.ss * V.a2 / 100000',
            l: 0,
            x2: '=V.dx2',
            dy1: '=height * V.a1 / 200000',
            vc: F,
            y1: '=V.vc - V.dy1',
            y2: '=V.vc + V.dy1',
            hd2: F,
            dx1: '=V.y1 * V.dx2 / V.hd2',
            x1: '=V.x2 - V.dx1',
            t: 0,
            b: h,
            r: w,
        },
        adjustInfo: [['adj1', 50000], ['adj2', 50000]],
        connectionPoints: [{
            x: d,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: d,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj1',
            minY: 0,
            maxY: 100000,
            position: {
                x: 'r',
                y: 'y1',
            },
            point: [w, e],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: 0,
            maxX: 'maxAdj2',
            position: {
                x: 'x2',
                y: 't',
            },
            point: [d, 0],
        },
        ],
        path: [[['M', 0, b], ['L', d, 0], ['L', d, e], ['L', w, e], ['L', w, f], ['L', d, f], ['L', d, h], ['Z'], {},
        ]],
        textRect: {
            left: c,
            top: e,
            right: w,
            bottom: f,
        },
    },
    upArrow: {
        variables: {
            adj1: 50000,
            adj2: 50000,
            ss: s,
            maxAdj2: '=100000 * height / V.ss',
            a1: '=MIN(MAX(0, V.adj1), 100000)',
            a2: '=MIN(MAX(0, V.adj2), V.maxAdj2)',
            dy1: '=height - V.ss * V.a2 / 100000',
            b: h,
            y1: '=height - V.dy1',
            dx1: '=width * V.a1 / 200000',
            hc: E,
            x1: '=V.hc - V.dx1',
            x2: '=V.hc + V.dx1',
            wd2: E,
            dy2: '=V.x1 * V.dy1 / V.wd2',
            y2: '=V.y1 + V.dy2',
            t: 0,
            l: 0,
            r: w,
            t2: '=V.dx1 * V.y1 / V.hc',
        },
        adjustInfo: [['adj1', 50000], ['adj2', 50000]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: e,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: e,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj1',
            minX: 0,
            maxX: 100000,
            position: {
                x: 'x1',
                y: 'b',
            },
            point: [c, h],
        }, {
            type: 'ahXY',
            gdRefY: 'adj2',
            minY: 0,
            maxY: 'maxAdj2',
            position: {
                x: 'l',
                y: 'y1',
            },
            point: [0, e],
        },
        ],
        path: [[['M', 0, e], ['L', a, 0], ['L', w, e], ['L', d, e], ['L', d, h], ['L', c, h], ['L', c, e], ['Z'], {},
        ]],
        textRect: {
            left: c,
            top: '=V.t2',
            right: d,
            bottom: h,
        },
    },
    downArrow: {
        variables: {
            adj1: 50000,
            adj2: 50000,
            ss: s,
            maxAdj2: '=100000 * height / V.ss',
            a1: '=MIN(MAX(0, V.adj1), 100000)',
            a2: '=MIN(MAX(0, V.adj2), V.maxAdj2)',
            dy1: '=V.ss * V.a2 / 100000',
            b: h,
            y1: '=height - V.dy1',
            dx1: '=width * V.a1 / 200000',
            hc: E,
            x1: '=V.hc - V.dx1',
            x2: '=V.hc + V.dx1',
            wd2: E,
            dy2: '=V.x1 * V.dy1 / V.wd2',
            y2: '=V.y1 + V.dy2',
            t: 0,
            l: 0,
            r: w,
        },
        adjustInfo: [['adj1', 50000], ['adj2', 50000]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: e,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: e,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj1',
            minX: 0,
            maxX: 100000,
            position: {
                x: 'x1',
                y: 't',
            },
            point: [c, 0],
        }, {
            type: 'ahXY',
            gdRefY: 'adj2',
            minY: 0,
            maxY: 'maxAdj2',
            position: {
                x: 'l',
                y: 'y1',
            },
            point: [0, e],
        },
        ],
        path: [[['M', 0, e], ['L', c, e], ['L', c, 0], ['L', d, 0], ['L', d, e], ['L', w, e], ['L', a, h], ['Z'], {},
        ]],
        textRect: {
            left: c,
            top: 0,
            right: d,
            bottom: f,
        },
    },
    leftRightArrow: {
        variables: {
            adj1: 50000,
            adj2: 50000,
            ss: s,
            maxAdj2: '=50000 * width / V.ss',
            a1: '=MIN(MAX(0, V.adj1), 100000)',
            a2: '=MIN(MAX(0, V.adj2), V.maxAdj2)',
            x2: '=V.ss * V.a2 / 100000',
            r: w,
            x3: '=width - V.x2',
            dy: '=height * V.a1 / 200000',
            vc: F,
            y1: '=V.vc - V.dy',
            y2: '=V.vc + V.dy',
            hd2: F,
            dx1: '=V.y1 * V.x2 / V.hd2',
            x1: '=V.x2 - V.dx1',
            x4: '=V.x3 + V.dx1',
            b: h,
            l: 0,
            t: 0,
        },
        adjustInfo: [['adj1', 50000], ['adj2', 50000]],
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: '=V.x3',
            y: h,
        }, {
            x: d,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: d,
            y: 0,
        }, {
            x: '=V.x3',
            y: 0,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj1',
            minY: 0,
            maxY: 100000,
            position: {
                x: 'x3',
                y: 'y1',
            },
            point: ['=V.x3', e],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: 0,
            maxX: 'maxAdj2',
            position: {
                x: 'x2',
                y: 't',
            },
            point: [d, 0],
        },
        ],
        path: [[['M', 0, b], ['L', d, 0], ['L', d, e], ['L', '=V.x3', e], ['L', '=V.x3', 0], ['L', w, b], ['L', '=V.x3', h], ['L', '=V.x3', f], ['L', d, f], ['L', d, h], ['Z'], {},
        ]],
        textRect: {
            left: c,
            top: e,
            right: '=V.x4',
            bottom: f,
        },
    },
    upDownArrow: {
        variables: {
            adj1: 50000,
            adj2: 50000,
            ss: s,
            maxAdj2: '=50000 * height / V.ss',
            a1: '=MIN(MAX(0, V.adj1), 100000)',
            a2: '=MIN(MAX(0, V.adj2), V.maxAdj2)',
            y2: '=V.ss * V.a2 / 100000',
            b: h,
            y3: '=height - V.y2',
            dx1: '=width * V.a1 / 200000',
            hc: E,
            x1: '=V.hc - V.dx1',
            x2: '=V.hc + V.dx1',
            wd2: E,
            dy1: '=V.x1 * V.y2 / V.wd2',
            y1: '=V.y2 - V.dy1',
            y4: '=V.y3 + V.dy1',
            t: 0,
            l: 0,
            vc: F,
            r: w,
        },
        adjustInfo: [['adj1', 50000], ['adj2', 50000]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: f,
        }, {
            x: c,
            y: b,
        }, {
            x: 0,
            y: '=V.y3',
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: '=V.y3',
        }, {
            x: d,
            y: b,
        }, {
            x: w,
            y: f,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj1',
            minX: 0,
            maxX: 100000,
            position: {
                x: 'x1',
                y: 'y3',
            },
            point: [c, '=V.y3'],
        }, {
            type: 'ahXY',
            gdRefY: 'adj2',
            minY: 0,
            maxY: 'maxAdj2',
            position: {
                x: 'l',
                y: 'y2',
            },
            point: [0, f],
        },
        ],
        path: [[['M', 0, f], ['L', a, 0], ['L', w, f], ['L', d, f], ['L', d, '=V.y3'], ['L', w, '=V.y3'], ['L', a, h], ['L', 0, '=V.y3'], ['L', c, '=V.y3'], ['L', c, f], ['Z'], {},
        ]],
        textRect: {
            left: c,
            top: e,
            right: d,
            bottom: '=V.y4',
        },
    },
    quadArrow: {
        variables: {
            adj1: 22500,
            adj2: 22500,
            adj3: 22500,
            a2: '=MIN(MAX(0, V.adj2), 50000)',
            maxAdj1: '=V.a2 * 2',
            a1: '=MIN(MAX(0, V.adj1), V.maxAdj1)',
            q1: '=100000 - V.maxAdj1',
            maxAdj3: '=V.q1 / 2',
            a3: '=MIN(MAX(0, V.adj3), V.maxAdj3)',
            ss: s,
            x1: '=V.ss * V.a3 / 100000',
            dx2: '=V.ss * V.a2 / 100000',
            hc: E,
            x2: '=V.hc - V.dx2',
            x5: '=V.hc + V.dx2',
            dx3: '=V.ss * V.a1 / 200000',
            x3: '=V.hc - V.dx3',
            x4: '=V.hc + V.dx3',
            r: w,
            x6: '=width - V.x1',
            vc: F,
            y2: '=V.vc - V.dx2',
            y5: '=V.vc + V.dx2',
            y3: '=V.vc - V.dx3',
            y4: '=V.vc + V.dx3',
            b: h,
            y6: '=height - V.x1',
            il: '=V.dx3 * V.x1 / V.dx2',
            ir: '=width - V.il',
            t: 0,
            l: 0,
        },
        adjustInfo: [['adj1', 22500], ['adj2', 22500], ['adj3', 22500]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj1',
            minX: 0,
            maxX: 'maxAdj1',
            position: {
                x: 'x3',
                y: 'x1',
            },
            point: ['=V.x3', c],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: 0,
            maxX: 50000,
            position: {
                x: 'x2',
                y: 't',
            },
            point: [d, 0],
        }, {
            type: 'ahXY',
            gdRefY: 'adj3',
            minY: 0,
            maxY: 'maxAdj3',
            position: {
                x: 'r',
                y: 'x1',
            },
            point: [w, c],
        },
        ],
        path: [[['M', 0, b], ['L', c, f], ['L', c, '=V.y3'], ['L', '=V.x3', '=V.y3'], ['L', '=V.x3', c], ['L', d, c], ['L', a, 0], ['L', '=V.x5', c], ['L', '=V.x4', c], ['L', '=V.x4', '=V.y3'], ['L', '=V.x6', '=V.y3'], ['L', '=V.x6', f], ['L', w, b], ['L', '=V.x6', '=V.y5'], ['L', '=V.x6', '=V.y4'], ['L', '=V.x4', '=V.y4'], ['L', '=V.x4', '=V.y6'], ['L', '=V.x5', '=V.y6'], ['L', a, h], ['L', d, '=V.y6'], ['L', '=V.x3', '=V.y6'], ['L', '=V.x3', '=V.y4'], ['L', c, '=V.y4'], ['L', c, '=V.y5'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.y3',
            right: '=V.ir',
            bottom: '=V.y4',
        },
    },
    leftRightUpArrow: {
        variables: {
            adj1: 25000,
            adj2: 25000,
            adj3: 25000,
            a2: '=MIN(MAX(0, V.adj2), 50000)',
            maxAdj1: '=V.a2 * 2',
            a1: '=MIN(MAX(0, V.adj1), V.maxAdj1)',
            q1: '=100000 - V.maxAdj1',
            maxAdj3: '=V.q1 / 2',
            a3: '=MIN(MAX(0, V.adj3), V.maxAdj3)',
            ss: s,
            x1: '=V.ss * V.a3 / 100000',
            dx2: '=V.ss * V.a2 / 100000',
            hc: E,
            x2: '=V.hc - V.dx2',
            x5: '=V.hc + V.dx2',
            dx3: '=V.ss * V.a1 / 200000',
            x3: '=V.hc - V.dx3',
            x4: '=V.hc + V.dx3',
            r: w,
            x6: '=width - V.x1',
            dy2: '=V.ss * V.a2 / 50000',
            b: h,
            y2: '=height - V.dy2',
            y4: '=height - V.dx2',
            y3: '=V.y4 - V.dx3',
            y5: '=V.y4 + V.dx3',
            il: '=V.dx3 * V.x1 / V.dx2',
            ir: '=width - V.il',
            t: 0,
            l: 0,
        },
        adjustInfo: [['adj1', 25000], ['adj2', 25000], ['adj3', 25000]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: '=V.y4',
        }, {
            x: a,
            y: '=V.y5',
        }, {
            x: w,
            y: '=V.y4',
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj1',
            minX: 0,
            maxX: 'maxAdj1',
            position: {
                x: 'x3',
                y: 'x1',
            },
            point: ['=V.x3', c],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: 0,
            maxX: 50000,
            position: {
                x: 'x2',
                y: 't',
            },
            point: [d, 0],
        }, {
            type: 'ahXY',
            gdRefY: 'adj3',
            minY: 0,
            maxY: 'maxAdj3',
            position: {
                x: 'r',
                y: 'x1',
            },
            point: [w, c],
        },
        ],
        path: [[['M', 0, '=V.y4'], ['L', c, f], ['L', c, '=V.y3'], ['L', '=V.x3', '=V.y3'], ['L', '=V.x3', c], ['L', d, c], ['L', a, 0], ['L', '=V.x5', c], ['L', '=V.x4', c], ['L', '=V.x4', '=V.y3'], ['L', '=V.x6', '=V.y3'], ['L', '=V.x6', f], ['L', w, '=V.y4'], ['L', '=V.x6', h], ['L', '=V.x6', '=V.y5'], ['L', c, '=V.y5'], ['L', c, h], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.y3',
            right: '=V.ir',
            bottom: '=V.y5',
        },
    },
    bentArrow: {
        variables: {
            adj1: 25000,
            adj2: 25000,
            adj3: 25000,
            adj4: 43750,
            a2: '=MIN(MAX(0, V.adj2), 50000)',
            maxAdj1: '=V.a2 * 2',
            a1: '=MIN(MAX(0, V.adj1), V.maxAdj1)',
            a3: '=MIN(MAX(0, V.adj3), 50000)',
            ss: s,
            th: '=V.ss * V.a1 / 100000',
            aw2: '=V.ss * V.a2 / 100000',
            th2: '=V.th / 2',
            dh2: '=V.aw2 - V.th2',
            ah: '=V.ss * V.a3 / 100000',
            r: w,
            bw: '=width - V.ah',
            b: h,
            bh: '=height - V.dh2',
            bs: '=MIN(V.bw, V.bh)',
            maxAdj4: '=100000 * V.bs / V.ss',
            a4: '=MIN(MAX(0, V.adj4), V.maxAdj4)',
            bd: '=V.ss * V.a4 / 100000',
            bd3: '=V.bd - V.th',
            bd2: '=MAX(V.bd3, 0)',
            x3: '=V.th + V.bd2',
            x4: '=width - V.ah',
            y3: '=V.dh2 + V.th',
            y4: '=V.y3 + V.dh2',
            y5: '=V.dh2 + V.bd',
            y6: '=V.y3 + V.bd2',
            t: 0,
            l: 0,
            cd2: B,
            cd4: C,
            cx1: '=C(V.bd,V.l,A(V.bd,V.bd,V.cd2),true)',
            cy1: '=C(V.bd,V.y5,A(V.bd,V.bd,V.cd2))',
            _3cd4: D,
            cx2: '=C(V.bd2,V.x3,A(V.bd2,V.bd2,V._3cd4),true)',
            cy2: '=C(V.bd2,V.y3,A(V.bd2,V.bd2,V._3cd4))',
        },
        adjustInfo: [['adj1', 25000], ['adj2', 25000], ['adj3', 25000], ['adj4', 43750]],
        connectionPoints: [{
            x: '=V.x4',
            y: 0,
        }, {
            x: '=V.x4',
            y: '=V.y4',
        }, {
            x: '=V.th2',
            y: h,
        }, {
            x: w,
            y: '=V.aw2',
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj1',
            minX: 0,
            maxX: 'maxAdj1',
            position: {
                x: 'th',
                y: 'b',
            },
            point: ['=V.th', h],
        }, {
            type: 'ahXY',
            gdRefY: 'adj2',
            minY: 0,
            maxY: 50000,
            position: {
                x: 'r',
                y: 'y4',
            },
            point: [w, '=V.y4'],
        }, {
            type: 'ahXY',
            gdRefX: 'adj3',
            minX: 0,
            maxX: 50000,
            position: {
                x: 'x4',
                y: 't',
            },
            point: ['=V.x4', 0],
        }, {
            type: 'ahXY',
            gdRefX: 'adj4',
            minX: 0,
            maxX: 'maxAdj4',
            position: {
                x: 'bd',
                y: 't',
            },
            point: ['=V.bd', 0],
        },
        ],
        path: [[['M', 0, h], ['L', 0, '=V.y5'], ['E', '=V.cx1', '=V.cy1', '=V.bd', '=V.bd', 0, '=A(V.bd,V.bd,V.cd2)', '=A(V.bd,V.bd,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', '=V.x4', '=V.dh2'], ['L', '=V.x4', 0], ['L', w, '=V.aw2'], ['L', '=V.x4', '=V.y4'], ['L', '=V.x4', '=V.y3'], ['L', '=V.x3', '=V.y3'], ['E', '=V.cx2', '=V.cy2', '=V.bd2', '=V.bd2', 0, '=A(V.bd2,V.bd2,V._3cd4)', '=A(V.bd2,V.bd2,(V._3cd4 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['L', '=V.th', h], ['Z'], {},
        ]],
    },
    uTurnArrow: {
        variables: {
            adj1: 25000,
            adj2: 25000,
            adj3: 25000,
            adj4: 43750,
            adj5: 75000,
            a2: '=MIN(MAX(0, V.adj2), 25000)',
            maxAdj1: '=V.a2 * 2',
            a1: '=MIN(MAX(0, V.adj1), V.maxAdj1)',
            ss: s,
            q2: '=V.a1 * V.ss / height',
            q3: '=100000 - V.q2',
            maxAdj3: '=V.q3 * height / V.ss',
            a3: '=MIN(MAX(0, V.adj3), V.maxAdj3)',
            q1: '=V.a3 + V.a1',
            minAdj5: '=V.q1 * V.ss / height',
            a5: '=MIN(MAX(V.minAdj5, V.adj5), 100000)',
            th: '=V.ss * V.a1 / 100000',
            aw2: '=V.ss * V.a2 / 100000',
            th2: '=V.th / 2',
            dh2: '=V.aw2 - V.th2',
            y5: '=height * V.a5 / 100000',
            ah: '=V.ss * V.a3 / 100000',
            y4: '=V.y5 - V.ah',
            r: w,
            x9: '=width - V.dh2',
            bw: '=V.x9 / 2',
            bs: '=MIN(V.bw, V.y4)',
            maxAdj4: '=V.bs * 100000 / V.ss',
            a4: '=MIN(MAX(0, V.adj4), V.maxAdj4)',
            bd: '=V.ss * V.a4 / 100000',
            bd3: '=V.bd - V.th',
            bd2: '=MAX(V.bd3, 0)',
            x3: '=V.th + V.bd2',
            x8: '=width - V.aw2',
            x6: '=V.x8 - V.aw2',
            x7: '=V.x6 + V.dh2',
            x4: '=V.x9 - V.bd',
            x5: '=V.x7 - V.bd2',
            cx: '=(V.th + V.x7) / 2',
            t: 0,
            b: h,
            l: 0,
            cd2: B,
            cd4: C,
            cx1: '=C(V.bd,V.l,A(V.bd,V.bd,V.cd2),true)',
            cy1: '=C(V.bd,V.bd,A(V.bd,V.bd,V.cd2))',
            _3cd4: D,
            cx2: '=C(V.bd,V.x4,A(V.bd,V.bd,V._3cd4),true)',
            cy2: '=C(V.bd,V.t,A(V.bd,V.bd,V._3cd4))',
            cx3: '=C(V.bd2,V.x7,A(V.bd2,V.bd2,0),true)',
            cy3: '=C(V.bd2,V.x3,A(V.bd2,V.bd2,0))',
            cx4: '=C(V.bd2,V.x3,A(V.bd2,V.bd2,V._3cd4),true)',
            cy4: '=C(V.bd2,V.th,A(V.bd2,V.bd2,V._3cd4))',
        },
        adjustInfo: [['adj1', 25000], ['adj2', 25000], ['adj3', 25000], ['adj4', 43750], ['adj5', 75000]],
        connectionPoints: [{
            x: '=V.x6',
            y: '=V.y4',
        }, {
            x: '=V.x8',
            y: '=V.y5',
        }, {
            x: w,
            y: '=V.y4',
        }, {
            x: '=V.cx',
            y: 0,
        }, {
            x: '=V.th2',
            y: h,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj1',
            minX: 0,
            maxX: 'maxAdj1',
            position: {
                x: 'th',
                y: 'b',
            },
            point: ['=V.th', h],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: 0,
            maxX: 25000,
            position: {
                x: 'x6',
                y: 'b',
            },
            point: ['=V.x6', h],
        }, {
            type: 'ahXY',
            gdRefY: 'adj3',
            minY: 0,
            maxY: 'maxAdj3',
            position: {
                x: 'x6',
                y: 'y4',
            },
            point: ['=V.x6', '=V.y4'],
        }, {
            type: 'ahXY',
            gdRefX: 'adj4',
            minX: 0,
            maxX: 'maxAdj4',
            position: {
                x: 'bd',
                y: 't',
            },
            point: ['=V.bd', 0],
        }, {
            type: 'ahXY',
            gdRefY: 'adj5',
            minY: 'minAdj5',
            maxY: 100000,
            position: {
                x: 'r',
                y: 'y5',
            },
            point: [w, '=V.y5'],
        },
        ],
        path: [[['M', 0, h], ['L', 0, '=V.bd'], ['E', '=V.cx1', '=V.cy1', '=V.bd', '=V.bd', 0, '=A(V.bd,V.bd,V.cd2)', '=A(V.bd,V.bd,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', '=V.x4', 0], ['E', '=V.cx2', '=V.cy2', '=V.bd', '=V.bd', 0, '=A(V.bd,V.bd,V._3cd4)', '=A(V.bd,V.bd,(V._3cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', '=V.x9', '=V.y4'], ['L', w, '=V.y4'], ['L', '=V.x8', '=V.y5'], ['L', '=V.x6', '=V.y4'], ['L', '=V.x7', '=V.y4'], ['L', '=V.x7', '=V.x3'], ['E', '=V.cx3', '=V.cy3', '=V.bd2', '=V.bd2', 0, '=A(V.bd2,V.bd2,0)', '=A(V.bd2,V.bd2,(-5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['L', '=V.x3', '=V.th'], ['E', '=V.cx4', '=V.cy4', '=V.bd2', '=V.bd2', 0, '=A(V.bd2,V.bd2,V._3cd4)', '=A(V.bd2,V.bd2,(V._3cd4 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['L', '=V.th', h], ['Z'], {},
        ]],
    },
    leftUpArrow: {
        variables: {
            adj1: 25000,
            adj2: 25000,
            adj3: 25000,
            a2: '=MIN(MAX(0, V.adj2), 50000)',
            maxAdj1: '=V.a2 * 2',
            a1: '=MIN(MAX(0, V.adj1), V.maxAdj1)',
            maxAdj3: '=100000 - V.maxAdj1',
            a3: '=MIN(MAX(0, V.adj3), V.maxAdj3)',
            ss: s,
            x1: '=V.ss * V.a3 / 100000',
            dx2: '=V.ss * V.a2 / 50000',
            r: w,
            x2: '=width - V.dx2',
            b: h,
            y2: '=height - V.dx2',
            dx4: '=V.ss * V.a2 / 100000',
            x4: '=width - V.dx4',
            y4: '=height - V.dx4',
            dx3: '=V.ss * V.a1 / 200000',
            x3: '=V.x4 - V.dx3',
            x5: '=V.x4 + V.dx3',
            y3: '=V.y4 - V.dx3',
            y5: '=V.y4 + V.dx3',
            il: '=V.dx3 * V.x1 / V.dx4',
            cx1: '=(V.x1 + V.x5) / 2',
            cy1: '=(V.x1 + V.y5) / 2',
            t: 0,
            l: 0,
        },
        adjustInfo: [['adj1', 25000], ['adj2', 25000], ['adj3', 25000]],
        connectionPoints: [{
            x: '=V.x4',
            y: 0,
        }, {
            x: d,
            y: c,
        }, {
            x: c,
            y: f,
        }, {
            x: 0,
            y: '=V.y4',
        }, {
            x: c,
            y: h,
        }, {
            x: '=V.cx1',
            y: '=V.y5',
        }, {
            x: '=V.x5',
            y: '=V.cy1',
        }, {
            x: w,
            y: c,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj1',
            minY: 0,
            maxY: 'maxAdj1',
            position: {
                x: 'x3',
                y: 'y3',
            },
            point: ['=V.x3', '=V.y3'],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: 0,
            maxX: 50000,
            position: {
                x: 'x2',
                y: 't',
            },
            point: [d, 0],
        }, {
            type: 'ahXY',
            gdRefY: 'adj3',
            minY: 0,
            maxY: 'maxAdj3',
            position: {
                x: 'x3',
                y: 'x1',
            },
            point: ['=V.x3', c],
        },
        ],
        path: [[['M', 0, '=V.y4'], ['L', c, f], ['L', c, '=V.y3'], ['L', '=V.x3', '=V.y3'], ['L', '=V.x3', c], ['L', d, c], ['L', '=V.x4', 0], ['L', w, c], ['L', '=V.x5', c], ['L', '=V.x5', '=V.y5'], ['L', c, '=V.y5'], ['L', c, h], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.y3',
            right: '=V.x4',
            bottom: '=V.y5',
        },
    },
    bentUpArrow: {
        variables: {
            adj1: 25000,
            adj2: 25000,
            adj3: 25000,
            a1: '=MIN(MAX(0, V.adj1), 50000)',
            a2: '=MIN(MAX(0, V.adj2), 50000)',
            a3: '=MIN(MAX(0, V.adj3), 50000)',
            ss: s,
            y1: '=V.ss * V.a3 / 100000',
            dx1: '=V.ss * V.a2 / 50000',
            r: w,
            x1: '=width - V.dx1',
            dx3: '=V.ss * V.a2 / 100000',
            x3: '=width - V.dx3',
            dx2: '=V.ss * V.a1 / 200000',
            x2: '=V.x3 - V.dx2',
            x4: '=V.x3 + V.dx2',
            dy2: '=V.ss * V.a1 / 100000',
            b: h,
            y2: '=height - V.dy2',
            x0: '=V.x4 / 2',
            y3: '=(V.y2 + V.b) / 2',
            y15: '=(V.y1 + V.b) / 2',
            t: 0,
            l: 0,
        },
        adjustInfo: [['adj1', 25000], ['adj2', 25000], ['adj3', 25000]],
        connectionPoints: [{
            x: '=V.x3',
            y: 0,
        }, {
            x: c,
            y: e,
        }, {
            x: 0,
            y: '=V.y3',
        }, {
            x: '=V.x0',
            y: h,
        }, {
            x: '=V.x4',
            y: '=V.y15',
        }, {
            x: w,
            y: e,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj1',
            minY: 0,
            maxY: 50000,
            position: {
                x: 'l',
                y: 'y2',
            },
            point: [0, f],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: 0,
            maxX: 50000,
            position: {
                x: 'x1',
                y: 't',
            },
            point: [c, 0],
        }, {
            type: 'ahXY',
            gdRefY: 'adj3',
            minY: 0,
            maxY: 50000,
            position: {
                x: 'x2',
                y: 'y1',
            },
            point: [d, e],
        },
        ],
        path: [[['M', 0, f], ['L', d, f], ['L', d, e], ['L', c, e], ['L', '=V.x3', 0], ['L', w, e], ['L', '=V.x4', e], ['L', '=V.x4', h], ['L', 0, h], ['Z'], {},
        ]],
        textRect: {
            left: 0,
            top: f,
            right: '=V.x4',
            bottom: h,
        },
    },
    curvedRightArrow: {
        variables: {
            adj1: 25000,
            adj2: 50000,
            adj3: 25000,
            ss: s,
            maxAdj2: '=50000 * height / V.ss',
            a2: '=MIN(MAX(0, V.adj2), V.maxAdj2)',
            a1: '=MIN(MAX(0, V.adj1), V.a2)',
            th: '=V.ss * V.a1 / 100000',
            aw: '=V.ss * V.a2 / 100000',
            q1: '=(V.th + V.aw) / 4',
            hd2: F,
            hR: '=V.hd2 - V.q1',
            q7: '=V.hR * 2',
            q8: '=V.q7 * V.q7',
            q9: '=V.th * V.th',
            q10: '=V.q8 - V.q9',
            q11: '=SQRT(V.q10)',
            idx: '=V.q11 * width / V.q7',
            maxAdj3: '=100000 * V.idx / V.ss',
            a3: '=MIN(MAX(0, V.adj3), V.maxAdj3)',
            ah: '=V.ss * V.a3 / 100000',
            y3: '=V.hR + V.th',
            q2: '=width * width',
            q3: '=V.ah * V.ah',
            q4: '=V.q2 - V.q3',
            q5: '=SQRT(V.q4)',
            dy: '=V.q5 * V.hR / width',
            y5: '=V.hR + V.dy',
            y7: '=V.y3 + V.dy',
            q6: '=V.aw - V.th',
            dh: '=V.q6 / 2',
            y4: '=V.y5 - V.dh',
            y8: '=V.y7 + V.dh',
            aw2: '=V.aw / 2',
            b: h,
            y6: '=height - V.aw2',
            r: w,
            x1: '=width - V.ah',
            d2r: A,
            swAng: '=(ATAN2(V.ah,V.dy) * V.d2r)',
            cd2: B,
            stAng: '=V.cd2 - V.swAng',
            mswAng: '=0 - V.swAng',
            ix: '=width - V.idx',
            iy: '=(V.hR + V.y3) / 2',
            q12: '=V.th / 2',
            dang2: '=(ATAN2(V.idx,V.q12) * V.d2r)',
            cd4: C,
            swAng2: '=V.dang2 - V.cd4',
            swAng3: '=V.cd4 + V.dang2',
            stAng3: '=V.cd2 - V.dang2',
            l: 0,
            cx1: '=C(width,V.l,A(width,V.hR,V.cd2),true)',
            cy1: '=C(V.hR,V.hR,A(width,V.hR,V.cd2))',
            cx2: '=C(width,V.x1,A(width,V.hR,V.stAng),true)',
            cy2: '=C(V.hR,V.y7,A(width,V.hR,V.stAng))',
            _3cd4: D,
            cx3: '=C(width,V.r,A(width,V.hR,V._3cd4),true)',
            cy3: '=C(V.hR,V.th,A(width,V.hR,V._3cd4))',
            cx4: '=C(width,P(V.cx3,width,A(width,V.hR,(V._3cd4 + V.swAng2)),true),A(width,V.hR,V.stAng3),true)',
            cy4: '=C(V.hR,P(V.cy3,V.hR,A(width,V.hR,(V._3cd4 + V.swAng2))),A(width,V.hR,V.stAng3))',
            cx5: '=C(width,V.l,A(width,V.hR,V.cd2),true)',
            cy5: '=C(V.hR,V.hR,A(width,V.hR,V.cd2))',
            cx6: '=C(width,V.x1,A(width,V.hR,V.stAng),true)',
            cy6: '=C(V.hR,V.y7,A(width,V.hR,V.stAng))',
            cx7: '=C(width,V.l,A(width,V.hR,V.cd2),true)',
            cy7: '=C(V.hR,V.hR,A(width,V.hR,V.cd2))',
            cx8: '=C(width,V.r,A(width,V.hR,V._3cd4),true)',
            cy8: '=C(V.hR,V.th,A(width,V.hR,V._3cd4))',
        },
        adjustInfo: [['adj1', 25000], ['adj2', 50000], ['adj3', 25000]],
        connectionPoints: [{
            x: 0,
            y: '=V.iy',
        }, {
            x: c,
            y: '=V.y8',
        }, {
            x: w,
            y: '=V.y6',
        }, {
            x: c,
            y: '=V.y4',
        }, {
            x: w,
            y: '=V.q12',
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj1',
            minY: 0,
            maxY: 'a2',
            position: {
                x: 'x1',
                y: 'y5',
            },
            point: [c, '=V.y5'],
        }, {
            type: 'ahXY',
            gdRefY: 'adj2',
            minY: 0,
            maxY: 'maxAdj2',
            position: {
                x: 'r',
                y: 'y4',
            },
            point: [w, '=V.y4'],
        }, {
            type: 'ahXY',
            gdRefX: 'adj3',
            minX: 0,
            maxX: 'maxAdj3',
            position: {
                x: 'x1',
                y: 'b',
            },
            point: [c, h],
        },
        ],
        path: [[['M', 0, '=V.hR'], ['E', '=V.cx1', '=V.cy1', w, '=V.hR', 0, '=A(width,V.hR,V.cd2)', '=A(width,V.hR,(V.cd2 + V.mswAng))', '=IF(V.mswAng > 0, FALSE, TRUE)'], ['L', c, '=V.y4'], ['L', w, '=V.y6'], ['L', c, '=V.y8'], ['L', c, '=V.y7'], ['E', '=V.cx2', '=V.cy2', w, '=V.hR', 0, '=A(width,V.hR,V.stAng)', '=A(width,V.hR,(V.stAng + V.swAng))', '=IF(V.swAng > 0, FALSE, TRUE)'], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', w, '=V.th'], ['E', '=V.cx3', '=V.cy3', w, '=V.hR', 0, '=A(width,V.hR,V._3cd4)', '=A(width,V.hR,(V._3cd4 + V.swAng2))', '=IF(V.swAng2 > 0, FALSE, TRUE)'], ['E', '=V.cx4', '=V.cy4', w, '=V.hR', 0, '=A(width,V.hR,V.stAng3)', '=A(width,V.hR,(V.stAng3 + V.swAng3))', '=IF(V.swAng3 > 0, FALSE, TRUE)'], ['Z'], {
            fillMode: 'darkenLess',
            strokeMode: 'false',
        },
        ], [['M', 0, '=V.hR'], ['E', '=V.cx5', '=V.cy5', w, '=V.hR', 0, '=A(width,V.hR,V.cd2)', '=A(width,V.hR,(V.cd2 + V.mswAng))', '=IF(V.mswAng > 0, FALSE, TRUE)'], ['L', c, '=V.y4'], ['L', w, '=V.y6'], ['L', c, '=V.y8'], ['L', c, '=V.y7'], ['E', '=V.cx6', '=V.cy6', w, '=V.hR', 0, '=A(width,V.hR,V.stAng)', '=A(width,V.hR,(V.stAng + V.swAng))', '=IF(V.swAng > 0, FALSE, TRUE)'], ['L', 0, '=V.hR'], ['E', '=V.cx7', '=V.cy7', w, '=V.hR', 0, '=A(width,V.hR,V.cd2)', '=A(width,V.hR,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', w, '=V.th'], ['E', '=V.cx8', '=V.cy8', w, '=V.hR', 0, '=A(width,V.hR,V._3cd4)', '=A(width,V.hR,(V._3cd4 + V.swAng2))', '=IF(V.swAng2 > 0, FALSE, TRUE)'], {
            fillMode: 'none',
        },
        ]],
    },
    curvedLeftArrow: {
        variables: {
            adj1: 25000,
            adj2: 50000,
            adj3: 25000,
            ss: s,
            maxAdj2: '=50000 * height / V.ss',
            a2: '=MIN(MAX(0, V.adj2), V.maxAdj2)',
            a1: '=MIN(MAX(0, V.adj1), V.a2)',
            th: '=V.ss * V.a1 / 100000',
            aw: '=V.ss * V.a2 / 100000',
            q1: '=(V.th + V.aw) / 4',
            hd2: F,
            hR: '=V.hd2 - V.q1',
            q7: '=V.hR * 2',
            q8: '=V.q7 * V.q7',
            q9: '=V.th * V.th',
            q10: '=V.q8 - V.q9',
            q11: '=SQRT(V.q10)',
            idx: '=V.q11 * width / V.q7',
            maxAdj3: '=100000 * V.idx / V.ss',
            a3: '=MIN(MAX(0, V.adj3), V.maxAdj3)',
            ah: '=V.ss * V.a3 / 100000',
            y3: '=V.hR + V.th',
            q2: '=width * width',
            q3: '=V.ah * V.ah',
            q4: '=V.q2 - V.q3',
            q5: '=SQRT(V.q4)',
            dy: '=V.q5 * V.hR / width',
            y5: '=V.hR + V.dy',
            y7: '=V.y3 + V.dy',
            q6: '=V.aw - V.th',
            dh: '=V.q6 / 2',
            y4: '=V.y5 - V.dh',
            y8: '=V.y7 + V.dh',
            aw2: '=V.aw / 2',
            b: h,
            y6: '=height - V.aw2',
            l: 0,
            x1: '=V.ah',
            d2r: A,
            swAng: '=(ATAN2(V.ah,V.dy) * V.d2r)',
            mswAng: '=0 - V.swAng',
            ix: '=V.idx',
            iy: '=(V.hR + V.y3) / 2',
            q12: '=V.th / 2',
            dang2: '=(ATAN2(V.idx,V.q12) * V.d2r)',
            swAng2: '=V.dang2 - V.swAng',
            swAng3: '=V.swAng + V.dang2',
            stAng3: '=0 - V.dang2',
            r: w,
            cx1: '=C(width,V.x1,A(width,V.hR,V.swAng),true)',
            cy1: '=C(V.hR,V.y5,A(width,V.hR,V.swAng))',
            cx2: '=C(width,P(V.cx1,width,A(width,V.hR,(V.swAng + V.swAng2)),true),A(width,V.hR,V.stAng3),true)',
            cy2: '=C(V.hR,P(V.cy1,V.hR,A(width,V.hR,(V.swAng + V.swAng2))),A(width,V.hR,V.stAng3))',
            cx3: '=C(width,V.r,A(width,V.hR,0),true)',
            cy3: '=C(V.hR,V.y3,A(width,V.hR,0))',
            t: 0,
            _3cd4: D,
            cd4: C,
            cx4: '=C(width,V.l,A(width,V.hR,V._3cd4),true)',
            cy4: '=C(V.hR,V.t,A(width,V.hR,V._3cd4))',
            cx5: '=C(width,V.r,A(width,V.hR,0),true)',
            cy5: '=C(V.hR,V.y3,A(width,V.hR,0))',
            cx6: '=C(width,V.l,A(width,V.hR,V._3cd4),true)',
            cy6: '=C(V.hR,V.t,A(width,V.hR,V._3cd4))',
            cx7: '=C(width,V.r,A(width,V.hR,0),true)',
            cy7: '=C(V.hR,V.y3,A(width,V.hR,0))',
            cx8: '=C(width,V.x1,A(width,V.hR,V.swAng),true)',
            cy8: '=C(V.hR,V.y5,A(width,V.hR,V.swAng))',
        },
        adjustInfo: [['adj1', 25000], ['adj2', 50000], ['adj3', 25000]],
        connectionPoints: [{
            x: 0,
            y: '=V.q12',
        }, {
            x: c,
            y: '=V.y4',
        }, {
            x: 0,
            y: '=V.y6',
        }, {
            x: c,
            y: '=V.y8',
        }, {
            x: w,
            y: '=V.iy',
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj1',
            minY: 0,
            maxY: 'a2',
            position: {
                x: 'x1',
                y: 'y5',
            },
            point: [c, '=V.y5'],
        }, {
            type: 'ahXY',
            gdRefY: 'adj2',
            minY: 0,
            maxY: 'maxAdj2',
            position: {
                x: 'r',
                y: 'y4',
            },
            point: [w, '=V.y4'],
        }, {
            type: 'ahXY',
            gdRefX: 'adj3',
            minX: 0,
            maxX: 'maxAdj3',
            position: {
                x: 'x1',
                y: 'b',
            },
            point: [c, h],
        },
        ],
        path: [[['M', 0, '=V.y6'], ['L', c, '=V.y4'], ['L', c, '=V.y5'], ['E', '=V.cx1', '=V.cy1', w, '=V.hR', 0, '=A(width,V.hR,V.swAng)', '=A(width,V.hR,(V.swAng + V.swAng2))', '=IF(V.swAng2 > 0, FALSE, TRUE)'], ['E', '=V.cx2', '=V.cy2', w, '=V.hR', 0, '=A(width,V.hR,V.stAng3)', '=A(width,V.hR,(V.stAng3 + V.swAng3))', '=IF(V.swAng3 > 0, FALSE, TRUE)'], ['L', c, '=V.y8'], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', w, '=V.y3'], ['E', '=V.cx3', '=V.cy3', w, '=V.hR', 0, '=A(width,V.hR,0)', '=A(width,V.hR,(-5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['L', 0, 0], ['E', '=V.cx4', '=V.cy4', w, '=V.hR', 0, '=A(width,V.hR,V._3cd4)', '=A(width,V.hR,(V._3cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['Z'], {
            fillMode: 'darkenLess',
            strokeMode: 'false',
        },
        ], [['M', w, '=V.y3'], ['E', '=V.cx5', '=V.cy5', w, '=V.hR', 0, '=A(width,V.hR,0)', '=A(width,V.hR,(-5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['L', 0, 0], ['E', '=V.cx6', '=V.cy6', w, '=V.hR', 0, '=A(width,V.hR,V._3cd4)', '=A(width,V.hR,(V._3cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', w, '=V.y3'], ['E', '=V.cx7', '=V.cy7', w, '=V.hR', 0, '=A(width,V.hR,0)', '=A(width,V.hR,(V.swAng))', '=IF(V.swAng > 0, FALSE, TRUE)'], ['L', c, '=V.y8'], ['L', 0, '=V.y6'], ['L', c, '=V.y4'], ['L', c, '=V.y5'], ['E', '=V.cx8', '=V.cy8', w, '=V.hR', 0, '=A(width,V.hR,V.swAng)', '=A(width,V.hR,(V.swAng + V.swAng2))', '=IF(V.swAng2 > 0, FALSE, TRUE)'], {
            fillMode: 'none',
        },
        ]],
    },
    curvedUpArrow: {
        variables: {
            adj1: 25000,
            adj2: 50000,
            adj3: 25000,
            ss: s,
            maxAdj2: '=50000 * width / V.ss',
            a2: '=MIN(MAX(0, V.adj2), V.maxAdj2)',
            a1: '=MIN(MAX(0, V.adj1), 100000)',
            th: '=V.ss * V.a1 / 100000',
            aw: '=V.ss * V.a2 / 100000',
            q1: '=(V.th + V.aw) / 4',
            wd2: E,
            wR: '=V.wd2 - V.q1',
            q7: '=V.wR * 2',
            q8: '=V.q7 * V.q7',
            q9: '=V.th * V.th',
            q10: '=V.q8 - V.q9',
            q11: '=SQRT(V.q10)',
            idy: '=V.q11 * height / V.q7',
            maxAdj3: '=100000 * V.idy / V.ss',
            a3: '=MIN(MAX(0, V.adj3), V.maxAdj3)',
            ah: '=V.ss * V.adj3 / 100000',
            x3: '=V.wR + V.th',
            q2: '=height * height',
            q3: '=V.ah * V.ah',
            q4: '=V.q2 - V.q3',
            q5: '=SQRT(V.q4)',
            dx: '=V.q5 * V.wR / height',
            x5: '=V.wR + V.dx',
            x7: '=V.x3 + V.dx',
            q6: '=V.aw - V.th',
            dh: '=V.q6 / 2',
            x4: '=V.x5 - V.dh',
            x8: '=V.x7 + V.dh',
            aw2: '=V.aw / 2',
            r: w,
            x6: '=width - V.aw2',
            t: 0,
            y1: '=V.ah',
            d2r: A,
            swAng: '=(ATAN2(V.ah,V.dx) * V.d2r)',
            mswAng: '=0 - V.swAng',
            iy: '=V.idy',
            ix: '=(V.wR + V.x3) / 2',
            q12: '=V.th / 2',
            dang2: '=(ATAN2(V.idy,V.q12) * V.d2r)',
            swAng2: '=V.dang2 - V.swAng',
            mswAng2: '=0 - V.swAng2',
            cd4: C,
            stAng3: '=V.cd4 - V.swAng',
            swAng3: '=V.swAng + V.dang2',
            stAng2: '=V.cd4 - V.dang2',
            b: h,
            cx1: '=C(V.wR,V.x7,A(V.wR,height,V.stAng3),true)',
            cy1: '=C(height,V.y1,A(V.wR,height,V.stAng3))',
            cx2: '=C(V.wR,P(V.cx1,V.wR,A(V.wR,height,(V.stAng3 + V.swAng3)),true),A(V.wR,height,V.stAng2),true)',
            cy2: '=C(height,P(V.cy1,height,A(V.wR,height,(V.stAng3 + V.swAng3))),A(V.wR,height,V.stAng2))',
            cx3: '=C(V.wR,V.wR,A(V.wR,height,V.cd4),true)',
            cy3: '=C(height,V.b,A(V.wR,height,V.cd4))',
            cd2: B,
            cx4: '=C(V.wR,V.th,A(V.wR,height,V.cd2),true)',
            cy4: '=C(height,V.t,A(V.wR,height,V.cd2))',
            cx5: '=C(V.wR,V.ix,A(V.wR,height,V.stAng2),true)',
            cy5: '=C(height,V.iy,A(V.wR,height,V.stAng2))',
            cx6: '=C(V.wR,V.x7,A(V.wR,height,V.stAng3),true)',
            cy6: '=C(height,V.y1,A(V.wR,height,V.stAng3))',
            cx7: '=C(V.wR,V.wR,A(V.wR,height,V.cd4),true)',
            cy7: '=C(height,V.b,A(V.wR,height,V.cd4))',
            cx8: '=C(V.wR,V.th,A(V.wR,height,V.cd2),true)',
            cy8: '=C(height,V.t,A(V.wR,height,V.cd2))',
        },
        adjustInfo: [['adj1', 25000], ['adj2', 50000], ['adj3', 25000]],
        connectionPoints: [{
            x: '=V.x6',
            y: 0,
        }, {
            x: '=V.x4',
            y: e,
        }, {
            x: '=V.q12',
            y: 0,
        }, {
            x: '=V.ix',
            y: h,
        }, {
            x: '=V.x8',
            y: e,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj1',
            minX: 0,
            maxX: 'a2',
            position: {
                x: 'x7',
                y: 'y1',
            },
            point: ['=V.x7', e],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: 0,
            maxX: 'maxAdj2',
            position: {
                x: 'x4',
                y: 't',
            },
            point: ['=V.x4', 0],
        }, {
            type: 'ahXY',
            gdRefY: 'adj3',
            minY: 0,
            maxY: 'maxAdj3',
            position: {
                x: 'r',
                y: 'y1',
            },
            point: [w, e],
        },
        ],
        path: [[['M', '=V.x6', 0], ['L', '=V.x8', e], ['L', '=V.x7', e], ['E', '=V.cx1', '=V.cy1', '=V.wR', h, 0, '=A(V.wR,height,V.stAng3)', '=A(V.wR,height,(V.stAng3 + V.swAng3))', '=IF(V.swAng3 > 0, FALSE, TRUE)'], ['E', '=V.cx2', '=V.cy2', '=V.wR', h, 0, '=A(V.wR,height,V.stAng2)', '=A(V.wR,height,(V.stAng2 + V.swAng2))', '=IF(V.swAng2 > 0, FALSE, TRUE)'], ['L', '=V.x4', e], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', '=V.wR', h], ['E', '=V.cx3', '=V.cy3', '=V.wR', h, 0, '=A(V.wR,height,V.cd4)', '=A(V.wR,height,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', '=V.th', 0], ['E', '=V.cx4', '=V.cy4', '=V.wR', h, 0, '=A(V.wR,height,V.cd2)', '=A(V.wR,height,(V.cd2 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['Z'], {
            fillMode: 'darkenLess',
            strokeMode: 'false',
        },
        ], [['M', '=V.ix', '=V.iy'], ['E', '=V.cx5', '=V.cy5', '=V.wR', h, 0, '=A(V.wR,height,V.stAng2)', '=A(V.wR,height,(V.stAng2 + V.swAng2))', '=IF(V.swAng2 > 0, FALSE, TRUE)'], ['L', '=V.x4', e], ['L', '=V.x6', 0], ['L', '=V.x8', e], ['L', '=V.x7', e], ['E', '=V.cx6', '=V.cy6', '=V.wR', h, 0, '=A(V.wR,height,V.stAng3)', '=A(V.wR,height,(V.stAng3 + V.swAng))', '=IF(V.swAng > 0, FALSE, TRUE)'], ['L', '=V.wR', h], ['E', '=V.cx7', '=V.cy7', '=V.wR', h, 0, '=A(V.wR,height,V.cd4)', '=A(V.wR,height,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', '=V.th', 0], ['E', '=V.cx8', '=V.cy8', '=V.wR', h, 0, '=A(V.wR,height,V.cd2)', '=A(V.wR,height,(V.cd2 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], {
            fillMode: 'none',
        },
        ]],
    },
    curvedDownArrow: {
        variables: {
            adj1: 25000,
            adj2: 50000,
            adj3: 25000,
            ss: s,
            maxAdj2: '=50000 * width / V.ss',
            a2: '=MIN(MAX(0, V.adj2), V.maxAdj2)',
            a1: '=MIN(MAX(0, V.adj1), 100000)',
            th: '=V.ss * V.a1 / 100000',
            aw: '=V.ss * V.a2 / 100000',
            q1: '=(V.th + V.aw) / 4',
            wd2: E,
            wR: '=V.wd2 - V.q1',
            q7: '=V.wR * 2',
            q8: '=V.q7 * V.q7',
            q9: '=V.th * V.th',
            q10: '=V.q8 - V.q9',
            q11: '=SQRT(V.q10)',
            idy: '=V.q11 * height / V.q7',
            maxAdj3: '=100000 * V.idy / V.ss',
            a3: '=MIN(MAX(0, V.adj3), V.maxAdj3)',
            ah: '=V.ss * V.adj3 / 100000',
            x3: '=V.wR + V.th',
            q2: '=height * height',
            q3: '=V.ah * V.ah',
            q4: '=V.q2 - V.q3',
            q5: '=SQRT(V.q4)',
            dx: '=V.q5 * V.wR / height',
            x5: '=V.wR + V.dx',
            x7: '=V.x3 + V.dx',
            q6: '=V.aw - V.th',
            dh: '=V.q6 / 2',
            x4: '=V.x5 - V.dh',
            x8: '=V.x7 + V.dh',
            aw2: '=V.aw / 2',
            r: w,
            x6: '=width - V.aw2',
            b: h,
            y1: '=height - V.ah',
            d2r: A,
            swAng: '=(ATAN2(V.ah,V.dx) * V.d2r)',
            mswAng: '=0 - V.swAng',
            iy: '=height - V.idy',
            ix: '=(V.wR + V.x3) / 2',
            q12: '=V.th / 2',
            dang2: '=(ATAN2(V.idy,V.q12) * V.d2r)',
            _3cd4: D,
            stAng: '=V._3cd4 + V.swAng',
            stAng2: '=V._3cd4 - V.dang2',
            cd4: C,
            swAng2: '=V.dang2 - V.cd4',
            swAng3: '=V.cd4 + V.dang2',
            t: 0,
            cx1: '=C(V.wR,V.x5,A(V.wR,height,V.stAng),true)',
            cy1: '=C(height,V.y1,A(V.wR,height,V.stAng))',
            cx2: '=C(V.wR,V.x3,A(V.wR,height,V._3cd4),true)',
            cy2: '=C(height,V.t,A(V.wR,height,V._3cd4))',
            cx3: '=C(V.wR,V.ix,A(V.wR,height,V.stAng2),true)',
            cy3: '=C(height,V.iy,A(V.wR,height,V.stAng2))',
            l: 0,
            cd2: B,
            cx4: '=C(V.wR,V.l,A(V.wR,height,V.cd2),true)',
            cy4: '=C(height,V.b,A(V.wR,height,V.cd2))',
            cx5: '=C(V.wR,V.ix,A(V.wR,height,V.stAng2),true)',
            cy5: '=C(height,V.iy,A(V.wR,height,V.stAng2))',
            cx6: '=C(V.wR,V.l,A(V.wR,height,V.cd2),true)',
            cy6: '=C(height,V.b,A(V.wR,height,V.cd2))',
            cx7: '=C(V.wR,V.x3,A(V.wR,height,V._3cd4),true)',
            cy7: '=C(height,V.t,A(V.wR,height,V._3cd4))',
            cx8: '=C(V.wR,V.x5,A(V.wR,height,V.stAng),true)',
            cy8: '=C(height,V.y1,A(V.wR,height,V.stAng))',
        },
        adjustInfo: [['adj1', 25000], ['adj2', 50000], ['adj3', 25000]],
        connectionPoints: [{
            x: '=V.ix',
            y: 0,
        }, {
            x: '=V.q12',
            y: h,
        }, {
            x: '=V.x4',
            y: e,
        }, {
            x: '=V.x6',
            y: h,
        }, {
            x: '=V.x8',
            y: e,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj1',
            minX: 0,
            maxX: 'adj2',
            position: {
                x: 'x7',
                y: 'y1',
            },
            point: ['=V.x7', e],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: 0,
            maxX: 'maxAdj2',
            position: {
                x: 'x4',
                y: 'b',
            },
            point: ['=V.x4', h],
        }, {
            type: 'ahXY',
            gdRefY: 'adj3',
            minY: 0,
            maxY: 'maxAdj3',
            position: {
                x: 'r',
                y: 'y1',
            },
            point: [w, e],
        },
        ],
        path: [[['M', '=V.x6', h], ['L', '=V.x4', e], ['L', '=V.x5', e], ['E', '=V.cx1', '=V.cy1', '=V.wR', h, 0, '=A(V.wR,height,V.stAng)', '=A(V.wR,height,(V.stAng + V.mswAng))', '=IF(V.mswAng > 0, FALSE, TRUE)'], ['L', '=V.x3', 0], ['E', '=V.cx2', '=V.cy2', '=V.wR', h, 0, '=A(V.wR,height,V._3cd4)', '=A(V.wR,height,(V._3cd4 + V.swAng))', '=IF(V.swAng > 0, FALSE, TRUE)'], ['L', '=V.x8', e], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', '=V.ix', '=V.iy'], ['E', '=V.cx3', '=V.cy3', '=V.wR', h, 0, '=A(V.wR,height,V.stAng2)', '=A(V.wR,height,(V.stAng2 + V.swAng2))', '=IF(V.swAng2 > 0, FALSE, TRUE)'], ['L', 0, h], ['E', '=V.cx4', '=V.cy4', '=V.wR', h, 0, '=A(V.wR,height,V.cd2)', '=A(V.wR,height,(V.cd2 + V.swAng3))', '=IF(V.swAng3 > 0, FALSE, TRUE)'], ['Z'], {
            fillMode: 'darkenLess',
            strokeMode: 'false',
        },
        ], [['M', '=V.ix', '=V.iy'], ['E', '=V.cx5', '=V.cy5', '=V.wR', h, 0, '=A(V.wR,height,V.stAng2)', '=A(V.wR,height,(V.stAng2 + V.swAng2))', '=IF(V.swAng2 > 0, FALSE, TRUE)'], ['L', 0, h], ['E', '=V.cx6', '=V.cy6', '=V.wR', h, 0, '=A(V.wR,height,V.cd2)', '=A(V.wR,height,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', '=V.x3', 0], ['E', '=V.cx7', '=V.cy7', '=V.wR', h, 0, '=A(V.wR,height,V._3cd4)', '=A(V.wR,height,(V._3cd4 + V.swAng))', '=IF(V.swAng > 0, FALSE, TRUE)'], ['L', '=V.x8', e], ['L', '=V.x6', h], ['L', '=V.x4', e], ['L', '=V.x5', e], ['E', '=V.cx8', '=V.cy8', '=V.wR', h, 0, '=A(V.wR,height,V.stAng)', '=A(V.wR,height,(V.stAng + V.mswAng))', '=IF(V.mswAng > 0, FALSE, TRUE)'], {
            fillMode: 'none',
        },
        ]],
    },
    stripedRightArrow: {
        variables: {
            adj1: 50000,
            adj2: 50000,
            ss: s,
            maxAdj2: '=84375 * width / V.ss',
            a1: '=MIN(MAX(0, V.adj1), 100000)',
            a2: '=MIN(MAX(0, V.adj2), V.maxAdj2)',
            x4: '=V.ss * 5 / 32',
            dx5: '=V.ss * V.a2 / 100000',
            r: w,
            x5: '=width - V.dx5',
            dy1: '=height * V.a1 / 200000',
            vc: F,
            y1: '=V.vc - V.dy1',
            y2: '=V.vc + V.dy1',
            hd2: F,
            dx6: '=V.dy1 * V.dx5 / V.hd2',
            x6: '=width - V.dx6',
            t: 0,
            l: 0,
            b: h,
            ssd32: '=V.ss / 32',
            ssd16: '=V.ss / 16',
            ssd8: '=V.ss / 8',
        },
        adjustInfo: [['adj1', 50000], ['adj2', 50000]],
        connectionPoints: [{
            x: '=V.x5',
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: '=V.x5',
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj1',
            minY: 0,
            maxY: 100000,
            position: {
                x: 'l',
                y: 'y1',
            },
            point: [0, e],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: 0,
            maxX: 'maxAdj2',
            position: {
                x: 'x5',
                y: 't',
            },
            point: ['=V.x5', 0],
        },
        ],
        path: [[['M', 0, e], ['L', '=V.ssd32', e], ['L', '=V.ssd32', f], ['L', 0, f], ['Z'], ['M', '=V.ssd16', e], ['L', '=V.ssd8', e], ['L', '=V.ssd8', f], ['L', '=V.ssd16', f], ['Z'], ['M', '=V.x4', e], ['L', '=V.x5', e], ['L', '=V.x5', 0], ['L', w, b], ['L', '=V.x5', h], ['L', '=V.x5', f], ['L', '=V.x4', f], ['Z'], {},
        ]],
        textRect: {
            left: '=V.x4',
            top: e,
            right: '=V.x6',
            bottom: f,
        },
    },
    notchedRightArrow: {
        variables: {
            adj1: 50000,
            adj2: 50000,
            ss: s,
            maxAdj2: '=100000 * width / V.ss',
            a1: '=MIN(MAX(0, V.adj1), 100000)',
            a2: '=MIN(MAX(0, V.adj2), V.maxAdj2)',
            dx2: '=V.ss * V.a2 / 100000',
            r: w,
            x2: '=width - V.dx2',
            dy1: '=height * V.a1 / 200000',
            vc: F,
            y1: '=V.vc - V.dy1',
            y2: '=V.vc + V.dy1',
            hd2: F,
            x1: '=V.dy1 * V.dx2 / V.hd2',
            x3: '=width - V.x1',
            t: 0,
            b: h,
            l: 0,
        },
        adjustInfo: [['adj1', 50000], ['adj2', 50000]],
        connectionPoints: [{
            x: d,
            y: 0,
        }, {
            x: c,
            y: b,
        }, {
            x: d,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj1',
            minY: 0,
            maxY: 100000,
            position: {
                x: 'r',
                y: 'y1',
            },
            point: [w, e],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: 0,
            maxX: 'maxAdj2',
            position: {
                x: 'x2',
                y: 't',
            },
            point: [d, 0],
        },
        ],
        path: [[['M', 0, e], ['L', d, e], ['L', d, 0], ['L', w, b], ['L', d, h], ['L', d, f], ['L', 0, f], ['L', c, b], ['Z'], {},
        ]],
        textRect: {
            left: c,
            top: e,
            right: '=V.x3',
            bottom: f,
        },
    },
    pentagon: {
        variables: {
            adj: 50000,
            ss: s,
            maxAdj: '=100000 * width / V.ss',
            a: '=MIN(MAX(0, V.adj), V.maxAdj)',
            dx1: '=V.ss * V.a / 100000',
            r: w,
            x1: '=width - V.dx1',
            ir: '=(V.x1 + V.r) / 2',
            x2: '=V.x1 / 2',
            t: 0,
            l: 0,
            vc: F,
            b: h,
        },
        adjustInfo: [['adj', 50000]],
        connectionPoints: [{
            x: d,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: c,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj',
            minX: 0,
            maxX: 'maxAdj',
            position: {
                x: 'x1',
                y: 't',
            },
            point: [c, 0],
        },
        ],
        path: [[['M', 0, 0], ['L', c, 0], ['L', w, b], ['L', c, h], ['L', 0, h], ['Z'], {},
        ]],
        textRect: {
            left: 0,
            top: 0,
            right: '=V.ir',
            bottom: h,
        },
    },
    chevron: {
        variables: {
            adj: 50000,
            ss: s,
            maxAdj: '=100000 * width / V.ss',
            a: '=MIN(MAX(0, V.adj), V.maxAdj)',
            x1: '=V.ss * V.a / 100000',
            r: w,
            x2: '=width - V.x1',
            x3: '=V.x2 / 2',
            dx: '=V.x2 - V.x1',
            l: 0,
            il: '=IF(V.dx > 0, V.x1, V.l)',
            ir: '=IF(V.dx > 0, V.x2, V.r)',
            t: 0,
            vc: F,
            b: h,
        },
        adjustInfo: [['adj', 50000]],
        connectionPoints: [{
            x: '=V.x3',
            y: 0,
        }, {
            x: c,
            y: b,
        }, {
            x: '=V.x3',
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj',
            minX: 0,
            maxX: 'maxAdj',
            position: {
                x: 'x2',
                y: 't',
            },
            point: [d, 0],
        },
        ],
        path: [[['M', 0, 0], ['L', d, 0], ['L', w, b], ['L', d, h], ['L', 0, h], ['L', c, b], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: 0,
            right: '=V.ir',
            bottom: h,
        },
    },
    rightArrowCallout: {
        variables: {
            adj1: 25000,
            adj2: 25000,
            adj3: 25000,
            adj4: 64977,
            ss: s,
            maxAdj2: '=50000 * height / V.ss',
            a2: '=MIN(MAX(0, V.adj2), V.maxAdj2)',
            maxAdj1: '=V.a2 * 2',
            a1: '=MIN(MAX(0, V.adj1), V.maxAdj1)',
            maxAdj3: '=100000 * width / V.ss',
            a3: '=MIN(MAX(0, V.adj3), V.maxAdj3)',
            q2: '=V.a3 * V.ss / width',
            maxAdj4: '=100000 - V.q2',
            a4: '=MIN(MAX(0, V.adj4), V.maxAdj4)',
            dy1: '=V.ss * V.a2 / 100000',
            dy2: '=V.ss * V.a1 / 200000',
            vc: F,
            y1: '=V.vc - V.dy1',
            y2: '=V.vc - V.dy2',
            y3: '=V.vc + V.dy2',
            y4: '=V.vc + V.dy1',
            dx3: '=V.ss * V.a3 / 100000',
            r: w,
            x3: '=width - V.dx3',
            x2: '=width * V.a4 / 100000',
            x1: '=V.x2 / 2',
            t: 0,
            l: 0,
            b: h,
        },
        adjustInfo: [['adj1', 25000], ['adj2', 25000], ['adj3', 25000], ['adj4', 64977]],
        connectionPoints: [{
            x: c,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: c,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj1',
            minY: 0,
            maxY: 'maxAdj1',
            position: {
                x: 'x3',
                y: 'y2',
            },
            point: ['=V.x3', f],
        }, {
            type: 'ahXY',
            gdRefY: 'adj2',
            minY: 0,
            maxY: 'maxAdj2',
            position: {
                x: 'r',
                y: 'y1',
            },
            point: [w, e],
        }, {
            type: 'ahXY',
            gdRefX: 'adj3',
            minX: 0,
            maxX: 'maxAdj3',
            position: {
                x: 'x3',
                y: 't',
            },
            point: ['=V.x3', 0],
        }, {
            type: 'ahXY',
            gdRefX: 'adj4',
            minX: 0,
            maxX: 'maxAdj4',
            position: {
                x: 'x2',
                y: 'b',
            },
            point: [d, h],
        },
        ],
        path: [[['M', 0, 0], ['L', d, 0], ['L', d, f], ['L', '=V.x3', f], ['L', '=V.x3', e], ['L', w, b], ['L', '=V.x3', '=V.y4'], ['L', '=V.x3', '=V.y3'], ['L', d, '=V.y3'], ['L', d, h], ['L', 0, h], ['Z'], {},
        ]],
        textRect: {
            left: 0,
            top: 0,
            right: d,
            bottom: h,
        },
    },
    leftArrowCallout: {
        variables: {
            adj1: 25000,
            adj2: 25000,
            adj3: 25000,
            adj4: 64977,
            ss: s,
            maxAdj2: '=50000 * height / V.ss',
            a2: '=MIN(MAX(0, V.adj2), V.maxAdj2)',
            maxAdj1: '=V.a2 * 2',
            a1: '=MIN(MAX(0, V.adj1), V.maxAdj1)',
            maxAdj3: '=100000 * width / V.ss',
            a3: '=MIN(MAX(0, V.adj3), V.maxAdj3)',
            q2: '=V.a3 * V.ss / width',
            maxAdj4: '=100000 - V.q2',
            a4: '=MIN(MAX(0, V.adj4), V.maxAdj4)',
            dy1: '=V.ss * V.a2 / 100000',
            dy2: '=V.ss * V.a1 / 200000',
            vc: F,
            y1: '=V.vc - V.dy1',
            y2: '=V.vc - V.dy2',
            y3: '=V.vc + V.dy2',
            y4: '=V.vc + V.dy1',
            x1: '=V.ss * V.a3 / 100000',
            dx2: '=width * V.a4 / 100000',
            r: w,
            x2: '=width - V.dx2',
            x3: '=(V.x2 + V.r) / 2',
            t: 0,
            l: 0,
            b: h,
        },
        adjustInfo: [['adj1', 25000], ['adj2', 25000], ['adj3', 25000], ['adj4', 64977]],
        connectionPoints: [{
            x: '=V.x3',
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: '=V.x3',
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj1',
            minY: 0,
            maxY: 'maxAdj1',
            position: {
                x: 'x1',
                y: 'y2',
            },
            point: [c, f],
        }, {
            type: 'ahXY',
            gdRefY: 'adj2',
            minY: 0,
            maxY: 'maxAdj2',
            position: {
                x: 'l',
                y: 'y1',
            },
            point: [0, e],
        }, {
            type: 'ahXY',
            gdRefX: 'adj3',
            minX: 0,
            maxX: 'maxAdj3',
            position: {
                x: 'x1',
                y: 't',
            },
            point: [c, 0],
        }, {
            type: 'ahXY',
            gdRefX: 'adj4',
            minX: 0,
            maxX: 'maxAdj4',
            position: {
                x: 'x2',
                y: 'b',
            },
            point: [d, h],
        },
        ],
        path: [[['M', 0, b], ['L', c, e], ['L', c, f], ['L', d, f], ['L', d, 0], ['L', w, 0], ['L', w, h], ['L', d, h], ['L', d, '=V.y3'], ['L', c, '=V.y3'], ['L', c, '=V.y4'], ['Z'], {},
        ]],
        textRect: {
            left: d,
            top: 0,
            right: w,
            bottom: h,
        },
    },
    upArrowCallout: {
        variables: {
            adj1: 25000,
            adj2: 25000,
            adj3: 25000,
            adj4: 64977,
            ss: s,
            maxAdj2: '=50000 * width / V.ss',
            a2: '=MIN(MAX(0, V.adj2), V.maxAdj2)',
            maxAdj1: '=V.a2 * 2',
            a1: '=MIN(MAX(0, V.adj1), V.maxAdj1)',
            maxAdj3: '=100000 * height / V.ss',
            a3: '=MIN(MAX(0, V.adj3), V.maxAdj3)',
            q2: '=V.a3 * V.ss / height',
            maxAdj4: '=100000 - V.q2',
            a4: '=MIN(MAX(0, V.adj4), V.maxAdj4)',
            dx1: '=V.ss * V.a2 / 100000',
            dx2: '=V.ss * V.a1 / 200000',
            hc: E,
            x1: '=V.hc - V.dx1',
            x2: '=V.hc - V.dx2',
            x3: '=V.hc + V.dx2',
            x4: '=V.hc + V.dx1',
            y1: '=V.ss * V.a3 / 100000',
            dy2: '=height * V.a4 / 100000',
            b: h,
            y2: '=height - V.dy2',
            y3: '=(V.y2 + V.b) / 2',
            t: 0,
            l: 0,
            r: w,
        },
        adjustInfo: [['adj1', 25000], ['adj2', 25000], ['adj3', 25000], ['adj4', 64977]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: f,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: f,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj1',
            minX: 0,
            maxX: 'maxAdj1',
            position: {
                x: 'x2',
                y: 'y1',
            },
            point: [d, e],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: 0,
            maxX: 'maxAdj2',
            position: {
                x: 'x1',
                y: 't',
            },
            point: [c, 0],
        }, {
            type: 'ahXY',
            gdRefY: 'adj3',
            minY: 0,
            maxY: 'maxAdj3',
            position: {
                x: 'r',
                y: 'y1',
            },
            point: [w, e],
        }, {
            type: 'ahXY',
            gdRefY: 'adj4',
            minY: 0,
            maxY: 'maxAdj4',
            position: {
                x: 'l',
                y: 'y2',
            },
            point: [0, f],
        },
        ],
        path: [[['M', 0, f], ['L', d, f], ['L', d, e], ['L', c, e], ['L', a, 0], ['L', '=V.x4', e], ['L', '=V.x3', e], ['L', '=V.x3', f], ['L', w, f], ['L', w, h], ['L', 0, h], ['Z'], {},
        ]],
        textRect: {
            left: 0,
            top: f,
            right: w,
            bottom: h,
        },
    },
    downArrowCallout: {
        variables: {
            adj1: 25000,
            adj2: 25000,
            adj3: 25000,
            adj4: 64977,
            ss: s,
            maxAdj2: '=50000 * width / V.ss',
            a2: '=MIN(MAX(0, V.adj2), V.maxAdj2)',
            maxAdj1: '=V.a2 * 2',
            a1: '=MIN(MAX(0, V.adj1), V.maxAdj1)',
            maxAdj3: '=100000 * height / V.ss',
            a3: '=MIN(MAX(0, V.adj3), V.maxAdj3)',
            q2: '=V.a3 * V.ss / height',
            maxAdj4: '=100000 - V.q2',
            a4: '=MIN(MAX(0, V.adj4), V.maxAdj4)',
            dx1: '=V.ss * V.a2 / 100000',
            dx2: '=V.ss * V.a1 / 200000',
            hc: E,
            x1: '=V.hc - V.dx1',
            x2: '=V.hc - V.dx2',
            x3: '=V.hc + V.dx2',
            x4: '=V.hc + V.dx1',
            dy3: '=V.ss * V.a3 / 100000',
            b: h,
            y3: '=height - V.dy3',
            y2: '=height * V.a4 / 100000',
            y1: '=V.y2 / 2',
            t: 0,
            l: 0,
            r: w,
        },
        adjustInfo: [['adj1', 25000], ['adj2', 25000], ['adj3', 25000], ['adj4', 64977]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: e,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: e,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj1',
            minX: 0,
            maxX: 'maxAdj1',
            position: {
                x: 'x2',
                y: 'y3',
            },
            point: [d, '=V.y3'],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: 0,
            maxX: 'maxAdj2',
            position: {
                x: 'x1',
                y: 'b',
            },
            point: [c, h],
        }, {
            type: 'ahXY',
            gdRefY: 'adj3',
            minY: 0,
            maxY: 'maxAdj3',
            position: {
                x: 'r',
                y: 'y3',
            },
            point: [w, '=V.y3'],
        }, {
            type: 'ahXY',
            gdRefY: 'adj4',
            minY: 0,
            maxY: 'maxAdj4',
            position: {
                x: 'l',
                y: 'y2',
            },
            point: [0, f],
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, f], ['L', '=V.x3', f], ['L', '=V.x3', '=V.y3'], ['L', '=V.x4', '=V.y3'], ['L', a, h], ['L', c, '=V.y3'], ['L', d, '=V.y3'], ['L', d, f], ['L', 0, f], ['Z'], {},
        ]],
        textRect: {
            left: 0,
            top: 0,
            right: w,
            bottom: f,
        },
    },
    leftRightArrowCallout: {
        variables: {
            adj1: 25000,
            adj2: 25000,
            adj3: 25000,
            adj4: 48123,
            ss: s,
            maxAdj2: '=50000 * height / V.ss',
            a2: '=MIN(MAX(0, V.adj2), V.maxAdj2)',
            maxAdj1: '=V.a2 * 2',
            a1: '=MIN(MAX(0, V.adj1), V.maxAdj1)',
            maxAdj3: '=50000 * width / V.ss',
            a3: '=MIN(MAX(0, V.adj3), V.maxAdj3)',
            wd2: E,
            q2: '=V.a3 * V.ss / V.wd2',
            maxAdj4: '=100000 - V.q2',
            a4: '=MIN(MAX(0, V.adj4), V.maxAdj4)',
            dy1: '=V.ss * V.a2 / 100000',
            dy2: '=V.ss * V.a1 / 200000',
            vc: F,
            y1: '=V.vc - V.dy1',
            y2: '=V.vc - V.dy2',
            y3: '=V.vc + V.dy2',
            y4: '=V.vc + V.dy1',
            x1: '=V.ss * V.a3 / 100000',
            r: w,
            x4: '=width - V.x1',
            dx2: '=width * V.a4 / 200000',
            hc: E,
            x2: '=V.hc - V.dx2',
            x3: '=V.hc + V.dx2',
            t: 0,
            l: 0,
            b: h,
        },
        adjustInfo: [['adj1', 25000], ['adj2', 25000], ['adj3', 25000], ['adj4', 48123]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj1',
            minY: 0,
            maxY: 'maxAdj1',
            position: {
                x: 'x1',
                y: 'y2',
            },
            point: [c, f],
        }, {
            type: 'ahXY',
            gdRefY: 'adj2',
            minY: 0,
            maxY: 'maxAdj2',
            position: {
                x: 'l',
                y: 'y1',
            },
            point: [0, e],
        }, {
            type: 'ahXY',
            gdRefX: 'adj3',
            minX: 0,
            maxX: 'maxAdj3',
            position: {
                x: 'x1',
                y: 't',
            },
            point: [c, 0],
        }, {
            type: 'ahXY',
            gdRefX: 'adj4',
            minX: 0,
            maxX: 'maxAdj4',
            position: {
                x: 'x2',
                y: 'b',
            },
            point: [d, h],
        },
        ],
        path: [[['M', 0, b], ['L', c, e], ['L', c, f], ['L', d, f], ['L', d, 0], ['L', '=V.x3', 0], ['L', '=V.x3', f], ['L', '=V.x4', f], ['L', '=V.x4', e], ['L', w, b], ['L', '=V.x4', '=V.y4'], ['L', '=V.x4', '=V.y3'], ['L', '=V.x3', '=V.y3'], ['L', '=V.x3', h], ['L', d, h], ['L', d, '=V.y3'], ['L', c, '=V.y3'], ['L', c, '=V.y4'], ['Z'], {},
        ]],
        textRect: {
            left: d,
            top: 0,
            right: '=V.x3',
            bottom: h,
        },
    },
    upDownArrowCallout: {
        variables: {
            adj1: 25000,
            adj2: 25000,
            adj3: 25000,
            adj4: 48123,
            ss: s,
            maxAdj2: '=50000 * width / V.ss',
            a2: '=MIN(MAX(0, V.adj2), V.maxAdj2)',
            maxAdj1: '=V.a2 * 2',
            a1: '=MIN(MAX(0, V.adj1), V.maxAdj1)',
            maxAdj3: '=50000 * height / V.ss',
            a3: '=MIN(MAX(0, V.adj3), V.maxAdj3)',
            hd2: F,
            q2: '=V.a3 * V.ss / V.hd2',
            maxAdj4: '=100000 - V.q2',
            a4: '=MIN(MAX(0, V.adj4), V.maxAdj4)',
            dx1: '=V.ss * V.a2 / 100000',
            dx2: '=V.ss * V.a1 / 200000',
            hc: E,
            x1: '=V.hc - V.dx1',
            x2: '=V.hc - V.dx2',
            x3: '=V.hc + V.dx2',
            x4: '=V.hc + V.dx1',
            y1: '=V.ss * V.a3 / 100000',
            b: h,
            y4: '=height - V.y1',
            dy2: '=height * V.a4 / 200000',
            vc: F,
            y2: '=V.vc - V.dy2',
            y3: '=V.vc + V.dy2',
            t: 0,
            l: 0,
            r: w,
        },
        adjustInfo: [['adj1', 25000], ['adj2', 25000], ['adj3', 25000], ['adj4', 48123]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj1',
            minX: 0,
            maxX: 'maxAdj1',
            position: {
                x: 'x2',
                y: 'y1',
            },
            point: [d, e],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: 0,
            maxX: 'maxAdj2',
            position: {
                x: 'x1',
                y: 't',
            },
            point: [c, 0],
        }, {
            type: 'ahXY',
            gdRefY: 'adj3',
            minY: 0,
            maxY: 'maxAdj3',
            position: {
                x: 'r',
                y: 'y1',
            },
            point: [w, e],
        }, {
            type: 'ahXY',
            gdRefY: 'adj4',
            minY: 0,
            maxY: 'maxAdj4',
            position: {
                x: 'l',
                y: 'y2',
            },
            point: [0, f],
        },
        ],
        path: [[['M', 0, f], ['L', d, f], ['L', d, e], ['L', c, e], ['L', a, 0], ['L', '=V.x4', e], ['L', '=V.x3', e], ['L', '=V.x3', f], ['L', w, f], ['L', w, '=V.y3'], ['L', '=V.x3', '=V.y3'], ['L', '=V.x3', '=V.y4'], ['L', '=V.x4', '=V.y4'], ['L', a, h], ['L', c, '=V.y4'], ['L', d, '=V.y4'], ['L', d, '=V.y3'], ['L', 0, '=V.y3'], ['Z'], {},
        ]],
        textRect: {
            left: 0,
            top: f,
            right: w,
            bottom: '=V.y3',
        },
    },
    quadArrowCallout: {
        variables: {
            adj1: 18515,
            adj2: 18515,
            adj3: 18515,
            adj4: 48123,
            a2: '=MIN(MAX(0, V.adj2), 50000)',
            maxAdj1: '=V.a2 * 2',
            a1: '=MIN(MAX(0, V.adj1), V.maxAdj1)',
            maxAdj3: '=50000 - V.a2',
            a3: '=MIN(MAX(0, V.adj3), V.maxAdj3)',
            q2: '=V.a3 * 2',
            maxAdj4: '=100000 - V.q2',
            a4: '=MIN(MAX(V.a1, V.adj4), V.maxAdj4)',
            ss: s,
            dx2: '=V.ss * V.a2 / 100000',
            dx3: '=V.ss * V.a1 / 200000',
            ah: '=V.ss * V.a3 / 100000',
            dx1: '=width * V.a4 / 200000',
            dy1: '=height * V.a4 / 200000',
            r: w,
            x8: '=width - V.ah',
            hc: E,
            x2: '=V.hc - V.dx1',
            x7: '=V.hc + V.dx1',
            x3: '=V.hc - V.dx2',
            x6: '=V.hc + V.dx2',
            x4: '=V.hc - V.dx3',
            x5: '=V.hc + V.dx3',
            b: h,
            y8: '=height - V.ah',
            vc: F,
            y2: '=V.vc - V.dy1',
            y7: '=V.vc + V.dy1',
            y3: '=V.vc - V.dx2',
            y6: '=V.vc + V.dx2',
            y4: '=V.vc - V.dx3',
            y5: '=V.vc + V.dx3',
            t: 0,
            l: 0,
        },
        adjustInfo: [['adj1', 18515], ['adj2', 18515], ['adj3', 18515], ['adj4', 48123]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj1',
            minX: 0,
            maxX: 'maxAdj1',
            position: {
                x: 'x4',
                y: 'ah',
            },
            point: ['=V.x4', '=V.ah'],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: 0,
            maxX: 50000,
            position: {
                x: 'x3',
                y: 't',
            },
            point: ['=V.x3', 0],
        }, {
            type: 'ahXY',
            gdRefY: 'adj3',
            minY: 0,
            maxY: 'maxAdj3',
            position: {
                x: 'r',
                y: 'ah',
            },
            point: [w, '=V.ah'],
        }, {
            type: 'ahXY',
            gdRefY: 'adj4',
            minY: 'a1',
            maxY: 'maxAdj4',
            position: {
                x: 'l',
                y: 'y2',
            },
            point: [0, f],
        },
        ],
        path: [[['M', 0, b], ['L', '=V.ah', '=V.y3'], ['L', '=V.ah', '=V.y4'], ['L', d, '=V.y4'], ['L', d, f], ['L', '=V.x4', f], ['L', '=V.x4', '=V.ah'], ['L', '=V.x3', '=V.ah'], ['L', a, 0], ['L', '=V.x6', '=V.ah'], ['L', '=V.x5', '=V.ah'], ['L', '=V.x5', f], ['L', '=V.x7', f], ['L', '=V.x7', '=V.y4'], ['L', '=V.x8', '=V.y4'], ['L', '=V.x8', '=V.y3'], ['L', w, b], ['L', '=V.x8', '=V.y6'], ['L', '=V.x8', '=V.y5'], ['L', '=V.x7', '=V.y5'], ['L', '=V.x7', '=V.y7'], ['L', '=V.x5', '=V.y7'], ['L', '=V.x5', '=V.y8'], ['L', '=V.x6', '=V.y8'], ['L', a, h], ['L', '=V.x3', '=V.y8'], ['L', '=V.x4', '=V.y8'], ['L', '=V.x4', '=V.y7'], ['L', d, '=V.y7'], ['L', d, '=V.y5'], ['L', '=V.ah', '=V.y5'], ['L', '=V.ah', '=V.y6'], ['Z'], {},
        ]],
        textRect: {
            left: d,
            top: f,
            right: '=V.x7',
            bottom: '=V.y7',
        },
    },
    circularArrow: {
        variables: {
            adj1: 12500,
            adj2: 1142319,
            adj3: 20457681,
            adj4: B,
            adj5: 12500,
            a5: '=MIN(MAX(0, V.adj5), 25000)',
            maxAdj1: '=V.a5 * 2',
            a1: '=MIN(MAX(0, V.adj1), V.maxAdj1)',
            enAng: '=MIN(MAX(1, V.adj3), 21599999)',
            stAng: '=MIN(MAX(0, V.adj4), 21599999)',
            ss: s,
            th: '=V.ss * V.a1 / 100000',
            thh: '=V.ss * V.a5 / 100000',
            th2: '=V.th / 2',
            wd2: E,
            rw1: '=V.wd2 + V.th2 - V.thh',
            hd2: F,
            rh1: '=V.hd2 + V.th2 - V.thh',
            rw2: '=V.rw1 - V.th',
            rh2: '=V.rh1 - V.th',
            rw3: '=V.rw2 + V.th2',
            rh3: '=V.rh2 + V.th2',
            d2r: A,
            wtH: '=V.rw3 * SIN(V.enAng / V.d2r)',
            htH: '=V.rh3 * COS(V.enAng / V.d2r)',
            dxH: '=V.rw3 * COS(ATAN2(V.htH,V.wtH))',
            dyH: '=V.rh3 * SIN(ATAN2(V.htH,V.wtH))',
            hc: E,
            xH: '=V.hc + V.dxH',
            vc: F,
            yH: '=V.vc + V.dyH',
            rI: '=MIN(V.rw2, V.rh2)',
            u1: '=V.dxH * V.dxH',
            u2: '=V.dyH * V.dyH',
            u3: '=V.rI * V.rI',
            u4: '=V.u1 - V.u3',
            u5: '=V.u2 - V.u3',
            u6: '=V.u4 * V.u5 / V.u1',
            u7: '=V.u6 / V.u2',
            u8: '=1 - V.u7',
            u9: '=SQRT(V.u8)',
            u10: '=V.u4 / V.dxH',
            u11: '=V.u10 / V.dyH',
            u12: '=(1 + V.u9) / V.u11',
            u13: '=(ATAN2(1,V.u12) * V.d2r)',
            u14: '=V.u13 + 21600000',
            u15: '=IF(V.u13 > 0, V.u13, V.u14)',
            u16: '=V.u15 - V.enAng',
            u17: '=V.u16 + 21600000',
            u18: '=IF(V.u16 > 0, V.u16, V.u17)',
            cd2: B,
            u19: '=V.u18 - V.cd2',
            u20: '=V.u18 - 21600000',
            u21: '=IF(V.u19 > 0, V.u20, V.u18)',
            maxAng: '=ABS(V.u21)',
            aAng: '=MIN(MAX(0, V.adj2), V.maxAng)',
            ptAng: '=V.enAng + V.aAng',
            wtA: '=V.rw3 * SIN(V.ptAng / V.d2r)',
            htA: '=V.rh3 * COS(V.ptAng / V.d2r)',
            dxA: '=V.rw3 * COS(ATAN2(V.htA,V.wtA))',
            dyA: '=V.rh3 * SIN(ATAN2(V.htA,V.wtA))',
            xA: '=V.hc + V.dxA',
            yA: '=V.vc + V.dyA',
            wtE: '=V.rw1 * SIN(V.stAng / V.d2r)',
            htE: '=V.rh1 * COS(V.stAng / V.d2r)',
            dxE: '=V.rw1 * COS(ATAN2(V.htE,V.wtE))',
            dyE: '=V.rh1 * SIN(ATAN2(V.htE,V.wtE))',
            xE: '=V.hc + V.dxE',
            yE: '=V.vc + V.dyE',
            dxG: '=V.thh * COS(V.ptAng / V.d2r)',
            dyG: '=V.thh * SIN(V.ptAng / V.d2r)',
            xG: '=V.xH + V.dxG',
            yG: '=V.yH + V.dyG',
            dxB: '=V.thh * COS(V.ptAng / V.d2r)',
            dyB: '=V.thh * SIN(V.ptAng / V.d2r)',
            xB: '=V.xH - V.dxB',
            yB: '=V.yH - V.dyB',
            sx1: '=V.xB - V.hc',
            sy1: '=V.yB - V.vc',
            sx2: '=V.xG - V.hc',
            sy2: '=V.yG - V.vc',
            rO: '=MIN(V.rw1, V.rh1)',
            x1O: '=V.sx1 * V.rO / V.rw1',
            y1O: '=V.sy1 * V.rO / V.rh1',
            x2O: '=V.sx2 * V.rO / V.rw1',
            y2O: '=V.sy2 * V.rO / V.rh1',
            dxO: '=V.x2O - V.x1O',
            dyO: '=V.y2O - V.y1O',
            dO: '=SQRT(V.dxO*V.dxO + V.dyO*V.dyO)',
            q1: '=V.x1O * V.y2O',
            q2: '=V.x2O * V.y1O',
            DO: '=V.q1 - V.q2',
            q3: '=V.rO * V.rO',
            q4: '=V.dO * V.dO',
            q5: '=V.q3 * V.q4',
            q6: '=V.DO * V.DO',
            q7: '=V.q5 - V.q6',
            q8: '=MAX(V.q7, 0)',
            sdelO: '=SQRT(V.q8)',
            ndyO: '=V.dyO * -1',
            sdyO: '=IF(V.ndyO > 0, -1, 1)',
            q9: '=V.sdyO * V.dxO',
            q10: '=V.q9 * V.sdelO',
            q11: '=V.DO * V.dyO',
            dxF1: '=(V.q11 + V.q10) / V.q4',
            q12: '=V.q11 - V.q10',
            dxF2: '=V.q12 / V.q4',
            adyO: '=ABS(V.dyO)',
            q13: '=V.adyO * V.sdelO',
            q14: '=V.DO * V.dxO / -1',
            dyF1: '=(V.q14 + V.q13) / V.q4',
            q15: '=V.q14 - V.q13',
            dyF2: '=V.q15 / V.q4',
            q16: '=V.x2O - V.dxF1',
            q17: '=V.x2O - V.dxF2',
            q18: '=V.y2O - V.dyF1',
            q19: '=V.y2O - V.dyF2',
            q20: '=SQRT(V.q16*V.q16 + V.q18*V.q18)',
            q21: '=SQRT(V.q17*V.q17 + V.q19*V.q19)',
            q22: '=V.q21 - V.q20',
            dxF: '=IF(V.q22 > 0, V.dxF1, V.dxF2)',
            dyF: '=IF(V.q22 > 0, V.dyF1, V.dyF2)',
            sdxF: '=V.dxF * V.rw1 / V.rO',
            sdyF: '=V.dyF * V.rh1 / V.rO',
            xF: '=V.hc + V.sdxF',
            yF: '=V.vc + V.sdyF',
            x1I: '=V.sx1 * V.rI / V.rw2',
            y1I: '=V.sy1 * V.rI / V.rh2',
            x2I: '=V.sx2 * V.rI / V.rw2',
            y2I: '=V.sy2 * V.rI / V.rh2',
            dxI: '=V.x2I - V.x1I',
            dyI: '=V.y2I - V.y1I',
            dI: '=SQRT(V.dxI*V.dxI + V.dyI*V.dyI)',
            v1: '=V.x1I * V.y2I',
            v2: '=V.x2I * V.y1I',
            DI: '=V.v1 - V.v2',
            v3: '=V.rI * V.rI',
            v4: '=V.dI * V.dI',
            v5: '=V.v3 * V.v4',
            v6: '=V.DI * V.DI',
            v7: '=V.v5 - V.v6',
            v8: '=MAX(V.v7, 0)',
            sdelI: '=SQRT(V.v8)',
            v9: '=V.sdyO * V.dxI',
            v10: '=V.v9 * V.sdelI',
            v11: '=V.DI * V.dyI',
            dxC1: '=(V.v11 + V.v10) / V.v4',
            v12: '=V.v11 - V.v10',
            dxC2: '=V.v12 / V.v4',
            adyI: '=ABS(V.dyI)',
            v13: '=V.adyI * V.sdelI',
            v14: '=V.DI * V.dxI / -1',
            dyC1: '=(V.v14 + V.v13) / V.v4',
            v15: '=V.v14 - V.v13',
            dyC2: '=V.v15 / V.v4',
            v16: '=V.x1I - V.dxC1',
            v17: '=V.x1I - V.dxC2',
            v18: '=V.y1I - V.dyC1',
            v19: '=V.y1I - V.dyC2',
            v20: '=SQRT(V.v16*V.v16 + V.v18*V.v18)',
            v21: '=SQRT(V.v17*V.v17 + V.v19*V.v19)',
            v22: '=V.v21 - V.v20',
            dxC: '=IF(V.v22 > 0, V.dxC1, V.dxC2)',
            dyC: '=IF(V.v22 > 0, V.dyC1, V.dyC2)',
            sdxC: '=V.dxC * V.rw2 / V.rI',
            sdyC: '=V.dyC * V.rh2 / V.rI',
            xC: '=V.hc + V.sdxC',
            yC: '=V.vc + V.sdyC',
            ist0: '=(ATAN2(V.sdxC,V.sdyC) * V.d2r)',
            ist1: '=V.ist0 + 21600000',
            istAng: '=IF(V.ist0 > 0, V.ist0, V.ist1)',
            isw1: '=V.stAng - V.istAng',
            isw2: '=V.isw1 - 21600000',
            iswAng: '=IF(V.isw1 > 0, V.isw2, V.isw1)',
            p1: '=V.xF - V.xC',
            p2: '=V.yF - V.yC',
            p3: '=SQRT(V.p1*V.p1 + V.p2*V.p2)',
            p4: '=V.p3 / 2',
            p5: '=V.p4 - V.thh',
            xGp: '=IF(V.p5 > 0, V.xF, V.xG)',
            yGp: '=IF(V.p5 > 0, V.yF, V.yG)',
            xBp: '=IF(V.p5 > 0, V.xC, V.xB)',
            yBp: '=IF(V.p5 > 0, V.yC, V.yB)',
            en0: '=(ATAN2(V.sdxF,V.sdyF) * V.d2r)',
            en1: '=V.en0 + 21600000',
            en2: '=IF(V.en0 > 0, V.en0, V.en1)',
            sw0: '=V.en2 - V.stAng',
            sw1: '=V.sw0 + 21600000',
            swAng: '=IF(V.sw0 > 0, V.sw0, V.sw1)',
            wtI: '=V.rw3 * SIN(V.stAng / V.d2r)',
            htI: '=V.rh3 * COS(V.stAng / V.d2r)',
            _dxI: '=V.rw3 * COS(ATAN2(V.htI,V.wtI))',
            _dyI: '=V.rh3 * SIN(ATAN2(V.htI,V.wtI))',
            xI: '=V.hc + V._dxI',
            yI: '=V.vc + V._dyI',
            cd4: C,
            aI: '=V.stAng - V.cd4',
            aA: '=V.ptAng + V.cd4',
            aB: '=V.ptAng + V.cd2',
            idx: '=V.rw1 * COS(2700000 / V.d2r)',
            idy: '=V.rh1 * SIN(2700000 / V.d2r)',
            il: '=V.hc - V.idx',
            ir: '=V.hc + V.idx',
            it: '=V.vc - V.idy',
            ib: '=V.vc + V.idy',
            cx1: '=C(V.rw1,V.xE,A(V.rw1,V.rh1,V.stAng),true)',
            cy1: '=C(V.rh1,V.yE,A(V.rw1,V.rh1,V.stAng))',
            cx2: '=C(V.rw2,V.xC,A(V.rw2,V.rh2,V.istAng),true)',
            cy2: '=C(V.rh2,V.yC,A(V.rw2,V.rh2,V.istAng))',
        },
        adjustInfo: [['adj1', 12500], ['adj2', 1142319], ['adj3', 20457681], ['adj4', 10800000], ['adj5', 12500]],
        connectionPoints: [{
            x: '=V.xI',
            y: '=V.yI',
        }, {
            x: '=V.xGp',
            y: '=V.yGp',
        }, {
            x: '=V.xA',
            y: '=V.yA',
        }, {
            x: '=V.xBp',
            y: '=V.yBp',
        },
        ],
        controlsInfo: [{
            type: 'ahPolar',
            gdRefAng: 'adj2',
            minAng: 0,
            maxAng: 'maxAng',
            position: {
                x: 'xA',
                y: 'yA',
            },
            point: ['=V.xA', '=V.yA'],
        }, {
            type: 'ahPolar',
            gdRefAng: 'adj4',
            minAng: 0,
            maxAng: 21599999,
            position: {
                x: 'xE',
                y: 'yE',
            },
            point: ['=V.xE', '=V.yE'],
        }, {
            type: 'ahPolar',
            gdRefR: 'adj1',
            minR: 0,
            maxR: 'maxAdj1',
            gdRefAng: 'adj3',
            minAng: 0,
            maxAng: 21599999,
            position: {
                x: 'xF',
                y: 'yF',
            },
            point: ['=V.xF', '=V.yF'],
        }, {
            type: 'ahPolar',
            gdRefR: 'adj5',
            minR: 0,
            maxR: 25000,
            position: {
                x: 'xB',
                y: 'yB',
            },
            point: ['=V.xB', '=V.yB'],
        },
        ],
        path: [[['M', '=V.xE', '=V.yE'], ['E', '=V.cx1', '=V.cy1', '=V.rw1', '=V.rh1', 0, '=A(V.rw1,V.rh1,V.stAng)', '=A(V.rw1,V.rh1,(V.stAng + V.swAng))', '=IF(V.swAng > 0, FALSE, TRUE)'], ['L', '=V.xGp', '=V.yGp'], ['L', '=V.xA', '=V.yA'], ['L', '=V.xBp', '=V.yBp'], ['L', '=V.xC', '=V.yC'], ['E', '=V.cx2', '=V.cy2', '=V.rw2', '=V.rh2', 0, '=A(V.rw2,V.rh2,V.istAng)', '=A(V.rw2,V.rh2,(V.istAng + V.iswAng))', '=IF(V.iswAng > 0, FALSE, TRUE)'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.it',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    flowchartProcess: {
        variables: {
            hc: E,
            t: 0,
            l: 0,
            vc: F,
            b: h,
            r: w,
            _scaleX1: '= width',
            _scaleY1: '= height',
        },
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {},
        ]],
    },
    flowchartAlternateProcess: {
        variables: {
            r: w,
            ss: s,
            ssd6: '=V.ss / 6',
            x2: '=width - V.ssd6',
            b: h,
            y2: '=height - V.ssd6',
            il: '=V.ssd6 * 29289 / 100000',
            ir: '=width - V.il',
            ib: '=height - V.il',
            hc: E,
            t: 0,
            l: 0,
            vc: F,
            cd2: B,
            cd4: C,
            cx1: '=C(V.ssd6,V.l,A(V.ssd6,V.ssd6,V.cd2),true)',
            cy1: '=C(V.ssd6,V.ssd6,A(V.ssd6,V.ssd6,V.cd2))',
            _3cd4: D,
            cx2: '=C(V.ssd6,V.x2,A(V.ssd6,V.ssd6,V._3cd4),true)',
            cy2: '=C(V.ssd6,V.t,A(V.ssd6,V.ssd6,V._3cd4))',
            cx3: '=C(V.ssd6,V.r,A(V.ssd6,V.ssd6,0),true)',
            cy3: '=C(V.ssd6,V.y2,A(V.ssd6,V.ssd6,0))',
            cx4: '=C(V.ssd6,V.ssd6,A(V.ssd6,V.ssd6,V.cd4),true)',
            cy4: '=C(V.ssd6,V.b,A(V.ssd6,V.ssd6,V.cd4))',
        },
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        path: [[['M', 0, '=V.ssd6'], ['E', '=V.cx1', '=V.cy1', '=V.ssd6', '=V.ssd6', 0, '=A(V.ssd6,V.ssd6,V.cd2)', '=A(V.ssd6,V.ssd6,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', d, 0], ['E', '=V.cx2', '=V.cy2', '=V.ssd6', '=V.ssd6', 0, '=A(V.ssd6,V.ssd6,V._3cd4)', '=A(V.ssd6,V.ssd6,(V._3cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', w, f], ['E', '=V.cx3', '=V.cy3', '=V.ssd6', '=V.ssd6', 0, '=A(V.ssd6,V.ssd6,0)', '=A(V.ssd6,V.ssd6,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', '=V.ssd6', h], ['E', '=V.cx4', '=V.cy4', '=V.ssd6', '=V.ssd6', 0, '=A(V.ssd6,V.ssd6,V.cd4)', '=A(V.ssd6,V.ssd6,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.il',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    flowchartDecision: {
        variables: {
            ir: '=width * 3 / 4',
            ib: '=height * 3 / 4',
            hc: E,
            t: 0,
            l: 0,
            vc: F,
            b: h,
            r: w,
            _scaleX1: '= width / 2',
            _scaleY1: '= height / 2',
            wd4: '=width/4',
            hd4: '=height/4',
        },
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        path: [[['M', 0, F], ['L', E, 0], ['L', w, F], ['L', E, h], ['Z'], {},
        ]],
        textRect: {
            left: '=V.wd4',
            top: '=V.hd4',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    flowchartData: {
        variables: {
            x3: '=width * 2 / 5',
            x4: '=width * 3 / 5',
            x5: '=width * 4 / 5',
            x6: '=width * 9 / 10',
            t: 0,
            hc: E,
            wd10: '=width/10',
            vc: F,
            b: h,
            _scaleX1: '= width / 5',
            _scaleY1: '= height / 5',
            wd5: '=width/5',
        },
        connectionPoints: [{
            x: '=V.x4',
            y: 0,
        }, {
            x: a,
            y: 0,
        }, {
            x: '=V.wd10',
            y: b,
        }, {
            x: '=V.x3',
            y: h,
        }, {
            x: a,
            y: h,
        }, {
            x: '=V.x6',
            y: b,
        },
        ],
        path: [[['M', 0, h], ['L', '=V._scaleX1', 0], ['L', w, 0], ['L', '=4 * V._scaleX1', h], ['Z'], {},
        ]],
        textRect: {
            left: '=V.wd5',
            top: 0,
            right: '=V.x5',
            bottom: h,
        },
    },
    flowchartPredefinedProcess: {
        variables: {
            x2: '=width * 7 / 8',
            hc: E,
            t: 0,
            l: 0,
            vc: F,
            b: h,
            r: w,
            _scaleX1: '= width',
            _scaleY1: '= height',
            _scaleX2: '= width / 8',
            _scaleY2: '= height / 8',
            _scaleX3: '= width',
            _scaleY3: '= height',
            wd8: '=width/8',
        },
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', '=V._scaleX2', 0], ['L', '=V._scaleX2', h], ['M', '=7 * V._scaleX2', 0], ['L', '=7 * V._scaleX2', h], {
            fillMode: 'none',
        },
        ], [['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {
            fillMode: 'none',
        },
        ]],
        textRect: {
            left: '=V.wd8',
            top: 0,
            right: d,
            bottom: h,
        },
    },
    flowchartInternalStorage: {
        variables: {
            hc: E,
            t: 0,
            l: 0,
            vc: F,
            b: h,
            r: w,
            _scaleX1: '= width',
            _scaleY1: '= height',
            _scaleX2: '= width / 8',
            _scaleY2: '= height / 8',
            _scaleX3: '= width',
            _scaleY3: '= height',
            wd8: '=width/8',
            hd8: '=height/8',
        },
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', '=V._scaleX2', 0], ['L', '=V._scaleX2', h], ['M', 0, '=V._scaleY2'], ['L', w, '=V._scaleY2'], {
            fillMode: 'none',
        },
        ], [['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {
            fillMode: 'none',
        },
        ]],
        textRect: {
            left: '=V.wd8',
            top: '=V.hd8',
            right: w,
            bottom: h,
        },
    },
    flowchartDocument: {
        variables: {
            y1: '=height * 17322 / 21600',
            y2: '=height * 20172 / 21600',
            hc: E,
            t: 0,
            l: 0,
            vc: F,
            r: w,
            _scaleX1: '= width / 21600',
            _scaleY1: '= height / 21600',
        },
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: f,
        }, {
            x: w,
            y: b,
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, '=17322 * V._scaleY1'], ['B', E, '=17322 * V._scaleY1', E, '=23922 * V._scaleY1', 0, '=20172 * V._scaleY1'], ['Z'], {},
        ]],
        textRect: {
            left: 0,
            top: 0,
            right: w,
            bottom: e,
        },
    },
    flowchartMultidocument: {
        variables: {
            y2: '=height * 3675 / 21600',
            y8: '=height * 20782 / 21600',
            x3: '=width * 9298 / 21600',
            x4: '=width * 12286 / 21600',
            x5: '=width * 18595 / 21600',
            t: 0,
            l: 0,
            vc: F,
            r: w,
            _scaleX1: '= width / 21600',
            _scaleY1: '= height / 21600',
            _scaleX2: '= width / 21600',
            _scaleY2: '= height / 21600',
            _scaleX3: '= width / 21600',
            _scaleY3: '= height / 21600',
        },
        connectionPoints: [{
            x: '=V.x4',
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: '=V.x3',
            y: '=V.y8',
        }, {
            x: w,
            y: b,
        },
        ],
        path: [[['M', 0, '=20782 * V._scaleY1'], ['B', '=9298 * V._scaleX1', '=23542 * V._scaleY1', '=9298 * V._scaleX1', '=18022 * V._scaleY1', '=18595 * V._scaleX1', '=18022 * V._scaleY1'], ['L', '=18595 * V._scaleX1', '=3675 * V._scaleY1'], ['L', 0, '=3675 * V._scaleY1'], ['Z'], ['M', '=1532 * V._scaleX1', '=3675 * V._scaleY1'], ['L', '=1532 * V._scaleX1', '=1815 * V._scaleY1'], ['L', '=20000 * V._scaleX1', '=1815 * V._scaleY1'], ['L', '=20000 * V._scaleX1', '=16252 * V._scaleY1'], ['B', '=19298 * V._scaleX1', '=16252 * V._scaleY1', '=18595 * V._scaleX1', '=16352 * V._scaleY1', '=18595 * V._scaleX1', '=16352 * V._scaleY1'], ['L', '=18595 * V._scaleX1', '=3675 * V._scaleY1'], ['Z'], ['M', '=2972 * V._scaleX1', '=1815 * V._scaleY1'], ['L', '=2972 * V._scaleX1', 0], ['L', w, 0], ['L', w, '=14392 * V._scaleY1'], ['B', '=20800 * V._scaleX1', '=14392 * V._scaleY1', '=20000 * V._scaleX1', '=14467 * V._scaleY1', '=20000 * V._scaleX1', '=14467 * V._scaleY1'], ['L', '=20000 * V._scaleX1', '=1815 * V._scaleY1'], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', 0, '=3675 * V._scaleY2'], ['L', '=18595 * V._scaleX2', '=3675 * V._scaleY2'], ['L', '=18595 * V._scaleX2', '=18022 * V._scaleY2'], ['B', '=9298 * V._scaleX2', '=18022 * V._scaleY2', '=9298 * V._scaleX2', '=23542 * V._scaleY2', 0, '=20782 * V._scaleY2'], ['Z'], ['M', '=1532 * V._scaleX2', '=3675 * V._scaleY2'], ['L', '=1532 * V._scaleX2', '=1815 * V._scaleY2'], ['L', '=20000 * V._scaleX2', '=1815 * V._scaleY2'], ['L', '=20000 * V._scaleX2', '=16252 * V._scaleY2'], ['B', '=19298 * V._scaleX2', '=16252 * V._scaleY2', '=18595 * V._scaleX2', '=16352 * V._scaleY2', '=18595 * V._scaleX2', '=16352 * V._scaleY2'], ['M', '=2972 * V._scaleX2', '=1815 * V._scaleY2'], ['L', '=2972 * V._scaleX2', 0], ['L', w, 0], ['L', w, '=14392 * V._scaleY2'], ['B', '=20800 * V._scaleX2', '=14392 * V._scaleY2', '=20000 * V._scaleX2', '=14467 * V._scaleY2', '=20000 * V._scaleX2', '=14467 * V._scaleY2'], {
            fillMode: 'none',
        },
        ], [['M', 0, '=20782 * V._scaleY3'], ['B', '=9298 * V._scaleX3', '=23542 * V._scaleY3', '=9298 * V._scaleX3', '=18022 * V._scaleY3', '=18595 * V._scaleX3', '=18022 * V._scaleY3'], ['L', '=18595 * V._scaleX3', '=16352 * V._scaleY3'], ['B', '=18595 * V._scaleX3', '=16352 * V._scaleY3', '=19298 * V._scaleX3', '=16252 * V._scaleY3', '=20000 * V._scaleX3', '=16252 * V._scaleY3'], ['L', '=20000 * V._scaleX3', '=14467 * V._scaleY3'], ['B', '=20000 * V._scaleX3', '=14467 * V._scaleY3', '=20800 * V._scaleX3', '=14392 * V._scaleY3', w, '=14392 * V._scaleY3'], ['L', w, 0], ['L', '=2972 * V._scaleX3', 0], ['L', '=2972 * V._scaleX3', '=1815 * V._scaleY3'], ['L', '=1532 * V._scaleX3', '=1815 * V._scaleY3'], ['L', '=1532 * V._scaleX3', '=3675 * V._scaleY3'], ['L', 0, '=3675 * V._scaleY3'], ['Z'], {
            fillMode: 'none',
            strokeMode: 'false',
        },
        ]],
        textRect: {
            left: 0,
            top: f,
            right: '=V.x5',
            bottom: '=V.y8',
        },
    },
    flowchartTerminator: {
        variables: {
            il: '=width * 1018 / 21600',
            ir: '=width * 20582 / 21600',
            it: '=height * 3163 / 21600',
            ib: '=height * 18437 / 21600',
            hc: E,
            t: 0,
            l: 0,
            vc: F,
            b: h,
            r: w,
            _scaleX1: '= width / 21600',
            _scaleY1: '= height / 21600',
            _3cd4: D,
            cd2: B,
            cx1: '=C(3475,18125,A(3475,10800,V._3cd4),true)',
            cy1: '=C(10800,0,A(3475,10800,V._3cd4))',
            cd4: C,
            cx2: '=C(3475,3475,A(3475,10800,V.cd4),true)',
            cy2: '=C(10800,21600,A(3475,10800,V.cd4))',
        },
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        path: [[['M', '=3475 * V._scaleX1', 0], ['L', '=18125 * V._scaleX1', 0], ['E', '=V.cx1 * V._scaleX1', '=V.cy1 * V._scaleY1', '=3475 * V._scaleX1', F, 0, '=A(3475,10800,V._3cd4)', '=A(3475,10800,(V._3cd4 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['L', '=3475 * V._scaleX1', h], ['E', '=V.cx2 * V._scaleX1', '=V.cy2 * V._scaleY1', '=3475 * V._scaleX1', F, 0, '=A(3475,10800,V.cd4)', '=A(3475,10800,(V.cd4 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.it',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    flowchartPreparation: {
        variables: {
            x2: '=width * 4 / 5',
            hc: E,
            t: 0,
            l: 0,
            vc: F,
            b: h,
            r: w,
            _scaleX1: '= width / 10',
            _scaleY1: '= height / 10',
            wd5: '=width/5',
        },
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        path: [[['M', 0, F], ['L', '=2 * V._scaleX1', 0], ['L', '=8 * V._scaleX1', 0], ['L', w, F], ['L', '=8 * V._scaleX1', h], ['L', '=2 * V._scaleX1', h], ['Z'], {},
        ]],
        textRect: {
            left: '=V.wd5',
            top: 0,
            right: d,
            bottom: h,
        },
    },
    flowchartManualInput: {
        variables: {
            hc: E,
            hd10: '=height/10',
            l: 0,
            vc: F,
            b: h,
            r: w,
            _scaleX1: '= width / 5',
            _scaleY1: '= height / 5',
            hd5: '=height/5',
        },
        connectionPoints: [{
            x: a,
            y: '=V.hd10',
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        path: [[['M', 0, '=V._scaleY1'], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {},
        ]],
        textRect: {
            left: 0,
            top: '=V.hd5',
            right: w,
            bottom: h,
        },
    },
    flowchartManualOperation: {
        variables: {
            x3: '=width * 4 / 5',
            x4: '=width * 9 / 10',
            hc: E,
            t: 0,
            wd10: '=width/10',
            vc: F,
            b: h,
            _scaleX1: '= width / 5',
            _scaleY1: '= height / 5',
            wd5: '=width/5',
        },
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: '=V.wd10',
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: '=V.x4',
            y: b,
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', '=4 * V._scaleX1', h], ['L', '=V._scaleX1', h], ['Z'], {},
        ]],
        textRect: {
            left: '=V.wd5',
            top: 0,
            right: '=V.x3',
            bottom: h,
        },
    },
    flowchartConnector: {
        variables: {
            wd2: E,
            d2r: A,
            idx: '=V.wd2 * COS(2700000 / V.d2r)',
            hd2: F,
            idy: '=V.hd2 * SIN(2700000 / V.d2r)',
            hc: E,
            il: '=V.hc - V.idx',
            ir: '=V.hc + V.idx',
            vc: F,
            it: '=V.vc - V.idy',
            ib: '=V.vc + V.idy',
            t: 0,
            l: 0,
            b: h,
            r: w,
            cd2: B,
            cd4: C,
            cx1: '=C(V.wd2,V.l,A(V.wd2,V.hd2,V.cd2),true)',
            cy1: '=C(V.hd2,V.vc,A(V.wd2,V.hd2,V.cd2))',
            _3cd4: D,
            cx2: '=C(V.wd2,P(V.cx1,V.wd2,A(V.wd2,V.hd2,(V.cd2 + V.cd4)),true),A(V.wd2,V.hd2,V._3cd4),true)',
            cy2: '=C(V.hd2,P(V.cy1,V.hd2,A(V.wd2,V.hd2,(V.cd2 + V.cd4))),A(V.wd2,V.hd2,V._3cd4))',
            cx3: '=C(V.wd2,P(V.cx2,V.wd2,A(V.wd2,V.hd2,(V._3cd4 + V.cd4)),true),A(V.wd2,V.hd2,0),true)',
            cy3: '=C(V.hd2,P(V.cy2,V.hd2,A(V.wd2,V.hd2,(V._3cd4 + V.cd4))),A(V.wd2,V.hd2,0))',
            cx4: '=C(V.wd2,P(V.cx3,V.wd2,A(V.wd2,V.hd2,(V.cd4)),true),A(V.wd2,V.hd2,V.cd4),true)',
            cy4: '=C(V.hd2,P(V.cy3,V.hd2,A(V.wd2,V.hd2,(V.cd4))),A(V.wd2,V.hd2,V.cd4))',
        },
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: '=V.il',
            y: '=V.it',
        }, {
            x: 0,
            y: b,
        }, {
            x: '=V.il',
            y: '=V.ib',
        }, {
            x: a,
            y: h,
        }, {
            x: '=V.ir',
            y: '=V.ib',
        }, {
            x: w,
            y: b,
        }, {
            x: '=V.ir',
            y: '=V.it',
        },
        ],
        path: [[['M', 0, b], ['E', '=V.cx1', '=V.cy1', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V.cd2)', '=A(V.wd2,V.hd2,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx2', '=V.cy2', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V._3cd4)', '=A(V.wd2,V.hd2,(V._3cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx3', '=V.cy3', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,0)', '=A(V.wd2,V.hd2,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx4', '=V.cy4', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V.cd4)', '=A(V.wd2,V.hd2,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.it',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    flowchartOffpageConnector: {
        variables: {
            y1: '=height * 4 / 5',
            hc: E,
            t: 0,
            l: 0,
            vc: F,
            b: h,
            r: w,
            _scaleX1: '= width / 10',
            _scaleY1: '= height / 10',
        },
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, '=8 * V._scaleY1'], ['L', E, h], ['L', 0, '=8 * V._scaleY1'], ['Z'], {},
        ]],
        textRect: {
            left: 0,
            top: 0,
            right: w,
            bottom: e,
        },
    },
    flowchartCard: {
        variables: {
            hc: E,
            t: 0,
            l: 0,
            vc: F,
            b: h,
            r: w,
            _scaleX1: '= width / 5',
            _scaleY1: '= height / 5',
            hd5: '=height/5',
        },
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        path: [[['M', 0, '=V._scaleY1'], ['L', '=V._scaleX1', 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {},
        ]],
        textRect: {
            left: 0,
            top: '=V.hd5',
            right: w,
            bottom: h,
        },
    },
    flowchartPunchedTape: {
        variables: {
            y2: '=height * 9 / 10',
            ib: '=height * 4 / 5',
            hc: E,
            hd10: '=height/10',
            l: 0,
            vc: F,
            r: w,
            _scaleX1: '= width / 20',
            _scaleY1: '= height / 20',
            cd2: B,
            cx1: '=C(5,0,A(5,2,V.cd2),true)',
            cy1: '=C(2,2,A(5,2,V.cd2))',
            cx2: '=C(5,P(V.cx1,5,A(5,2,(V.cd2 + -10800000)),true),A(5,2,V.cd2),true)',
            cy2: '=C(2,P(V.cy1,2,A(5,2,(V.cd2 + -10800000))),A(5,2,V.cd2))',
            cx3: '=C(5,20,A(5,2,0),true)',
            cy3: '=C(2,18,A(5,2,0))',
            cx4: '=C(5,P(V.cx3,5,A(5,2,(-10800000)),true),A(5,2,0),true)',
            cy4: '=C(2,P(V.cy3,2,A(5,2,(-10800000))),A(5,2,0))',
            hd5: '=height/5',
        },
        connectionPoints: [{
            x: a,
            y: '=V.hd10',
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: f,
        }, {
            x: w,
            y: b,
        },
        ],
        path: [[['M', 0, '=2 * V._scaleY1'], ['E', '=V.cx1 * V._scaleX1', '=V.cy1 * V._scaleY1', '=5 * V._scaleX1', '=2 * V._scaleY1', 0, '=A(5,2,V.cd2)', '=A(5,2,(V.cd2 + -10800000))', '=IF(-10800000 > 0, FALSE, TRUE)'], ['E', '=V.cx2 * V._scaleX1', '=V.cy2 * V._scaleY1', '=5 * V._scaleX1', '=2 * V._scaleY1', 0, '=A(5,2,V.cd2)', '=A(5,2,(V.cd2 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['L', w, '=18 * V._scaleY1'], ['E', '=V.cx3 * V._scaleX1', '=V.cy3 * V._scaleY1', '=5 * V._scaleX1', '=2 * V._scaleY1', 0, '=A(5,2,0)', '=A(5,2,(-10800000))', '=IF(-10800000 > 0, FALSE, TRUE)'], ['E', '=V.cx4 * V._scaleX1', '=V.cy4 * V._scaleY1', '=5 * V._scaleX1', '=2 * V._scaleY1', 0, '=A(5,2,0)', '=A(5,2,(V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['Z'], {},
        ]],
        textRect: {
            left: 0,
            top: '=V.hd5',
            right: w,
            bottom: '=V.ib',
        },
    },
    flowchartSummingJunction: {
        variables: {
            wd2: E,
            d2r: A,
            idx: '=V.wd2 * COS(2700000 / V.d2r)',
            hd2: F,
            idy: '=V.hd2 * SIN(2700000 / V.d2r)',
            hc: E,
            il: '=V.hc - V.idx',
            ir: '=V.hc + V.idx',
            vc: F,
            it: '=V.vc - V.idy',
            ib: '=V.vc + V.idy',
            t: 0,
            l: 0,
            b: h,
            r: w,
            cd2: B,
            cd4: C,
            cx1: '=C(V.wd2,V.l,A(V.wd2,V.hd2,V.cd2),true)',
            cy1: '=C(V.hd2,V.vc,A(V.wd2,V.hd2,V.cd2))',
            _3cd4: D,
            cx2: '=C(V.wd2,P(V.cx1,V.wd2,A(V.wd2,V.hd2,(V.cd2 + V.cd4)),true),A(V.wd2,V.hd2,V._3cd4),true)',
            cy2: '=C(V.hd2,P(V.cy1,V.hd2,A(V.wd2,V.hd2,(V.cd2 + V.cd4))),A(V.wd2,V.hd2,V._3cd4))',
            cx3: '=C(V.wd2,P(V.cx2,V.wd2,A(V.wd2,V.hd2,(V._3cd4 + V.cd4)),true),A(V.wd2,V.hd2,0),true)',
            cy3: '=C(V.hd2,P(V.cy2,V.hd2,A(V.wd2,V.hd2,(V._3cd4 + V.cd4))),A(V.wd2,V.hd2,0))',
            cx4: '=C(V.wd2,P(V.cx3,V.wd2,A(V.wd2,V.hd2,(V.cd4)),true),A(V.wd2,V.hd2,V.cd4),true)',
            cy4: '=C(V.hd2,P(V.cy3,V.hd2,A(V.wd2,V.hd2,(V.cd4))),A(V.wd2,V.hd2,V.cd4))',
            cx5: '=C(V.wd2,V.l,A(V.wd2,V.hd2,V.cd2),true)',
            cy5: '=C(V.hd2,V.vc,A(V.wd2,V.hd2,V.cd2))',
            cx6: '=C(V.wd2,P(V.cx5,V.wd2,A(V.wd2,V.hd2,(V.cd2 + V.cd4)),true),A(V.wd2,V.hd2,V._3cd4),true)',
            cy6: '=C(V.hd2,P(V.cy5,V.hd2,A(V.wd2,V.hd2,(V.cd2 + V.cd4))),A(V.wd2,V.hd2,V._3cd4))',
            cx7: '=C(V.wd2,P(V.cx6,V.wd2,A(V.wd2,V.hd2,(V._3cd4 + V.cd4)),true),A(V.wd2,V.hd2,0),true)',
            cy7: '=C(V.hd2,P(V.cy6,V.hd2,A(V.wd2,V.hd2,(V._3cd4 + V.cd4))),A(V.wd2,V.hd2,0))',
            cx8: '=C(V.wd2,P(V.cx7,V.wd2,A(V.wd2,V.hd2,(V.cd4)),true),A(V.wd2,V.hd2,V.cd4),true)',
            cy8: '=C(V.hd2,P(V.cy7,V.hd2,A(V.wd2,V.hd2,(V.cd4))),A(V.wd2,V.hd2,V.cd4))',
        },
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: '=V.il',
            y: '=V.it',
        }, {
            x: 0,
            y: b,
        }, {
            x: '=V.il',
            y: '=V.ib',
        }, {
            x: a,
            y: h,
        }, {
            x: '=V.ir',
            y: '=V.ib',
        }, {
            x: w,
            y: b,
        }, {
            x: '=V.ir',
            y: '=V.it',
        },
        ],
        path: [[['M', 0, b], ['E', '=V.cx1', '=V.cy1', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V.cd2)', '=A(V.wd2,V.hd2,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx2', '=V.cy2', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V._3cd4)', '=A(V.wd2,V.hd2,(V._3cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx3', '=V.cy3', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,0)', '=A(V.wd2,V.hd2,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx4', '=V.cy4', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V.cd4)', '=A(V.wd2,V.hd2,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', '=V.il', '=V.it'], ['L', '=V.ir', '=V.ib'], ['M', '=V.ir', '=V.it'], ['L', '=V.il', '=V.ib'], {
            fillMode: 'none',
        },
        ], [['M', 0, b], ['E', '=V.cx5', '=V.cy5', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V.cd2)', '=A(V.wd2,V.hd2,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx6', '=V.cy6', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V._3cd4)', '=A(V.wd2,V.hd2,(V._3cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx7', '=V.cy7', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,0)', '=A(V.wd2,V.hd2,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx8', '=V.cy8', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V.cd4)', '=A(V.wd2,V.hd2,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['Z'], {
            fillMode: 'none',
        },
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.it',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    flowchartOr: {
        variables: {
            wd2: E,
            d2r: A,
            idx: '=V.wd2 * COS(2700000 / V.d2r)',
            hd2: F,
            idy: '=V.hd2 * SIN(2700000 / V.d2r)',
            hc: E,
            il: '=V.hc - V.idx',
            ir: '=V.hc + V.idx',
            vc: F,
            it: '=V.vc - V.idy',
            ib: '=V.vc + V.idy',
            t: 0,
            l: 0,
            b: h,
            r: w,
            cd2: B,
            cd4: C,
            cx1: '=C(V.wd2,V.l,A(V.wd2,V.hd2,V.cd2),true)',
            cy1: '=C(V.hd2,V.vc,A(V.wd2,V.hd2,V.cd2))',
            _3cd4: D,
            cx2: '=C(V.wd2,P(V.cx1,V.wd2,A(V.wd2,V.hd2,(V.cd2 + V.cd4)),true),A(V.wd2,V.hd2,V._3cd4),true)',
            cy2: '=C(V.hd2,P(V.cy1,V.hd2,A(V.wd2,V.hd2,(V.cd2 + V.cd4))),A(V.wd2,V.hd2,V._3cd4))',
            cx3: '=C(V.wd2,P(V.cx2,V.wd2,A(V.wd2,V.hd2,(V._3cd4 + V.cd4)),true),A(V.wd2,V.hd2,0),true)',
            cy3: '=C(V.hd2,P(V.cy2,V.hd2,A(V.wd2,V.hd2,(V._3cd4 + V.cd4))),A(V.wd2,V.hd2,0))',
            cx4: '=C(V.wd2,P(V.cx3,V.wd2,A(V.wd2,V.hd2,(V.cd4)),true),A(V.wd2,V.hd2,V.cd4),true)',
            cy4: '=C(V.hd2,P(V.cy3,V.hd2,A(V.wd2,V.hd2,(V.cd4))),A(V.wd2,V.hd2,V.cd4))',
            cx5: '=C(V.wd2,V.l,A(V.wd2,V.hd2,V.cd2),true)',
            cy5: '=C(V.hd2,V.vc,A(V.wd2,V.hd2,V.cd2))',
            cx6: '=C(V.wd2,P(V.cx5,V.wd2,A(V.wd2,V.hd2,(V.cd2 + V.cd4)),true),A(V.wd2,V.hd2,V._3cd4),true)',
            cy6: '=C(V.hd2,P(V.cy5,V.hd2,A(V.wd2,V.hd2,(V.cd2 + V.cd4))),A(V.wd2,V.hd2,V._3cd4))',
            cx7: '=C(V.wd2,P(V.cx6,V.wd2,A(V.wd2,V.hd2,(V._3cd4 + V.cd4)),true),A(V.wd2,V.hd2,0),true)',
            cy7: '=C(V.hd2,P(V.cy6,V.hd2,A(V.wd2,V.hd2,(V._3cd4 + V.cd4))),A(V.wd2,V.hd2,0))',
            cx8: '=C(V.wd2,P(V.cx7,V.wd2,A(V.wd2,V.hd2,(V.cd4)),true),A(V.wd2,V.hd2,V.cd4),true)',
            cy8: '=C(V.hd2,P(V.cy7,V.hd2,A(V.wd2,V.hd2,(V.cd4))),A(V.wd2,V.hd2,V.cd4))',
        },
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: '=V.il',
            y: '=V.it',
        }, {
            x: 0,
            y: b,
        }, {
            x: '=V.il',
            y: '=V.ib',
        }, {
            x: a,
            y: h,
        }, {
            x: '=V.ir',
            y: '=V.ib',
        }, {
            x: w,
            y: b,
        }, {
            x: '=V.ir',
            y: '=V.it',
        },
        ],
        path: [[['M', 0, b], ['E', '=V.cx1', '=V.cy1', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V.cd2)', '=A(V.wd2,V.hd2,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx2', '=V.cy2', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V._3cd4)', '=A(V.wd2,V.hd2,(V._3cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx3', '=V.cy3', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,0)', '=A(V.wd2,V.hd2,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx4', '=V.cy4', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V.cd4)', '=A(V.wd2,V.hd2,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', a, 0], ['L', a, h], ['M', 0, b], ['L', w, b], {
            fillMode: 'none',
        },
        ], [['M', 0, b], ['E', '=V.cx5', '=V.cy5', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V.cd2)', '=A(V.wd2,V.hd2,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx6', '=V.cy6', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V._3cd4)', '=A(V.wd2,V.hd2,(V._3cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx7', '=V.cy7', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,0)', '=A(V.wd2,V.hd2,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx8', '=V.cy8', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V.cd4)', '=A(V.wd2,V.hd2,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['Z'], {
            fillMode: 'none',
        },
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.it',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    flowchartCollate: {
        variables: {
            ir: '=width * 3 / 4',
            ib: '=height * 3 / 4',
            hc: E,
            t: 0,
            vc: F,
            b: h,
            _scaleX1: '= width / 2',
            _scaleY1: '= height / 2',
            wd4: '=width/4',
            hd4: '=height/4',
        },
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: a,
            y: b,
        }, {
            x: a,
            y: h,
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', E, F], ['L', w, h], ['L', 0, h], ['L', E, F], ['Z'], {},
        ]],
        textRect: {
            left: '=V.wd4',
            top: '=V.hd4',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    flowchartSort: {
        variables: {
            ir: '=width * 3 / 4',
            ib: '=height * 3 / 4',
            hc: E,
            t: 0,
            l: 0,
            vc: F,
            b: h,
            r: w,
            _scaleX1: '= width / 2',
            _scaleY1: '= height / 2',
            _scaleX2: '= width / 2',
            _scaleX3: '= width / 2',
            _scaleY3: '= height / 2',
            wd4: '=width/4',
            hd4: '=height/4',
        },
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        path: [[['M', 0, F], ['L', E, 0], ['L', w, F], ['L', E, h], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', 0, F], ['L', w, F], {
            fillMode: 'none',
        },
        ], [['M', 0, F], ['L', E, 0], ['L', w, F], ['L', E, h], ['Z'], {
            fillMode: 'none',
        },
        ]],
        textRect: {
            left: '=V.wd4',
            top: '=V.hd4',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    flowchartExtract: {
        variables: {
            x2: '=width * 3 / 4',
            hc: E,
            t: 0,
            wd4: '=width/4',
            vc: F,
            b: h,
            _scaleX1: '= width / 2',
            _scaleY1: '= height / 2',
        },
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: '=V.wd4',
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: d,
            y: b,
        },
        ],
        path: [[['M', 0, h], ['L', E, 0], ['L', w, h], ['Z'], {},
        ]],
        textRect: {
            left: '=V.wd4',
            top: b,
            right: d,
            bottom: h,
        },
    },
    flowchartMerge: {
        variables: {
            x2: '=width * 3 / 4',
            hc: E,
            t: 0,
            wd4: '=width/4',
            vc: F,
            b: h,
            _scaleX1: '= width / 2',
            _scaleY1: '= height / 2',
        },
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: '=V.wd4',
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: d,
            y: b,
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', E, h], ['Z'], {},
        ]],
        textRect: {
            left: '=V.wd4',
            top: 0,
            right: d,
            bottom: b,
        },
    },
    flowchartStoredData: {
        variables: {
            x2: '=width * 5 / 6',
            hc: E,
            t: 0,
            l: 0,
            vc: F,
            b: h,
            _scaleX1: '= width / 6',
            _scaleY1: '= height / 6',
            _3cd4: D,
            cx1: '=C(1,6,A(1,3,V._3cd4),true)',
            cy1: '=C(3,0,A(1,3,V._3cd4))',
            cd4: C,
            cd2: B,
            cx2: '=C(1,1,A(1,3,V.cd4),true)',
            cy2: '=C(3,6,A(1,3,V.cd4))',
            wd6: '=width/6',
        },
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: d,
            y: b,
        },
        ],
        path: [[['M', '=V._scaleX1', 0], ['L', w, 0], ['E', '=V.cx1 * V._scaleX1', '=V.cy1 * V._scaleY1', '=V._scaleX1', F, 0, '=A(1,3,V._3cd4)', '=A(1,3,(V._3cd4 + -10800000))', '=IF(-10800000 > 0, FALSE, TRUE)'], ['L', '=V._scaleX1', h], ['E', '=V.cx2 * V._scaleX1', '=V.cy2 * V._scaleY1', '=V._scaleX1', F, 0, '=A(1,3,V.cd4)', '=A(1,3,(V.cd4 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.wd6',
            top: 0,
            right: d,
            bottom: h,
        },
    },
    flowchartDelay: {
        variables: {
            wd2: E,
            d2r: A,
            idx: '=V.wd2 * COS(2700000 / V.d2r)',
            hd2: F,
            idy: '=V.hd2 * SIN(2700000 / V.d2r)',
            hc: E,
            ir: '=V.hc + V.idx',
            vc: F,
            it: '=V.vc - V.idy',
            ib: '=V.vc + V.idy',
            t: 0,
            l: 0,
            b: h,
            r: w,
            _3cd4: D,
            cd2: B,
            cx1: '=C(V.wd2,V.hc,A(V.wd2,V.hd2,V._3cd4),true)',
            cy1: '=C(V.hd2,V.t,A(V.wd2,V.hd2,V._3cd4))',
        },
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        path: [[['M', 0, 0], ['L', a, 0], ['E', '=V.cx1', '=V.cy1', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V._3cd4)', '=A(V.wd2,V.hd2,(V._3cd4 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['L', 0, h], ['Z'], {},
        ]],
        textRect: {
            left: 0,
            top: '=V.it',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    flowchartSequentialAccessStorage: {
        variables: {
            wd2: E,
            d2r: A,
            idx: '=V.wd2 * COS(2700000 / V.d2r)',
            hd2: F,
            idy: '=V.hd2 * SIN(2700000 / V.d2r)',
            hc: E,
            il: '=V.hc - V.idx',
            ir: '=V.hc + V.idx',
            vc: F,
            it: '=V.vc - V.idy',
            ib: '=V.vc + V.idy',
            ang1: '=(ATAN2(width,height) * V.d2r)',
            t: 0,
            l: 0,
            b: h,
            r: w,
            cd4: C,
            cx1: '=C(V.wd2,V.hc,A(V.wd2,V.hd2,V.cd4),true)',
            cy1: '=C(V.hd2,V.b,A(V.wd2,V.hd2,V.cd4))',
            cd2: B,
            cx2: '=C(V.wd2,P(V.cx1,V.wd2,A(V.wd2,V.hd2,(V.cd4 + V.cd4)),true),A(V.wd2,V.hd2,V.cd2),true)',
            cy2: '=C(V.hd2,P(V.cy1,V.hd2,A(V.wd2,V.hd2,(V.cd4 + V.cd4))),A(V.wd2,V.hd2,V.cd2))',
            _3cd4: D,
            cx3: '=C(V.wd2,P(V.cx2,V.wd2,A(V.wd2,V.hd2,(V.cd2 + V.cd4)),true),A(V.wd2,V.hd2,V._3cd4),true)',
            cy3: '=C(V.hd2,P(V.cy2,V.hd2,A(V.wd2,V.hd2,(V.cd2 + V.cd4))),A(V.wd2,V.hd2,V._3cd4))',
            cx4: '=C(V.wd2,P(V.cx3,V.wd2,A(V.wd2,V.hd2,(V._3cd4 + V.cd4)),true),A(V.wd2,V.hd2,0),true)',
            cy4: '=C(V.hd2,P(V.cy3,V.hd2,A(V.wd2,V.hd2,(V._3cd4 + V.cd4))),A(V.wd2,V.hd2,0))',
        },
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        path: [[['M', a, h], ['E', '=V.cx1', '=V.cy1', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V.cd4)', '=A(V.wd2,V.hd2,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx2', '=V.cy2', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V.cd2)', '=A(V.wd2,V.hd2,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx3', '=V.cy3', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V._3cd4)', '=A(V.wd2,V.hd2,(V._3cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx4', '=V.cy4', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,0)', '=A(V.wd2,V.hd2,(V.ang1))', '=IF(V.ang1 > 0, FALSE, TRUE)'], ['L', w, '=V.ib'], ['L', w, h], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.it',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    flowchartMagneticDisk: {
        variables: {
            y3: '=height * 5 / 6',
            hc: E,
            hd3: '=height/3',
            t: 0,
            l: 0,
            vc: F,
            b: h,
            r: w,
            _scaleX1: '= width / 6',
            _scaleY1: '= height / 6',
            cd2: B,
            cx1: '=C(3,0,A(3,1,V.cd2),true)',
            cy1: '=C(1,1,A(3,1,V.cd2))',
            cx2: '=C(3,6,A(3,1,0),true)',
            cy2: '=C(1,5,A(3,1,0))',
            _scaleX2: '= width / 6',
            _scaleY2: '= height / 6',
            cx3: '=C(3,6,A(3,1,0),true)',
            cy3: '=C(1,1,A(3,1,0))',
            _scaleX3: '= width / 6',
            _scaleY3: '= height / 6',
            cx4: '=C(3,0,A(3,1,V.cd2),true)',
            cy4: '=C(1,1,A(3,1,V.cd2))',
            cx5: '=C(3,6,A(3,1,0),true)',
            cy5: '=C(1,5,A(3,1,0))',
        },
        connectionPoints: [{
            x: a,
            y: '=V.hd3',
        }, {
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        path: [[['M', 0, '=V._scaleY1'], ['E', '=V.cx1 * V._scaleX1', '=V.cy1 * V._scaleY1', E, '=V._scaleY1', 0, '=A(3,1,V.cd2)', '=A(3,1,(V.cd2 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['L', w, '=5 * V._scaleY1'], ['E', '=V.cx2 * V._scaleX1', '=V.cy2 * V._scaleY1', E, '=V._scaleY1', 0, '=A(3,1,0)', '=A(3,1,(V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', w, '=V._scaleY2'], ['E', '=V.cx3 * V._scaleX2', '=V.cy3 * V._scaleY2', E, '=V._scaleY2', 0, '=A(3,1,0)', '=A(3,1,(V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], {
            fillMode: 'none',
        },
        ], [['M', 0, '=V._scaleY3'], ['E', '=V.cx4 * V._scaleX3', '=V.cy4 * V._scaleY3', E, '=V._scaleY3', 0, '=A(3,1,V.cd2)', '=A(3,1,(V.cd2 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['L', w, '=5 * V._scaleY3'], ['E', '=V.cx5 * V._scaleX3', '=V.cy5 * V._scaleY3', E, '=V._scaleY3', 0, '=A(3,1,0)', '=A(3,1,(V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['Z'], {
            fillMode: 'none',
        },
        ]],
        textRect: {
            left: 0,
            top: '=V.hd3',
            right: w,
            bottom: '=V.y3',
        },
    },
    flowchartDirectAccessStorage: {
        variables: {
            x2: '=width * 2 / 3',
            hc: E,
            t: 0,
            l: 0,
            vc: F,
            b: h,
            r: w,
            _scaleX1: '= width / 6',
            _scaleY1: '= height / 6',
            _3cd4: D,
            cd2: B,
            cx1: '=C(1,5,A(1,3,V._3cd4),true)',
            cy1: '=C(3,0,A(1,3,V._3cd4))',
            cd4: C,
            cx2: '=C(1,1,A(1,3,V.cd4),true)',
            cy2: '=C(3,6,A(1,3,V.cd4))',
            _scaleX2: '= width / 6',
            _scaleY2: '= height / 6',
            cx3: '=C(1,5,A(1,3,V.cd4),true)',
            cy3: '=C(3,6,A(1,3,V.cd4))',
            _scaleX3: '= width / 6',
            _scaleY3: '= height / 6',
            cx4: '=C(1,5,A(1,3,V._3cd4),true)',
            cy4: '=C(3,0,A(1,3,V._3cd4))',
            cx5: '=C(1,1,A(1,3,V.cd4),true)',
            cy5: '=C(3,6,A(1,3,V.cd4))',
            wd6: '=width/6',
        },
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: d,
            y: b,
        }, {
            x: w,
            y: b,
        },
        ],
        path: [[['M', '=V._scaleX1', 0], ['L', '=5 * V._scaleX1', 0], ['E', '=V.cx1 * V._scaleX1', '=V.cy1 * V._scaleY1', '=V._scaleX1', F, 0, '=A(1,3,V._3cd4)', '=A(1,3,(V._3cd4 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['L', '=V._scaleX1', h], ['E', '=V.cx2 * V._scaleX1', '=V.cy2 * V._scaleY1', '=V._scaleX1', F, 0, '=A(1,3,V.cd4)', '=A(1,3,(V.cd4 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', '=5 * V._scaleX2', h], ['E', '=V.cx3 * V._scaleX2', '=V.cy3 * V._scaleY2', '=V._scaleX2', F, 0, '=A(1,3,V.cd4)', '=A(1,3,(V.cd4 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], {
            fillMode: 'none',
        },
        ], [['M', '=V._scaleX3', 0], ['L', '=5 * V._scaleX3', 0], ['E', '=V.cx4 * V._scaleX3', '=V.cy4 * V._scaleY3', '=V._scaleX3', F, 0, '=A(1,3,V._3cd4)', '=A(1,3,(V._3cd4 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['L', '=V._scaleX3', h], ['E', '=V.cx5 * V._scaleX3', '=V.cy5 * V._scaleY3', '=V._scaleX3', F, 0, '=A(1,3,V.cd4)', '=A(1,3,(V.cd4 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['Z'], {
            fillMode: 'none',
        },
        ]],
        textRect: {
            left: '=V.wd6',
            top: 0,
            right: d,
            bottom: h,
        },
    },
    flowchartDisplay: {
        variables: {
            x2: '=width * 5 / 6',
            hc: E,
            t: 0,
            l: 0,
            vc: F,
            b: h,
            r: w,
            _scaleX1: '= width / 6',
            _scaleY1: '= height / 6',
            _3cd4: D,
            cd2: B,
            cx1: '=C(1,5,A(1,3,V._3cd4),true)',
            cy1: '=C(3,0,A(1,3,V._3cd4))',
            wd6: '=width/6',
        },
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        path: [[['M', 0, F], ['L', '=V._scaleX1', 0], ['L', '=5 * V._scaleX1', 0], ['E', '=V.cx1 * V._scaleX1', '=V.cy1 * V._scaleY1', '=V._scaleX1', F, 0, '=A(1,3,V._3cd4)', '=A(1,3,(V._3cd4 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['L', '=V._scaleX1', h], ['Z'], {},
        ]],
        textRect: {
            left: '=V.wd6',
            top: 0,
            right: d,
            bottom: h,
        },
    },
    explosion1: {
        variables: {
            x5: '=width * 4627 / 21600',
            x12: '=width * 8485 / 21600',
            x21: '=width * 16702 / 21600',
            x24: '=width * 14522 / 21600',
            y3: '=height * 6320 / 21600',
            y6: '=height * 8615 / 21600',
            y9: '=height * 13937 / 21600',
            y18: '=height * 13290 / 21600',
            t: 0,
            l: 0,
            b: h,
            r: w,
            _scaleX1: '= width / 21600',
            _scaleY1: '= height / 21600',
        },
        connectionPoints: [{
            x: '=V.x24',
            y: 0,
        }, {
            x: 0,
            y: '=V.y6',
        }, {
            x: '=V.x12',
            y: h,
        }, {
            x: w,
            y: '=V.y18',
        },
        ],
        path: [[['M', E, '=5800 * V._scaleY1'], ['L', '=14522 * V._scaleX1', 0], ['L', '=14155 * V._scaleX1', '=5325 * V._scaleY1'], ['L', '=18380 * V._scaleX1', '=4457 * V._scaleY1'], ['L', '=16702 * V._scaleX1', '=7315 * V._scaleY1'], ['L', '=21097 * V._scaleX1', '=8137 * V._scaleY1'], ['L', '=17607 * V._scaleX1', '=10475 * V._scaleY1'], ['L', w, '=13290 * V._scaleY1'], ['L', '=16837 * V._scaleX1', '=12942 * V._scaleY1'], ['L', '=18145 * V._scaleX1', '=18095 * V._scaleY1'], ['L', '=14020 * V._scaleX1', '=14457 * V._scaleY1'], ['L', '=13247 * V._scaleX1', '=19737 * V._scaleY1'], ['L', '=10532 * V._scaleX1', '=14935 * V._scaleY1'], ['L', '=8485 * V._scaleX1', h], ['L', '=7715 * V._scaleX1', '=15627 * V._scaleY1'], ['L', '=4762 * V._scaleX1', '=17617 * V._scaleY1'], ['L', '=5667 * V._scaleX1', '=13937 * V._scaleY1'], ['L', '=135 * V._scaleX1', '=14587 * V._scaleY1'], ['L', '=3722 * V._scaleX1', '=11775 * V._scaleY1'], ['L', 0, '=8615 * V._scaleY1'], ['L', '=4627 * V._scaleX1', '=7617 * V._scaleY1'], ['L', '=370 * V._scaleX1', '=2295 * V._scaleY1'], ['L', '=7312 * V._scaleX1', '=6320 * V._scaleY1'], ['L', '=8352 * V._scaleX1', '=2295 * V._scaleY1'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.x5',
            top: '=V.y3',
            right: '=V.x21',
            bottom: '=V.y9',
        },
    },
    explosion2: {
        variables: {
            x2: '=width * 9722 / 21600',
            x5: '=width * 5372 / 21600',
            x16: '=width * 11612 / 21600',
            x19: '=width * 14640 / 21600',
            y2: '=height * 1887 / 21600',
            y3: '=height * 6382 / 21600',
            y8: '=height * 12877 / 21600',
            y14: '=height * 19712 / 21600',
            y16: '=height * 18842 / 21600',
            y17: '=height * 15935 / 21600',
            y24: '=height * 6645 / 21600',
            l: 0,
            r: w,
            _scaleX1: '= width / 21600',
            _scaleY1: '= height / 21600',
        },
        connectionPoints: [{
            x: d,
            y: f,
        }, {
            x: 0,
            y: '=V.y8',
        }, {
            x: '=V.x16',
            y: '=V.y16',
        }, {
            x: w,
            y: '=V.y24',
        },
        ],
        path: [[['M', '=11462 * V._scaleX1', '=4342 * V._scaleY1'], ['L', '=14790 * V._scaleX1', 0], ['L', '=14525 * V._scaleX1', '=5777 * V._scaleY1'], ['L', '=18007 * V._scaleX1', '=3172 * V._scaleY1'], ['L', '=16380 * V._scaleX1', '=6532 * V._scaleY1'], ['L', w, '=6645 * V._scaleY1'], ['L', '=16985 * V._scaleX1', '=9402 * V._scaleY1'], ['L', '=18270 * V._scaleX1', '=11290 * V._scaleY1'], ['L', '=16380 * V._scaleX1', '=12310 * V._scaleY1'], ['L', '=18877 * V._scaleX1', '=15632 * V._scaleY1'], ['L', '=14640 * V._scaleX1', '=14350 * V._scaleY1'], ['L', '=14942 * V._scaleX1', '=17370 * V._scaleY1'], ['L', '=12180 * V._scaleX1', '=15935 * V._scaleY1'], ['L', '=11612 * V._scaleX1', '=18842 * V._scaleY1'], ['L', '=9872 * V._scaleX1', '=17370 * V._scaleY1'], ['L', '=8700 * V._scaleX1', '=19712 * V._scaleY1'], ['L', '=7527 * V._scaleX1', '=18125 * V._scaleY1'], ['L', '=4917 * V._scaleX1', h], ['L', '=4805 * V._scaleX1', '=18240 * V._scaleY1'], ['L', '=1285 * V._scaleX1', '=17825 * V._scaleY1'], ['L', '=3330 * V._scaleX1', '=15370 * V._scaleY1'], ['L', 0, '=12877 * V._scaleY1'], ['L', '=3935 * V._scaleX1', '=11592 * V._scaleY1'], ['L', '=1172 * V._scaleX1', '=8270 * V._scaleY1'], ['L', '=5372 * V._scaleX1', '=7817 * V._scaleY1'], ['L', '=4502 * V._scaleX1', '=3625 * V._scaleY1'], ['L', '=8550 * V._scaleX1', '=6382 * V._scaleY1'], ['L', '=9722 * V._scaleX1', '=1887 * V._scaleY1'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.x5',
            top: '=V.y3',
            right: '=V.x19',
            bottom: '=V.y17',
        },
    },
    shape4pointStar: {
        variables: {
            adj: 12500,
            a: '=MIN(MAX(0, V.adj), 50000)',
            wd2: E,
            iwd2: '=V.wd2 * V.a / 50000',
            hd2: F,
            ihd2: '=V.hd2 * V.a / 50000',
            d2r: A,
            sdx: '=V.iwd2 * COS(2700000 / V.d2r)',
            sdy: '=V.ihd2 * SIN(2700000 / V.d2r)',
            hc: E,
            sx1: '=V.hc - V.sdx',
            sx2: '=V.hc + V.sdx',
            vc: F,
            sy1: '=V.vc - V.sdy',
            sy2: '=V.vc + V.sdy',
            yAdj: '=V.vc - V.ihd2',
            t: 0,
            l: 0,
            b: h,
            r: w,
        },
        adjustInfo: [['adj', 12500]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj',
            minY: 0,
            maxY: 50000,
            position: {
                x: 'hc',
                y: 'yAdj',
            },
            point: [a, '=V.yAdj'],
        },
        ],
        path: [[['M', 0, b], ['L', '=V.sx1', '=V.sy1'], ['L', a, 0], ['L', '=V.sx2', '=V.sy1'], ['L', w, b], ['L', '=V.sx2', '=V.sy2'], ['L', a, h], ['L', '=V.sx1', '=V.sy2'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.sx1',
            top: '=V.sy1',
            right: '=V.sx2',
            bottom: '=V.sy2',
        },
    },
    shape5pointStar: {
        variables: {
            adj: 19098,
            hf: 105146,
            vf: 110557,
            a: '=MIN(MAX(0, V.adj), 50000)',
            wd2: E,
            swd2: '=V.wd2 * V.hf / 100000',
            hd2: F,
            shd2: '=V.hd2 * V.vf / 100000',
            vc: F,
            svc: '=V.vc * V.vf / 100000',
            d2r: A,
            dx1: '=V.swd2 * COS(1080000 / V.d2r)',
            dx2: '=V.swd2 * COS(18360000 / V.d2r)',
            dy1: '=V.shd2 * SIN(1080000 / V.d2r)',
            dy2: '=V.shd2 * SIN(18360000 / V.d2r)',
            hc: E,
            x1: '=V.hc - V.dx1',
            x2: '=V.hc - V.dx2',
            x3: '=V.hc + V.dx2',
            x4: '=V.hc + V.dx1',
            y1: '=V.svc - V.dy1',
            y2: '=V.svc - V.dy2',
            iwd2: '=V.swd2 * V.a / 50000',
            ihd2: '=V.shd2 * V.a / 50000',
            sdx1: '=V.iwd2 * COS(20520000 / V.d2r)',
            sdx2: '=V.iwd2 * COS(3240000 / V.d2r)',
            sdy1: '=V.ihd2 * SIN(3240000 / V.d2r)',
            sdy2: '=V.ihd2 * SIN(20520000 / V.d2r)',
            sx1: '=V.hc - V.sdx1',
            sx2: '=V.hc - V.sdx2',
            sx3: '=V.hc + V.sdx2',
            sx4: '=V.hc + V.sdx1',
            sy1: '=V.svc - V.sdy1',
            sy2: '=V.svc - V.sdy2',
            sy3: '=V.svc + V.ihd2',
            yAdj: '=V.svc - V.ihd2',
            t: 0,
        },
        adjustInfo: [['adj', 19098], ['hf', 105146], ['vf', 110557]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: c,
            y: e,
        }, {
            x: d,
            y: f,
        }, {
            x: '=V.x3',
            y: f,
        }, {
            x: '=V.x4',
            y: e,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj',
            minY: 0,
            maxY: 50000,
            position: {
                x: 'hc',
                y: 'yAdj',
            },
            point: [a, '=V.yAdj'],
        },
        ],
        path: [[['M', c, e], ['L', '=V.sx2', '=V.sy1'], ['L', a, 0], ['L', '=V.sx3', '=V.sy1'], ['L', '=V.x4', e], ['L', '=V.sx4', '=V.sy2'], ['L', '=V.x3', f], ['L', a, '=V.sy3'], ['L', d, f], ['L', '=V.sx1', '=V.sy2'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.sx1',
            top: '=V.sy1',
            right: '=V.sx4',
            bottom: '=V.sy3',
        },
    },
    shape8pointStar: {
        variables: {
            adj: 37500,
            a: '=MIN(MAX(0, V.adj), 50000)',
            wd2: E,
            d2r: A,
            dx1: '=V.wd2 * COS(2700000 / V.d2r)',
            hc: E,
            x1: '=V.hc - V.dx1',
            x2: '=V.hc + V.dx1',
            hd2: F,
            dy1: '=V.hd2 * SIN(2700000 / V.d2r)',
            vc: F,
            y1: '=V.vc - V.dy1',
            y2: '=V.vc + V.dy1',
            iwd2: '=V.wd2 * V.a / 50000',
            ihd2: '=V.hd2 * V.a / 50000',
            sdx1: '=V.iwd2 * 92388 / 100000',
            sdx2: '=V.iwd2 * 38268 / 100000',
            sdy1: '=V.ihd2 * 92388 / 100000',
            sdy2: '=V.ihd2 * 38268 / 100000',
            sx1: '=V.hc - V.sdx1',
            sx2: '=V.hc - V.sdx2',
            sx3: '=V.hc + V.sdx2',
            sx4: '=V.hc + V.sdx1',
            sy1: '=V.vc - V.sdy1',
            sy2: '=V.vc - V.sdy2',
            sy3: '=V.vc + V.sdy2',
            sy4: '=V.vc + V.sdy1',
            yAdj: '=V.vc - V.ihd2',
            r: w,
            b: h,
            l: 0,
            t: 0,
        },
        adjustInfo: [['adj', 37500]],
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: d,
            y: f,
        }, {
            x: a,
            y: h,
        }, {
            x: c,
            y: f,
        }, {
            x: 0,
            y: b,
        }, {
            x: c,
            y: e,
        }, {
            x: a,
            y: 0,
        }, {
            x: d,
            y: e,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj',
            minY: 0,
            maxY: 50000,
            position: {
                x: 'hc',
                y: 'yAdj',
            },
            point: [a, '=V.yAdj'],
        },
        ],
        path: [[['M', 0, b], ['L', '=V.sx1', '=V.sy2'], ['L', c, e], ['L', '=V.sx2', '=V.sy1'], ['L', a, 0], ['L', '=V.sx3', '=V.sy1'], ['L', d, e], ['L', '=V.sx4', '=V.sy2'], ['L', w, b], ['L', '=V.sx4', '=V.sy3'], ['L', d, f], ['L', '=V.sx3', '=V.sy4'], ['L', a, h], ['L', '=V.sx2', '=V.sy4'], ['L', c, f], ['L', '=V.sx1', '=V.sy3'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.sx1',
            top: '=V.sy1',
            right: '=V.sx4',
            bottom: '=V.sy4',
        },
    },
    shape16pointStar: {
        variables: {
            adj: 37500,
            a: '=MIN(MAX(0, V.adj), 50000)',
            wd2: E,
            dx1: '=V.wd2 * 92388 / 100000',
            dx2: '=V.wd2 * 70711 / 100000',
            dx3: '=V.wd2 * 38268 / 100000',
            hd2: F,
            dy1: '=V.hd2 * 92388 / 100000',
            dy2: '=V.hd2 * 70711 / 100000',
            dy3: '=V.hd2 * 38268 / 100000',
            hc: E,
            x1: '=V.hc - V.dx1',
            x2: '=V.hc - V.dx2',
            x3: '=V.hc - V.dx3',
            x4: '=V.hc + V.dx3',
            x5: '=V.hc + V.dx2',
            x6: '=V.hc + V.dx1',
            vc: F,
            y1: '=V.vc - V.dy1',
            y2: '=V.vc - V.dy2',
            y3: '=V.vc - V.dy3',
            y4: '=V.vc + V.dy3',
            y5: '=V.vc + V.dy2',
            y6: '=V.vc + V.dy1',
            iwd2: '=V.wd2 * V.a / 50000',
            ihd2: '=V.hd2 * V.a / 50000',
            sdx1: '=V.iwd2 * 98079 / 100000',
            sdx2: '=V.iwd2 * 83147 / 100000',
            sdx3: '=V.iwd2 * 55557 / 100000',
            sdx4: '=V.iwd2 * 19509 / 100000',
            sdy1: '=V.ihd2 * 98079 / 100000',
            sdy2: '=V.ihd2 * 83147 / 100000',
            sdy3: '=V.ihd2 * 55557 / 100000',
            sdy4: '=V.ihd2 * 19509 / 100000',
            sx1: '=V.hc - V.sdx1',
            sx2: '=V.hc - V.sdx2',
            sx3: '=V.hc - V.sdx3',
            sx4: '=V.hc - V.sdx4',
            sx5: '=V.hc + V.sdx4',
            sx6: '=V.hc + V.sdx3',
            sx7: '=V.hc + V.sdx2',
            sx8: '=V.hc + V.sdx1',
            sy1: '=V.vc - V.sdy1',
            sy2: '=V.vc - V.sdy2',
            sy3: '=V.vc - V.sdy3',
            sy4: '=V.vc - V.sdy4',
            sy5: '=V.vc + V.sdy4',
            sy6: '=V.vc + V.sdy3',
            sy7: '=V.vc + V.sdy2',
            sy8: '=V.vc + V.sdy1',
            d2r: A,
            idx: '=V.iwd2 * COS(2700000 / V.d2r)',
            idy: '=V.ihd2 * SIN(2700000 / V.d2r)',
            il: '=V.hc - V.idx',
            it: '=V.vc - V.idy',
            ir: '=V.hc + V.idx',
            ib: '=V.vc + V.idy',
            yAdj: '=V.vc - V.ihd2',
            r: w,
            b: h,
            l: 0,
            t: 0,
        },
        adjustInfo: [['adj', 37500]],
        connectionPoints: [{
            x: '=V.x5',
            y: f,
        }, {
            x: '=V.x6',
            y: '=V.y3',
        }, {
            x: w,
            y: b,
        }, {
            x: '=V.x6',
            y: '=V.y4',
        }, {
            x: '=V.x5',
            y: '=V.y5',
        }, {
            x: '=V.x4',
            y: '=V.y6',
        }, {
            x: a,
            y: h,
        }, {
            x: '=V.x3',
            y: '=V.y6',
        }, {
            x: d,
            y: '=V.y5',
        }, {
            x: c,
            y: '=V.y4',
        }, {
            x: 0,
            y: b,
        }, {
            x: c,
            y: '=V.y3',
        }, {
            x: d,
            y: f,
        }, {
            x: '=V.x3',
            y: e,
        }, {
            x: a,
            y: 0,
        }, {
            x: '=V.x4',
            y: e,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj',
            minY: 0,
            maxY: 50000,
            position: {
                x: 'hc',
                y: 'yAdj',
            },
            point: [a, '=V.yAdj'],
        },
        ],
        path: [[['M', 0, b], ['L', '=V.sx1', '=V.sy4'], ['L', c, '=V.y3'], ['L', '=V.sx2', '=V.sy3'], ['L', d, f], ['L', '=V.sx3', '=V.sy2'], ['L', '=V.x3', e], ['L', '=V.sx4', '=V.sy1'], ['L', a, 0], ['L', '=V.sx5', '=V.sy1'], ['L', '=V.x4', e], ['L', '=V.sx6', '=V.sy2'], ['L', '=V.x5', f], ['L', '=V.sx7', '=V.sy3'], ['L', '=V.x6', '=V.y3'], ['L', '=V.sx8', '=V.sy4'], ['L', w, b], ['L', '=V.sx8', '=V.sy5'], ['L', '=V.x6', '=V.y4'], ['L', '=V.sx7', '=V.sy6'], ['L', '=V.x5', '=V.y5'], ['L', '=V.sx6', '=V.sy7'], ['L', '=V.x4', '=V.y6'], ['L', '=V.sx5', '=V.sy8'], ['L', a, h], ['L', '=V.sx4', '=V.sy8'], ['L', '=V.x3', '=V.y6'], ['L', '=V.sx3', '=V.sy7'], ['L', d, '=V.y5'], ['L', '=V.sx2', '=V.sy6'], ['L', c, '=V.y4'], ['L', '=V.sx1', '=V.sy5'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.it',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    shape24pointStar: {
        variables: {
            adj: 37500,
            a: '=MIN(MAX(0, V.adj), 50000)',
            wd2: E,
            d2r: A,
            dx1: '=V.wd2 * COS(900000 / V.d2r)',
            dx2: '=V.wd2 * COS(1800000 / V.d2r)',
            dx3: '=V.wd2 * COS(2700000 / V.d2r)',
            wd4: '=width/4',
            dx4: '=V.wd4',
            dx5: '=V.wd2 * COS(4500000 / V.d2r)',
            hd2: F,
            dy1: '=V.hd2 * SIN(4500000 / V.d2r)',
            dy2: '=V.hd2 * SIN(3600000 / V.d2r)',
            dy3: '=V.hd2 * SIN(2700000 / V.d2r)',
            hd4: '=height/4',
            dy4: '=V.hd4',
            dy5: '=V.hd2 * SIN(900000 / V.d2r)',
            hc: E,
            x1: '=V.hc - V.dx1',
            x2: '=V.hc - V.dx2',
            x3: '=V.hc - V.dx3',
            x4: '=V.hc - V.dx4',
            x5: '=V.hc - V.dx5',
            x6: '=V.hc + V.dx5',
            x7: '=V.hc + V.dx4',
            x8: '=V.hc + V.dx3',
            x9: '=V.hc + V.dx2',
            x10: '=V.hc + V.dx1',
            vc: F,
            y1: '=V.vc - V.dy1',
            y2: '=V.vc - V.dy2',
            y3: '=V.vc - V.dy3',
            y4: '=V.vc - V.dy4',
            y5: '=V.vc - V.dy5',
            y6: '=V.vc + V.dy5',
            y7: '=V.vc + V.dy4',
            y8: '=V.vc + V.dy3',
            y9: '=V.vc + V.dy2',
            y10: '=V.vc + V.dy1',
            iwd2: '=V.wd2 * V.a / 50000',
            ihd2: '=V.hd2 * V.a / 50000',
            sdx1: '=V.iwd2 * 99144 / 100000',
            sdx2: '=V.iwd2 * 92388 / 100000',
            sdx3: '=V.iwd2 * 79335 / 100000',
            sdx4: '=V.iwd2 * 60876 / 100000',
            sdx5: '=V.iwd2 * 38268 / 100000',
            sdx6: '=V.iwd2 * 13053 / 100000',
            sdy1: '=V.ihd2 * 99144 / 100000',
            sdy2: '=V.ihd2 * 92388 / 100000',
            sdy3: '=V.ihd2 * 79335 / 100000',
            sdy4: '=V.ihd2 * 60876 / 100000',
            sdy5: '=V.ihd2 * 38268 / 100000',
            sdy6: '=V.ihd2 * 13053 / 100000',
            sx1: '=V.hc - V.sdx1',
            sx2: '=V.hc - V.sdx2',
            sx3: '=V.hc - V.sdx3',
            sx4: '=V.hc - V.sdx4',
            sx5: '=V.hc - V.sdx5',
            sx6: '=V.hc - V.sdx6',
            sx7: '=V.hc + V.sdx6',
            sx8: '=V.hc + V.sdx5',
            sx9: '=V.hc + V.sdx4',
            sx10: '=V.hc + V.sdx3',
            sx11: '=V.hc + V.sdx2',
            sx12: '=V.hc + V.sdx1',
            sy1: '=V.vc - V.sdy1',
            sy2: '=V.vc - V.sdy2',
            sy3: '=V.vc - V.sdy3',
            sy4: '=V.vc - V.sdy4',
            sy5: '=V.vc - V.sdy5',
            sy6: '=V.vc - V.sdy6',
            sy7: '=V.vc + V.sdy6',
            sy8: '=V.vc + V.sdy5',
            sy9: '=V.vc + V.sdy4',
            sy10: '=V.vc + V.sdy3',
            sy11: '=V.vc + V.sdy2',
            sy12: '=V.vc + V.sdy1',
            idx: '=V.iwd2 * COS(2700000 / V.d2r)',
            idy: '=V.ihd2 * SIN(2700000 / V.d2r)',
            il: '=V.hc - V.idx',
            it: '=V.vc - V.idy',
            ir: '=V.hc + V.idx',
            ib: '=V.vc + V.idy',
            yAdj: '=V.vc - V.ihd2',
            t: 0,
            l: 0,
            b: h,
            r: w,
        },
        adjustInfo: [['adj', 37500]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj',
            minY: 0,
            maxY: 50000,
            position: {
                x: 'hc',
                y: 'yAdj',
            },
            point: [a, '=V.yAdj'],
        },
        ],
        path: [[['M', 0, b], ['L', '=V.sx1', '=V.sy6'], ['L', c, '=V.y5'], ['L', '=V.sx2', '=V.sy5'], ['L', d, '=V.y4'], ['L', '=V.sx3', '=V.sy4'], ['L', '=V.x3', '=V.y3'], ['L', '=V.sx4', '=V.sy3'], ['L', '=V.x4', f], ['L', '=V.sx5', '=V.sy2'], ['L', '=V.x5', e], ['L', '=V.sx6', '=V.sy1'], ['L', a, 0], ['L', '=V.sx7', '=V.sy1'], ['L', '=V.x6', e], ['L', '=V.sx8', '=V.sy2'], ['L', '=V.x7', f], ['L', '=V.sx9', '=V.sy3'], ['L', '=V.x8', '=V.y3'], ['L', '=V.sx10', '=V.sy4'], ['L', '=V.x9', '=V.y4'], ['L', '=V.sx11', '=V.sy5'], ['L', '=V.x10', '=V.y5'], ['L', '=V.sx12', '=V.sy6'], ['L', w, b], ['L', '=V.sx12', '=V.sy7'], ['L', '=V.x10', '=V.y6'], ['L', '=V.sx11', '=V.sy8'], ['L', '=V.x9', '=V.y7'], ['L', '=V.sx10', '=V.sy9'], ['L', '=V.x8', '=V.y8'], ['L', '=V.sx9', '=V.sy10'], ['L', '=V.x7', '=V.y9'], ['L', '=V.sx8', '=V.sy11'], ['L', '=V.x6', '=V.y10'], ['L', '=V.sx7', '=V.sy12'], ['L', a, h], ['L', '=V.sx6', '=V.sy12'], ['L', '=V.x5', '=V.y10'], ['L', '=V.sx5', '=V.sy11'], ['L', '=V.x4', '=V.y9'], ['L', '=V.sx4', '=V.sy10'], ['L', '=V.x3', '=V.y8'], ['L', '=V.sx3', '=V.sy9'], ['L', d, '=V.y7'], ['L', '=V.sx2', '=V.sy8'], ['L', c, '=V.y6'], ['L', '=V.sx1', '=V.sy7'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.it',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    shape32pointStar: {
        variables: {
            adj: 37500,
            a: '=MIN(MAX(0, V.adj), 50000)',
            wd2: E,
            dx1: '=V.wd2 * 98079 / 100000',
            dx2: '=V.wd2 * 92388 / 100000',
            dx3: '=V.wd2 * 83147 / 100000',
            d2r: A,
            dx4: '=V.wd2 * COS(2700000 / V.d2r)',
            dx5: '=V.wd2 * 55557 / 100000',
            dx6: '=V.wd2 * 38268 / 100000',
            dx7: '=V.wd2 * 19509 / 100000',
            hd2: F,
            dy1: '=V.hd2 * 98079 / 100000',
            dy2: '=V.hd2 * 92388 / 100000',
            dy3: '=V.hd2 * 83147 / 100000',
            dy4: '=V.hd2 * SIN(2700000 / V.d2r)',
            dy5: '=V.hd2 * 55557 / 100000',
            dy6: '=V.hd2 * 38268 / 100000',
            dy7: '=V.hd2 * 19509 / 100000',
            hc: E,
            x1: '=V.hc - V.dx1',
            x2: '=V.hc - V.dx2',
            x3: '=V.hc - V.dx3',
            x4: '=V.hc - V.dx4',
            x5: '=V.hc - V.dx5',
            x6: '=V.hc - V.dx6',
            x7: '=V.hc - V.dx7',
            x8: '=V.hc + V.dx7',
            x9: '=V.hc + V.dx6',
            x10: '=V.hc + V.dx5',
            x11: '=V.hc + V.dx4',
            x12: '=V.hc + V.dx3',
            x13: '=V.hc + V.dx2',
            x14: '=V.hc + V.dx1',
            vc: F,
            y1: '=V.vc - V.dy1',
            y2: '=V.vc - V.dy2',
            y3: '=V.vc - V.dy3',
            y4: '=V.vc - V.dy4',
            y5: '=V.vc - V.dy5',
            y6: '=V.vc - V.dy6',
            y7: '=V.vc - V.dy7',
            y8: '=V.vc + V.dy7',
            y9: '=V.vc + V.dy6',
            y10: '=V.vc + V.dy5',
            y11: '=V.vc + V.dy4',
            y12: '=V.vc + V.dy3',
            y13: '=V.vc + V.dy2',
            y14: '=V.vc + V.dy1',
            iwd2: '=V.wd2 * V.a / 50000',
            ihd2: '=V.hd2 * V.a / 50000',
            sdx1: '=V.iwd2 * 99518 / 100000',
            sdx2: '=V.iwd2 * 95694 / 100000',
            sdx3: '=V.iwd2 * 88192 / 100000',
            sdx4: '=V.iwd2 * 77301 / 100000',
            sdx5: '=V.iwd2 * 63439 / 100000',
            sdx6: '=V.iwd2 * 47140 / 100000',
            sdx7: '=V.iwd2 * 29028 / 100000',
            sdx8: '=V.iwd2 * 9802 / 100000',
            sdy1: '=V.ihd2 * 99518 / 100000',
            sdy2: '=V.ihd2 * 95694 / 100000',
            sdy3: '=V.ihd2 * 88192 / 100000',
            sdy4: '=V.ihd2 * 77301 / 100000',
            sdy5: '=V.ihd2 * 63439 / 100000',
            sdy6: '=V.ihd2 * 47140 / 100000',
            sdy7: '=V.ihd2 * 29028 / 100000',
            sdy8: '=V.ihd2 * 9802 / 100000',
            sx1: '=V.hc - V.sdx1',
            sx2: '=V.hc - V.sdx2',
            sx3: '=V.hc - V.sdx3',
            sx4: '=V.hc - V.sdx4',
            sx5: '=V.hc - V.sdx5',
            sx6: '=V.hc - V.sdx6',
            sx7: '=V.hc - V.sdx7',
            sx8: '=V.hc - V.sdx8',
            sx9: '=V.hc + V.sdx8',
            sx10: '=V.hc + V.sdx7',
            sx11: '=V.hc + V.sdx6',
            sx12: '=V.hc + V.sdx5',
            sx13: '=V.hc + V.sdx4',
            sx14: '=V.hc + V.sdx3',
            sx15: '=V.hc + V.sdx2',
            sx16: '=V.hc + V.sdx1',
            sy1: '=V.vc - V.sdy1',
            sy2: '=V.vc - V.sdy2',
            sy3: '=V.vc - V.sdy3',
            sy4: '=V.vc - V.sdy4',
            sy5: '=V.vc - V.sdy5',
            sy6: '=V.vc - V.sdy6',
            sy7: '=V.vc - V.sdy7',
            sy8: '=V.vc - V.sdy8',
            sy9: '=V.vc + V.sdy8',
            sy10: '=V.vc + V.sdy7',
            sy11: '=V.vc + V.sdy6',
            sy12: '=V.vc + V.sdy5',
            sy13: '=V.vc + V.sdy4',
            sy14: '=V.vc + V.sdy3',
            sy15: '=V.vc + V.sdy2',
            sy16: '=V.vc + V.sdy1',
            idx: '=V.iwd2 * COS(2700000 / V.d2r)',
            idy: '=V.ihd2 * SIN(2700000 / V.d2r)',
            il: '=V.hc - V.idx',
            it: '=V.vc - V.idy',
            ir: '=V.hc + V.idx',
            ib: '=V.vc + V.idy',
            yAdj: '=V.vc - V.ihd2',
            t: 0,
            l: 0,
            b: h,
            r: w,
        },
        adjustInfo: [['adj', 37500]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj',
            minY: 0,
            maxY: 50000,
            position: {
                x: 'hc',
                y: 'yAdj',
            },
            point: [a, '=V.yAdj'],
        },
        ],
        path: [[['M', 0, b], ['L', '=V.sx1', '=V.sy8'], ['L', c, '=V.y7'], ['L', '=V.sx2', '=V.sy7'], ['L', d, '=V.y6'], ['L', '=V.sx3', '=V.sy6'], ['L', '=V.x3', '=V.y5'], ['L', '=V.sx4', '=V.sy5'], ['L', '=V.x4', '=V.y4'], ['L', '=V.sx5', '=V.sy4'], ['L', '=V.x5', '=V.y3'], ['L', '=V.sx6', '=V.sy3'], ['L', '=V.x6', f], ['L', '=V.sx7', '=V.sy2'], ['L', '=V.x7', e], ['L', '=V.sx8', '=V.sy1'], ['L', a, 0], ['L', '=V.sx9', '=V.sy1'], ['L', '=V.x8', e], ['L', '=V.sx10', '=V.sy2'], ['L', '=V.x9', f], ['L', '=V.sx11', '=V.sy3'], ['L', '=V.x10', '=V.y3'], ['L', '=V.sx12', '=V.sy4'], ['L', '=V.x11', '=V.y4'], ['L', '=V.sx13', '=V.sy5'], ['L', '=V.x12', '=V.y5'], ['L', '=V.sx14', '=V.sy6'], ['L', '=V.x13', '=V.y6'], ['L', '=V.sx15', '=V.sy7'], ['L', '=V.x14', '=V.y7'], ['L', '=V.sx16', '=V.sy8'], ['L', w, b], ['L', '=V.sx16', '=V.sy9'], ['L', '=V.x14', '=V.y8'], ['L', '=V.sx15', '=V.sy10'], ['L', '=V.x13', '=V.y9'], ['L', '=V.sx14', '=V.sy11'], ['L', '=V.x12', '=V.y10'], ['L', '=V.sx13', '=V.sy12'], ['L', '=V.x11', '=V.y11'], ['L', '=V.sx12', '=V.sy13'], ['L', '=V.x10', '=V.y12'], ['L', '=V.sx11', '=V.sy14'], ['L', '=V.x9', '=V.y13'], ['L', '=V.sx10', '=V.sy15'], ['L', '=V.x8', '=V.y14'], ['L', '=V.sx9', '=V.sy16'], ['L', a, h], ['L', '=V.sx8', '=V.sy16'], ['L', '=V.x7', '=V.y14'], ['L', '=V.sx7', '=V.sy15'], ['L', '=V.x6', '=V.y13'], ['L', '=V.sx6', '=V.sy14'], ['L', '=V.x5', '=V.y12'], ['L', '=V.sx5', '=V.sy13'], ['L', '=V.x4', '=V.y11'], ['L', '=V.sx4', '=V.sy12'], ['L', '=V.x3', '=V.y10'], ['L', '=V.sx3', '=V.sy11'], ['L', d, '=V.y9'], ['L', '=V.sx2', '=V.sy10'], ['L', c, '=V.y8'], ['L', '=V.sx1', '=V.sy9'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.it',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    upRibbon: {
        variables: {
            adj1: 16667,
            adj2: 50000,
            a1: '=MIN(MAX(0, V.adj1), 33333)',
            a2: '=MIN(MAX(25000, V.adj2), 75000)',
            r: w,
            wd8: '=width/8',
            x10: '=width - V.wd8',
            dx2: '=width * V.a2 / 200000',
            hc: E,
            x2: '=V.hc - V.dx2',
            x9: '=V.hc + V.dx2',
            wd32: '=width/32',
            x3: '=V.x2 + V.wd32',
            x8: '=V.x9 - V.wd32',
            x5: '=V.x2 + V.wd8',
            x6: '=V.x9 - V.wd8',
            x4: '=V.x5 - V.wd32',
            x7: '=V.x6 + V.wd32',
            dy1: '=height * V.a1 / 200000',
            b: h,
            y1: '=height - V.dy1',
            dy2: '=height * V.a1 / 100000',
            y2: '=height - V.dy2',
            t: 0,
            y4: '=V.dy2',
            y3: '=(V.y4 + V.b) / 2',
            hR: '=height * V.a1 / 400000',
            y6: '=height - V.hR',
            y7: '=V.y1 - V.hR',
            l: 0,
            cd4: C,
            cx1: '=C(V.wd32,V.x4,A(V.wd32,V.hR,V.cd4),true)',
            cy1: '=C(V.hR,V.b,A(V.wd32,V.hR,V.cd4))',
            cd2: B,
            cx2: '=C(V.wd32,V.x3,A(V.wd32,V.hR,V.cd4),true)',
            cy2: '=C(V.hR,V.y1,A(V.wd32,V.hR,V.cd4))',
            _3cd4: D,
            cx3: '=C(V.wd32,V.x8,A(V.wd32,V.hR,V._3cd4),true)',
            cy3: '=C(V.hR,V.y2,A(V.wd32,V.hR,V._3cd4))',
            cx4: '=C(V.wd32,V.x7,A(V.wd32,V.hR,V._3cd4),true)',
            cy4: '=C(V.hR,V.y1,A(V.wd32,V.hR,V._3cd4))',
            cx5: '=C(V.wd32,V.x9,A(V.wd32,V.hR,0),true)',
            cy5: '=C(V.hR,V.hR,A(V.wd32,V.hR,0))',
            cx6: '=C(V.wd32,V.x3,A(V.wd32,V.hR,V._3cd4),true)',
            cy6: '=C(V.hR,V.t,A(V.wd32,V.hR,V._3cd4))',
            cx7: '=C(V.wd32,V.x5,A(V.wd32,V.hR,0),true)',
            cy7: '=C(V.hR,V.y6,A(V.wd32,V.hR,0))',
            cx8: '=C(V.wd32,V.x3,A(V.wd32,V.hR,V.cd4),true)',
            cy8: '=C(V.hR,V.y1,A(V.wd32,V.hR,V.cd4))',
            cx9: '=C(V.wd32,V.x6,A(V.wd32,V.hR,V.cd2),true)',
            cy9: '=C(V.hR,V.y6,A(V.wd32,V.hR,V.cd2))',
            cx10: '=C(V.wd32,V.x8,A(V.wd32,V.hR,V.cd4),true)',
            cy10: '=C(V.hR,V.y1,A(V.wd32,V.hR,V.cd4))',
            cx11: '=C(V.wd32,V.x2,A(V.wd32,V.hR,V.cd2),true)',
            cy11: '=C(V.hR,V.hR,A(V.wd32,V.hR,V.cd2))',
            cx12: '=C(V.wd32,V.x8,A(V.wd32,V.hR,V._3cd4),true)',
            cy12: '=C(V.hR,V.t,A(V.wd32,V.hR,V._3cd4))',
            cx13: '=C(V.wd32,V.x7,A(V.wd32,V.hR,V.cd4),true)',
            cy13: '=C(V.hR,V.b,A(V.wd32,V.hR,V.cd4))',
            cx14: '=C(V.wd32,V.x8,A(V.wd32,V.hR,V.cd4),true)',
            cy14: '=C(V.hR,V.y1,A(V.wd32,V.hR,V.cd4))',
            cx15: '=C(V.wd32,V.x3,A(V.wd32,V.hR,V._3cd4),true)',
            cy15: '=C(V.hR,V.y2,A(V.wd32,V.hR,V._3cd4))',
            cx16: '=C(V.wd32,V.x4,A(V.wd32,V.hR,V._3cd4),true)',
            cy16: '=C(V.hR,V.y1,A(V.wd32,V.hR,V._3cd4))',
        },
        adjustInfo: [['adj1', 16667], ['adj2', 50000]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: '=V.wd8',
            y: '=V.y3',
        }, {
            x: a,
            y: f,
        }, {
            x: '=V.x10',
            y: '=V.y3',
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj1',
            minY: 0,
            maxY: 33333,
            position: {
                x: 'hc',
                y: 'y2',
            },
            point: [a, f],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: 25000,
            maxX: 75000,
            position: {
                x: 'x2',
                y: 'b',
            },
            point: [d, h],
        },
        ],
        path: [[['M', 0, h], ['L', '=V.x4', h], ['E', '=V.cx1', '=V.cy1', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V.cd4)', '=A(V.wd32,V.hR,(V.cd4 + -10800000))', '=IF(-10800000 > 0, FALSE, TRUE)'], ['L', '=V.x3', e], ['E', '=V.cx2', '=V.cy2', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V.cd4)', '=A(V.wd32,V.hR,(V.cd4 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['L', '=V.x8', f], ['E', '=V.cx3', '=V.cy3', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V._3cd4)', '=A(V.wd32,V.hR,(V._3cd4 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['L', '=V.x7', e], ['E', '=V.cx4', '=V.cy4', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V._3cd4)', '=A(V.wd32,V.hR,(V._3cd4 + -10800000))', '=IF(-10800000 > 0, FALSE, TRUE)'], ['L', w, h], ['L', '=V.x10', '=V.y3'], ['L', w, '=V.y4'], ['L', '=V.x9', '=V.y4'], ['L', '=V.x9', '=V.hR'], ['E', '=V.cx5', '=V.cy5', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,0)', '=A(V.wd32,V.hR,(-5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['L', '=V.x3', 0], ['E', '=V.cx6', '=V.cy6', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V._3cd4)', '=A(V.wd32,V.hR,(V._3cd4 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['L', d, '=V.y4'], ['L', 0, '=V.y4'], ['L', '=V.wd8', '=V.y3'], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', '=V.x5', '=V.y6'], ['E', '=V.cx7', '=V.cy7', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,0)', '=A(V.wd32,V.hR,(-5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['L', '=V.x3', e], ['E', '=V.cx8', '=V.cy8', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V.cd4)', '=A(V.wd32,V.hR,(V.cd4 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['L', '=V.x5', f], ['Z'], ['M', '=V.x6', '=V.y6'], ['E', '=V.cx9', '=V.cy9', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V.cd2)', '=A(V.wd32,V.hR,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', '=V.x8', e], ['E', '=V.cx10', '=V.cy10', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V.cd4)', '=A(V.wd32,V.hR,(V.cd4 + -10800000))', '=IF(-10800000 > 0, FALSE, TRUE)'], ['L', '=V.x6', f], ['Z'], {
            fillMode: 'darkenLess',
            strokeMode: 'false',
        },
        ], [['M', 0, h], ['L', '=V.wd8', '=V.y3'], ['L', 0, '=V.y4'], ['L', d, '=V.y4'], ['L', d, '=V.hR'], ['E', '=V.cx11', '=V.cy11', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V.cd2)', '=A(V.wd32,V.hR,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', '=V.x8', 0], ['E', '=V.cx12', '=V.cy12', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V._3cd4)', '=A(V.wd32,V.hR,(V._3cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', '=V.x9', '=V.y4'], ['L', '=V.x9', '=V.y4'], ['L', w, '=V.y4'], ['L', '=V.x10', '=V.y3'], ['L', w, h], ['L', '=V.x7', h], ['E', '=V.cx13', '=V.cy13', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V.cd4)', '=A(V.wd32,V.hR,(V.cd4 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['L', '=V.x8', e], ['E', '=V.cx14', '=V.cy14', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V.cd4)', '=A(V.wd32,V.hR,(V.cd4 + -10800000))', '=IF(-10800000 > 0, FALSE, TRUE)'], ['L', '=V.x3', f], ['E', '=V.cx15', '=V.cy15', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V._3cd4)', '=A(V.wd32,V.hR,(V._3cd4 + -10800000))', '=IF(-10800000 > 0, FALSE, TRUE)'], ['L', '=V.x4', e], ['E', '=V.cx16', '=V.cy16', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V._3cd4)', '=A(V.wd32,V.hR,(V._3cd4 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['Z'], ['M', '=V.x5', f], ['L', '=V.x5', '=V.y6'], ['M', '=V.x6', '=V.y6'], ['L', '=V.x6', f], ['M', d, '=V.y7'], ['L', d, '=V.y4'], ['M', '=V.x9', '=V.y4'], ['L', '=V.x9', '=V.y7'], {
            fillMode: 'none',
        },
        ]],
        textRect: {
            left: d,
            top: 0,
            right: '=V.x9',
            bottom: f,
        },
    },
    downRibbon: {
        variables: {
            adj1: 16667,
            adj2: 50000,
            a1: '=MIN(MAX(0, V.adj1), 33333)',
            a2: '=MIN(MAX(25000, V.adj2), 75000)',
            r: w,
            wd8: '=width/8',
            x10: '=width - V.wd8',
            dx2: '=width * V.a2 / 200000',
            hc: E,
            x2: '=V.hc - V.dx2',
            x9: '=V.hc + V.dx2',
            wd32: '=width/32',
            x3: '=V.x2 + V.wd32',
            x8: '=V.x9 - V.wd32',
            x5: '=V.x2 + V.wd8',
            x6: '=V.x9 - V.wd8',
            x4: '=V.x5 - V.wd32',
            x7: '=V.x6 + V.wd32',
            y1: '=height * V.a1 / 200000',
            y2: '=height * V.a1 / 100000',
            b: h,
            y4: '=height - V.y2',
            y3: '=V.y4 / 2',
            hR: '=height * V.a1 / 400000',
            y5: '=height - V.hR',
            y6: '=V.y2 - V.hR',
            t: 0,
            l: 0,
            _3cd4: D,
            cd2: B,
            cx1: '=C(V.wd32,V.x4,A(V.wd32,V.hR,V._3cd4),true)',
            cy1: '=C(V.hR,V.t,A(V.wd32,V.hR,V._3cd4))',
            cx2: '=C(V.wd32,V.x3,A(V.wd32,V.hR,V._3cd4),true)',
            cy2: '=C(V.hR,V.y1,A(V.wd32,V.hR,V._3cd4))',
            cd4: C,
            cx3: '=C(V.wd32,V.x8,A(V.wd32,V.hR,V.cd4),true)',
            cy3: '=C(V.hR,V.y2,A(V.wd32,V.hR,V.cd4))',
            cx4: '=C(V.wd32,V.x7,A(V.wd32,V.hR,V.cd4),true)',
            cy4: '=C(V.hR,V.y1,A(V.wd32,V.hR,V.cd4))',
            cx5: '=C(V.wd32,V.x9,A(V.wd32,V.hR,0),true)',
            cy5: '=C(V.hR,V.y5,A(V.wd32,V.hR,0))',
            cx6: '=C(V.wd32,V.x3,A(V.wd32,V.hR,V.cd4),true)',
            cy6: '=C(V.hR,V.b,A(V.wd32,V.hR,V.cd4))',
            cx7: '=C(V.wd32,V.x5,A(V.wd32,V.hR,0),true)',
            cy7: '=C(V.hR,V.hR,A(V.wd32,V.hR,0))',
            cx8: '=C(V.wd32,V.x3,A(V.wd32,V.hR,V._3cd4),true)',
            cy8: '=C(V.hR,V.y1,A(V.wd32,V.hR,V._3cd4))',
            cx9: '=C(V.wd32,V.x6,A(V.wd32,V.hR,V.cd2),true)',
            cy9: '=C(V.hR,V.hR,A(V.wd32,V.hR,V.cd2))',
            cx10: '=C(V.wd32,V.x8,A(V.wd32,V.hR,V._3cd4),true)',
            cy10: '=C(V.hR,V.y1,A(V.wd32,V.hR,V._3cd4))',
            cx11: '=C(V.wd32,V.x4,A(V.wd32,V.hR,V._3cd4),true)',
            cy11: '=C(V.hR,V.t,A(V.wd32,V.hR,V._3cd4))',
            cx12: '=C(V.wd32,V.x3,A(V.wd32,V.hR,V._3cd4),true)',
            cy12: '=C(V.hR,V.y1,A(V.wd32,V.hR,V._3cd4))',
            cx13: '=C(V.wd32,V.x8,A(V.wd32,V.hR,V.cd4),true)',
            cy13: '=C(V.hR,V.y2,A(V.wd32,V.hR,V.cd4))',
            cx14: '=C(V.wd32,V.x7,A(V.wd32,V.hR,V.cd4),true)',
            cy14: '=C(V.hR,V.y1,A(V.wd32,V.hR,V.cd4))',
            cx15: '=C(V.wd32,V.x9,A(V.wd32,V.hR,0),true)',
            cy15: '=C(V.hR,V.y5,A(V.wd32,V.hR,0))',
            cx16: '=C(V.wd32,V.x3,A(V.wd32,V.hR,V.cd4),true)',
            cy16: '=C(V.hR,V.b,A(V.wd32,V.hR,V.cd4))',
        },
        adjustInfo: [['adj1', 16667], ['adj2', 50000]],
        connectionPoints: [{
            x: a,
            y: f,
        }, {
            x: '=V.wd8',
            y: '=V.y3',
        }, {
            x: a,
            y: h,
        }, {
            x: '=V.x10',
            y: '=V.y3',
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj1',
            minY: 0,
            maxY: 33333,
            position: {
                x: 'hc',
                y: 'y2',
            },
            point: [a, f],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: 25000,
            maxX: 75000,
            position: {
                x: 'x2',
                y: 't',
            },
            point: [d, 0],
        },
        ],
        path: [[['M', 0, 0], ['L', '=V.x4', 0], ['E', '=V.cx1', '=V.cy1', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V._3cd4)', '=A(V.wd32,V.hR,(V._3cd4 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['L', '=V.x3', e], ['E', '=V.cx2', '=V.cy2', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V._3cd4)', '=A(V.wd32,V.hR,(V._3cd4 + -10800000))', '=IF(-10800000 > 0, FALSE, TRUE)'], ['L', '=V.x8', f], ['E', '=V.cx3', '=V.cy3', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V.cd4)', '=A(V.wd32,V.hR,(V.cd4 + -10800000))', '=IF(-10800000 > 0, FALSE, TRUE)'], ['L', '=V.x7', e], ['E', '=V.cx4', '=V.cy4', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V.cd4)', '=A(V.wd32,V.hR,(V.cd4 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['L', w, 0], ['L', '=V.x10', '=V.y3'], ['L', w, '=V.y4'], ['L', '=V.x9', '=V.y4'], ['L', '=V.x9', '=V.y5'], ['E', '=V.cx5', '=V.cy5', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,0)', '=A(V.wd32,V.hR,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', '=V.x3', h], ['E', '=V.cx6', '=V.cy6', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V.cd4)', '=A(V.wd32,V.hR,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', d, '=V.y4'], ['L', 0, '=V.y4'], ['L', '=V.wd8', '=V.y3'], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', '=V.x5', '=V.hR'], ['E', '=V.cx7', '=V.cy7', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,0)', '=A(V.wd32,V.hR,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', '=V.x3', e], ['E', '=V.cx8', '=V.cy8', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V._3cd4)', '=A(V.wd32,V.hR,(V._3cd4 + -10800000))', '=IF(-10800000 > 0, FALSE, TRUE)'], ['L', '=V.x5', f], ['Z'], ['M', '=V.x6', '=V.hR'], ['E', '=V.cx9', '=V.cy9', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V.cd2)', '=A(V.wd32,V.hR,(V.cd2 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['L', '=V.x8', e], ['E', '=V.cx10', '=V.cy10', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V._3cd4)', '=A(V.wd32,V.hR,(V._3cd4 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['L', '=V.x6', f], ['Z'], {
            fillMode: 'darkenLess',
            strokeMode: 'false',
        },
        ], [['M', 0, 0], ['L', '=V.x4', 0], ['E', '=V.cx11', '=V.cy11', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V._3cd4)', '=A(V.wd32,V.hR,(V._3cd4 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['L', '=V.x3', e], ['E', '=V.cx12', '=V.cy12', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V._3cd4)', '=A(V.wd32,V.hR,(V._3cd4 + -10800000))', '=IF(-10800000 > 0, FALSE, TRUE)'], ['L', '=V.x8', f], ['E', '=V.cx13', '=V.cy13', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V.cd4)', '=A(V.wd32,V.hR,(V.cd4 + -10800000))', '=IF(-10800000 > 0, FALSE, TRUE)'], ['L', '=V.x7', e], ['E', '=V.cx14', '=V.cy14', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V.cd4)', '=A(V.wd32,V.hR,(V.cd4 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['L', w, 0], ['L', '=V.x10', '=V.y3'], ['L', w, '=V.y4'], ['L', '=V.x9', '=V.y4'], ['L', '=V.x9', '=V.y5'], ['E', '=V.cx15', '=V.cy15', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,0)', '=A(V.wd32,V.hR,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', '=V.x3', h], ['E', '=V.cx16', '=V.cy16', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V.cd4)', '=A(V.wd32,V.hR,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', d, '=V.y4'], ['L', 0, '=V.y4'], ['L', '=V.wd8', '=V.y3'], ['Z'], ['M', '=V.x5', '=V.hR'], ['L', '=V.x5', f], ['M', '=V.x6', f], ['L', '=V.x6', '=V.hR'], ['M', d, '=V.y4'], ['L', d, '=V.y6'], ['M', '=V.x9', '=V.y6'], ['L', '=V.x9', '=V.y4'], {
            fillMode: 'none',
        },
        ]],
        textRect: {
            left: d,
            top: f,
            right: '=V.x9',
            bottom: h,
        },
    },
    curvedUpRibbon: {
        variables: {
            adj1: 25000,
            adj2: 50000,
            adj3: 12500,
            a1: '=MIN(MAX(0, V.adj1), 100000)',
            a2: '=MIN(MAX(25000, V.adj2), 75000)',
            q10: '=100000 - V.a1',
            q11: '=V.q10 / 2',
            q12: '=V.a1 - V.q11',
            minAdj3: '=MAX(0, V.q12)',
            a3: '=MIN(MAX(V.minAdj3, V.adj3), V.a1)',
            dx2: '=width * V.a2 / 200000',
            hc: E,
            x2: '=V.hc - V.dx2',
            wd8: '=width/8',
            x3: '=V.x2 + V.wd8',
            r: w,
            x4: '=width - V.x3',
            x5: '=width - V.x2',
            x6: '=width - V.wd8',
            dy1: '=height * V.a3 / 100000',
            f1: '=4 * V.dy1 / width',
            q1: '=V.x3 * V.x3 / width',
            q2: '=V.x3 - V.q1',
            u1: '=V.f1 * V.q2',
            b: h,
            y1: '=height - V.u1',
            cx1: '=V.x3 / 2',
            cu1: '=V.f1 * V.cx1',
            cy1: '=height - V.cu1',
            cx2: '=width - V.cx1',
            _q1: '=height * V.a1 / 100000',
            dy3: '=V._q1 - V.dy1',
            q3: '=V.x2 * V.x2 / width',
            q4: '=V.x2 - V.q3',
            q5: '=V.f1 * V.q4',
            u3: '=V.q5 + V.dy3',
            y3: '=height - V.u3',
            q6: '=V.dy1 + V.dy3 - V.u3',
            q7: '=V.q6 + V.dy1',
            cu3: '=V.q7 + V.dy3',
            cy3: '=height - V.cu3',
            rh: '=height - V._q1',
            q8: '=V.dy1 * 14 / 16',
            u2: '=(V.q8 + V.rh) / 2',
            y2: '=height - V.u2',
            u5: '=V.q5 + V.rh',
            y5: '=height - V.u5',
            u6: '=V.u3 + V.rh',
            y6: '=height - V.u6',
            cx4: '=V.x2 / 2',
            q9: '=V.f1 * V.cx4',
            cu4: '=V.q9 + V.rh',
            cy4: '=height - V.cu4',
            cx5: '=width - V.cx4',
            cu6: '=V.cu3 + V.rh',
            cy6: '=height - V.cu6',
            u7: '=V.u1 + V.dy3',
            y7: '=height - V.u7',
            cu7: '=V._q1 + V._q1 - V.u7',
            cy7: '=height - V.cu7',
            t: 0,
            l: 0,
        },
        adjustInfo: [['adj1', 25000], ['adj2', 50000], ['adj3', 12500]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: '=V.wd8',
            y: f,
        }, {
            x: a,
            y: '=V.rh',
        }, {
            x: '=V.x6',
            y: f,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj1',
            minY: 0,
            maxY: 100000,
            position: {
                x: 'hc',
                y: 'rh',
            },
            point: [a, '=V.rh'],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: 25000,
            maxX: 100000,
            position: {
                x: 'x2',
                y: 't',
            },
            point: [d, 0],
        }, {
            type: 'ahXY',
            gdRefY: 'adj3',
            minY: 'minAdj3',
            maxY: 'a1',
            position: {
                x: 'l',
                y: 'dy1',
            },
            point: [0, '=V.dy1'],
        },
        ],
        path: [[['M', 0, h], ['Q', '=V.cx1', '=V.cy1', '=V.x3', e], ['L', d, '=V.y3'], ['Q', a, '=V.cy3', '=V.x5', '=V.y3'], ['L', '=V.x4', e], ['Q', '=V.cx2', '=V.cy1', w, h], ['L', '=V.x6', f], ['L', w, '=V._q1'], ['Q', '=V.cx5', '=V.cy4', '=V.x5', '=V.y5'], ['L', '=V.x5', '=V.y6'], ['Q', a, '=V.cy6', d, '=V.y6'], ['L', d, '=V.y5'], ['Q', '=V.cx4', '=V.cy4', 0, '=V._q1'], ['L', '=V.wd8', f], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', '=V.x3', '=V.y7'], ['L', '=V.x3', e], ['L', d, '=V.y3'], ['Q', a, '=V.cy3', '=V.x5', '=V.y3'], ['L', '=V.x4', e], ['L', '=V.x4', '=V.y7'], ['Q', a, '=V.cy7', '=V.x3', '=V.y7'], ['Z'], {
            fillMode: 'darkenLess',
            strokeMode: 'false',
        },
        ], [['M', 0, h], ['L', '=V.wd8', f], ['L', 0, '=V._q1'], ['Q', '=V.cx4', '=V.cy4', d, '=V.y5'], ['L', d, '=V.y6'], ['Q', a, '=V.cy6', '=V.x5', '=V.y6'], ['L', '=V.x5', '=V.y5'], ['Q', '=V.cx5', '=V.cy4', w, '=V._q1'], ['L', '=V.x6', f], ['L', w, h], ['Q', '=V.cx2', '=V.cy1', '=V.x4', e], ['L', '=V.x5', '=V.y3'], ['Q', a, '=V.cy3', d, '=V.y3'], ['L', '=V.x3', e], ['Q', '=V.cx1', '=V.cy1', 0, h], ['Z'], ['M', d, '=V.y3'], ['L', d, '=V.y5'], ['M', '=V.x5', '=V.y5'], ['L', '=V.x5', '=V.y3'], ['M', '=V.x3', '=V.y7'], ['L', '=V.x3', e], ['M', '=V.x4', e], ['L', '=V.x4', '=V.y7'], {
            fillMode: 'none',
        },
        ]],
        textRect: {
            left: d,
            top: '=V.y6',
            right: '=V.x5',
            bottom: '=V.rh',
        },
    },
    curvedDownRibbon: {
        variables: {
            adj1: 25000,
            adj2: 50000,
            adj3: 12500,
            a1: '=MIN(MAX(0, V.adj1), 100000)',
            a2: '=MIN(MAX(25000, V.adj2), 75000)',
            q10: '=100000 - V.a1',
            q11: '=V.q10 / 2',
            q12: '=V.a1 - V.q11',
            minAdj3: '=MAX(0, V.q12)',
            a3: '=MIN(MAX(V.minAdj3, V.adj3), V.a1)',
            dx2: '=width * V.a2 / 200000',
            hc: E,
            x2: '=V.hc - V.dx2',
            wd8: '=width/8',
            x3: '=V.x2 + V.wd8',
            r: w,
            x4: '=width - V.x3',
            x5: '=width - V.x2',
            x6: '=width - V.wd8',
            dy1: '=height * V.a3 / 100000',
            f1: '=4 * V.dy1 / width',
            q1: '=V.x3 * V.x3 / width',
            q2: '=V.x3 - V.q1',
            y1: '=V.f1 * V.q2',
            cx1: '=V.x3 / 2',
            cy1: '=V.f1 * V.cx1',
            cx2: '=width - V.cx1',
            _q1: '=height * V.a1 / 100000',
            dy3: '=V._q1 - V.dy1',
            q3: '=V.x2 * V.x2 / width',
            q4: '=V.x2 - V.q3',
            q5: '=V.f1 * V.q4',
            y3: '=V.q5 + V.dy3',
            q6: '=V.dy1 + V.dy3 - V.y3',
            q7: '=V.q6 + V.dy1',
            cy3: '=V.q7 + V.dy3',
            b: h,
            rh: '=height - V._q1',
            q8: '=V.dy1 * 14 / 16',
            y2: '=(V.q8 + V.rh) / 2',
            y5: '=V.q5 + V.rh',
            y6: '=V.y3 + V.rh',
            cx4: '=V.x2 / 2',
            q9: '=V.f1 * V.cx4',
            cy4: '=V.q9 + V.rh',
            cx5: '=width - V.cx4',
            cy6: '=V.cy3 + V.rh',
            y7: '=V.y1 + V.dy3',
            cy7: '=V._q1 + V._q1 - V.y7',
            y8: '=height - V.dy1',
            l: 0,
            t: 0,
        },
        adjustInfo: [['adj1', 25000], ['adj2', 50000], ['adj3', 12500]],
        connectionPoints: [{
            x: a,
            y: '=V._q1',
        }, {
            x: '=V.wd8',
            y: f,
        }, {
            x: a,
            y: h,
        }, {
            x: '=V.x6',
            y: f,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj1',
            minY: 0,
            maxY: 100000,
            position: {
                x: 'hc',
                y: '_q1',
            },
            point: [a, '=V._q1'],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: 25000,
            maxX: 75000,
            position: {
                x: 'x2',
                y: 'b',
            },
            point: [d, h],
        }, {
            type: 'ahXY',
            gdRefY: 'adj3',
            minY: 'minAdj3',
            maxY: 'a1',
            position: {
                x: 'l',
                y: 'y8',
            },
            point: [0, '=V.y8'],
        },
        ],
        path: [[['M', 0, 0], ['Q', '=V.cx1', '=V.cy1', '=V.x3', e], ['L', d, '=V.y3'], ['Q', a, '=V.cy3', '=V.x5', '=V.y3'], ['L', '=V.x4', e], ['Q', '=V.cx2', '=V.cy1', w, 0], ['L', '=V.x6', f], ['L', w, '=V.rh'], ['Q', '=V.cx5', '=V.cy4', '=V.x5', '=V.y5'], ['L', '=V.x5', '=V.y6'], ['Q', a, '=V.cy6', d, '=V.y6'], ['L', d, '=V.y5'], ['Q', '=V.cx4', '=V.cy4', 0, '=V.rh'], ['L', '=V.wd8', f], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', '=V.x3', '=V.y7'], ['L', '=V.x3', e], ['L', d, '=V.y3'], ['Q', a, '=V.cy3', '=V.x5', '=V.y3'], ['L', '=V.x4', e], ['L', '=V.x4', '=V.y7'], ['Q', a, '=V.cy7', '=V.x3', '=V.y7'], ['Z'], {
            fillMode: 'darkenLess',
            strokeMode: 'false',
        },
        ], [['M', 0, 0], ['Q', '=V.cx1', '=V.cy1', '=V.x3', e], ['L', d, '=V.y3'], ['Q', a, '=V.cy3', '=V.x5', '=V.y3'], ['L', '=V.x4', e], ['Q', '=V.cx2', '=V.cy1', w, 0], ['L', '=V.x6', f], ['L', w, '=V.rh'], ['Q', '=V.cx5', '=V.cy4', '=V.x5', '=V.y5'], ['L', '=V.x5', '=V.y6'], ['Q', a, '=V.cy6', d, '=V.y6'], ['L', d, '=V.y5'], ['Q', '=V.cx4', '=V.cy4', 0, '=V.rh'], ['L', '=V.wd8', f], ['Z'], ['M', d, '=V.y5'], ['L', d, '=V.y3'], ['M', '=V.x5', '=V.y3'], ['L', '=V.x5', '=V.y5'], ['M', '=V.x3', e], ['L', '=V.x3', '=V.y7'], ['M', '=V.x4', '=V.y7'], ['L', '=V.x4', e], {
            fillMode: 'none',
        },
        ]],
        textRect: {
            left: d,
            top: '=V._q1',
            right: '=V.x5',
            bottom: '=V.y6',
        },
    },
    verticalScroll: {
        variables: {
            adj: 12500,
            a: '=MIN(MAX(0, V.adj), 25000)',
            ss: s,
            ch: '=V.ss * V.a / 100000',
            ch2: '=V.ch / 2',
            ch4: '=V.ch / 4',
            x3: '=V.ch + V.ch2',
            x4: '=V.ch + V.ch',
            r: w,
            x6: '=width - V.ch',
            x7: '=width - V.ch2',
            x5: '=V.x6 - V.ch2',
            b: h,
            y3: '=height - V.ch',
            y4: '=height - V.ch2',
            hc: E,
            t: 0,
            vc: F,
            l: 0,
            cd4: C,
            cx1: '=C(V.ch2,V.ch2,A(V.ch2,V.ch2,V.cd4),true)',
            cy1: '=C(V.ch2,V.b,A(V.ch2,V.ch2,V.cd4))',
            cx2: '=C(V.ch4,V.ch2,A(V.ch4,V.ch4,V.cd4),true)',
            cy2: '=C(V.ch4,V.y4,A(V.ch4,V.ch4,V.cd4))',
            cd2: B,
            cx3: '=C(V.ch2,V.ch,A(V.ch2,V.ch2,V.cd2),true)',
            cy3: '=C(V.ch2,V.ch2,A(V.ch2,V.ch2,V.cd2))',
            _3cd4: D,
            cx4: '=C(V.ch2,V.x7,A(V.ch2,V.ch2,V._3cd4),true)',
            cy4: '=C(V.ch2,V.t,A(V.ch2,V.ch2,V._3cd4))',
            cx5: '=C(V.ch2,V.x6,A(V.ch2,V.ch2,0),true)',
            cy5: '=C(V.ch2,V.y4,A(V.ch2,V.ch2,0))',
            cx6: '=C(V.ch2,V.x4,A(V.ch2,V.ch2,0),true)',
            cy6: '=C(V.ch2,V.ch2,A(V.ch2,V.ch2,0))',
            cx7: '=C(V.ch4,P(V.cx6,V.ch2,A(V.ch2,V.ch2,(V.cd4)),true),A(V.ch4,V.ch4,V.cd4),true)',
            cy7: '=C(V.ch4,P(V.cy6,V.ch2,A(V.ch2,V.ch2,(V.cd4))),A(V.ch4,V.ch4,V.cd4))',
            cx8: '=C(V.ch2,V.x4,A(V.ch2,V.ch2,0),true)',
            cy8: '=C(V.ch2,V.ch2,A(V.ch2,V.ch2,0))',
            cx9: '=C(V.ch4,P(V.cx8,V.ch2,A(V.ch2,V.ch2,(V.cd4)),true),A(V.ch4,V.ch4,V.cd4),true)',
            cy9: '=C(V.ch4,P(V.cy8,V.ch2,A(V.ch2,V.ch2,(V.cd4))),A(V.ch4,V.ch4,V.cd4))',
            cx10: '=C(V.ch2,V.ch,A(V.ch2,V.ch2,0),true)',
            cy10: '=C(V.ch2,V.y4,A(V.ch2,V.ch2,0))',
            cx11: '=C(V.ch4,P(V.cx10,V.ch2,A(V.ch2,V.ch2,(V._3cd4)),true),A(V.ch4,V.ch4,V._3cd4),true)',
            cy11: '=C(V.ch4,P(V.cy10,V.ch2,A(V.ch2,V.ch2,(V._3cd4))),A(V.ch4,V.ch4,V._3cd4))',
            cx12: '=C(V.ch2,V.ch,A(V.ch2,V.ch2,V.cd2),true)',
            cy12: '=C(V.ch2,V.ch2,A(V.ch2,V.ch2,V.cd2))',
            cx13: '=C(V.ch2,V.x7,A(V.ch2,V.ch2,V._3cd4),true)',
            cy13: '=C(V.ch2,V.t,A(V.ch2,V.ch2,V._3cd4))',
            cx14: '=C(V.ch2,V.x6,A(V.ch2,V.ch2,0),true)',
            cy14: '=C(V.ch2,V.y4,A(V.ch2,V.ch2,0))',
            cx15: '=C(V.ch2,V.ch2,A(V.ch2,V.ch2,V.cd4),true)',
            cy15: '=C(V.ch2,V.b,A(V.ch2,V.ch2,V.cd4))',
            cx16: '=C(V.ch2,V.x3,A(V.ch2,V.ch2,V._3cd4),true)',
            cy16: '=C(V.ch2,V.t,A(V.ch2,V.ch2,V._3cd4))',
            cx17: '=C(V.ch4,P(V.cx16,V.ch2,A(V.ch2,V.ch2,(V._3cd4 + V.cd2)),true),A(V.ch4,V.ch4,V.cd4),true)',
            cy17: '=C(V.ch4,P(V.cy16,V.ch2,A(V.ch2,V.ch2,(V._3cd4 + V.cd2))),A(V.ch4,V.ch4,V.cd4))',
            cx18: '=C(V.ch4,V.ch2,A(V.ch4,V.ch4,V._3cd4),true)',
            cy18: '=C(V.ch4,V.y3,A(V.ch4,V.ch4,V._3cd4))',
            cx19: '=C(V.ch2,V.ch2,A(V.ch2,V.ch2,V.cd4),true)',
            cy19: '=C(V.ch2,V.b,A(V.ch2,V.ch2,V.cd4))',
        },
        adjustInfo: [['adj', 12500]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: '=V.ch',
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: '=V.x6',
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj',
            minY: 0,
            maxY: 25000,
            position: {
                x: 'l',
                y: 'ch',
            },
            point: [0, '=V.ch'],
        },
        ],
        path: [[['M', '=V.ch2', h], ['E', '=V.cx1', '=V.cy1', '=V.ch2', '=V.ch2', 0, '=A(V.ch2,V.ch2,V.cd4)', '=A(V.ch2,V.ch2,(V.cd4 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['L', '=V.ch2', '=V.y4'], ['E', '=V.cx2', '=V.cy2', '=V.ch4', '=V.ch4', 0, '=A(V.ch4,V.ch4,V.cd4)', '=A(V.ch4,V.ch4,(V.cd4 + -10800000))', '=IF(-10800000 > 0, FALSE, TRUE)'], ['L', '=V.ch', '=V.y3'], ['L', '=V.ch', '=V.ch2'], ['E', '=V.cx3', '=V.cy3', '=V.ch2', '=V.ch2', 0, '=A(V.ch2,V.ch2,V.cd2)', '=A(V.ch2,V.ch2,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', '=V.x7', 0], ['E', '=V.cx4', '=V.cy4', '=V.ch2', '=V.ch2', 0, '=A(V.ch2,V.ch2,V._3cd4)', '=A(V.ch2,V.ch2,(V._3cd4 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['L', '=V.x6', '=V.ch'], ['L', '=V.x6', '=V.y4'], ['E', '=V.cx5', '=V.cy5', '=V.ch2', '=V.ch2', 0, '=A(V.ch2,V.ch2,0)', '=A(V.ch2,V.ch2,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['Z'], ['M', '=V.x4', '=V.ch2'], ['E', '=V.cx6', '=V.cy6', '=V.ch2', '=V.ch2', 0, '=A(V.ch2,V.ch2,0)', '=A(V.ch2,V.ch2,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx7', '=V.cy7', '=V.ch4', '=V.ch4', 0, '=A(V.ch4,V.ch4,V.cd4)', '=A(V.ch4,V.ch4,(V.cd4 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', '=V.x4', '=V.ch2'], ['E', '=V.cx8', '=V.cy8', '=V.ch2', '=V.ch2', 0, '=A(V.ch2,V.ch2,0)', '=A(V.ch2,V.ch2,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx9', '=V.cy9', '=V.ch4', '=V.ch4', 0, '=A(V.ch4,V.ch4,V.cd4)', '=A(V.ch4,V.ch4,(V.cd4 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['Z'], ['M', '=V.ch', '=V.y4'], ['E', '=V.cx10', '=V.cy10', '=V.ch2', '=V.ch2', 0, '=A(V.ch2,V.ch2,0)', '=A(V.ch2,V.ch2,(V._3cd4))', '=IF(V._3cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx11', '=V.cy11', '=V.ch4', '=V.ch4', 0, '=A(V.ch4,V.ch4,V._3cd4)', '=A(V.ch4,V.ch4,(V._3cd4 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['Z'], {
            fillMode: 'darkenLess',
            strokeMode: 'false',
        },
        ], [['M', '=V.ch', '=V.y3'], ['L', '=V.ch', '=V.ch2'], ['E', '=V.cx12', '=V.cy12', '=V.ch2', '=V.ch2', 0, '=A(V.ch2,V.ch2,V.cd2)', '=A(V.ch2,V.ch2,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', '=V.x7', 0], ['E', '=V.cx13', '=V.cy13', '=V.ch2', '=V.ch2', 0, '=A(V.ch2,V.ch2,V._3cd4)', '=A(V.ch2,V.ch2,(V._3cd4 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['L', '=V.x6', '=V.ch'], ['L', '=V.x6', '=V.y4'], ['E', '=V.cx14', '=V.cy14', '=V.ch2', '=V.ch2', 0, '=A(V.ch2,V.ch2,0)', '=A(V.ch2,V.ch2,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', '=V.ch2', h], ['E', '=V.cx15', '=V.cy15', '=V.ch2', '=V.ch2', 0, '=A(V.ch2,V.ch2,V.cd4)', '=A(V.ch2,V.ch2,(V.cd4 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['Z'], ['M', '=V.x3', 0], ['E', '=V.cx16', '=V.cy16', '=V.ch2', '=V.ch2', 0, '=A(V.ch2,V.ch2,V._3cd4)', '=A(V.ch2,V.ch2,(V._3cd4 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['E', '=V.cx17', '=V.cy17', '=V.ch4', '=V.ch4', 0, '=A(V.ch4,V.ch4,V.cd4)', '=A(V.ch4,V.ch4,(V.cd4 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['L', '=V.x4', '=V.ch2'], ['M', '=V.x6', '=V.ch'], ['L', '=V.x3', '=V.ch'], ['M', '=V.ch2', '=V.y3'], ['E', '=V.cx18', '=V.cy18', '=V.ch4', '=V.ch4', 0, '=A(V.ch4,V.ch4,V._3cd4)', '=A(V.ch4,V.ch4,(V._3cd4 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['L', '=V.ch', '=V.y4'], ['M', '=V.ch2', h], ['E', '=V.cx19', '=V.cy19', '=V.ch2', '=V.ch2', 0, '=A(V.ch2,V.ch2,V.cd4)', '=A(V.ch2,V.ch2,(V.cd4 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['L', '=V.ch', '=V.y3'], {
            fillMode: 'none',
        },
        ]],
        textRect: {
            left: '=V.ch',
            top: '=V.ch',
            right: '=V.x6',
            bottom: '=V.y4',
        },
    },
    horizontalScroll: {
        variables: {
            adj: 12500,
            a: '=MIN(MAX(0, V.adj), 25000)',
            ss: s,
            ch: '=V.ss * V.a / 100000',
            ch2: '=V.ch / 2',
            ch4: '=V.ch / 4',
            y3: '=V.ch + V.ch2',
            y4: '=V.ch + V.ch',
            b: h,
            y6: '=height - V.ch',
            y7: '=height - V.ch2',
            y5: '=V.y6 - V.ch2',
            r: w,
            x3: '=width - V.ch',
            x4: '=width - V.ch2',
            hc: E,
            l: 0,
            vc: F,
            t: 0,
            cd4: C,
            cx1: '=C(V.ch2,V.r,A(V.ch2,V.ch2,0),true)',
            cy1: '=C(V.ch2,V.ch2,A(V.ch2,V.ch2,0))',
            cd2: B,
            cx2: '=C(V.ch4,V.x4,A(V.ch4,V.ch4,0),true)',
            cy2: '=C(V.ch4,V.ch2,A(V.ch4,V.ch4,0))',
            _3cd4: D,
            cx3: '=C(V.ch2,V.ch2,A(V.ch2,V.ch2,V._3cd4),true)',
            cy3: '=C(V.ch2,V.ch,A(V.ch2,V.ch2,V._3cd4))',
            cx4: '=C(V.ch2,V.l,A(V.ch2,V.ch2,V.cd2),true)',
            cy4: '=C(V.ch2,V.y7,A(V.ch2,V.ch2,V.cd2))',
            cx5: '=C(V.ch2,V.x4,A(V.ch2,V.ch2,V.cd4),true)',
            cy5: '=C(V.ch2,V.y6,A(V.ch2,V.ch2,V.cd4))',
            cx6: '=C(V.ch2,V.ch2,A(V.ch2,V.ch2,V.cd4),true)',
            cy6: '=C(V.ch2,V.y4,A(V.ch2,V.ch2,V.cd4))',
            cx7: '=C(V.ch4,P(V.cx6,V.ch2,A(V.ch2,V.ch2,(V.cd4 + -5400000)),true),A(V.ch4,V.ch4,0),true)',
            cy7: '=C(V.ch4,P(V.cy6,V.ch2,A(V.ch2,V.ch2,(V.cd4 + -5400000))),A(V.ch4,V.ch4,0))',
            cx8: '=C(V.ch2,V.ch2,A(V.ch2,V.ch2,V.cd4),true)',
            cy8: '=C(V.ch2,V.y4,A(V.ch2,V.ch2,V.cd4))',
            cx9: '=C(V.ch4,P(V.cx8,V.ch2,A(V.ch2,V.ch2,(V.cd4 + -5400000)),true),A(V.ch4,V.ch4,0),true)',
            cy9: '=C(V.ch4,P(V.cy8,V.ch2,A(V.ch2,V.ch2,(V.cd4 + -5400000))),A(V.ch4,V.ch4,0))',
            cx10: '=C(V.ch2,V.x4,A(V.ch2,V.ch2,V.cd4),true)',
            cy10: '=C(V.ch2,V.ch,A(V.ch2,V.ch2,V.cd4))',
            cx11: '=C(V.ch4,P(V.cx10,V.ch2,A(V.ch2,V.ch2,(V.cd4 + -16200000)),true),A(V.ch4,V.ch4,V.cd2),true)',
            cy11: '=C(V.ch4,P(V.cy10,V.ch2,A(V.ch2,V.ch2,(V.cd4 + -16200000))),A(V.ch4,V.ch4,V.cd2))',
            cx12: '=C(V.ch2,V.l,A(V.ch2,V.ch2,V.cd2),true)',
            cy12: '=C(V.ch2,V.y3,A(V.ch2,V.ch2,V.cd2))',
            cx13: '=C(V.ch2,V.x3,A(V.ch2,V.ch2,V.cd2),true)',
            cy13: '=C(V.ch2,V.ch2,A(V.ch2,V.ch2,V.cd2))',
            cx14: '=C(V.ch2,V.r,A(V.ch2,V.ch2,0),true)',
            cy14: '=C(V.ch2,V.y5,A(V.ch2,V.ch2,0))',
            cx15: '=C(V.ch2,V.ch,A(V.ch2,V.ch2,0),true)',
            cy15: '=C(V.ch2,V.y7,A(V.ch2,V.ch2,0))',
            cx16: '=C(V.ch2,V.x4,A(V.ch2,V.ch2,V.cd4),true)',
            cy16: '=C(V.ch2,V.ch,A(V.ch2,V.ch2,V.cd4))',
            cx17: '=C(V.ch4,V.x4,A(V.ch4,V.ch4,0),true)',
            cy17: '=C(V.ch4,V.ch2,A(V.ch4,V.ch4,0))',
            cx18: '=C(V.ch4,V.ch2,A(V.ch4,V.ch4,V.cd2),true)',
            cy18: '=C(V.ch4,V.y3,A(V.ch4,V.ch4,V.cd2))',
            cx19: '=C(V.ch2,P(V.cx18,V.ch4,A(V.ch4,V.ch4,(V.cd2 + V.cd2)),true),A(V.ch2,V.ch2,0),true)',
            cy19: '=C(V.ch2,P(V.cy18,V.ch4,A(V.ch4,V.ch4,(V.cd2 + V.cd2))),A(V.ch2,V.ch2,0))',
        },
        adjustInfo: [['adj', 12500]],
        connectionPoints: [{
            x: a,
            y: '=V.ch',
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: '=V.y6',
        }, {
            x: w,
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj',
            minX: 0,
            maxX: 25000,
            position: {
                x: 'ch',
                y: 't',
            },
            point: ['=V.ch', 0],
        },
        ],
        path: [[['M', w, '=V.ch2'], ['E', '=V.cx1', '=V.cy1', '=V.ch2', '=V.ch2', 0, '=A(V.ch2,V.ch2,0)', '=A(V.ch2,V.ch2,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', '=V.x4', '=V.ch2'], ['E', '=V.cx2', '=V.cy2', '=V.ch4', '=V.ch4', 0, '=A(V.ch4,V.ch4,0)', '=A(V.ch4,V.ch4,(V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['L', '=V.x3', '=V.ch'], ['L', '=V.ch2', '=V.ch'], ['E', '=V.cx3', '=V.cy3', '=V.ch2', '=V.ch2', 0, '=A(V.ch2,V.ch2,V._3cd4)', '=A(V.ch2,V.ch2,(V._3cd4 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['L', 0, '=V.y7'], ['E', '=V.cx4', '=V.cy4', '=V.ch2', '=V.ch2', 0, '=A(V.ch2,V.ch2,V.cd2)', '=A(V.ch2,V.ch2,(V.cd2 + -10800000))', '=IF(-10800000 > 0, FALSE, TRUE)'], ['L', '=V.ch', '=V.y6'], ['L', '=V.x4', '=V.y6'], ['E', '=V.cx5', '=V.cy5', '=V.ch2', '=V.ch2', 0, '=A(V.ch2,V.ch2,V.cd4)', '=A(V.ch2,V.ch2,(V.cd4 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['Z'], ['M', '=V.ch2', '=V.y4'], ['E', '=V.cx6', '=V.cy6', '=V.ch2', '=V.ch2', 0, '=A(V.ch2,V.ch2,V.cd4)', '=A(V.ch2,V.ch2,(V.cd4 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['E', '=V.cx7', '=V.cy7', '=V.ch4', '=V.ch4', 0, '=A(V.ch4,V.ch4,0)', '=A(V.ch4,V.ch4,(-10800000))', '=IF(-10800000 > 0, FALSE, TRUE)'], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', '=V.ch2', '=V.y4'], ['E', '=V.cx8', '=V.cy8', '=V.ch2', '=V.ch2', 0, '=A(V.ch2,V.ch2,V.cd4)', '=A(V.ch2,V.ch2,(V.cd4 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['E', '=V.cx9', '=V.cy9', '=V.ch4', '=V.ch4', 0, '=A(V.ch4,V.ch4,0)', '=A(V.ch4,V.ch4,(-10800000))', '=IF(-10800000 > 0, FALSE, TRUE)'], ['Z'], ['M', '=V.x4', '=V.ch'], ['E', '=V.cx10', '=V.cy10', '=V.ch2', '=V.ch2', 0, '=A(V.ch2,V.ch2,V.cd4)', '=A(V.ch2,V.ch2,(V.cd4 + -16200000))', '=IF(-16200000 > 0, FALSE, TRUE)'], ['E', '=V.cx11', '=V.cy11', '=V.ch4', '=V.ch4', 0, '=A(V.ch4,V.ch4,V.cd2)', '=A(V.ch4,V.ch4,(V.cd2 + -10800000))', '=IF(-10800000 > 0, FALSE, TRUE)'], ['Z'], {
            fillMode: 'darkenLess',
            strokeMode: 'false',
        },
        ], [['M', 0, '=V.y3'], ['E', '=V.cx12', '=V.cy12', '=V.ch2', '=V.ch2', 0, '=A(V.ch2,V.ch2,V.cd2)', '=A(V.ch2,V.ch2,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', '=V.x3', '=V.ch'], ['L', '=V.x3', '=V.ch2'], ['E', '=V.cx13', '=V.cy13', '=V.ch2', '=V.ch2', 0, '=A(V.ch2,V.ch2,V.cd2)', '=A(V.ch2,V.ch2,(V.cd2 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['L', w, '=V.y5'], ['E', '=V.cx14', '=V.cy14', '=V.ch2', '=V.ch2', 0, '=A(V.ch2,V.ch2,0)', '=A(V.ch2,V.ch2,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', '=V.ch', '=V.y6'], ['L', '=V.ch', '=V.y7'], ['E', '=V.cx15', '=V.cy15', '=V.ch2', '=V.ch2', 0, '=A(V.ch2,V.ch2,0)', '=A(V.ch2,V.ch2,(V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['Z'], ['M', '=V.x3', '=V.ch'], ['L', '=V.x4', '=V.ch'], ['E', '=V.cx16', '=V.cy16', '=V.ch2', '=V.ch2', 0, '=A(V.ch2,V.ch2,V.cd4)', '=A(V.ch2,V.ch2,(V.cd4 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['M', '=V.x4', '=V.ch'], ['L', '=V.x4', '=V.ch2'], ['E', '=V.cx17', '=V.cy17', '=V.ch4', '=V.ch4', 0, '=A(V.ch4,V.ch4,0)', '=A(V.ch4,V.ch4,(V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['M', '=V.ch2', '=V.y4'], ['L', '=V.ch2', '=V.y3'], ['E', '=V.cx18', '=V.cy18', '=V.ch4', '=V.ch4', 0, '=A(V.ch4,V.ch4,V.cd2)', '=A(V.ch4,V.ch4,(V.cd2 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['E', '=V.cx19', '=V.cy19', '=V.ch2', '=V.ch2', 0, '=A(V.ch2,V.ch2,0)', '=A(V.ch2,V.ch2,(V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['M', '=V.ch', '=V.y3'], ['L', '=V.ch', '=V.y6'], {
            fillMode: 'none',
        },
        ]],
        textRect: {
            left: '=V.ch',
            top: '=V.ch',
            right: '=V.x4',
            bottom: '=V.y6',
        },
    },
    wave: {
        variables: {
            adj1: 12500,
            adj2: 0,
            a1: '=MIN(MAX(0, V.adj1), 20000)',
            a2: '=MIN(MAX(-10000, V.adj2), 10000)',
            y1: '=height * V.a1 / 100000',
            dy2: '=V.y1 * 10 / 3',
            y2: '=V.y1 - V.dy2',
            y3: '=V.y1 + V.dy2',
            b: h,
            y4: '=height - V.y1',
            y5: '=V.y4 - V.dy2',
            y6: '=V.y4 + V.dy2',
            dx1: '=width * V.a2 / 100000',
            of2: '=width * V.a2 / 50000',
            x1: '=ABS(V.dx1)',
            dx2: '=IF(V.of2 > 0, 0, V.of2)',
            l: 0,
            x2: '=0 - V.dx2',
            dx5: '=IF(V.of2 > 0, V.of2, 0)',
            r: w,
            x5: '=width - V.dx5',
            dx3: '=(V.dx2 + V.x5) / 3',
            x3: '=V.x2 + V.dx3',
            x4: '=(V.x3 + V.x5) / 2',
            x6: '=V.dx5',
            x10: '=width + V.dx2',
            x7: '=V.x6 + V.dx3',
            x8: '=(V.x7 + V.x10) / 2',
            x9: '=width - V.x1',
            hc: E,
            xAdj: '=V.hc + V.dx1',
            xAdj2: '=V.hc - V.dx1',
            il: '=MAX(V.x2, V.x6)',
            ir: '=MIN(V.x5, V.x10)',
            it: '=height * V.a1 / 50000',
            ib: '=height - V.it',
            vc: F,
        },
        adjustInfo: [['adj1', 12500], ['adj2', 0]],
        connectionPoints: [{
            x: '=V.xAdj2',
            y: e,
        }, {
            x: c,
            y: b,
        }, {
            x: '=V.xAdj',
            y: '=V.y4',
        }, {
            x: '=V.x9',
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj1',
            minY: 0,
            maxY: 20000,
            position: {
                x: 'l',
                y: 'y1',
            },
            point: [0, e],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: -10000,
            maxX: 10000,
            position: {
                x: 'xAdj',
                y: 'b',
            },
            point: ['=V.xAdj', h],
        },
        ],
        path: [[['M', d, e], ['B', '=V.x3', f, '=V.x4', '=V.y3', '=V.x5', e], ['L', '=V.x10', '=V.y4'], ['B', '=V.x8', '=V.y6', '=V.x7', '=V.y5', '=V.x6', '=V.y4'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.it',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    doubleWave: {
        variables: {
            adj1: 6250,
            adj2: 0,
            a1: '=MIN(MAX(0, V.adj1), 12500)',
            a2: '=MIN(MAX(-10000, V.adj2), 10000)',
            y1: '=height * V.a1 / 100000',
            dy2: '=V.y1 * 10 / 3',
            y2: '=V.y1 - V.dy2',
            y3: '=V.y1 + V.dy2',
            b: h,
            y4: '=height - V.y1',
            y5: '=V.y4 - V.dy2',
            y6: '=V.y4 + V.dy2',
            dx1: '=width * V.a2 / 100000',
            of2: '=width * V.a2 / 50000',
            x1: '=ABS(V.dx1)',
            dx2: '=IF(V.of2 > 0, 0, V.of2)',
            l: 0,
            x2: '=0 - V.dx2',
            dx8: '=IF(V.of2 > 0, V.of2, 0)',
            r: w,
            x8: '=width - V.dx8',
            dx3: '=(V.dx2 + V.x8) / 6',
            x3: '=V.x2 + V.dx3',
            dx4: '=(V.dx2 + V.x8) / 3',
            x4: '=V.x2 + V.dx4',
            x5: '=(V.x2 + V.x8) / 2',
            x6: '=V.x5 + V.dx3',
            x7: '=(V.x6 + V.x8) / 2',
            x9: '=V.dx8',
            x15: '=width + V.dx2',
            x10: '=V.x9 + V.dx3',
            x11: '=V.x9 + V.dx4',
            x12: '=(V.x9 + V.x15) / 2',
            x13: '=V.x12 + V.dx3',
            x14: '=(V.x13 + V.x15) / 2',
            x16: '=width - V.x1',
            hc: E,
            xAdj: '=V.hc + V.dx1',
            il: '=MAX(V.x2, V.x9)',
            ir: '=MIN(V.x8, V.x15)',
            it: '=height * V.a1 / 50000',
            ib: '=height - V.it',
            vc: F,
        },
        adjustInfo: [['adj1', 6250], ['adj2', 0]],
        connectionPoints: [{
            x: '=V.x12',
            y: e,
        }, {
            x: c,
            y: b,
        }, {
            x: '=V.x5',
            y: '=V.y4',
        }, {
            x: '=V.x16',
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj1',
            minY: 0,
            maxY: 12500,
            position: {
                x: 'l',
                y: 'y1',
            },
            point: [0, e],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: -10000,
            maxX: 10000,
            position: {
                x: 'xAdj',
                y: 'b',
            },
            point: ['=V.xAdj', h],
        },
        ],
        path: [[['M', d, e], ['B', '=V.x3', f, '=V.x4', '=V.y3', '=V.x5', e], ['B', '=V.x6', f, '=V.x7', '=V.y3', '=V.x8', e], ['L', '=V.x15', '=V.y4'], ['B', '=V.x14', '=V.y6', '=V.x13', '=V.y5', '=V.x12', '=V.y4'], ['B', '=V.x11', '=V.y6', '=V.x10', '=V.y5', '=V.x9', '=V.y4'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.it',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    rectangularCallout: {
        variables: {
            adj1: -20833,
            adj2: 62500,
            dxPos: '=width * V.adj1 / 100000',
            dyPos: '=height * V.adj2 / 100000',
            hc: E,
            xPos: '=V.hc + V.dxPos',
            vc: F,
            yPos: '=V.vc + V.dyPos',
            dx: '=V.xPos - V.hc',
            dy: '=V.yPos - V.vc',
            dq: '=V.dxPos * height / width',
            ady: '=ABS(V.dyPos)',
            adq: '=ABS(V.dq)',
            dz: '=V.ady - V.adq',
            xg1: '=IF(V.dxPos > 0, 7, 2)',
            xg2: '=IF(V.dxPos > 0, 10, 5)',
            x1: '=width * V.xg1 / 12',
            x2: '=width * V.xg2 / 12',
            yg1: '=IF(V.dyPos > 0, 7, 2)',
            yg2: '=IF(V.dyPos > 0, 10, 5)',
            y1: '=height * V.yg1 / 12',
            y2: '=height * V.yg2 / 12',
            l: 0,
            t1: '=IF(V.dxPos > 0, V.l, V.xPos)',
            xl: '=IF(V.dz > 0, V.l, V.t1)',
            t2: '=IF(V.dyPos > 0, V.x1, V.xPos)',
            xt: '=IF(V.dz > 0, V.t2, V.x1)',
            r: w,
            t3: '=IF(V.dxPos > 0, V.xPos, V.r)',
            xr: '=IF(V.dz > 0, V.r, V.t3)',
            t4: '=IF(V.dyPos > 0, V.xPos, V.x1)',
            xb: '=IF(V.dz > 0, V.t4, V.x1)',
            t5: '=IF(V.dxPos > 0, V.y1, V.yPos)',
            yl: '=IF(V.dz > 0, V.y1, V.t5)',
            t: 0,
            t6: '=IF(V.dyPos > 0, V.t, V.yPos)',
            yt: '=IF(V.dz > 0, V.t6, V.t)',
            t7: '=IF(V.dxPos > 0, V.yPos, V.y1)',
            yr: '=IF(V.dz > 0, V.y1, V.t7)',
            b: h,
            t8: '=IF(V.dyPos > 0, V.yPos, V.b)',
            yb: '=IF(V.dz > 0, V.t8, V.b)',
        },
        adjustInfo: [['adj1', -20833], ['adj2', 62500]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        }, {
            x: '=V.xPos',
            y: '=V.yPos',
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj1',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj2',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'xPos',
                y: 'yPos',
            },
            point: ['=V.xPos', '=V.yPos'],
        },
        ],
        path: [[['M', 0, 0], ['L', c, 0], ['L', '=V.xt', '=V.yt'], ['L', d, 0], ['L', w, 0], ['L', w, e], ['L', '=V.xr', '=V.yr'], ['L', w, f], ['L', w, h], ['L', d, h], ['L', '=V.xb', '=V.yb'], ['L', c, h], ['L', 0, h], ['L', 0, f], ['L', '=V.xl', '=V.yl'], ['L', 0, e], ['Z'], {},
        ]],
    },
    roundedRectangularCallout: {
        variables: {
            adj1: -20833,
            adj2: 62500,
            adj3: 16667,
            dxPos: '=width * V.adj1 / 100000',
            dyPos: '=height * V.adj2 / 100000',
            hc: E,
            xPos: '=V.hc + V.dxPos',
            vc: F,
            yPos: '=V.vc + V.dyPos',
            dq: '=V.dxPos * height / width',
            ady: '=ABS(V.dyPos)',
            adq: '=ABS(V.dq)',
            dz: '=V.ady - V.adq',
            xg1: '=IF(V.dxPos > 0, 7, 2)',
            xg2: '=IF(V.dxPos > 0, 10, 5)',
            x1: '=width * V.xg1 / 12',
            x2: '=width * V.xg2 / 12',
            yg1: '=IF(V.dyPos > 0, 7, 2)',
            yg2: '=IF(V.dyPos > 0, 10, 5)',
            y1: '=height * V.yg1 / 12',
            y2: '=height * V.yg2 / 12',
            l: 0,
            t1: '=IF(V.dxPos > 0, V.l, V.xPos)',
            xl: '=IF(V.dz > 0, V.l, V.t1)',
            t2: '=IF(V.dyPos > 0, V.x1, V.xPos)',
            xt: '=IF(V.dz > 0, V.t2, V.x1)',
            r: w,
            t3: '=IF(V.dxPos > 0, V.xPos, V.r)',
            xr: '=IF(V.dz > 0, V.r, V.t3)',
            t4: '=IF(V.dyPos > 0, V.xPos, V.x1)',
            xb: '=IF(V.dz > 0, V.t4, V.x1)',
            t5: '=IF(V.dxPos > 0, V.y1, V.yPos)',
            yl: '=IF(V.dz > 0, V.y1, V.t5)',
            t: 0,
            t6: '=IF(V.dyPos > 0, V.t, V.yPos)',
            yt: '=IF(V.dz > 0, V.t6, V.t)',
            t7: '=IF(V.dxPos > 0, V.yPos, V.y1)',
            yr: '=IF(V.dz > 0, V.y1, V.t7)',
            b: h,
            t8: '=IF(V.dyPos > 0, V.yPos, V.b)',
            yb: '=IF(V.dz > 0, V.t8, V.b)',
            ss: s,
            u1: '=V.ss * V.adj3 / 100000',
            u2: '=width - V.u1',
            v2: '=height - V.u1',
            il: '=V.u1 * 29289 / 100000',
            ir: '=width - V.il',
            ib: '=height - V.il',
            cd2: B,
            cd4: C,
            cx1: '=C(V.u1,V.l,A(V.u1,V.u1,V.cd2),true)',
            cy1: '=C(V.u1,V.u1,A(V.u1,V.u1,V.cd2))',
            _3cd4: D,
            cx2: '=C(V.u1,V.u2,A(V.u1,V.u1,V._3cd4),true)',
            cy2: '=C(V.u1,V.t,A(V.u1,V.u1,V._3cd4))',
            cx3: '=C(V.u1,V.r,A(V.u1,V.u1,0),true)',
            cy3: '=C(V.u1,V.v2,A(V.u1,V.u1,0))',
            cx4: '=C(V.u1,V.u1,A(V.u1,V.u1,V.cd4),true)',
            cy4: '=C(V.u1,V.b,A(V.u1,V.u1,V.cd4))',
        },
        adjustInfo: [['adj1', -20833], ['adj2', 62500], ['adj3', 16667]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        }, {
            x: '=V.xPos',
            y: '=V.yPos',
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj1',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj2',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'xPos',
                y: 'yPos',
            },
            point: ['=V.xPos', '=V.yPos'],
        },
        ],
        path: [[['M', 0, '=V.u1'], ['E', '=V.cx1', '=V.cy1', '=V.u1', '=V.u1', 0, '=A(V.u1,V.u1,V.cd2)', '=A(V.u1,V.u1,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', c, 0], ['L', '=V.xt', '=V.yt'], ['L', d, 0], ['L', '=V.u2', 0], ['E', '=V.cx2', '=V.cy2', '=V.u1', '=V.u1', 0, '=A(V.u1,V.u1,V._3cd4)', '=A(V.u1,V.u1,(V._3cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', w, e], ['L', '=V.xr', '=V.yr'], ['L', w, f], ['L', w, '=V.v2'], ['E', '=V.cx3', '=V.cy3', '=V.u1', '=V.u1', 0, '=A(V.u1,V.u1,0)', '=A(V.u1,V.u1,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', d, h], ['L', '=V.xb', '=V.yb'], ['L', c, h], ['L', '=V.u1', h], ['E', '=V.cx4', '=V.cy4', '=V.u1', '=V.u1', 0, '=A(V.u1,V.u1,V.cd4)', '=A(V.u1,V.u1,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', 0, f], ['L', '=V.xl', '=V.yl'], ['L', 0, e], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.il',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    ovalCallout: {
        variables: {
            adj1: -20833,
            adj2: 62500,
            dxPos: '=width * V.adj1 / 100000',
            dyPos: '=height * V.adj2 / 100000',
            hc: E,
            xPos: '=V.hc + V.dxPos',
            vc: F,
            yPos: '=V.vc + V.dyPos',
            sdx: '=V.dxPos * height',
            sdy: '=V.dyPos * width',
            d2r: A,
            pang: '=(ATAN2(V.sdx,V.sdy) * V.d2r)',
            stAng: '=V.pang + 660000',
            enAng: '=V.pang - 660000',
            wd2: E,
            dx1: '=V.wd2 * COS(V.stAng / V.d2r)',
            hd2: F,
            dy1: '=V.hd2 * SIN(V.stAng / V.d2r)',
            x1: '=V.hc + V.dx1',
            y1: '=V.vc + V.dy1',
            dx2: '=V.wd2 * COS(V.enAng / V.d2r)',
            dy2: '=V.hd2 * SIN(V.enAng / V.d2r)',
            x2: '=V.hc + V.dx2',
            y2: '=V.vc + V.dy2',
            stAng1: '=(ATAN2(V.dx1,V.dy1) * V.d2r)',
            enAng1: '=(ATAN2(V.dx2,V.dy2) * V.d2r)',
            swAng1: '=V.enAng1 - V.stAng1',
            swAng2: '=V.swAng1 + 21600000',
            swAng: '=IF(V.swAng1 > 0, V.swAng1, V.swAng2)',
            idx: '=V.wd2 * COS(2700000 / V.d2r)',
            idy: '=V.hd2 * SIN(2700000 / V.d2r)',
            il: '=V.hc - V.idx',
            ir: '=V.hc + V.idx',
            it: '=V.vc - V.idy',
            ib: '=V.vc + V.idy',
            t: 0,
            b: h,
            r: w,
            cx1: '=C(V.wd2,V.x1,A(V.wd2,V.hd2,V.stAng1),true)',
            cy1: '=C(V.hd2,V.y1,A(V.wd2,V.hd2,V.stAng1))',
        },
        adjustInfo: [['adj1', -20833], ['adj2', 62500]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: '=V.il',
            y: '=V.it',
        }, {
            x: '=V.il',
            y: '=V.ib',
        }, {
            x: a,
            y: h,
        }, {
            x: '=V.ir',
            y: '=V.ib',
        }, {
            x: w,
            y: b,
        }, {
            x: '=V.ir',
            y: '=V.it',
        }, {
            x: '=V.xPos',
            y: '=V.yPos',
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj1',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj2',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'xPos',
                y: 'yPos',
            },
            point: ['=V.xPos', '=V.yPos'],
        },
        ],
        path: [[['M', '=V.xPos', '=V.yPos'], ['L', c, e], ['E', '=V.cx1', '=V.cy1', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V.stAng1)', '=A(V.wd2,V.hd2,(V.stAng1 + V.swAng))', '=IF(V.swAng > 0, FALSE, TRUE)'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.it',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    cloudCallout: {
        variables: {
            adj1: -20833,
            adj2: 62500,
            dxPos: '=width * V.adj1 / 100000',
            dyPos: '=height * V.adj2 / 100000',
            hc: E,
            xPos: '=V.hc + V.dxPos',
            vc: F,
            yPos: '=V.vc + V.dyPos',
            hd2: F,
            ht: '=V.hd2 * COS(ATAN2(V.dxPos,V.dyPos))',
            wd2: E,
            wt: '=V.wd2 * SIN(ATAN2(V.dxPos,V.dyPos))',
            g2: '=V.wd2 * COS(ATAN2(V.ht,V.wt))',
            g3: '=V.hd2 * SIN(ATAN2(V.ht,V.wt))',
            g4: '=V.hc + V.g2',
            g5: '=V.vc + V.g3',
            g6: '=V.g4 - V.xPos',
            g7: '=V.g5 - V.yPos',
            g8: '=SQRT(V.g6*V.g6 + V.g7*V.g7)',
            ss: s,
            g9: '=V.ss * 6600 / 21600',
            g10: '=V.g8 - V.g9',
            g11: '=V.g10 / 3',
            g12: '=V.ss * 1800 / 21600',
            g13: '=V.g11 + V.g12',
            g14: '=V.g13 * V.g6 / V.g8',
            g15: '=V.g13 * V.g7 / V.g8',
            g16: '=V.g14 + V.xPos',
            g17: '=V.g15 + V.yPos',
            g18: '=V.ss * 4800 / 21600',
            g19: '=V.g11 * 2',
            g20: '=V.g18 + V.g19',
            g21: '=V.g20 * V.g6 / V.g8',
            g22: '=V.g20 * V.g7 / V.g8',
            g23: '=V.g21 + V.xPos',
            g24: '=V.g22 + V.yPos',
            g25: '=V.ss * 1200 / 21600',
            g26: '=V.ss * 600 / 21600',
            x23: '=V.xPos + V.g26',
            x24: '=V.g16 + V.g25',
            x25: '=V.g23 + V.g12',
            il: '=width * 4477 / 21600',
            it: '=height * 3262 / 21600',
            ir: '=width * 18587 / 21600',
            ib: '=height * 17337 / 21600',
            g27: '=width * 67 / 21600',
            g28: '=height * 21577 / 21600',
            g29: '=width * 21582 / 21600',
            g30: '=height * 1235 / 21600',
            d2r: A,
            pang: '=(ATAN2(V.dxPos,V.dyPos) * V.d2r)',
            _scaleX1: '= width / 43200',
            _scaleY1: '= height / 43200',
            cx1: '=C(6753,3900,A(6753,9190,-11429249),true)',
            cy1: '=C(9190,14370,A(6753,9190,-11429249))',
            cx2: '=C(5333,P(V.cx1,6753,A(6753,9190,(-11429249 + 7426832)),true),A(5333,7267,-8646143),true)',
            cy2: '=C(7267,P(V.cy1,9190,A(6753,9190,(-11429249 + 7426832))),A(5333,7267,-8646143))',
            cx3: '=C(4365,P(V.cx2,5333,A(5333,7267,(-8646143 + 5396714)),true),A(4365,5945,-8748475),true)',
            cy3: '=C(5945,P(V.cy2,7267,A(5333,7267,(-8646143 + 5396714))),A(4365,5945,-8748475))',
            cx4: '=C(4857,P(V.cx3,4365,A(4365,5945,(-8748475 + 5983381)),true),A(4857,6595,-7859164),true)',
            cy4: '=C(6595,P(V.cy3,5945,A(4365,5945,(-8748475 + 5983381))),A(4857,6595,-7859164))',
            cx5: '=C(5333,P(V.cx4,4857,A(4857,6595,(-7859164 + 7034504)),true),A(5333,7273,-4722533),true)',
            cy5: '=C(7273,P(V.cy4,6595,A(4857,6595,(-7859164 + 7034504))),A(5333,7273,-4722533))',
            cx6: '=C(6775,P(V.cx5,5333,A(5333,7273,(-4722533 + 6541615)),true),A(6775,9220,-2776035),true)',
            cy6: '=C(9220,P(V.cy5,7273,A(5333,7273,(-4722533 + 6541615))),A(6775,9220,-2776035))',
            cx7: '=C(5785,P(V.cx6,6775,A(6775,9220,(-2776035 + 7816140)),true),A(5785,7867,37501),true)',
            cy7: '=C(7867,P(V.cy6,9220,A(6775,9220,(-2776035 + 7816140))),A(5785,7867,37501))',
            cx8: '=C(6752,P(V.cx7,5785,A(5785,7867,(37501 + 6842000)),true),A(6752,9215,1347096),true)',
            cy8: '=C(9215,P(V.cy7,7867,A(5785,7867,(37501 + 6842000))),A(6752,9215,1347096))',
            cx9: '=C(7720,P(V.cx8,6752,A(6752,9215,(1347096 + 6910353)),true),A(7720,10543,3974558),true)',
            cy9: '=C(10543,P(V.cy8,9215,A(6752,9215,(1347096 + 6910353))),A(7720,10543,3974558))',
            cx10: '=C(4360,P(V.cx9,7720,A(7720,10543,(3974558 + 4542661)),true),A(4360,5918,-16496525),true)',
            cy10: '=C(5918,P(V.cy9,10543,A(7720,10543,(3974558 + 4542661))),A(4360,5918,-16496525))',
            cx11: '=C(4345,P(V.cx10,4360,A(4360,5918,(-16496525 + 8804134)),true),A(4345,5945,-14809710),true)',
            cy11: '=C(5945,P(V.cy10,5918,A(4360,5918,(-16496525 + 8804134))),A(4345,5945,-14809710))',
            cx12: '=C(V.g26,V.x23,A(V.g26,V.g26,0),true)',
            cy12: '=C(V.g26,V.yPos,A(V.g26,V.g26,0))',
            cx13: '=C(V.g25,V.x24,A(V.g25,V.g25,0),true)',
            cy13: '=C(V.g25,V.g17,A(V.g25,V.g25,0))',
            cx14: '=C(V.g12,V.x25,A(V.g12,V.g12,0),true)',
            cy14: '=C(V.g12,V.g24,A(V.g12,V.g12,0))',
            _scaleX2: '= width / 43200',
            _scaleY2: '= height / 43200',
            cx15: '=C(4345,4693,A(4345,5945,5204520),true)',
            cy15: '=C(5945,26177,A(4345,5945,5204520))',
            cx16: '=C(4360,6928,A(4360,5918,4416628),true)',
            cy16: '=C(5918,34899,A(4360,5918,4416628))',
            cx17: '=C(6752,16478,A(6752,9215,8257449),true)',
            cy17: '=C(9215,39090,A(6752,9215,8257449))',
            cx18: '=C(6752,28827,A(6752,9215,387196),true)',
            cy18: '=C(9215,34751,A(6752,9215,387196))',
            cx19: '=C(5785,34129,A(5785,7867,-4217541),true)',
            cy19: '=C(7867,22954,A(5785,7867,-4217541))',
            cx20: '=C(5333,41798,A(5333,7273,1819082),true)',
            cy20: '=C(7273,15354,A(5333,7273,1819082))',
            cx21: '=C(4857,38324,A(4857,6595,-824660),true)',
            cy21: '=C(6595,5426,A(4857,6595,-824660))',
            cx22: '=C(4857,29078,A(4857,6595,-8950887),true)',
            cy22: '=C(6595,3952,A(4857,6595,-8950887))',
            cx23: '=C(4365,22141,A(4365,5945,-9809656),true)',
            cy23: '=C(5945,4720,A(4365,5945,-9809656))',
            cx24: '=C(6753,14000,A(6753,9190,-4002417),true)',
            cy24: '=C(9190,5192,A(6753,9190,-4002417))',
            cx25: '=C(6753,4127,A(6753,9190,9459261),true)',
            cy25: '=C(9190,15789,A(6753,9190,9459261))',
        },
        adjustInfo: [['adj1', -20833], ['adj2', 62500]],
        connectionPoints: [{
            x: '=V.g27',
            y: b,
        }, {
            x: a,
            y: '=V.g28',
        }, {
            x: '=V.g29',
            y: b,
        }, {
            x: a,
            y: '=V.g30',
        }, {
            x: '=V.xPos',
            y: '=V.yPos',
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj1',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj2',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'xPos',
                y: 'yPos',
            },
            point: ['=V.xPos', '=V.yPos'],
        },
        ],
        path: [[['M', '=3900 * V._scaleX1', '=14370 * V._scaleY1'], ['E', '=V.cx1 * V._scaleX1', '=V.cy1 * V._scaleY1', '=6753 * V._scaleX1', '=9190 * V._scaleY1', 0, '=A(6753,9190,-11429249)', '=A(6753,9190,(-11429249 + 7426832))', '=IF(7426832 > 0, FALSE, TRUE)'], ['E', '=V.cx2 * V._scaleX1', '=V.cy2 * V._scaleY1', '=5333 * V._scaleX1', '=7267 * V._scaleY1', 0, '=A(5333,7267,-8646143)', '=A(5333,7267,(-8646143 + 5396714))', '=IF(5396714 > 0, FALSE, TRUE)'], ['E', '=V.cx3 * V._scaleX1', '=V.cy3 * V._scaleY1', '=4365 * V._scaleX1', '=5945 * V._scaleY1', 0, '=A(4365,5945,-8748475)', '=A(4365,5945,(-8748475 + 5983381))', '=IF(5983381 > 0, FALSE, TRUE)'], ['E', '=V.cx4 * V._scaleX1', '=V.cy4 * V._scaleY1', '=4857 * V._scaleX1', '=6595 * V._scaleY1', 0, '=A(4857,6595,-7859164)', '=A(4857,6595,(-7859164 + 7034504))', '=IF(7034504 > 0, FALSE, TRUE)'], ['E', '=V.cx5 * V._scaleX1', '=V.cy5 * V._scaleY1', '=5333 * V._scaleX1', '=7273 * V._scaleY1', 0, '=A(5333,7273,-4722533)', '=A(5333,7273,(-4722533 + 6541615))', '=IF(6541615 > 0, FALSE, TRUE)'], ['E', '=V.cx6 * V._scaleX1', '=V.cy6 * V._scaleY1', '=6775 * V._scaleX1', '=9220 * V._scaleY1', 0, '=A(6775,9220,-2776035)', '=A(6775,9220,(-2776035 + 7816140))', '=IF(7816140 > 0, FALSE, TRUE)'], ['E', '=V.cx7 * V._scaleX1', '=V.cy7 * V._scaleY1', '=5785 * V._scaleX1', '=7867 * V._scaleY1', 0, '=A(5785,7867,37501)', '=A(5785,7867,(37501 + 6842000))', '=IF(6842000 > 0, FALSE, TRUE)'], ['E', '=V.cx8 * V._scaleX1', '=V.cy8 * V._scaleY1', '=6752 * V._scaleX1', '=9215 * V._scaleY1', 0, '=A(6752,9215,1347096)', '=A(6752,9215,(1347096 + 6910353))', '=IF(6910353 > 0, FALSE, TRUE)'], ['E', '=V.cx9 * V._scaleX1', '=V.cy9 * V._scaleY1', '=7720 * V._scaleX1', '=10543 * V._scaleY1', 0, '=A(7720,10543,3974558)', '=A(7720,10543,(3974558 + 4542661))', '=IF(4542661 > 0, FALSE, TRUE)'], ['E', '=V.cx10 * V._scaleX1', '=V.cy10 * V._scaleY1', '=4360 * V._scaleX1', '=5918 * V._scaleY1', 0, '=A(4360,5918,-16496525)', '=A(4360,5918,(-16496525 + 8804134))', '=IF(8804134 > 0, FALSE, TRUE)'], ['E', '=V.cx11 * V._scaleX1', '=V.cy11 * V._scaleY1', '=4345 * V._scaleX1', '=5945 * V._scaleY1', 0, '=A(4345,5945,-14809710)', '=A(4345,5945,(-14809710 + 9151131))', '=IF(9151131 > 0, FALSE, TRUE)'], ['Z'], {},
        ], [['M', '=V.x23', '=V.yPos'], ['E', '=V.cx12', '=V.cy12', '=V.g26', '=V.g26', 0, '=A(V.g26,V.g26,0)', '=(A(V.g26,V.g26,0)+ 2*PI())', '=IF(21600000 > 0, FALSE, TRUE)'], ['Z'], {},
        ], [['M', '=V.x24', '=V.g17'], ['E', '=V.cx13', '=V.cy13', '=V.g25', '=V.g25', 0, '=A(V.g25,V.g25,0)', '=(A(V.g25,V.g25,0)+ 2*PI())', '=IF(21600000 > 0, FALSE, TRUE)'], ['Z'], {},
        ], [['M', '=V.x25', '=V.g24'], ['E', '=V.cx14', '=V.cy14', '=V.g12', '=V.g12', 0, '=A(V.g12,V.g12,0)', '=(A(V.g12,V.g12,0)+ 2*PI())', '=IF(21600000 > 0, FALSE, TRUE)'], ['Z'], {},
        ], [['M', '=4693 * V._scaleX2', '=26177 * V._scaleY2'], ['E', '=V.cx15 * V._scaleX2', '=V.cy15 * V._scaleY2', '=4345 * V._scaleX2', '=5945 * V._scaleY2', 0, '=A(4345,5945,5204520)', '=A(4345,5945,(5204520 + 1585770))', '=IF(1585770 > 0, FALSE, TRUE)'], ['M', '=6928 * V._scaleX2', '=34899 * V._scaleY2'], ['E', '=V.cx16 * V._scaleX2', '=V.cy16 * V._scaleY2', '=4360 * V._scaleX2', '=5918 * V._scaleY2', 0, '=A(4360,5918,4416628)', '=A(4360,5918,(4416628 + 686848))', '=IF(686848 > 0, FALSE, TRUE)'], ['M', '=16478 * V._scaleX2', '=39090 * V._scaleY2'], ['E', '=V.cx17 * V._scaleX2', '=V.cy17 * V._scaleY2', '=6752 * V._scaleX2', '=9215 * V._scaleY2', 0, '=A(6752,9215,8257449)', '=A(6752,9215,(8257449 + 844866))', '=IF(844866 > 0, FALSE, TRUE)'], ['M', '=28827 * V._scaleX2', '=34751 * V._scaleY2'], ['E', '=V.cx18 * V._scaleX2', '=V.cy18 * V._scaleY2', '=6752 * V._scaleX2', '=9215 * V._scaleY2', 0, '=A(6752,9215,387196)', '=A(6752,9215,(387196 + 959901))', '=IF(959901 > 0, FALSE, TRUE)'], ['M', '=34129 * V._scaleX2', '=22954 * V._scaleY2'], ['E', '=V.cx19 * V._scaleX2', '=V.cy19 * V._scaleY2', '=5785 * V._scaleX2', '=7867 * V._scaleY2', 0, '=A(5785,7867,-4217541)', '=A(5785,7867,(-4217541 + 4255042))', '=IF(4255042 > 0, FALSE, TRUE)'], ['M', '=41798 * V._scaleX2', '=15354 * V._scaleY2'], ['E', '=V.cx20 * V._scaleX2', '=V.cy20 * V._scaleY2', '=5333 * V._scaleX2', '=7273 * V._scaleY2', 0, '=A(5333,7273,1819082)', '=A(5333,7273,(1819082 + 1665090))', '=IF(1665090 > 0, FALSE, TRUE)'], ['M', '=38324 * V._scaleX2', '=5426 * V._scaleY2'], ['E', '=V.cx21 * V._scaleX2', '=V.cy21 * V._scaleY2', '=4857 * V._scaleX2', '=6595 * V._scaleY2', 0, '=A(4857,6595,-824660)', '=A(4857,6595,(-824660 + 891534))', '=IF(891534 > 0, FALSE, TRUE)'], ['M', '=29078 * V._scaleX2', '=3952 * V._scaleY2'], ['E', '=V.cx22 * V._scaleX2', '=V.cy22 * V._scaleY2', '=4857 * V._scaleX2', '=6595 * V._scaleY2', 0, '=A(4857,6595,-8950887)', '=A(4857,6595,(-8950887 + 1091722))', '=IF(1091722 > 0, FALSE, TRUE)'], ['M', '=22141 * V._scaleX2', '=4720 * V._scaleY2'], ['E', '=V.cx23 * V._scaleX2', '=V.cy23 * V._scaleY2', '=4365 * V._scaleX2', '=5945 * V._scaleY2', 0, '=A(4365,5945,-9809656)', '=A(4365,5945,(-9809656 + 1061181))', '=IF(1061181 > 0, FALSE, TRUE)'], ['M', '=14000 * V._scaleX2', '=5192 * V._scaleY2'], ['E', '=V.cx24 * V._scaleX2', '=V.cy24 * V._scaleY2', '=6753 * V._scaleX2', '=9190 * V._scaleY2', 0, '=A(6753,9190,-4002417)', '=A(6753,9190,(-4002417 + 739161))', '=IF(739161 > 0, FALSE, TRUE)'], ['M', '=4127 * V._scaleX2', '=15789 * V._scaleY2'], ['E', '=V.cx25 * V._scaleX2', '=V.cy25 * V._scaleY2', '=6753 * V._scaleX2', '=9190 * V._scaleY2', 0, '=A(6753,9190,9459261)', '=A(6753,9190,(9459261 + 711490))', '=IF(711490 > 0, FALSE, TRUE)'], {
            fillMode: 'none',
        },
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.it',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    lineCallout1: {
        variables: {
            adj1: 18750,
            adj2: -8333,
            adj3: 112500,
            adj4: -38333,
            y1: '=height * V.adj1 / 100000',
            x1: '=width * V.adj2 / 100000',
            y2: '=height * V.adj3 / 100000',
            x2: '=width * V.adj4 / 100000',
            r: w,
            vc: F,
            hc: E,
            b: h,
            l: 0,
            t: 0,
        },
        adjustInfo: [['adj1', 18750], ['adj2', -8333], ['adj3', 112500], ['adj4', -38333]],
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj1',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x1',
                y: 'y1',
            },
            point: [c, e],
        }, {
            type: 'ahXY',
            gdRefX: 'adj4',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj3',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x2',
                y: 'y2',
            },
            point: [d, f],
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {},
        ], [['M', c, e], ['L', d, f], {
            fillMode: 'none',
        },
        ]],
    },
    lineCallout2: {
        variables: {
            adj1: 18750,
            adj2: -8333,
            adj3: 112500,
            adj4: -38333,
            y1: '=height * V.adj1 / 100000',
            x1: '=width * V.adj2 / 100000',
            y2: '=height * V.adj3 / 100000',
            x2: '=width * V.adj4 / 100000',
            r: w,
            vc: F,
            hc: E,
            b: h,
            l: 0,
            t: 0,
        },
        adjustInfo: [['adj1', 18750], ['adj2', -8333], ['adj3', 112500], ['adj4', -38333]],
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj1',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x1',
                y: 'y1',
            },
            point: [c, e],
        }, {
            type: 'ahXY',
            gdRefX: 'adj4',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj3',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x2',
                y: 'y2',
            },
            point: [d, f],
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {},
        ], [['M', c, e], ['L', d, f], {
            fillMode: 'none',
        },
        ]],
    },
    lineCallout3: {
        variables: {
            adj1: 18750,
            adj2: -8333,
            adj3: 18750,
            adj4: -16667,
            adj5: 112500,
            adj6: -46667,
            y1: '=height * V.adj1 / 100000',
            x1: '=width * V.adj2 / 100000',
            y2: '=height * V.adj3 / 100000',
            x2: '=width * V.adj4 / 100000',
            y3: '=height * V.adj5 / 100000',
            x3: '=width * V.adj6 / 100000',
            r: w,
            vc: F,
            hc: E,
            b: h,
            l: 0,
            t: 0,
        },
        adjustInfo: [['adj1', 18750], ['adj2', -8333], ['adj3', 18750], ['adj4', -16667], ['adj5', 112500], ['adj6', -46667]],
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj1',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x1',
                y: 'y1',
            },
            point: [c, e],
        }, {
            type: 'ahXY',
            gdRefX: 'adj4',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj3',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x2',
                y: 'y2',
            },
            point: [d, f],
        }, {
            type: 'ahXY',
            gdRefX: 'adj6',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj5',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x3',
                y: 'y3',
            },
            point: ['=V.x3', '=V.y3'],
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {},
        ], [['M', c, e], ['L', d, f], ['L', '=V.x3', '=V.y3'], {
            fillMode: 'none',
        },
        ]],
    },
    lineCallout4: {
        variables: {
            adj1: 18750,
            adj2: -8333,
            adj3: 18750,
            adj4: -16667,
            adj5: 100000,
            adj6: -16667,
            adj7: 112963,
            adj8: -8333,
            y1: '=height * V.adj1 / 100000',
            x1: '=width * V.adj2 / 100000',
            y2: '=height * V.adj3 / 100000',
            x2: '=width * V.adj4 / 100000',
            y3: '=height * V.adj5 / 100000',
            x3: '=width * V.adj6 / 100000',
            y4: '=height * V.adj7 / 100000',
            x4: '=width * V.adj8 / 100000',
            r: w,
            vc: F,
            hc: E,
            b: h,
            l: 0,
            t: 0,
        },
        adjustInfo: [['adj1', 18750], ['adj2', -8333], ['adj3', 18750], ['adj4', -16667], ['adj5', 100000], ['adj6', -16667], ['adj7', 112963], ['adj8', -8333]],
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj1',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x1',
                y: 'y1',
            },
            point: [c, e],
        }, {
            type: 'ahXY',
            gdRefX: 'adj4',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj3',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x2',
                y: 'y2',
            },
            point: [d, f],
        }, {
            type: 'ahXY',
            gdRefX: 'adj6',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj5',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x3',
                y: 'y3',
            },
            point: ['=V.x3', '=V.y3'],
        }, {
            type: 'ahXY',
            gdRefX: 'adj8',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj7',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x4',
                y: 'y4',
            },
            point: ['=V.x4', '=V.y4'],
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {},
        ], [['M', c, e], ['L', d, f], ['L', '=V.x3', '=V.y3'], ['L', '=V.x4', '=V.y4'], {
            fillMode: 'none',
        },
        ]],
    },
    lineCallout1AccentBar: {
        variables: {
            adj1: 18750,
            adj2: -8333,
            adj3: 112500,
            adj4: -38333,
            y1: '=height * V.adj1 / 100000',
            x1: '=width * V.adj2 / 100000',
            y2: '=height * V.adj3 / 100000',
            x2: '=width * V.adj4 / 100000',
            r: w,
            vc: F,
            hc: E,
            b: h,
            l: 0,
            t: 0,
        },
        adjustInfo: [['adj1', 18750], ['adj2', -8333], ['adj3', 112500], ['adj4', -38333]],
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj1',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x1',
                y: 'y1',
            },
            point: [c, e],
        }, {
            type: 'ahXY',
            gdRefX: 'adj4',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj3',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x2',
                y: 'y2',
            },
            point: [d, f],
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', c, e], ['L', d, f], {
            fillMode: 'none',
        },
        ]],
    },
    lineCallout2AccentBar: {
        variables: {
            adj1: 18750,
            adj2: -8333,
            adj3: 112500,
            adj4: -38333,
            y1: '=height * V.adj1 / 100000',
            x1: '=width * V.adj2 / 100000',
            y2: '=height * V.adj3 / 100000',
            x2: '=width * V.adj4 / 100000',
            r: w,
            vc: F,
            hc: E,
            b: h,
            l: 0,
            t: 0,
        },
        adjustInfo: [['adj1', 18750], ['adj2', -8333], ['adj3', 112500], ['adj4', -38333]],
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj1',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x1',
                y: 'y1',
            },
            point: [c, e],
        }, {
            type: 'ahXY',
            gdRefX: 'adj4',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj3',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x2',
                y: 'y2',
            },
            point: [d, f],
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', c, 0], ['Z'], ['L', c, h], {
            fillMode: 'none',
        },
        ], [['M', c, e], ['L', d, f], {
            fillMode: 'none',
        },
        ]],
    },
    lineCallout3AccentBar: {
        variables: {
            adj1: 18750,
            adj2: -8333,
            adj3: 18750,
            adj4: -16667,
            adj5: 112500,
            adj6: -46667,
            y1: '=height * V.adj1 / 100000',
            x1: '=width * V.adj2 / 100000',
            y2: '=height * V.adj3 / 100000',
            x2: '=width * V.adj4 / 100000',
            y3: '=height * V.adj5 / 100000',
            x3: '=width * V.adj6 / 100000',
            r: w,
            vc: F,
            hc: E,
            b: h,
            l: 0,
            t: 0,
        },
        adjustInfo: [['adj1', 18750], ['adj2', -8333], ['adj3', 18750], ['adj4', -16667], ['adj5', 112500], ['adj6', -46667]],
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj1',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x1',
                y: 'y1',
            },
            point: [c, e],
        }, {
            type: 'ahXY',
            gdRefX: 'adj4',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj3',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x2',
                y: 'y2',
            },
            point: [d, f],
        }, {
            type: 'ahXY',
            gdRefX: 'adj6',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj5',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x3',
                y: 'y3',
            },
            point: ['=V.x3', '=V.y3'],
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', c, 0], ['Z'], ['L', c, h], {
            fillMode: 'none',
        },
        ], [['M', c, e], ['L', d, f], ['L', '=V.x3', '=V.y3'], {
            fillMode: 'none',
        },
        ]],
    },
    lineCallout4AccentBar: {
        variables: {
            adj1: 18750,
            adj2: -8333,
            adj3: 18750,
            adj4: -16667,
            adj5: 100000,
            adj6: -16667,
            adj7: 112963,
            adj8: -8333,
            y1: '=height * V.adj1 / 100000',
            x1: '=width * V.adj2 / 100000',
            y2: '=height * V.adj3 / 100000',
            x2: '=width * V.adj4 / 100000',
            y3: '=height * V.adj5 / 100000',
            x3: '=width * V.adj6 / 100000',
            y4: '=height * V.adj7 / 100000',
            x4: '=width * V.adj8 / 100000',
            r: w,
            vc: F,
            hc: E,
            b: h,
            l: 0,
            t: 0,
        },
        adjustInfo: [['adj1', 18750], ['adj2', -8333], ['adj3', 18750], ['adj4', -16667], ['adj5', 100000], ['adj6', -16667], ['adj7', 112963], ['adj8', -8333]],
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj1',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x1',
                y: 'y1',
            },
            point: [c, e],
        }, {
            type: 'ahXY',
            gdRefX: 'adj4',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj3',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x2',
                y: 'y2',
            },
            point: [d, f],
        }, {
            type: 'ahXY',
            gdRefX: 'adj6',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj5',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x3',
                y: 'y3',
            },
            point: ['=V.x3', '=V.y3'],
        }, {
            type: 'ahXY',
            gdRefX: 'adj8',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj7',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x4',
                y: 'y4',
            },
            point: ['=V.x4', '=V.y4'],
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', c, 0], ['Z'], ['L', c, h], {
            fillMode: 'none',
        },
        ], [['M', c, e], ['L', d, f], ['L', '=V.x3', '=V.y3'], ['L', '=V.x4', '=V.y4'], {
            fillMode: 'none',
        },
        ]],
    },
    lineCallout1NoBorder: {
        variables: {
            adj1: 18750,
            adj2: -8333,
            adj3: 112500,
            adj4: -38333,
            y1: '=height * V.adj1 / 100000',
            x1: '=width * V.adj2 / 100000',
            y2: '=height * V.adj3 / 100000',
            x2: '=width * V.adj4 / 100000',
            r: w,
            vc: F,
            hc: E,
            b: h,
            l: 0,
            t: 0,
        },
        adjustInfo: [['adj1', 18750], ['adj2', -8333], ['adj3', 112500], ['adj4', -38333]],
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj1',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x1',
                y: 'y1',
            },
            point: [c, e],
        }, {
            type: 'ahXY',
            gdRefX: 'adj4',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj3',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x2',
                y: 'y2',
            },
            point: [d, f],
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', c, e], ['L', d, f], {
            fillMode: 'none',
        },
        ]],
    },
    lineCallout2NoBorder: {
        variables: {
            adj1: 18750,
            adj2: -8333,
            adj3: 112500,
            adj4: -38333,
            y1: '=height * V.adj1 / 100000',
            x1: '=width * V.adj2 / 100000',
            y2: '=height * V.adj3 / 100000',
            x2: '=width * V.adj4 / 100000',
            r: w,
            vc: F,
            hc: E,
            b: h,
            l: 0,
            t: 0,
        },
        adjustInfo: [['adj1', 18750], ['adj2', -8333], ['adj3', 112500], ['adj4', -38333]],
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj1',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x1',
                y: 'y1',
            },
            point: [c, e],
        }, {
            type: 'ahXY',
            gdRefX: 'adj4',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj3',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x2',
                y: 'y2',
            },
            point: [d, f],
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', c, e], ['L', d, f], {
            fillMode: 'none',
        },
        ]],
    },
    lineCallout3NoBorder: {
        variables: {
            adj1: 18750,
            adj2: -8333,
            adj3: 18750,
            adj4: -16667,
            adj5: 112500,
            adj6: -46667,
            y1: '=height * V.adj1 / 100000',
            x1: '=width * V.adj2 / 100000',
            y2: '=height * V.adj3 / 100000',
            x2: '=width * V.adj4 / 100000',
            y3: '=height * V.adj5 / 100000',
            x3: '=width * V.adj6 / 100000',
            r: w,
            vc: F,
            hc: E,
            b: h,
            l: 0,
            t: 0,
        },
        adjustInfo: [['adj1', 18750], ['adj2', -8333], ['adj3', 18750], ['adj4', -16667], ['adj5', 112500], ['adj6', -46667]],
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj1',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x1',
                y: 'y1',
            },
            point: [c, e],
        }, {
            type: 'ahXY',
            gdRefX: 'adj4',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj3',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x2',
                y: 'y2',
            },
            point: [d, f],
        }, {
            type: 'ahXY',
            gdRefX: 'adj6',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj5',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x3',
                y: 'y3',
            },
            point: ['=V.x3', '=V.y3'],
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', c, e], ['L', d, f], ['L', '=V.x3', '=V.y3'], {
            fillMode: 'none',
        },
        ]],
    },
    lineCallout4NoBorder: {
        variables: {
            adj1: 18750,
            adj2: -8333,
            adj3: 18750,
            adj4: -16667,
            adj5: 100000,
            adj6: -16667,
            adj7: 112963,
            adj8: -8333,
            y1: '=height * V.adj1 / 100000',
            x1: '=width * V.adj2 / 100000',
            y2: '=height * V.adj3 / 100000',
            x2: '=width * V.adj4 / 100000',
            y3: '=height * V.adj5 / 100000',
            x3: '=width * V.adj6 / 100000',
            y4: '=height * V.adj7 / 100000',
            x4: '=width * V.adj8 / 100000',
            r: w,
            vc: F,
            hc: E,
            b: h,
            l: 0,
            t: 0,
        },
        adjustInfo: [['adj1', 18750], ['adj2', -8333], ['adj3', 18750], ['adj4', -16667], ['adj5', 100000], ['adj6', -16667], ['adj7', 112963], ['adj8', -8333]],
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj1',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x1',
                y: 'y1',
            },
            point: [c, e],
        }, {
            type: 'ahXY',
            gdRefX: 'adj4',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj3',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x2',
                y: 'y2',
            },
            point: [d, f],
        }, {
            type: 'ahXY',
            gdRefX: 'adj6',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj5',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x3',
                y: 'y3',
            },
            point: ['=V.x3', '=V.y3'],
        }, {
            type: 'ahXY',
            gdRefX: 'adj8',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj7',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x4',
                y: 'y4',
            },
            point: ['=V.x4', '=V.y4'],
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', c, e], ['L', d, f], ['L', '=V.x3', '=V.y3'], ['L', '=V.x4', '=V.y4'], {
            fillMode: 'none',
        },
        ]],
    },
    lineCallout1BorderandAccentBar: {
        variables: {
            adj1: 18750,
            adj2: -8333,
            adj3: 112500,
            adj4: -38333,
            y1: '=height * V.adj1 / 100000',
            x1: '=width * V.adj2 / 100000',
            y2: '=height * V.adj3 / 100000',
            x2: '=width * V.adj4 / 100000',
            r: w,
            vc: F,
            hc: E,
            b: h,
            l: 0,
            t: 0,
        },
        adjustInfo: [['adj1', 18750], ['adj2', -8333], ['adj3', 112500], ['adj4', -38333]],
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj1',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x1',
                y: 'y1',
            },
            point: [c, e],
        }, {
            type: 'ahXY',
            gdRefX: 'adj4',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj3',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x2',
                y: 'y2',
            },
            point: [d, f],
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {},
        ], [['M', c, e], ['L', d, f], {
            fillMode: 'none',
        },
        ]],
    },
    lineCallout2BorderandAccentBar: {
        variables: {
            adj1: 18750,
            adj2: -8333,
            adj3: 112500,
            adj4: -38333,
            y1: '=height * V.adj1 / 100000',
            x1: '=width * V.adj2 / 100000',
            y2: '=height * V.adj3 / 100000',
            x2: '=width * V.adj4 / 100000',
            r: w,
            vc: F,
            hc: E,
            b: h,
            l: 0,
            t: 0,
        },
        adjustInfo: [['adj1', 18750], ['adj2', -8333], ['adj3', 112500], ['adj4', -38333]],
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj1',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x1',
                y: 'y1',
            },
            point: [c, e],
        }, {
            type: 'ahXY',
            gdRefX: 'adj4',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj3',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x2',
                y: 'y2',
            },
            point: [d, f],
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {},
        ], [['M', c, 0], ['Z'], ['L', c, h], {
            fillMode: 'none',
        },
        ], [['M', c, e], ['L', d, f], {
            fillMode: 'none',
        },
        ]],
    },
    lineCallout3BorderandAccentBar: {
        variables: {
            adj1: 18750,
            adj2: -8333,
            adj3: 18750,
            adj4: -16667,
            adj5: 112500,
            adj6: -46667,
            y1: '=height * V.adj1 / 100000',
            x1: '=width * V.adj2 / 100000',
            y2: '=height * V.adj3 / 100000',
            x2: '=width * V.adj4 / 100000',
            y3: '=height * V.adj5 / 100000',
            x3: '=width * V.adj6 / 100000',
            r: w,
            vc: F,
            hc: E,
            b: h,
            l: 0,
            t: 0,
        },
        adjustInfo: [['adj1', 18750], ['adj2', -8333], ['adj3', 18750], ['adj4', -16667], ['adj5', 112500], ['adj6', -46667]],
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj1',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x1',
                y: 'y1',
            },
            point: [c, e],
        }, {
            type: 'ahXY',
            gdRefX: 'adj4',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj3',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x2',
                y: 'y2',
            },
            point: [d, f],
        }, {
            type: 'ahXY',
            gdRefX: 'adj6',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj5',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x3',
                y: 'y3',
            },
            point: ['=V.x3', '=V.y3'],
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {},
        ], [['M', c, 0], ['Z'], ['L', c, h], {
            fillMode: 'none',
        },
        ], [['M', c, e], ['L', d, f], ['L', '=V.x3', '=V.y3'], {
            fillMode: 'none',
        },
        ]],
    },
    lineCallout4BorderandAccentBar: {
        variables: {
            adj1: 18750,
            adj2: -8333,
            adj3: 18750,
            adj4: -16667,
            adj5: 100000,
            adj6: -16667,
            adj7: 112963,
            adj8: -8333,
            y1: '=height * V.adj1 / 100000',
            x1: '=width * V.adj2 / 100000',
            y2: '=height * V.adj3 / 100000',
            x2: '=width * V.adj4 / 100000',
            y3: '=height * V.adj5 / 100000',
            x3: '=width * V.adj6 / 100000',
            y4: '=height * V.adj7 / 100000',
            x4: '=width * V.adj8 / 100000',
            r: w,
            vc: F,
            hc: E,
            b: h,
            l: 0,
            t: 0,
        },
        adjustInfo: [['adj1', 18750], ['adj2', -8333], ['adj3', 18750], ['adj4', -16667], ['adj5', 100000], ['adj6', -16667], ['adj7', 112963], ['adj8', -8333]],
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj1',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x1',
                y: 'y1',
            },
            point: [c, e],
        }, {
            type: 'ahXY',
            gdRefX: 'adj4',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj3',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x2',
                y: 'y2',
            },
            point: [d, f],
        }, {
            type: 'ahXY',
            gdRefX: 'adj6',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj5',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x3',
                y: 'y3',
            },
            point: ['=V.x3', '=V.y3'],
        }, {
            type: 'ahXY',
            gdRefX: 'adj8',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj7',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'x4',
                y: 'y4',
            },
            point: ['=V.x4', '=V.y4'],
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {},
        ], [['M', c, 0], ['Z'], ['L', c, h], {
            fillMode: 'none',
        },
        ], [['M', c, e], ['L', d, f], ['L', '=V.x3', '=V.y3'], ['L', '=V.x4', '=V.y4'], {
            fillMode: 'none',
        },
        ]],
    },
    actionButtonCustom: {
        variables: {
            r: w,
            vc: F,
            hc: E,
            b: h,
            l: 0,
            t: 0,
        },
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {},
        ]],
    },
    actionButtonHome: {
        variables: {
            ss: s,
            dx2: '=V.ss * 3 / 8',
            vc: F,
            g9: '=V.vc - V.dx2',
            g10: '=V.vc + V.dx2',
            hc: E,
            g11: '=V.hc - V.dx2',
            g12: '=V.hc + V.dx2',
            g13: '=V.ss * 3 / 4',
            g14: '=V.g13 / 16',
            g15: '=V.g13 / 8',
            g16: '=V.g13 * 3 / 16',
            g17: '=V.g13 * 5 / 16',
            g18: '=V.g13 * 7 / 16',
            g19: '=V.g13 * 9 / 16',
            g20: '=V.g13 * 11 / 16',
            g21: '=V.g13 * 3 / 4',
            g22: '=V.g13 * 13 / 16',
            g23: '=V.g13 * 7 / 8',
            g24: '=V.g9 + V.g14',
            g25: '=V.g9 + V.g16',
            g26: '=V.g9 + V.g17',
            g27: '=V.g9 + V.g21',
            g28: '=V.g11 + V.g15',
            g29: '=V.g11 + V.g18',
            g30: '=V.g11 + V.g19',
            g31: '=V.g11 + V.g20',
            g32: '=V.g11 + V.g22',
            g33: '=V.g11 + V.g23',
            r: w,
            b: h,
            l: 0,
            t: 0,
        },
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], ['M', a, '=V.g9'], ['L', '=V.g11', b], ['L', '=V.g28', b], ['L', '=V.g28', '=V.g10'], ['L', '=V.g33', '=V.g10'], ['L', '=V.g33', b], ['L', '=V.g12', b], ['L', '=V.g32', '=V.g26'], ['L', '=V.g32', '=V.g24'], ['L', '=V.g31', '=V.g24'], ['L', '=V.g31', '=V.g25'], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', '=V.g32', '=V.g26'], ['L', '=V.g32', '=V.g24'], ['L', '=V.g31', '=V.g24'], ['L', '=V.g31', '=V.g25'], ['Z'], ['M', '=V.g28', b], ['L', '=V.g28', '=V.g10'], ['L', '=V.g29', '=V.g10'], ['L', '=V.g29', '=V.g27'], ['L', '=V.g30', '=V.g27'], ['L', '=V.g30', '=V.g10'], ['L', '=V.g33', '=V.g10'], ['L', '=V.g33', b], ['Z'], {
            fillMode: 'darkenLess',
            strokeMode: 'false',
        },
        ], [['M', a, '=V.g9'], ['L', '=V.g11', b], ['L', '=V.g12', b], ['Z'], ['M', '=V.g29', '=V.g27'], ['L', '=V.g30', '=V.g27'], ['L', '=V.g30', '=V.g10'], ['L', '=V.g29', '=V.g10'], ['Z'], {
            fillMode: 'darken',
            strokeMode: 'false',
        },
        ], [['M', a, '=V.g9'], ['L', '=V.g31', '=V.g25'], ['L', '=V.g31', '=V.g24'], ['L', '=V.g32', '=V.g24'], ['L', '=V.g32', '=V.g26'], ['L', '=V.g12', b], ['L', '=V.g33', b], ['L', '=V.g33', '=V.g10'], ['L', '=V.g28', '=V.g10'], ['L', '=V.g28', b], ['L', '=V.g11', b], ['Z'], ['M', '=V.g31', '=V.g25'], ['L', '=V.g32', '=V.g26'], ['M', '=V.g33', b], ['L', '=V.g28', b], ['M', '=V.g29', '=V.g10'], ['L', '=V.g29', '=V.g27'], ['L', '=V.g30', '=V.g27'], ['L', '=V.g30', '=V.g10'], {
            fillMode: 'none',
        },
        ], [['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {
            fillMode: 'none',
        },
        ]],
    },
    actionButtonHelp: {
        variables: {
            ss: s,
            dx2: '=V.ss * 3 / 8',
            vc: F,
            g9: '=V.vc - V.dx2',
            hc: E,
            g11: '=V.hc - V.dx2',
            g13: '=V.ss * 3 / 4',
            g14: '=V.g13 / 7',
            g15: '=V.g13 * 3 / 14',
            g16: '=V.g13 * 2 / 7',
            g19: '=V.g13 * 3 / 7',
            g20: '=V.g13 * 4 / 7',
            g21: '=V.g13 * 17 / 28',
            g23: '=V.g13 * 21 / 28',
            g24: '=V.g13 * 11 / 14',
            g27: '=V.g9 + V.g16',
            g29: '=V.g9 + V.g21',
            g30: '=V.g9 + V.g23',
            g31: '=V.g9 + V.g24',
            g33: '=V.g11 + V.g15',
            g36: '=V.g11 + V.g19',
            g37: '=V.g11 + V.g20',
            g41: '=V.g13 / 14',
            g42: '=V.g13 * 3 / 28',
            r: w,
            b: h,
            l: 0,
            t: 0,
            cd2: B,
            cx1: '=C(V.g16,V.g33,A(V.g16,V.g16,V.cd2),true)',
            cy1: '=C(V.g16,V.g27,A(V.g16,V.g16,V.cd2))',
            cd4: C,
            cx2: '=C(V.g14,P(V.cx1,V.g16,A(V.g16,V.g16,(V.cd2 + V.cd2)),true),A(V.g14,V.g15,0),true)',
            cy2: '=C(V.g15,P(V.cy1,V.g16,A(V.g16,V.g16,(V.cd2 + V.cd2))),A(V.g14,V.g15,0))',
            _3cd4: D,
            cx3: '=C(V.g41,P(V.cx2,V.g14,A(V.g14,V.g15,(V.cd4)),true),A(V.g41,V.g42,V._3cd4),true)',
            cy3: '=C(V.g42,P(V.cy2,V.g15,A(V.g14,V.g15,(V.cd4))),A(V.g41,V.g42,V._3cd4))',
            cx4: '=C(V.g14,V.g36,A(V.g14,V.g15,V.cd2),true)',
            cy4: '=C(V.g15,V.g29,A(V.g14,V.g15,V.cd2))',
            cx5: '=C(V.g41,P(V.cx4,V.g14,A(V.g14,V.g15,(V.cd2 + V.cd4)),true),A(V.g41,V.g42,V.cd4),true)',
            cy5: '=C(V.g42,P(V.cy4,V.g15,A(V.g14,V.g15,(V.cd2 + V.cd4))),A(V.g41,V.g42,V.cd4))',
            cx6: '=C(V.g14,P(V.cx5,V.g41,A(V.g41,V.g42,(V.cd4 + -5400000)),true),A(V.g14,V.g14,0),true)',
            cy6: '=C(V.g14,P(V.cy5,V.g42,A(V.g41,V.g42,(V.cd4 + -5400000))),A(V.g14,V.g14,0))',
            cx7: '=C(V.g42,V.hc,A(V.g42,V.g42,V._3cd4),true)',
            cy7: '=C(V.g42,V.g31,A(V.g42,V.g42,V._3cd4))',
            cx8: '=C(V.g16,V.g33,A(V.g16,V.g16,V.cd2),true)',
            cy8: '=C(V.g16,V.g27,A(V.g16,V.g16,V.cd2))',
            cx9: '=C(V.g14,P(V.cx8,V.g16,A(V.g16,V.g16,(V.cd2 + V.cd2)),true),A(V.g14,V.g15,0),true)',
            cy9: '=C(V.g15,P(V.cy8,V.g16,A(V.g16,V.g16,(V.cd2 + V.cd2))),A(V.g14,V.g15,0))',
            cx10: '=C(V.g41,P(V.cx9,V.g14,A(V.g14,V.g15,(V.cd4)),true),A(V.g41,V.g42,V._3cd4),true)',
            cy10: '=C(V.g42,P(V.cy9,V.g15,A(V.g14,V.g15,(V.cd4))),A(V.g41,V.g42,V._3cd4))',
            cx11: '=C(V.g14,V.g36,A(V.g14,V.g15,V.cd2),true)',
            cy11: '=C(V.g15,V.g29,A(V.g14,V.g15,V.cd2))',
            cx12: '=C(V.g41,P(V.cx11,V.g14,A(V.g14,V.g15,(V.cd2 + V.cd4)),true),A(V.g41,V.g42,V.cd4),true)',
            cy12: '=C(V.g42,P(V.cy11,V.g15,A(V.g14,V.g15,(V.cd2 + V.cd4))),A(V.g41,V.g42,V.cd4))',
            cx13: '=C(V.g14,P(V.cx12,V.g41,A(V.g41,V.g42,(V.cd4 + -5400000)),true),A(V.g14,V.g14,0),true)',
            cy13: '=C(V.g14,P(V.cy12,V.g42,A(V.g41,V.g42,(V.cd4 + -5400000))),A(V.g14,V.g14,0))',
            cx14: '=C(V.g42,V.hc,A(V.g42,V.g42,V._3cd4),true)',
            cy14: '=C(V.g42,V.g31,A(V.g42,V.g42,V._3cd4))',
            cx15: '=C(V.g16,V.g33,A(V.g16,V.g16,V.cd2),true)',
            cy15: '=C(V.g16,V.g27,A(V.g16,V.g16,V.cd2))',
            cx16: '=C(V.g14,P(V.cx15,V.g16,A(V.g16,V.g16,(V.cd2 + V.cd2)),true),A(V.g14,V.g15,0),true)',
            cy16: '=C(V.g15,P(V.cy15,V.g16,A(V.g16,V.g16,(V.cd2 + V.cd2))),A(V.g14,V.g15,0))',
            cx17: '=C(V.g41,P(V.cx16,V.g14,A(V.g14,V.g15,(V.cd4)),true),A(V.g41,V.g42,V._3cd4),true)',
            cy17: '=C(V.g42,P(V.cy16,V.g15,A(V.g14,V.g15,(V.cd4))),A(V.g41,V.g42,V._3cd4))',
            cx18: '=C(V.g14,V.g36,A(V.g14,V.g15,V.cd2),true)',
            cy18: '=C(V.g15,V.g29,A(V.g14,V.g15,V.cd2))',
            cx19: '=C(V.g41,P(V.cx18,V.g14,A(V.g14,V.g15,(V.cd2 + V.cd4)),true),A(V.g41,V.g42,V.cd4),true)',
            cy19: '=C(V.g42,P(V.cy18,V.g15,A(V.g14,V.g15,(V.cd2 + V.cd4))),A(V.g41,V.g42,V.cd4))',
            cx20: '=C(V.g14,P(V.cx19,V.g41,A(V.g41,V.g42,(V.cd4 + -5400000)),true),A(V.g14,V.g14,0),true)',
            cy20: '=C(V.g14,P(V.cy19,V.g42,A(V.g41,V.g42,(V.cd4 + -5400000))),A(V.g14,V.g14,0))',
            cx21: '=C(V.g42,V.hc,A(V.g42,V.g42,V._3cd4),true)',
            cy21: '=C(V.g42,V.g31,A(V.g42,V.g42,V._3cd4))',
        },
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], ['M', '=V.g33', '=V.g27'], ['E', '=V.cx1', '=V.cy1', '=V.g16', '=V.g16', 0, '=A(V.g16,V.g16,V.cd2)', '=A(V.g16,V.g16,(V.cd2 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['E', '=V.cx2', '=V.cy2', '=V.g14', '=V.g15', 0, '=A(V.g14,V.g15,0)', '=A(V.g14,V.g15,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx3', '=V.cy3', '=V.g41', '=V.g42', 0, '=A(V.g41,V.g42,V._3cd4)', '=A(V.g41,V.g42,(V._3cd4 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['L', '=V.g37', '=V.g30'], ['L', '=V.g36', '=V.g30'], ['L', '=V.g36', '=V.g29'], ['E', '=V.cx4', '=V.cy4', '=V.g14', '=V.g15', 0, '=A(V.g14,V.g15,V.cd2)', '=A(V.g14,V.g15,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx5', '=V.cy5', '=V.g41', '=V.g42', 0, '=A(V.g41,V.g42,V.cd4)', '=A(V.g41,V.g42,(V.cd4 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['E', '=V.cx6', '=V.cy6', '=V.g14', '=V.g14', 0, '=A(V.g14,V.g14,0)', '=A(V.g14,V.g14,(-10800000))', '=IF(-10800000 > 0, FALSE, TRUE)'], ['Z'], ['M', a, '=V.g31'], ['E', '=V.cx7', '=V.cy7', '=V.g42', '=V.g42', 0, '=A(V.g42,V.g42,V._3cd4)', '=(A(V.g42,V.g42,V._3cd4)+ 2*PI())', '=IF(21600000 > 0, FALSE, TRUE)'], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', '=V.g33', '=V.g27'], ['E', '=V.cx8', '=V.cy8', '=V.g16', '=V.g16', 0, '=A(V.g16,V.g16,V.cd2)', '=A(V.g16,V.g16,(V.cd2 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['E', '=V.cx9', '=V.cy9', '=V.g14', '=V.g15', 0, '=A(V.g14,V.g15,0)', '=A(V.g14,V.g15,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx10', '=V.cy10', '=V.g41', '=V.g42', 0, '=A(V.g41,V.g42,V._3cd4)', '=A(V.g41,V.g42,(V._3cd4 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['L', '=V.g37', '=V.g30'], ['L', '=V.g36', '=V.g30'], ['L', '=V.g36', '=V.g29'], ['E', '=V.cx11', '=V.cy11', '=V.g14', '=V.g15', 0, '=A(V.g14,V.g15,V.cd2)', '=A(V.g14,V.g15,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx12', '=V.cy12', '=V.g41', '=V.g42', 0, '=A(V.g41,V.g42,V.cd4)', '=A(V.g41,V.g42,(V.cd4 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['E', '=V.cx13', '=V.cy13', '=V.g14', '=V.g14', 0, '=A(V.g14,V.g14,0)', '=A(V.g14,V.g14,(-10800000))', '=IF(-10800000 > 0, FALSE, TRUE)'], ['Z'], ['M', a, '=V.g31'], ['E', '=V.cx14', '=V.cy14', '=V.g42', '=V.g42', 0, '=A(V.g42,V.g42,V._3cd4)', '=(A(V.g42,V.g42,V._3cd4)+ 2*PI())', '=IF(21600000 > 0, FALSE, TRUE)'], ['Z'], {
            fillMode: 'darken',
            strokeMode: 'false',
        },
        ], [['M', '=V.g33', '=V.g27'], ['E', '=V.cx15', '=V.cy15', '=V.g16', '=V.g16', 0, '=A(V.g16,V.g16,V.cd2)', '=A(V.g16,V.g16,(V.cd2 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['E', '=V.cx16', '=V.cy16', '=V.g14', '=V.g15', 0, '=A(V.g14,V.g15,0)', '=A(V.g14,V.g15,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx17', '=V.cy17', '=V.g41', '=V.g42', 0, '=A(V.g41,V.g42,V._3cd4)', '=A(V.g41,V.g42,(V._3cd4 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['L', '=V.g37', '=V.g30'], ['L', '=V.g36', '=V.g30'], ['L', '=V.g36', '=V.g29'], ['E', '=V.cx18', '=V.cy18', '=V.g14', '=V.g15', 0, '=A(V.g14,V.g15,V.cd2)', '=A(V.g14,V.g15,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx19', '=V.cy19', '=V.g41', '=V.g42', 0, '=A(V.g41,V.g42,V.cd4)', '=A(V.g41,V.g42,(V.cd4 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['E', '=V.cx20', '=V.cy20', '=V.g14', '=V.g14', 0, '=A(V.g14,V.g14,0)', '=A(V.g14,V.g14,(-10800000))', '=IF(-10800000 > 0, FALSE, TRUE)'], ['Z'], ['M', a, '=V.g31'], ['E', '=V.cx21', '=V.cy21', '=V.g42', '=V.g42', 0, '=A(V.g42,V.g42,V._3cd4)', '=(A(V.g42,V.g42,V._3cd4)+ 2*PI())', '=IF(21600000 > 0, FALSE, TRUE)'], ['Z'], {
            fillMode: 'none',
        },
        ], [['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {
            fillMode: 'none',
        },
        ]],
    },
    actionButtonInformation: {
        variables: {
            ss: s,
            dx2: '=V.ss * 3 / 8',
            vc: F,
            g9: '=V.vc - V.dx2',
            hc: E,
            g11: '=V.hc - V.dx2',
            g13: '=V.ss * 3 / 4',
            g14: '=V.g13 / 32',
            g17: '=V.g13 * 5 / 16',
            g18: '=V.g13 * 3 / 8',
            g19: '=V.g13 * 13 / 32',
            g20: '=V.g13 * 19 / 32',
            g22: '=V.g13 * 11 / 16',
            g23: '=V.g13 * 13 / 16',
            g24: '=V.g13 * 7 / 8',
            g25: '=V.g9 + V.g14',
            g28: '=V.g9 + V.g17',
            g29: '=V.g9 + V.g18',
            g30: '=V.g9 + V.g23',
            g31: '=V.g9 + V.g24',
            g32: '=V.g11 + V.g17',
            g34: '=V.g11 + V.g19',
            g35: '=V.g11 + V.g20',
            g37: '=V.g11 + V.g22',
            g38: '=V.g13 * 3 / 32',
            r: w,
            b: h,
            l: 0,
            t: 0,
            _3cd4: D,
            cx1: '=C(V.dx2,V.hc,A(V.dx2,V.dx2,V._3cd4),true)',
            cy1: '=C(V.dx2,V.g9,A(V.dx2,V.dx2,V._3cd4))',
            cx2: '=C(V.dx2,V.hc,A(V.dx2,V.dx2,V._3cd4),true)',
            cy2: '=C(V.dx2,V.g9,A(V.dx2,V.dx2,V._3cd4))',
            cx3: '=C(V.g38,V.hc,A(V.g38,V.g38,V._3cd4),true)',
            cy3: '=C(V.g38,V.g25,A(V.g38,V.g38,V._3cd4))',
            cx4: '=C(V.g38,V.hc,A(V.g38,V.g38,V._3cd4),true)',
            cy4: '=C(V.g38,V.g25,A(V.g38,V.g38,V._3cd4))',
            cx5: '=C(V.dx2,V.hc,A(V.dx2,V.dx2,V._3cd4),true)',
            cy5: '=C(V.dx2,V.g9,A(V.dx2,V.dx2,V._3cd4))',
            cx6: '=C(V.g38,V.hc,A(V.g38,V.g38,V._3cd4),true)',
            cy6: '=C(V.g38,V.g25,A(V.g38,V.g38,V._3cd4))',
        },
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], ['M', a, '=V.g9'], ['E', '=V.cx1', '=V.cy1', '=V.dx2', '=V.dx2', 0, '=A(V.dx2,V.dx2,V._3cd4)', '=(A(V.dx2,V.dx2,V._3cd4)+ 2*PI())', '=IF(21600000 > 0, FALSE, TRUE)'], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', a, '=V.g9'], ['E', '=V.cx2', '=V.cy2', '=V.dx2', '=V.dx2', 0, '=A(V.dx2,V.dx2,V._3cd4)', '=(A(V.dx2,V.dx2,V._3cd4)+ 2*PI())', '=IF(21600000 > 0, FALSE, TRUE)'], ['Z'], ['M', a, '=V.g25'], ['E', '=V.cx3', '=V.cy3', '=V.g38', '=V.g38', 0, '=A(V.g38,V.g38,V._3cd4)', '=(A(V.g38,V.g38,V._3cd4)+ 2*PI())', '=IF(21600000 > 0, FALSE, TRUE)'], ['M', '=V.g32', '=V.g28'], ['L', '=V.g32', '=V.g29'], ['L', '=V.g34', '=V.g29'], ['L', '=V.g34', '=V.g30'], ['L', '=V.g32', '=V.g30'], ['L', '=V.g32', '=V.g31'], ['L', '=V.g37', '=V.g31'], ['L', '=V.g37', '=V.g30'], ['L', '=V.g35', '=V.g30'], ['L', '=V.g35', '=V.g28'], ['Z'], {
            fillMode: 'darken',
            strokeMode: 'false',
        },
        ], [['M', a, '=V.g25'], ['E', '=V.cx4', '=V.cy4', '=V.g38', '=V.g38', 0, '=A(V.g38,V.g38,V._3cd4)', '=(A(V.g38,V.g38,V._3cd4)+ 2*PI())', '=IF(21600000 > 0, FALSE, TRUE)'], ['M', '=V.g32', '=V.g28'], ['L', '=V.g35', '=V.g28'], ['L', '=V.g35', '=V.g30'], ['L', '=V.g37', '=V.g30'], ['L', '=V.g37', '=V.g31'], ['L', '=V.g32', '=V.g31'], ['L', '=V.g32', '=V.g30'], ['L', '=V.g34', '=V.g30'], ['L', '=V.g34', '=V.g29'], ['L', '=V.g32', '=V.g29'], ['Z'], {
            fillMode: 'lighten',
            strokeMode: 'false',
        },
        ], [['M', a, '=V.g9'], ['E', '=V.cx5', '=V.cy5', '=V.dx2', '=V.dx2', 0, '=A(V.dx2,V.dx2,V._3cd4)', '=(A(V.dx2,V.dx2,V._3cd4)+ 2*PI())', '=IF(21600000 > 0, FALSE, TRUE)'], ['Z'], ['M', a, '=V.g25'], ['E', '=V.cx6', '=V.cy6', '=V.g38', '=V.g38', 0, '=A(V.g38,V.g38,V._3cd4)', '=(A(V.g38,V.g38,V._3cd4)+ 2*PI())', '=IF(21600000 > 0, FALSE, TRUE)'], ['M', '=V.g32', '=V.g28'], ['L', '=V.g35', '=V.g28'], ['L', '=V.g35', '=V.g30'], ['L', '=V.g37', '=V.g30'], ['L', '=V.g37', '=V.g31'], ['L', '=V.g32', '=V.g31'], ['L', '=V.g32', '=V.g30'], ['L', '=V.g34', '=V.g30'], ['L', '=V.g34', '=V.g29'], ['L', '=V.g32', '=V.g29'], ['Z'], {
            fillMode: 'none',
        },
        ], [['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {
            fillMode: 'none',
        },
        ]],
    },
    actionButtonBackorPrevious: {
        variables: {
            ss: s,
            dx2: '=V.ss * 3 / 8',
            vc: F,
            g9: '=V.vc - V.dx2',
            g10: '=V.vc + V.dx2',
            hc: E,
            g11: '=V.hc - V.dx2',
            g12: '=V.hc + V.dx2',
            r: w,
            b: h,
            l: 0,
            t: 0,
        },
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], ['M', '=V.g11', b], ['L', '=V.g12', '=V.g9'], ['L', '=V.g12', '=V.g10'], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', '=V.g11', b], ['L', '=V.g12', '=V.g9'], ['L', '=V.g12', '=V.g10'], ['Z'], {
            fillMode: 'darken',
            strokeMode: 'false',
        },
        ], [['M', '=V.g11', b], ['L', '=V.g12', '=V.g9'], ['L', '=V.g12', '=V.g10'], ['Z'], {
            fillMode: 'none',
        },
        ], [['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {
            fillMode: 'none',
        },
        ]],
    },
    actionButtonForwardorNext: {
        variables: {
            ss: s,
            dx2: '=V.ss * 3 / 8',
            vc: F,
            g9: '=V.vc - V.dx2',
            g10: '=V.vc + V.dx2',
            hc: E,
            g11: '=V.hc - V.dx2',
            g12: '=V.hc + V.dx2',
            r: w,
            b: h,
            l: 0,
            t: 0,
        },
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], ['M', '=V.g12', b], ['L', '=V.g11', '=V.g9'], ['L', '=V.g11', '=V.g10'], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', '=V.g12', b], ['L', '=V.g11', '=V.g9'], ['L', '=V.g11', '=V.g10'], ['Z'], {
            fillMode: 'darken',
            strokeMode: 'false',
        },
        ], [['M', '=V.g12', b], ['L', '=V.g11', '=V.g10'], ['L', '=V.g11', '=V.g9'], ['Z'], {
            fillMode: 'none',
        },
        ], [['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {
            fillMode: 'none',
        },
        ]],
    },
    actionButtonBeginning: {
        variables: {
            ss: s,
            dx2: '=V.ss * 3 / 8',
            vc: F,
            g9: '=V.vc - V.dx2',
            g10: '=V.vc + V.dx2',
            hc: E,
            g11: '=V.hc - V.dx2',
            g12: '=V.hc + V.dx2',
            g13: '=V.ss * 3 / 4',
            g14: '=V.g13 / 8',
            g15: '=V.g13 / 4',
            g16: '=V.g11 + V.g14',
            g17: '=V.g11 + V.g15',
            r: w,
            b: h,
            l: 0,
            t: 0,
        },
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], ['M', '=V.g17', b], ['L', '=V.g12', '=V.g9'], ['L', '=V.g12', '=V.g10'], ['Z'], ['M', '=V.g16', '=V.g9'], ['L', '=V.g11', '=V.g9'], ['L', '=V.g11', '=V.g10'], ['L', '=V.g16', '=V.g10'], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', '=V.g17', b], ['L', '=V.g12', '=V.g9'], ['L', '=V.g12', '=V.g10'], ['Z'], ['M', '=V.g16', '=V.g9'], ['L', '=V.g11', '=V.g9'], ['L', '=V.g11', '=V.g10'], ['L', '=V.g16', '=V.g10'], ['Z'], {
            fillMode: 'darken',
            strokeMode: 'false',
        },
        ], [['M', '=V.g17', b], ['L', '=V.g12', '=V.g9'], ['L', '=V.g12', '=V.g10'], ['Z'], ['M', '=V.g16', '=V.g9'], ['L', '=V.g16', '=V.g10'], ['L', '=V.g11', '=V.g10'], ['L', '=V.g11', '=V.g9'], ['Z'], {
            fillMode: 'none',
        },
        ], [['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {
            fillMode: 'none',
        },
        ]],
    },
    actionButtonEnd: {
        variables: {
            ss: s,
            dx2: '=V.ss * 3 / 8',
            vc: F,
            g9: '=V.vc - V.dx2',
            g10: '=V.vc + V.dx2',
            hc: E,
            g11: '=V.hc - V.dx2',
            g12: '=V.hc + V.dx2',
            g13: '=V.ss * 3 / 4',
            g14: '=V.g13 * 3 / 4',
            g15: '=V.g13 * 7 / 8',
            g16: '=V.g11 + V.g14',
            g17: '=V.g11 + V.g15',
            r: w,
            b: h,
            l: 0,
            t: 0,
        },
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], ['M', '=V.g16', b], ['L', '=V.g11', '=V.g9'], ['L', '=V.g11', '=V.g10'], ['Z'], ['M', '=V.g17', '=V.g9'], ['L', '=V.g12', '=V.g9'], ['L', '=V.g12', '=V.g10'], ['L', '=V.g17', '=V.g10'], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', '=V.g16', b], ['L', '=V.g11', '=V.g9'], ['L', '=V.g11', '=V.g10'], ['Z'], ['M', '=V.g17', '=V.g9'], ['L', '=V.g12', '=V.g9'], ['L', '=V.g12', '=V.g10'], ['L', '=V.g17', '=V.g10'], ['Z'], {
            fillMode: 'darken',
            strokeMode: 'false',
        },
        ], [['M', '=V.g16', b], ['L', '=V.g11', '=V.g10'], ['L', '=V.g11', '=V.g9'], ['Z'], ['M', '=V.g17', '=V.g9'], ['L', '=V.g12', '=V.g9'], ['L', '=V.g12', '=V.g10'], ['L', '=V.g17', '=V.g10'], ['Z'], {
            fillMode: 'none',
        },
        ], [['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {
            fillMode: 'none',
        },
        ]],
    },
    actionButtonReturn: {
        variables: {
            ss: s,
            dx2: '=V.ss * 3 / 8',
            vc: F,
            g9: '=V.vc - V.dx2',
            g10: '=V.vc + V.dx2',
            hc: E,
            g11: '=V.hc - V.dx2',
            g12: '=V.hc + V.dx2',
            g13: '=V.ss * 3 / 4',
            g14: '=V.g13 * 7 / 8',
            g15: '=V.g13 * 3 / 4',
            g16: '=V.g13 * 5 / 8',
            g17: '=V.g13 * 3 / 8',
            g18: '=V.g13 / 4',
            g19: '=V.g9 + V.g15',
            g20: '=V.g9 + V.g16',
            g21: '=V.g9 + V.g18',
            g22: '=V.g11 + V.g14',
            g23: '=V.g11 + V.g15',
            g24: '=V.g11 + V.g16',
            g25: '=V.g11 + V.g17',
            g26: '=V.g11 + V.g18',
            g27: '=V.g13 / 8',
            r: w,
            b: h,
            l: 0,
            t: 0,
            cd4: C,
            cx1: '=C(V.g27,V.g24,A(V.g27,V.g27,0),true)',
            cy1: '=C(V.g27,V.g20,A(V.g27,V.g27,0))',
            cx2: '=C(V.g27,V.g25,A(V.g27,V.g27,V.cd4),true)',
            cy2: '=C(V.g27,V.g19,A(V.g27,V.g27,V.cd4))',
            cd2: B,
            cx3: '=C(V.g17,V.g11,A(V.g17,V.g17,V.cd2),true)',
            cy3: '=C(V.g17,V.g20,A(V.g17,V.g17,V.cd2))',
            cx4: '=C(V.g17,V.hc,A(V.g17,V.g17,V.cd4),true)',
            cy4: '=C(V.g17,V.g10,A(V.g17,V.g17,V.cd4))',
            cx5: '=C(V.g27,V.g24,A(V.g27,V.g27,0),true)',
            cy5: '=C(V.g27,V.g20,A(V.g27,V.g27,0))',
            cx6: '=C(V.g27,V.g25,A(V.g27,V.g27,V.cd4),true)',
            cy6: '=C(V.g27,V.g19,A(V.g27,V.g27,V.cd4))',
            cx7: '=C(V.g17,V.g11,A(V.g17,V.g17,V.cd2),true)',
            cy7: '=C(V.g17,V.g20,A(V.g17,V.g17,V.cd2))',
            cx8: '=C(V.g17,V.hc,A(V.g17,V.g17,V.cd4),true)',
            cy8: '=C(V.g17,V.g10,A(V.g17,V.g17,V.cd4))',
            cx9: '=C(V.g17,V.g22,A(V.g17,V.g17,0),true)',
            cy9: '=C(V.g17,V.g20,A(V.g17,V.g17,0))',
            cx10: '=C(V.g17,V.g25,A(V.g17,V.g17,V.cd4),true)',
            cy10: '=C(V.g17,V.g10,A(V.g17,V.g17,V.cd4))',
            cx11: '=C(V.g27,V.g26,A(V.g27,V.g27,V.cd2),true)',
            cy11: '=C(V.g27,V.g20,A(V.g27,V.g27,V.cd2))',
            cx12: '=C(V.g27,V.hc,A(V.g27,V.g27,V.cd4),true)',
            cy12: '=C(V.g27,V.g19,A(V.g27,V.g27,V.cd4))',
        },
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], ['M', '=V.g12', '=V.g21'], ['L', '=V.g23', '=V.g9'], ['L', a, '=V.g21'], ['L', '=V.g24', '=V.g21'], ['L', '=V.g24', '=V.g20'], ['E', '=V.cx1', '=V.cy1', '=V.g27', '=V.g27', 0, '=A(V.g27,V.g27,0)', '=A(V.g27,V.g27,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', '=V.g25', '=V.g19'], ['E', '=V.cx2', '=V.cy2', '=V.g27', '=V.g27', 0, '=A(V.g27,V.g27,V.cd4)', '=A(V.g27,V.g27,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', '=V.g26', '=V.g21'], ['L', '=V.g11', '=V.g21'], ['L', '=V.g11', '=V.g20'], ['E', '=V.cx3', '=V.cy3', '=V.g17', '=V.g17', 0, '=A(V.g17,V.g17,V.cd2)', '=A(V.g17,V.g17,(V.cd2 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['L', a, '=V.g10'], ['E', '=V.cx4', '=V.cy4', '=V.g17', '=V.g17', 0, '=A(V.g17,V.g17,V.cd4)', '=A(V.g17,V.g17,(V.cd4 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['L', '=V.g22', '=V.g21'], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', '=V.g12', '=V.g21'], ['L', '=V.g23', '=V.g9'], ['L', a, '=V.g21'], ['L', '=V.g24', '=V.g21'], ['L', '=V.g24', '=V.g20'], ['E', '=V.cx5', '=V.cy5', '=V.g27', '=V.g27', 0, '=A(V.g27,V.g27,0)', '=A(V.g27,V.g27,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', '=V.g25', '=V.g19'], ['E', '=V.cx6', '=V.cy6', '=V.g27', '=V.g27', 0, '=A(V.g27,V.g27,V.cd4)', '=A(V.g27,V.g27,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', '=V.g26', '=V.g21'], ['L', '=V.g11', '=V.g21'], ['L', '=V.g11', '=V.g20'], ['E', '=V.cx7', '=V.cy7', '=V.g17', '=V.g17', 0, '=A(V.g17,V.g17,V.cd2)', '=A(V.g17,V.g17,(V.cd2 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['L', a, '=V.g10'], ['E', '=V.cx8', '=V.cy8', '=V.g17', '=V.g17', 0, '=A(V.g17,V.g17,V.cd4)', '=A(V.g17,V.g17,(V.cd4 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['L', '=V.g22', '=V.g21'], ['Z'], {
            fillMode: 'darken',
            strokeMode: 'false',
        },
        ], [['M', '=V.g12', '=V.g21'], ['L', '=V.g22', '=V.g21'], ['L', '=V.g22', '=V.g20'], ['E', '=V.cx9', '=V.cy9', '=V.g17', '=V.g17', 0, '=A(V.g17,V.g17,0)', '=A(V.g17,V.g17,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', '=V.g25', '=V.g10'], ['E', '=V.cx10', '=V.cy10', '=V.g17', '=V.g17', 0, '=A(V.g17,V.g17,V.cd4)', '=A(V.g17,V.g17,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', '=V.g11', '=V.g21'], ['L', '=V.g26', '=V.g21'], ['L', '=V.g26', '=V.g20'], ['E', '=V.cx11', '=V.cy11', '=V.g27', '=V.g27', 0, '=A(V.g27,V.g27,V.cd2)', '=A(V.g27,V.g27,(V.cd2 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['L', a, '=V.g19'], ['E', '=V.cx12', '=V.cy12', '=V.g27', '=V.g27', 0, '=A(V.g27,V.g27,V.cd4)', '=A(V.g27,V.g27,(V.cd4 + -5400000))', '=IF(-5400000 > 0, FALSE, TRUE)'], ['L', '=V.g24', '=V.g21'], ['L', a, '=V.g21'], ['L', '=V.g23', '=V.g9'], ['Z'], {
            fillMode: 'none',
        },
        ], [['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {
            fillMode: 'none',
        },
        ]],
    },
    actionButtonDocument: {
        variables: {
            ss: s,
            dx2: '=V.ss * 3 / 8',
            vc: F,
            g9: '=V.vc - V.dx2',
            g10: '=V.vc + V.dx2',
            dx1: '=V.ss * 9 / 32',
            hc: E,
            g11: '=V.hc - V.dx1',
            g12: '=V.hc + V.dx1',
            g13: '=V.ss * 3 / 16',
            g14: '=V.g12 - V.g13',
            g15: '=V.g9 + V.g13',
            r: w,
            b: h,
            l: 0,
            t: 0,
        },
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], ['M', '=V.g11', '=V.g9'], ['L', '=V.g14', '=V.g9'], ['L', '=V.g12', '=V.g15'], ['L', '=V.g12', '=V.g10'], ['L', '=V.g11', '=V.g10'], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', '=V.g11', '=V.g9'], ['L', '=V.g14', '=V.g9'], ['L', '=V.g14', '=V.g15'], ['L', '=V.g12', '=V.g15'], ['L', '=V.g12', '=V.g10'], ['L', '=V.g11', '=V.g10'], ['Z'], {
            fillMode: 'darkenLess',
            strokeMode: 'false',
        },
        ], [['M', '=V.g14', '=V.g9'], ['L', '=V.g14', '=V.g15'], ['L', '=V.g12', '=V.g15'], ['Z'], {
            fillMode: 'darken',
            strokeMode: 'false',
        },
        ], [['M', '=V.g11', '=V.g9'], ['L', '=V.g14', '=V.g9'], ['L', '=V.g12', '=V.g15'], ['L', '=V.g12', '=V.g10'], ['L', '=V.g11', '=V.g10'], ['Z'], ['M', '=V.g12', '=V.g15'], ['L', '=V.g14', '=V.g15'], ['L', '=V.g14', '=V.g9'], {
            fillMode: 'none',
        },
        ], [['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {
            fillMode: 'none',
        },
        ]],
    },
    actionButtonSound: {
        variables: {
            ss: s,
            dx2: '=V.ss * 3 / 8',
            vc: F,
            g9: '=V.vc - V.dx2',
            g10: '=V.vc + V.dx2',
            hc: E,
            g11: '=V.hc - V.dx2',
            g12: '=V.hc + V.dx2',
            g13: '=V.ss * 3 / 4',
            g14: '=V.g13 / 8',
            g15: '=V.g13 * 5 / 16',
            g16: '=V.g13 * 5 / 8',
            g17: '=V.g13 * 11 / 16',
            g18: '=V.g13 * 3 / 4',
            g19: '=V.g13 * 7 / 8',
            g20: '=V.g9 + V.g14',
            g21: '=V.g9 + V.g15',
            g22: '=V.g9 + V.g17',
            g23: '=V.g9 + V.g19',
            g24: '=V.g11 + V.g15',
            g25: '=V.g11 + V.g16',
            g26: '=V.g11 + V.g18',
            r: w,
            b: h,
            l: 0,
            t: 0,
        },
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], ['M', '=V.g11', '=V.g21'], ['L', '=V.g11', '=V.g22'], ['L', '=V.g24', '=V.g22'], ['L', '=V.g25', '=V.g10'], ['L', '=V.g25', '=V.g9'], ['L', '=V.g24', '=V.g21'], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', '=V.g11', '=V.g21'], ['L', '=V.g11', '=V.g22'], ['L', '=V.g24', '=V.g22'], ['L', '=V.g25', '=V.g10'], ['L', '=V.g25', '=V.g9'], ['L', '=V.g24', '=V.g21'], ['Z'], {
            fillMode: 'darken',
            strokeMode: 'false',
        },
        ], [['M', '=V.g11', '=V.g21'], ['L', '=V.g24', '=V.g21'], ['L', '=V.g25', '=V.g9'], ['L', '=V.g25', '=V.g10'], ['L', '=V.g24', '=V.g22'], ['L', '=V.g11', '=V.g22'], ['Z'], ['M', '=V.g26', '=V.g21'], ['L', '=V.g12', '=V.g20'], ['M', '=V.g26', b], ['L', '=V.g12', b], ['M', '=V.g26', '=V.g22'], ['L', '=V.g12', '=V.g23'], {
            fillMode: 'none',
        },
        ], [['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {
            fillMode: 'none',
        },
        ]],
    },
    actionButtonMovie: {
        variables: {
            ss: s,
            dx2: '=V.ss * 3 / 8',
            vc: F,
            g9: '=V.vc - V.dx2',
            g10: '=V.vc + V.dx2',
            hc: E,
            g11: '=V.hc - V.dx2',
            g12: '=V.hc + V.dx2',
            g13: '=V.ss * 3 / 4',
            g14: '=V.g13 * 1455 / 21600',
            g15: '=V.g13 * 1905 / 21600',
            g16: '=V.g13 * 2325 / 21600',
            g17: '=V.g13 * 16155 / 21600',
            g18: '=V.g13 * 17010 / 21600',
            g19: '=V.g13 * 19335 / 21600',
            g20: '=V.g13 * 19725 / 21600',
            g21: '=V.g13 * 20595 / 21600',
            g22: '=V.g13 * 5280 / 21600',
            g23: '=V.g13 * 5730 / 21600',
            g24: '=V.g13 * 6630 / 21600',
            g25: '=V.g13 * 7492 / 21600',
            g26: '=V.g13 * 9067 / 21600',
            g27: '=V.g13 * 9555 / 21600',
            g28: '=V.g13 * 13342 / 21600',
            g29: '=V.g13 * 14580 / 21600',
            g30: '=V.g13 * 15592 / 21600',
            g31: '=V.g11 + V.g14',
            g32: '=V.g11 + V.g15',
            g33: '=V.g11 + V.g16',
            g34: '=V.g11 + V.g17',
            g35: '=V.g11 + V.g18',
            g36: '=V.g11 + V.g19',
            g37: '=V.g11 + V.g20',
            g38: '=V.g11 + V.g21',
            g39: '=V.g9 + V.g22',
            g40: '=V.g9 + V.g23',
            g41: '=V.g9 + V.g24',
            g42: '=V.g9 + V.g25',
            g43: '=V.g9 + V.g26',
            g44: '=V.g9 + V.g27',
            g45: '=V.g9 + V.g28',
            g46: '=V.g9 + V.g29',
            g47: '=V.g9 + V.g30',
            g48: '=V.g9 + V.g31',
            r: w,
            b: h,
            l: 0,
            t: 0,
        },
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], ['M', '=V.g11', '=V.g39'], ['L', '=V.g11', '=V.g44'], ['L', '=V.g31', '=V.g44'], ['L', '=V.g32', '=V.g43'], ['L', '=V.g33', '=V.g43'], ['L', '=V.g33', '=V.g47'], ['L', '=V.g35', '=V.g47'], ['L', '=V.g35', '=V.g45'], ['L', '=V.g36', '=V.g45'], ['L', '=V.g38', '=V.g46'], ['L', '=V.g12', '=V.g46'], ['L', '=V.g12', '=V.g41'], ['L', '=V.g38', '=V.g41'], ['L', '=V.g37', '=V.g42'], ['L', '=V.g35', '=V.g42'], ['L', '=V.g35', '=V.g41'], ['L', '=V.g34', '=V.g40'], ['L', '=V.g32', '=V.g40'], ['L', '=V.g31', '=V.g39'], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', '=V.g11', '=V.g39'], ['L', '=V.g11', '=V.g44'], ['L', '=V.g31', '=V.g44'], ['L', '=V.g32', '=V.g43'], ['L', '=V.g33', '=V.g43'], ['L', '=V.g33', '=V.g47'], ['L', '=V.g35', '=V.g47'], ['L', '=V.g35', '=V.g45'], ['L', '=V.g36', '=V.g45'], ['L', '=V.g38', '=V.g46'], ['L', '=V.g12', '=V.g46'], ['L', '=V.g12', '=V.g41'], ['L', '=V.g38', '=V.g41'], ['L', '=V.g37', '=V.g42'], ['L', '=V.g35', '=V.g42'], ['L', '=V.g35', '=V.g41'], ['L', '=V.g34', '=V.g40'], ['L', '=V.g32', '=V.g40'], ['L', '=V.g31', '=V.g39'], ['Z'], {
            fillMode: 'darken',
            strokeMode: 'false',
        },
        ], [['M', '=V.g11', '=V.g39'], ['L', '=V.g31', '=V.g39'], ['L', '=V.g32', '=V.g40'], ['L', '=V.g34', '=V.g40'], ['L', '=V.g35', '=V.g41'], ['L', '=V.g35', '=V.g42'], ['L', '=V.g37', '=V.g42'], ['L', '=V.g38', '=V.g41'], ['L', '=V.g12', '=V.g41'], ['L', '=V.g12', '=V.g46'], ['L', '=V.g38', '=V.g46'], ['L', '=V.g36', '=V.g45'], ['L', '=V.g35', '=V.g45'], ['L', '=V.g35', '=V.g47'], ['L', '=V.g33', '=V.g47'], ['L', '=V.g33', '=V.g43'], ['L', '=V.g32', '=V.g43'], ['L', '=V.g31', '=V.g44'], ['L', '=V.g11', '=V.g44'], ['Z'], {
            fillMode: 'none',
        },
        ], [['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], {
            fillMode: 'none',
        },
        ]],
    },
    balloon: {
        variables: {
            adj1: -20833,
            adj2: 62500,
            adj3: 16667,
            dxPos: '=width * V.adj1 / 100000',
            dyPos: '=height * V.adj2 / 100000',
            hc: E,
            xPos: '=V.hc + V.dxPos',
            vc: F,
            yPos: '=V.vc + V.dyPos',
            dq: '=V.dxPos * height / width',
            ady: '=ABS(V.dyPos)',
            adq: '=ABS(V.dq)',
            dz: '=V.ady - V.adq',
            xg1: '=IF(V.dxPos > 0, 7, 2)',
            xg2: '=IF(V.dxPos > 0, 10, 5)',
            x1: '=width * V.xg1 / 12',
            x2: '=width * V.xg2 / 12',
            yg1: '=IF(V.dyPos > 0, 7, 2)',
            yg2: '=IF(V.dyPos > 0, 10, 5)',
            y1: '=height * V.yg1 / 12',
            y2: '=height * V.yg2 / 12',
            l: 0,
            t1: '=IF(V.dxPos > 0, V.l, V.xPos)',
            xl: '=IF(V.dz > 0, V.l, V.t1)',
            t2: '=IF(V.dyPos > 0, V.x1, V.xPos)',
            xt: '=IF(V.dz > 0, V.t2, V.x1)',
            r: w,
            t3: '=IF(V.dxPos > 0, V.xPos, V.r)',
            xr: '=IF(V.dz > 0, V.r, V.t3)',
            t4: '=IF(V.dyPos > 0, V.xPos, V.x1)',
            xb: '=IF(V.dz > 0, V.t4, V.x1)',
            t5: '=IF(V.dxPos > 0, V.y1, V.yPos)',
            yl: '=IF(V.dz > 0, V.y1, V.t5)',
            t: 0,
            t6: '=IF(V.dyPos > 0, V.t, V.yPos)',
            yt: '=IF(V.dz > 0, V.t6, V.t)',
            t7: '=IF(V.dxPos > 0, V.yPos, V.y1)',
            yr: '=IF(V.dz > 0, V.y1, V.t7)',
            b: h,
            t8: '=IF(V.dyPos > 0, V.yPos, V.b)',
            yb: '=IF(V.dz > 0, V.t8, V.b)',
            ss: s,
            u1: '=V.ss * V.adj3 / 100000',
            u2: '=width - V.u1',
            v2: '=height - V.u1',
            il: '=V.u1 * 29289 / 100000',
            ir: '=width - V.il',
            ib: '=height - V.il',
            cd2: B,
            cd4: C,
            cx1: '=C(V.u1,V.l,A(V.u1,V.u1,V.cd2),true)',
            cy1: '=C(V.u1,V.u1,A(V.u1,V.u1,V.cd2))',
            _3cd4: D,
            cx2: '=C(V.u1,V.u2,A(V.u1,V.u1,V._3cd4),true)',
            cy2: '=C(V.u1,V.t,A(V.u1,V.u1,V._3cd4))',
            cx3: '=C(V.u1,V.r,A(V.u1,V.u1,0),true)',
            cy3: '=C(V.u1,V.v2,A(V.u1,V.u1,0))',
            cx4: '=C(V.u1,V.u1,A(V.u1,V.u1,V.cd4),true)',
            cy4: '=C(V.u1,V.b,A(V.u1,V.u1,V.cd4))',
        },
        adjustInfo: [['adj1', -20833], ['adj2', 62500], ['adj3', 16667]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        }, {
            x: '=V.xPos',
            y: '=V.yPos',
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj1',
            minX: -2147483647,
            maxX: 2147483647,
            gdRefY: 'adj2',
            minY: -2147483647,
            maxY: 2147483647,
            position: {
                x: 'xPos',
                y: 'yPos',
            },
            point: ['=V.xPos', '=V.yPos'],
        },
        ],
        path: [[['M', 0, '=V.u1'], ['E', '=V.cx1', '=V.cy1', '=V.u1', '=V.u1', 0, '=A(V.u1,V.u1,V.cd2)', '=A(V.u1,V.u1,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', c, 0], ['L', '=V.xt', '=V.yt'], ['L', d, 0], ['L', '=V.u2', 0], ['E', '=V.cx2', '=V.cy2', '=V.u1', '=V.u1', 0, '=A(V.u1,V.u1,V._3cd4)', '=A(V.u1,V.u1,(V._3cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', w, e], ['L', '=V.xr', '=V.yr'], ['L', w, f], ['L', w, '=V.v2'], ['E', '=V.cx3', '=V.cy3', '=V.u1', '=V.u1', 0, '=A(V.u1,V.u1,0)', '=A(V.u1,V.u1,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', d, h], ['L', '=V.xb', '=V.yb'], ['L', c, h], ['L', '=V.u1', h], ['E', '=V.cx4', '=V.cy4', '=V.u1', '=V.u1', 0, '=A(V.u1,V.u1,V.cd4)', '=A(V.u1,V.u1,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', 0, f], ['L', '=V.xl', '=V.yl'], ['L', 0, e], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.il',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    flowchartOfflineStorage: {
        variables: {
            x4: '=width * 3 / 4',
            vc: F,
            hc: E,
            b: h,
            wd4: '=width/4',
            t: 0,
            _scaleX1: '= width / 2',
            _scaleY1: '= height / 2',
            _scaleX2: '= width / 5',
            _scaleY2: '= height / 5',
            _scaleX3: '= width / 2',
            _scaleY3: '= height / 2',
        },
        connectionPoints: [{
            x: '=V.x4',
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: '=V.wd4',
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', E, h], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', '=2 * V._scaleX2', '=4 * V._scaleY2'], ['L', '=3 * V._scaleX2', '=4 * V._scaleY2'], {
            fillMode: 'none',
        },
        ], [['M', 0, 0], ['L', w, 0], ['L', E, h], ['Z'], {
            fillMode: 'none',
        },
        ]],
        textRect: {
            left: '=V.wd4',
            top: 0,
            right: '=V.x4',
            bottom: b,
        },
    },
    leftRightRibbon: {
        variables: {
            adj1: 50000,
            adj2: 50000,
            adj3: 16667,
            a3: '=MIN(MAX(0, V.adj3), 33333)',
            maxAdj1: '=100000 - V.a3',
            a1: '=MIN(MAX(0, V.adj1), V.maxAdj1)',
            wd2: E,
            wd32: '=width/32',
            w1: '=V.wd2 - V.wd32',
            ss: s,
            maxAdj2: '=100000 * V.w1 / V.ss',
            a2: '=MIN(MAX(0, V.adj2), V.maxAdj2)',
            x1: '=V.ss * V.a2 / 100000',
            r: w,
            x4: '=width - V.x1',
            dy1: '=height * V.a1 / 200000',
            dy2: '=height * V.a3 / -200000',
            vc: F,
            ly1: '=V.vc + V.dy2 - V.dy1',
            ry4: '=V.vc + V.dy1 - V.dy2',
            ly2: '=V.ly1 + V.dy1',
            b: h,
            ry3: '=height - V.ly2',
            ly4: '=V.ly2 * 2',
            ry1: '=height - V.ly4',
            ly3: '=V.ly4 - V.ly1',
            ry2: '=height - V.ly3',
            hR: '=V.a3 * V.ss / 400000',
            hc: E,
            x2: '=V.hc - V.wd32',
            x3: '=V.hc + V.wd32',
            y1: '=V.ly1 + V.hR',
            y2: '=V.ry2 - V.hR',
            l: 0,
            t: 0,
            _3cd4: D,
            cd2: B,
            cx1: '=C(V.wd32,V.hc,A(V.wd32,V.hR,V._3cd4),true)',
            cy1: '=C(V.hR,V.ly1,A(V.wd32,V.hR,V._3cd4))',
            cx2: '=C(V.wd32,P(V.cx1,V.wd32,A(V.wd32,V.hR,(V._3cd4 + V.cd2)),true),A(V.wd32,V.hR,V._3cd4),true)',
            cy2: '=C(V.hR,P(V.cy1,V.hR,A(V.wd32,V.hR,(V._3cd4 + V.cd2))),A(V.wd32,V.hR,V._3cd4))',
            cd4: C,
            cx3: '=C(V.wd32,V.hc,A(V.wd32,V.hR,V.cd4),true)',
            cy3: '=C(V.hR,V.ry4,A(V.wd32,V.hR,V.cd4))',
            cx4: '=C(V.wd32,V.x3,A(V.wd32,V.hR,0),true)',
            cy4: '=C(V.hR,V.y1,A(V.wd32,V.hR,0))',
            cx5: '=C(V.wd32,P(V.cx4,V.wd32,A(V.wd32,V.hR,(V.cd4)),true),A(V.wd32,V.hR,V._3cd4),true)',
            cy5: '=C(V.hR,P(V.cy4,V.hR,A(V.wd32,V.hR,(V.cd4))),A(V.wd32,V.hR,V._3cd4))',
            cx6: '=C(V.wd32,V.hc,A(V.wd32,V.hR,V._3cd4),true)',
            cy6: '=C(V.hR,V.ly1,A(V.wd32,V.hR,V._3cd4))',
            cx7: '=C(V.wd32,P(V.cx6,V.wd32,A(V.wd32,V.hR,(V._3cd4 + V.cd2)),true),A(V.wd32,V.hR,V._3cd4),true)',
            cy7: '=C(V.hR,P(V.cy6,V.hR,A(V.wd32,V.hR,(V._3cd4 + V.cd2))),A(V.wd32,V.hR,V._3cd4))',
            cx8: '=C(V.wd32,V.hc,A(V.wd32,V.hR,V.cd4),true)',
            cy8: '=C(V.hR,V.ry4,A(V.wd32,V.hR,V.cd4))',
        },
        adjustInfo: [['adj1', 50000], ['adj2', 50000], ['adj3', 16667]],
        connectionPoints: [{
            x: w,
            y: '=V.ry3',
        }, {
            x: '=V.x4',
            y: h,
        }, {
            x: c,
            y: '=V.ly4',
        }, {
            x: 0,
            y: '=V.ly2',
        }, {
            x: c,
            y: 0,
        }, {
            x: '=V.x4',
            y: '=V.ry1',
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj1',
            minY: 0,
            maxY: 'maxAdj1',
            position: {
                x: 'x4',
                y: 'ry2',
            },
            point: ['=V.x4', '=V.ry2'],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: 0,
            maxX: 'maxAdj2',
            position: {
                x: 'x1',
                y: 't',
            },
            point: [c, 0],
        }, {
            type: 'ahXY',
            gdRefY: 'adj3',
            minY: 0,
            maxY: 33333,
            position: {
                x: 'x3',
                y: 'ry2',
            },
            point: ['=V.x3', '=V.ry2'],
        },
        ],
        path: [[['M', 0, '=V.ly2'], ['L', c, 0], ['L', c, '=V.ly1'], ['L', a, '=V.ly1'], ['E', '=V.cx1', '=V.cy1', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V._3cd4)', '=A(V.wd32,V.hR,(V._3cd4 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['E', '=V.cx2', '=V.cy2', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V._3cd4)', '=A(V.wd32,V.hR,(V._3cd4 + -10800000))', '=IF(-10800000 > 0, FALSE, TRUE)'], ['L', '=V.x4', '=V.ry2'], ['L', '=V.x4', '=V.ry1'], ['L', w, '=V.ry3'], ['L', '=V.x4', h], ['L', '=V.x4', '=V.ry4'], ['L', a, '=V.ry4'], ['E', '=V.cx3', '=V.cy3', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V.cd4)', '=A(V.wd32,V.hR,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', d, '=V.ly3'], ['L', c, '=V.ly3'], ['L', c, '=V.ly4'], ['Z'], {
            strokeMode: 'false',
        },
        ], [['M', '=V.x3', e], ['E', '=V.cx4', '=V.cy4', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,0)', '=A(V.wd32,V.hR,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx5', '=V.cy5', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V._3cd4)', '=A(V.wd32,V.hR,(V._3cd4 + -10800000))', '=IF(-10800000 > 0, FALSE, TRUE)'], ['L', '=V.x3', '=V.ry2'], ['Z'], {
            fillMode: 'darkenLess',
            strokeMode: 'false',
        },
        ], [['M', 0, '=V.ly2'], ['L', c, 0], ['L', c, '=V.ly1'], ['L', a, '=V.ly1'], ['E', '=V.cx6', '=V.cy6', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V._3cd4)', '=A(V.wd32,V.hR,(V._3cd4 + V.cd2))', '=IF(V.cd2 > 0, FALSE, TRUE)'], ['E', '=V.cx7', '=V.cy7', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V._3cd4)', '=A(V.wd32,V.hR,(V._3cd4 + -10800000))', '=IF(-10800000 > 0, FALSE, TRUE)'], ['L', '=V.x4', '=V.ry2'], ['L', '=V.x4', '=V.ry1'], ['L', w, '=V.ry3'], ['L', '=V.x4', h], ['L', '=V.x4', '=V.ry4'], ['L', a, '=V.ry4'], ['E', '=V.cx8', '=V.cy8', '=V.wd32', '=V.hR', 0, '=A(V.wd32,V.hR,V.cd4)', '=A(V.wd32,V.hR,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', d, '=V.ly3'], ['L', c, '=V.ly3'], ['L', c, '=V.ly4'], ['Z'], ['M', '=V.x3', e], ['L', '=V.x3', '=V.ry2'], ['M', d, f], ['L', d, '=V.ly3'], {
            fillMode: 'none',
        },
        ]],
        textRect: {
            left: c,
            top: '=V.ly1',
            right: '=V.x4',
            bottom: '=V.ry4',
        },
    },
    diagonalStripe: {
        variables: {
            adj: 50000,
            a: '=MIN(MAX(0, V.adj), 100000)',
            x2: '=width * V.a / 100000',
            x1: '=V.x2 / 2',
            r: w,
            x3: '=(V.x2 + V.r) / 2',
            y2: '=height * V.a / 100000',
            y1: '=V.y2 / 2',
            b: h,
            y3: '=(V.y2 + V.b) / 2',
            hc: E,
            vc: F,
            l: 0,
            t: 0,
        },
        adjustInfo: [['adj', 50000]],
        connectionPoints: [{
            x: a,
            y: b,
        }, {
            x: 0,
            y: '=V.y3',
        }, {
            x: c,
            y: e,
        }, {
            x: '=V.x3',
            y: 0,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj',
            minY: 0,
            maxY: 100000,
            position: {
                x: 'l',
                y: 'y2',
            },
            point: [0, f],
        },
        ],
        path: [[['M', 0, f], ['L', d, 0], ['L', w, 0], ['L', 0, h], ['Z'], {},
        ]],
        textRect: {
            left: 0,
            top: 0,
            right: '=V.x3',
            bottom: '=V.y3',
        },
    },
    pie: {
        variables: {
            adj1: 0,
            adj2: D,
            stAng: '=MIN(MAX(0, V.adj1), 21599999)',
            enAng: '=MIN(MAX(0, V.adj2), 21599999)',
            sw1: '=V.enAng - V.stAng',
            sw2: '=V.sw1 + 21600000',
            swAng: '=IF(V.sw1 > 0, V.sw1, V.sw2)',
            wd2: E,
            d2r: A,
            wt1: '=V.wd2 * SIN(V.stAng / V.d2r)',
            hd2: F,
            ht1: '=V.hd2 * COS(V.stAng / V.d2r)',
            dx1: '=V.wd2 * COS(ATAN2(V.ht1,V.wt1))',
            dy1: '=V.hd2 * SIN(ATAN2(V.ht1,V.wt1))',
            hc: E,
            x1: '=V.hc + V.dx1',
            vc: F,
            y1: '=V.vc + V.dy1',
            wt2: '=V.wd2 * SIN(V.enAng / V.d2r)',
            ht2: '=V.hd2 * COS(V.enAng / V.d2r)',
            dx2: '=V.wd2 * COS(ATAN2(V.ht2,V.wt2))',
            dy2: '=V.hd2 * SIN(ATAN2(V.ht2,V.wt2))',
            x2: '=V.hc + V.dx2',
            y2: '=V.vc + V.dy2',
            idx: '=V.wd2 * COS(2700000 / V.d2r)',
            idy: '=V.hd2 * SIN(2700000 / V.d2r)',
            il: '=V.hc - V.idx',
            ir: '=V.hc + V.idx',
            it: '=V.vc - V.idy',
            ib: '=V.vc + V.idy',
            r: w,
            b: h,
            l: 0,
            t: 0,
            cx1: '=C(V.wd2,V.x1,A(V.wd2,V.hd2,V.stAng),true)',
            cy1: '=C(V.hd2,V.y1,A(V.wd2,V.hd2,V.stAng))',
        },
        adjustInfo: [['adj1', 0], ['adj2', 16200000]],
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        controlsInfo: [{
            type: 'ahPolar',
            gdRefAng: 'adj1',
            minAng: 0,
            maxAng: 21599999,
            position: {
                x: 'x1',
                y: 'y1',
            },
            point: [c, e],
        }, {
            type: 'ahPolar',
            gdRefAng: 'adj2',
            minAng: 0,
            maxAng: 21599999,
            position: {
                x: 'x2',
                y: 'y2',
            },
            point: [d, f],
        },
        ],
        path: [[['M', c, e], ['E', '=V.cx1', '=V.cy1', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V.stAng)', '=A(V.wd2,V.hd2,(V.stAng + V.swAng))', '=IF(V.swAng > 0, FALSE, TRUE)'], ['L', a, b], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            right: '=V.ir',
            top: '=V.it',
            bottom: '=V.ib',
        },
    },
    nonIsoscelesTrapezoid: {
        variables: {
            adj1: 25000,
            adj2: 25000,
            ss: s,
            maxAdj: '=50000 * width / V.ss',
            a1: '=MIN(MAX(0, V.adj1), V.maxAdj)',
            a2: '=MIN(MAX(0, V.adj2), V.maxAdj)',
            x1: '=V.ss * V.a1 / 200000',
            x2: '=V.ss * V.a1 / 100000',
            dx3: '=V.ss * V.a2 / 100000',
            r: w,
            x3: '=width - V.dx3',
            x4: '=(width + V.x3) / 2',
            wd3: '=width/3',
            il: '=V.wd3 * V.a1 / V.maxAdj',
            adjm: '=MAX(V.a1, V.a2)',
            hd3: '=height/3',
            it: '=V.hd3 * V.adjm / V.maxAdj',
            irt: '=V.wd3 * V.a2 / V.maxAdj',
            ir: '=width - V.irt',
            vc: F,
            hc: E,
            b: h,
            t: 0,
            l: 0,
        },
        adjustInfo: [['adj1', 25000], ['adj2', 25000]],
        connectionPoints: [{
            x: '=V.x4',
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: c,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj1',
            minX: 0,
            maxX: 'maxAdj',
            position: {
                x: 'x2',
                y: 't',
            },
            point: [d, 0],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: 0,
            maxX: 'maxAdj',
            position: {
                x: 'x3',
                y: 't',
            },
            point: ['=V.x3', 0],
        },
        ],
        path: [[['M', 0, h], ['L', d, 0], ['L', '=V.x3', 0], ['L', w, h], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.it',
            right: '=V.ir',
            bottom: h,
        },
    },
    decagon: {
        variables: {
            vf: 105146,
            hd2: F,
            shd2: '=V.hd2 * V.vf / 100000',
            wd2: E,
            d2r: A,
            dx1: '=V.wd2 * COS(2160000 / V.d2r)',
            dx2: '=V.wd2 * COS(4320000 / V.d2r)',
            hc: E,
            x1: '=V.hc - V.dx1',
            x2: '=V.hc - V.dx2',
            x3: '=V.hc + V.dx2',
            x4: '=V.hc + V.dx1',
            dy1: '=V.shd2 * SIN(4320000 / V.d2r)',
            dy2: '=V.shd2 * SIN(2160000 / V.d2r)',
            vc: F,
            y1: '=V.vc - V.dy1',
            y2: '=V.vc - V.dy2',
            y3: '=V.vc + V.dy2',
            y4: '=V.vc + V.dy1',
            r: w,
            l: 0,
        },
        adjustInfo: [['vf', 105146]],
        connectionPoints: [{
            x: '=V.x4',
            y: f,
        }, {
            x: w,
            y: b,
        }, {
            x: '=V.x4',
            y: '=V.y3',
        }, {
            x: '=V.x3',
            y: '=V.y4',
        }, {
            x: d,
            y: '=V.y4',
        }, {
            x: c,
            y: '=V.y3',
        }, {
            x: 0,
            y: b,
        }, {
            x: c,
            y: f,
        }, {
            x: d,
            y: e,
        }, {
            x: '=V.x3',
            y: e,
        },
        ],
        path: [[['M', 0, b], ['L', c, f], ['L', d, e], ['L', '=V.x3', e], ['L', '=V.x4', f], ['L', w, b], ['L', '=V.x4', '=V.y3'], ['L', '=V.x3', '=V.y4'], ['L', d, '=V.y4'], ['L', c, '=V.y3'], ['Z'], {},
        ]],
        textRect: {
            left: c,
            top: f,
            right: '=V.x4',
            bottom: '=V.y3',
        },
    },
    heptagon: {
        variables: {
            hf: 102572,
            vf: 105210,
            wd2: E,
            swd2: '=V.wd2 * V.hf / 100000',
            hd2: F,
            shd2: '=V.hd2 * V.vf / 100000',
            vc: F,
            svc: '=V.vc * V.vf / 100000',
            dx1: '=V.swd2 * 97493 / 100000',
            dx2: '=V.swd2 * 78183 / 100000',
            dx3: '=V.swd2 * 43388 / 100000',
            dy1: '=V.shd2 * 62349 / 100000',
            dy2: '=V.shd2 * 22252 / 100000',
            dy3: '=V.shd2 * 90097 / 100000',
            hc: E,
            x1: '=V.hc - V.dx1',
            x2: '=V.hc - V.dx2',
            x3: '=V.hc - V.dx3',
            x4: '=V.hc + V.dx3',
            x5: '=V.hc + V.dx2',
            x6: '=V.hc + V.dx1',
            y1: '=V.svc - V.dy1',
            y2: '=V.svc + V.dy2',
            y3: '=V.svc + V.dy3',
            b: h,
            ib: '=height - V.y1',
            t: 0,
        },
        adjustInfo: [['hf', 102572], ['vf', 105210]],
        connectionPoints: [{
            x: '=V.x5',
            y: e,
        }, {
            x: '=V.x6',
            y: f,
        }, {
            x: '=V.x4',
            y: '=V.y3',
        }, {
            x: '=V.x3',
            y: '=V.y3',
        }, {
            x: c,
            y: f,
        }, {
            x: d,
            y: e,
        }, {
            x: a,
            y: 0,
        },
        ],
        path: [[['M', c, f], ['L', d, e], ['L', a, 0], ['L', '=V.x5', e], ['L', '=V.x6', f], ['L', '=V.x4', '=V.y3'], ['L', '=V.x3', '=V.y3'], ['Z'], {},
        ]],
        textRect: {
            left: d,
            top: e,
            right: '=V.x5',
            bottom: '=V.ib',
        },
    },
    dodecagon: {
        variables: {
            x1: '=width * 2894 / 21600',
            x2: '=width * 7906 / 21600',
            x3: '=width * 13694 / 21600',
            x4: '=width * 18706 / 21600',
            y1: '=height * 2894 / 21600',
            y2: '=height * 7906 / 21600',
            y3: '=height * 13694 / 21600',
            y4: '=height * 18706 / 21600',
            r: w,
            b: h,
            l: 0,
            t: 0,
        },
        connectionPoints: [{
            x: '=V.x4',
            y: e,
        }, {
            x: w,
            y: f,
        }, {
            x: w,
            y: '=V.y3',
        }, {
            x: '=V.x4',
            y: '=V.y4',
        }, {
            x: '=V.x3',
            y: h,
        }, {
            x: d,
            y: h,
        }, {
            x: c,
            y: '=V.y4',
        }, {
            x: 0,
            y: '=V.y3',
        }, {
            x: 0,
            y: f,
        }, {
            x: c,
            y: e,
        }, {
            x: d,
            y: 0,
        }, {
            x: '=V.x3',
            y: 0,
        },
        ],
        path: [[['M', 0, f], ['L', c, e], ['L', d, 0], ['L', '=V.x3', 0], ['L', '=V.x4', e], ['L', w, f], ['L', w, '=V.y3'], ['L', '=V.x4', '=V.y4'], ['L', '=V.x3', h], ['L', d, h], ['L', c, '=V.y4'], ['L', 0, '=V.y3'], ['Z'], {},
        ]],
        textRect: {
            left: c,
            top: e,
            right: '=V.x4',
            bottom: '=V.y4',
        },
    },
    star6Point: {
        variables: {
            adj: 28868,
            hf: 115470,
            a: '=MIN(MAX(0, V.adj), 50000)',
            wd2: E,
            swd2: '=V.wd2 * V.hf / 100000',
            d2r: A,
            dx1: '=V.swd2 * COS(1800000 / V.d2r)',
            hc: E,
            x1: '=V.hc - V.dx1',
            x2: '=V.hc + V.dx1',
            vc: F,
            hd4: '=height/4',
            y2: '=V.vc + V.hd4',
            iwd2: '=V.swd2 * V.a / 50000',
            hd2: F,
            ihd2: '=V.hd2 * V.a / 50000',
            sdx2: '=V.iwd2 / 2',
            sx1: '=V.hc - V.iwd2',
            sx2: '=V.hc - V.sdx2',
            sx3: '=V.hc + V.sdx2',
            sx4: '=V.hc + V.iwd2',
            sdy1: '=V.ihd2 * SIN(3600000 / V.d2r)',
            sy1: '=V.vc - V.sdy1',
            sy2: '=V.vc + V.sdy1',
            yAdj: '=V.vc - V.ihd2',
            b: h,
            t: 0,
        },
        adjustInfo: [['adj', 28868], ['hf', 115470]],
        connectionPoints: [{
            x: d,
            y: '=V.hd4',
        }, {
            x: d,
            y: f,
        }, {
            x: a,
            y: h,
        }, {
            x: c,
            y: f,
        }, {
            x: c,
            y: '=V.hd4',
        }, {
            x: a,
            y: 0,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj',
            minY: 0,
            maxY: 50000,
            position: {
                x: 'hc',
                y: 'yAdj',
            },
            point: [a, '=V.yAdj'],
        },
        ],
        path: [[['M', c, '=V.hd4'], ['L', '=V.sx2', '=V.sy1'], ['L', a, 0], ['L', '=V.sx3', '=V.sy1'], ['L', d, '=V.hd4'], ['L', '=V.sx4', b], ['L', d, f], ['L', '=V.sx3', '=V.sy2'], ['L', a, h], ['L', '=V.sx2', '=V.sy2'], ['L', c, f], ['L', '=V.sx1', b], ['Z'], {},
        ]],
        textRect: {
            left: '=V.sx1',
            top: '=V.sy1',
            right: '=V.sx4',
            bottom: '=V.sy2',
        },
    },
    star7Point: {
        variables: {
            adj: 34601,
            hf: 102572,
            vf: 105210,
            a: '=MIN(MAX(0, V.adj), 50000)',
            wd2: E,
            swd2: '=V.wd2 * V.hf / 100000',
            hd2: F,
            shd2: '=V.hd2 * V.vf / 100000',
            vc: F,
            svc: '=V.vc * V.vf / 100000',
            dx1: '=V.swd2 * 97493 / 100000',
            dx2: '=V.swd2 * 78183 / 100000',
            dx3: '=V.swd2 * 43388 / 100000',
            dy1: '=V.shd2 * 62349 / 100000',
            dy2: '=V.shd2 * 22252 / 100000',
            dy3: '=V.shd2 * 90097 / 100000',
            hc: E,
            x1: '=V.hc - V.dx1',
            x2: '=V.hc - V.dx2',
            x3: '=V.hc - V.dx3',
            x4: '=V.hc + V.dx3',
            x5: '=V.hc + V.dx2',
            x6: '=V.hc + V.dx1',
            y1: '=V.svc - V.dy1',
            y2: '=V.svc + V.dy2',
            y3: '=V.svc + V.dy3',
            iwd2: '=V.swd2 * V.a / 50000',
            ihd2: '=V.shd2 * V.a / 50000',
            sdx1: '=V.iwd2 * 97493 / 100000',
            sdx2: '=V.iwd2 * 78183 / 100000',
            sdx3: '=V.iwd2 * 43388 / 100000',
            sx1: '=V.hc - V.sdx1',
            sx2: '=V.hc - V.sdx2',
            sx3: '=V.hc - V.sdx3',
            sx4: '=V.hc + V.sdx3',
            sx5: '=V.hc + V.sdx2',
            sx6: '=V.hc + V.sdx1',
            sdy1: '=V.ihd2 * 90097 / 100000',
            sdy2: '=V.ihd2 * 22252 / 100000',
            sdy3: '=V.ihd2 * 62349 / 100000',
            sy1: '=V.svc - V.sdy1',
            sy2: '=V.svc - V.sdy2',
            sy3: '=V.svc + V.sdy3',
            sy4: '=V.svc + V.ihd2',
            yAdj: '=V.svc - V.ihd2',
            t: 0,
        },
        adjustInfo: [['adj', 34601], ['hf', 102572], ['vf', 105210]],
        connectionPoints: [{
            x: '=V.x5',
            y: e,
        }, {
            x: '=V.x6',
            y: f,
        }, {
            x: '=V.x4',
            y: '=V.y3',
        }, {
            x: '=V.x3',
            y: '=V.y3',
        }, {
            x: c,
            y: f,
        }, {
            x: d,
            y: e,
        }, {
            x: a,
            y: 0,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj',
            minY: 0,
            maxY: 50000,
            position: {
                x: 'hc',
                y: 'yAdj',
            },
            point: [a, '=V.yAdj'],
        },
        ],
        path: [[['M', c, f], ['L', '=V.sx1', '=V.sy2'], ['L', d, e], ['L', '=V.sx3', '=V.sy1'], ['L', a, 0], ['L', '=V.sx4', '=V.sy1'], ['L', '=V.x5', e], ['L', '=V.sx6', '=V.sy2'], ['L', '=V.x6', f], ['L', '=V.sx5', '=V.sy3'], ['L', '=V.x4', '=V.y3'], ['L', a, '=V.sy4'], ['L', '=V.x3', '=V.y3'], ['L', '=V.sx2', '=V.sy3'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.sx2',
            top: '=V.sy1',
            right: '=V.sx5',
            bottom: '=V.sy3',
        },
    },
    star10Point: {
        variables: {
            adj: 42533,
            hf: 105146,
            a: '=MIN(MAX(0, V.adj), 50000)',
            wd2: E,
            swd2: '=V.wd2 * V.hf / 100000',
            dx1: '=V.swd2 * 95106 / 100000',
            dx2: '=V.swd2 * 58779 / 100000',
            hc: E,
            x1: '=V.hc - V.dx1',
            x2: '=V.hc - V.dx2',
            x3: '=V.hc + V.dx2',
            x4: '=V.hc + V.dx1',
            hd2: F,
            dy1: '=V.hd2 * 80902 / 100000',
            dy2: '=V.hd2 * 30902 / 100000',
            vc: F,
            y1: '=V.vc - V.dy1',
            y2: '=V.vc - V.dy2',
            y3: '=V.vc + V.dy2',
            y4: '=V.vc + V.dy1',
            iwd2: '=V.swd2 * V.a / 50000',
            ihd2: '=V.hd2 * V.a / 50000',
            sdx1: '=V.iwd2 * 80902 / 100000',
            sdx2: '=V.iwd2 * 30902 / 100000',
            sdy1: '=V.ihd2 * 95106 / 100000',
            sdy2: '=V.ihd2 * 58779 / 100000',
            sx1: '=V.hc - V.iwd2',
            sx2: '=V.hc - V.sdx1',
            sx3: '=V.hc - V.sdx2',
            sx4: '=V.hc + V.sdx2',
            sx5: '=V.hc + V.sdx1',
            sx6: '=V.hc + V.iwd2',
            sy1: '=V.vc - V.sdy1',
            sy2: '=V.vc - V.sdy2',
            sy3: '=V.vc + V.sdy2',
            sy4: '=V.vc + V.sdy1',
            yAdj: '=V.vc - V.ihd2',
            b: h,
            t: 0,
        },
        adjustInfo: [['adj', 42533], ['hf', 105146]],
        connectionPoints: [{
            x: '=V.x4',
            y: f,
        }, {
            x: '=V.x4',
            y: '=V.y3',
        }, {
            x: '=V.x3',
            y: '=V.y4',
        }, {
            x: a,
            y: h,
        }, {
            x: d,
            y: '=V.y4',
        }, {
            x: c,
            y: '=V.y3',
        }, {
            x: c,
            y: f,
        }, {
            x: d,
            y: e,
        }, {
            x: a,
            y: 0,
        }, {
            x: '=V.x3',
            y: e,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj',
            minY: 0,
            maxY: 50000,
            position: {
                x: 'hc',
                y: 'yAdj',
            },
            point: [a, '=V.yAdj'],
        },
        ],
        path: [[['M', c, f], ['L', '=V.sx2', '=V.sy2'], ['L', d, e], ['L', '=V.sx3', '=V.sy1'], ['L', a, 0], ['L', '=V.sx4', '=V.sy1'], ['L', '=V.x3', e], ['L', '=V.sx5', '=V.sy2'], ['L', '=V.x4', f], ['L', '=V.sx6', b], ['L', '=V.x4', '=V.y3'], ['L', '=V.sx5', '=V.sy3'], ['L', '=V.x3', '=V.y4'], ['L', '=V.sx4', '=V.sy4'], ['L', a, h], ['L', '=V.sx3', '=V.sy4'], ['L', d, '=V.y4'], ['L', '=V.sx2', '=V.sy3'], ['L', c, '=V.y3'], ['L', '=V.sx1', b], ['Z'], {},
        ]],
        textRect: {
            left: '=V.sx2',
            top: '=V.sy2',
            right: '=V.sx5',
            bottom: '=V.sy3',
        },
    },
    star12Point: {
        variables: {
            adj: 37500,
            a: '=MIN(MAX(0, V.adj), 50000)',
            wd2: E,
            d2r: A,
            dx1: '=V.wd2 * COS(1800000 / V.d2r)',
            hd2: F,
            dy1: '=V.hd2 * SIN(3600000 / V.d2r)',
            hc: E,
            x1: '=V.hc - V.dx1',
            x3: '=width * 3 / 4',
            x4: '=V.hc + V.dx1',
            vc: F,
            y1: '=V.vc - V.dy1',
            y3: '=height * 3 / 4',
            y4: '=V.vc + V.dy1',
            iwd2: '=V.wd2 * V.a / 50000',
            ihd2: '=V.hd2 * V.a / 50000',
            sdx1: '=V.iwd2 * COS(900000 / V.d2r)',
            sdx2: '=V.iwd2 * COS(2700000 / V.d2r)',
            sdx3: '=V.iwd2 * COS(4500000 / V.d2r)',
            sdy1: '=V.ihd2 * SIN(4500000 / V.d2r)',
            sdy2: '=V.ihd2 * SIN(2700000 / V.d2r)',
            sdy3: '=V.ihd2 * SIN(900000 / V.d2r)',
            sx1: '=V.hc - V.sdx1',
            sx2: '=V.hc - V.sdx2',
            sx3: '=V.hc - V.sdx3',
            sx4: '=V.hc + V.sdx3',
            sx5: '=V.hc + V.sdx2',
            sx6: '=V.hc + V.sdx1',
            sy1: '=V.vc - V.sdy1',
            sy2: '=V.vc - V.sdy2',
            sy3: '=V.vc - V.sdy3',
            sy4: '=V.vc + V.sdy3',
            sy5: '=V.vc + V.sdy2',
            sy6: '=V.vc + V.sdy1',
            yAdj: '=V.vc - V.ihd2',
            hd4: '=height/4',
            r: w,
            b: h,
            wd4: '=width/4',
            l: 0,
            t: 0,
        },
        adjustInfo: [['adj', 37500]],
        connectionPoints: [{
            x: '=V.x4',
            y: '=V.hd4',
        }, {
            x: w,
            y: b,
        }, {
            x: '=V.x4',
            y: '=V.y3',
        }, {
            x: '=V.x3',
            y: '=V.y4',
        }, {
            x: a,
            y: h,
        }, {
            x: '=V.wd4',
            y: '=V.y4',
        }, {
            x: c,
            y: '=V.y3',
        }, {
            x: 0,
            y: b,
        }, {
            x: c,
            y: '=V.hd4',
        }, {
            x: '=V.wd4',
            y: e,
        }, {
            x: a,
            y: 0,
        }, {
            x: '=V.x3',
            y: e,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj',
            minY: 0,
            maxY: 50000,
            position: {
                x: 'hc',
                y: 'yAdj',
            },
            point: [a, '=V.yAdj'],
        },
        ],
        path: [[['M', 0, b], ['L', '=V.sx1', '=V.sy3'], ['L', c, '=V.hd4'], ['L', '=V.sx2', '=V.sy2'], ['L', '=V.wd4', e], ['L', '=V.sx3', '=V.sy1'], ['L', a, 0], ['L', '=V.sx4', '=V.sy1'], ['L', '=V.x3', e], ['L', '=V.sx5', '=V.sy2'], ['L', '=V.x4', '=V.hd4'], ['L', '=V.sx6', '=V.sy3'], ['L', w, b], ['L', '=V.sx6', '=V.sy4'], ['L', '=V.x4', '=V.y3'], ['L', '=V.sx5', '=V.sy5'], ['L', '=V.x3', '=V.y4'], ['L', '=V.sx4', '=V.sy6'], ['L', a, h], ['L', '=V.sx3', '=V.sy6'], ['L', '=V.wd4', '=V.y4'], ['L', '=V.sx2', '=V.sy5'], ['L', c, '=V.y3'], ['L', '=V.sx1', '=V.sy4'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.sx2',
            top: '=V.sy2',
            right: '=V.sx5',
            bottom: '=V.sy5',
        },
    },
    round1Rectangle: {
        variables: {
            adj: 16667,
            a: '=MIN(MAX(0, V.adj), 50000)',
            ss: s,
            dx1: '=V.ss * V.a / 100000',
            r: w,
            x1: '=width - V.dx1',
            idx: '=V.dx1 * 29289 / 100000',
            ir: '=width - V.idx',
            hc: E,
            t: 0,
            l: 0,
            vc: F,
            b: h,
            _3cd4: D,
            cd4: C,
            cx1: '=C(V.dx1,V.x1,A(V.dx1,V.dx1,V._3cd4),true)',
            cy1: '=C(V.dx1,V.t,A(V.dx1,V.dx1,V._3cd4))',
        },
        adjustInfo: [['adj', 16667]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj',
            minX: 0,
            maxX: 50000,
            position: {
                x: 'x1',
                y: 't',
            },
            point: [c, 0],
        },
        ],
        path: [[['M', 0, 0], ['L', c, 0], ['E', '=V.cx1', '=V.cy1', '=V.dx1', '=V.dx1', 0, '=A(V.dx1,V.dx1,V._3cd4)', '=A(V.dx1,V.dx1,(V._3cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', w, h], ['L', 0, h], ['Z'], {},
        ]],
        textRect: {
            left: 0,
            top: 0,
            right: '=V.ir',
            bottom: h,
        },
    },
    round2SameRectangle: {
        variables: {
            adj1: 16667,
            adj2: 0,
            a1: '=MIN(MAX(0, V.adj1), 50000)',
            a2: '=MIN(MAX(0, V.adj2), 50000)',
            ss: s,
            tx1: '=V.ss * V.a1 / 100000',
            r: w,
            tx2: '=width - V.tx1',
            bx1: '=V.ss * V.a2 / 100000',
            bx2: '=width - V.bx1',
            b: h,
            by1: '=height - V.bx1',
            d: '=V.tx1 - V.bx1',
            tdx: '=V.tx1 * 29289 / 100000',
            bdx: '=V.bx1 * 29289 / 100000',
            il: '=IF(V.d > 0, V.tdx, V.bdx)',
            ir: '=width - V.il',
            ib: '=height - V.bdx',
            vc: F,
            hc: E,
            l: 0,
            t: 0,
            _3cd4: D,
            cd4: C,
            cx1: '=C(V.tx1,V.tx2,A(V.tx1,V.tx1,V._3cd4),true)',
            cy1: '=C(V.tx1,V.t,A(V.tx1,V.tx1,V._3cd4))',
            cx2: '=C(V.bx1,V.r,A(V.bx1,V.bx1,0),true)',
            cy2: '=C(V.bx1,V.by1,A(V.bx1,V.bx1,0))',
            cx3: '=C(V.bx1,V.bx1,A(V.bx1,V.bx1,V.cd4),true)',
            cy3: '=C(V.bx1,V.b,A(V.bx1,V.bx1,V.cd4))',
            cd2: B,
            cx4: '=C(V.tx1,V.l,A(V.tx1,V.tx1,V.cd2),true)',
            cy4: '=C(V.tx1,V.tx1,A(V.tx1,V.tx1,V.cd2))',
        },
        adjustInfo: [['adj1', 16667], ['adj2', 0]],
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj1',
            minX: 0,
            maxX: 50000,
            position: {
                x: 'tx2',
                y: 't',
            },
            point: ['=V.tx2', 0],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: 0,
            maxX: 50000,
            position: {
                x: 'bx1',
                y: 'b',
            },
            point: ['=V.bx1', h],
        },
        ],
        path: [[['M', '=V.tx1', 0], ['L', '=V.tx2', 0], ['E', '=V.cx1', '=V.cy1', '=V.tx1', '=V.tx1', 0, '=A(V.tx1,V.tx1,V._3cd4)', '=A(V.tx1,V.tx1,(V._3cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', w, '=V.by1'], ['E', '=V.cx2', '=V.cy2', '=V.bx1', '=V.bx1', 0, '=A(V.bx1,V.bx1,0)', '=A(V.bx1,V.bx1,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', '=V.bx1', h], ['E', '=V.cx3', '=V.cy3', '=V.bx1', '=V.bx1', 0, '=A(V.bx1,V.bx1,V.cd4)', '=A(V.bx1,V.bx1,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', 0, '=V.tx1'], ['E', '=V.cx4', '=V.cy4', '=V.tx1', '=V.tx1', 0, '=A(V.tx1,V.tx1,V.cd2)', '=A(V.tx1,V.tx1,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.tdx',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    round2DiagRectangle: {
        variables: {
            adj1: 16667,
            adj2: 0,
            a1: '=MIN(MAX(0, V.adj1), 50000)',
            a2: '=MIN(MAX(0, V.adj2), 50000)',
            ss: s,
            x1: '=V.ss * V.a1 / 100000',
            b: h,
            y1: '=height - V.x1',
            a: '=V.ss * V.a2 / 100000',
            r: w,
            x2: '=width - V.a',
            y2: '=height - V.a',
            dx1: '=V.x1 * 29289 / 100000',
            dx2: '=V.a * 29289 / 100000',
            d: '=V.dx1 - V.dx2',
            dx: '=IF(V.d > 0, V.dx1, V.dx2)',
            ir: '=width - V.dx',
            ib: '=height - V.dx',
            vc: F,
            hc: E,
            l: 0,
            t: 0,
            _3cd4: D,
            cd4: C,
            cx1: '=C(V.a,V.x2,A(V.a,V.a,V._3cd4),true)',
            cy1: '=C(V.a,V.t,A(V.a,V.a,V._3cd4))',
            cx2: '=C(V.x1,V.r,A(V.x1,V.x1,0),true)',
            cy2: '=C(V.x1,V.y1,A(V.x1,V.x1,0))',
            cx3: '=C(V.a,V.a,A(V.a,V.a,V.cd4),true)',
            cy3: '=C(V.a,V.b,A(V.a,V.a,V.cd4))',
            cd2: B,
            cx4: '=C(V.x1,V.l,A(V.x1,V.x1,V.cd2),true)',
            cy4: '=C(V.x1,V.x1,A(V.x1,V.x1,V.cd2))',
        },
        adjustInfo: [['adj1', 16667], ['adj2', 0]],
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj1',
            minX: 0,
            maxX: 50000,
            position: {
                x: 'x1',
                y: 't',
            },
            point: [c, 0],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: 0,
            maxX: 50000,
            position: {
                x: 'x2',
                y: 't',
            },
            point: [d, 0],
        },
        ],
        path: [[['M', c, 0], ['L', d, 0], ['E', '=V.cx1', '=V.cy1', '=V.a', '=V.a', 0, '=A(V.a,V.a,V._3cd4)', '=A(V.a,V.a,(V._3cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', w, e], ['E', '=V.cx2', '=V.cy2', c, c, 0, '=A(V.x1,V.x1,0)', '=A(V.x1,V.x1,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', '=V.a', h], ['E', '=V.cx3', '=V.cy3', '=V.a', '=V.a', 0, '=A(V.a,V.a,V.cd4)', '=A(V.a,V.a,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', 0, c], ['E', '=V.cx4', '=V.cy4', c, c, 0, '=A(V.x1,V.x1,V.cd2)', '=A(V.x1,V.x1,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.dx',
            top: '=V.dx',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    snipRoundRectangle: {
        variables: {
            adj1: 16667,
            adj2: 16667,
            a1: '=MIN(MAX(0, V.adj1), 50000)',
            a2: '=MIN(MAX(0, V.adj2), 50000)',
            ss: s,
            x1: '=V.ss * V.a1 / 100000',
            dx2: '=V.ss * V.a2 / 100000',
            r: w,
            x2: '=width - V.dx2',
            il: '=V.x1 * 29289 / 100000',
            ir: '=(V.x2 + V.r) / 2',
            vc: F,
            hc: E,
            b: h,
            l: 0,
            t: 0,
            cd2: B,
            cd4: C,
            cx1: '=C(V.x1,V.l,A(V.x1,V.x1,V.cd2),true)',
            cy1: '=C(V.x1,V.x1,A(V.x1,V.x1,V.cd2))',
        },
        adjustInfo: [['adj1', 16667], ['adj2', 16667]],
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj1',
            minX: 0,
            maxX: 50000,
            position: {
                x: 'x1',
                y: 't',
            },
            point: [c, 0],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: 0,
            maxX: 50000,
            position: {
                x: 'x2',
                y: 't',
            },
            point: [d, 0],
        },
        ],
        path: [[['M', c, 0], ['L', d, 0], ['L', w, '=V.dx2'], ['L', w, h], ['L', 0, h], ['L', 0, c], ['E', '=V.cx1', '=V.cy1', c, c, 0, '=A(V.x1,V.x1,V.cd2)', '=A(V.x1,V.x1,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.il',
            right: '=V.ir',
            bottom: h,
        },
    },
    snip1Rectangle: {
        variables: {
            adj: 16667,
            a: '=MIN(MAX(0, V.adj), 50000)',
            ss: s,
            dx1: '=V.ss * V.a / 100000',
            r: w,
            x1: '=width - V.dx1',
            it: '=V.dx1 / 2',
            ir: '=(V.x1 + V.r) / 2',
            vc: F,
            hc: E,
            b: h,
            l: 0,
            t: 0,
        },
        adjustInfo: [['adj', 16667]],
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj',
            minX: 0,
            maxX: 50000,
            position: {
                x: 'x1',
                y: 't',
            },
            point: [c, 0],
        },
        ],
        path: [[['M', 0, 0], ['L', c, 0], ['L', w, '=V.dx1'], ['L', w, h], ['L', 0, h], ['Z'], {},
        ]],
        textRect: {
            left: 0,
            top: '=V.it',
            right: '=V.ir',
            bottom: h,
        },
    },
    snip2SameRectangle: {
        variables: {
            adj1: 16667,
            adj2: 0,
            a1: '=MIN(MAX(0, V.adj1), 50000)',
            a2: '=MIN(MAX(0, V.adj2), 50000)',
            ss: s,
            tx1: '=V.ss * V.a1 / 100000',
            r: w,
            tx2: '=width - V.tx1',
            bx1: '=V.ss * V.a2 / 100000',
            bx2: '=width - V.bx1',
            b: h,
            by1: '=height - V.bx1',
            d: '=V.tx1 - V.bx1',
            dx: '=IF(V.d > 0, V.tx1, V.bx1)',
            il: '=V.dx / 2',
            ir: '=width - V.il',
            it: '=V.tx1 / 2',
            ib: '=(V.by1 + V.b) / 2',
            vc: F,
            hc: E,
            l: 0,
            t: 0,
        },
        adjustInfo: [['adj1', 16667], ['adj2', 0]],
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj1',
            minX: 0,
            maxX: 50000,
            position: {
                x: 'tx2',
                y: 't',
            },
            point: ['=V.tx2', 0],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: 0,
            maxX: 50000,
            position: {
                x: 'bx1',
                y: 'b',
            },
            point: ['=V.bx1', h],
        },
        ],
        path: [[['M', '=V.tx1', 0], ['L', '=V.tx2', 0], ['L', w, '=V.tx1'], ['L', w, '=V.by1'], ['L', '=V.bx2', h], ['L', '=V.bx1', h], ['L', 0, '=V.by1'], ['L', 0, '=V.tx1'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.it',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    snip2DiagRectangle: {
        variables: {
            adj1: 0,
            adj2: 16667,
            a1: '=MIN(MAX(0, V.adj1), 50000)',
            a2: '=MIN(MAX(0, V.adj2), 50000)',
            ss: s,
            lx1: '=V.ss * V.a1 / 100000',
            r: w,
            lx2: '=width - V.lx1',
            b: h,
            ly1: '=height - V.lx1',
            rx1: '=V.ss * V.a2 / 100000',
            rx2: '=width - V.rx1',
            ry1: '=height - V.rx1',
            d: '=V.lx1 - V.rx1',
            dx: '=IF(V.d > 0, V.lx1, V.rx1)',
            il: '=V.dx / 2',
            ir: '=width - V.il',
            ib: '=height - V.il',
            vc: F,
            hc: E,
            l: 0,
            t: 0,
        },
        adjustInfo: [['adj1', 0], ['adj2', 16667]],
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj1',
            minX: 0,
            maxX: 50000,
            position: {
                x: 'lx1',
                y: 't',
            },
            point: ['=V.lx1', 0],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: 0,
            maxX: 50000,
            position: {
                x: 'rx2',
                y: 't',
            },
            point: ['=V.rx2', 0],
        },
        ],
        path: [[['M', '=V.lx1', 0], ['L', '=V.rx2', 0], ['L', w, '=V.rx1'], ['L', w, '=V.ly1'], ['L', '=V.lx2', h], ['L', '=V.rx1', h], ['L', 0, '=V.ry1'], ['L', 0, '=V.lx1'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.il',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    frame: {
        variables: {
            adj1: 12500,
            a1: '=MIN(MAX(0, V.adj1), 50000)',
            ss: s,
            x1: '=V.ss * V.a1 / 100000',
            r: w,
            x4: '=width - V.x1',
            b: h,
            y4: '=height - V.x1',
            hc: E,
            t: 0,
            l: 0,
            vc: F,
        },
        adjustInfo: [['adj1', 12500]],
        connectionPoints: [{
            x: a,
            y: 0,
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: h,
        }, {
            x: w,
            y: b,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj1',
            minX: 0,
            maxX: 50000,
            position: {
                x: 'x1',
                y: 't',
            },
            point: [c, 0],
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', w, h], ['L', 0, h], ['Z'], ['M', c, c], ['L', c, '=V.y4'], ['L', '=V.x4', '=V.y4'], ['L', '=V.x4', c], ['Z'], {},
        ]],
        textRect: {
            left: c,
            top: c,
            right: '=V.x4',
            bottom: '=V.y4',
        },
    },
    halfFrame: {
        variables: {
            adj1: 33333,
            adj2: 33333,
            ss: s,
            maxAdj2: '=100000 * width / V.ss',
            a2: '=MIN(MAX(0, V.adj2), V.maxAdj2)',
            x1: '=V.ss * V.a2 / 100000',
            g1: '=height * V.x1 / width',
            g2: '=height - V.g1',
            maxAdj1: '=100000 * V.g2 / V.ss',
            a1: '=MIN(MAX(0, V.adj1), V.maxAdj1)',
            y1: '=V.ss * V.a1 / 100000',
            dx2: '=V.y1 * width / height',
            r: w,
            x2: '=width - V.dx2',
            dy2: '=V.x1 * height / width',
            b: h,
            y2: '=height - V.dy2',
            cx1: '=V.x1 / 2',
            cy1: '=(V.y2 + V.b) / 2',
            cx2: '=(V.x2 + V.r) / 2',
            cy2: '=V.y1 / 2',
            l: 0,
            vc: F,
            hc: E,
            t: 0,
        },
        adjustInfo: [['adj1', 33333], ['adj2', 33333]],
        connectionPoints: [{
            x: '=V.cx2',
            y: '=V.cy2',
        }, {
            x: '=V.cx1',
            y: '=V.cy1',
        }, {
            x: 0,
            y: b,
        }, {
            x: a,
            y: 0,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj1',
            minY: 0,
            maxY: 'maxAdj1',
            position: {
                x: 'l',
                y: 'y1',
            },
            point: [0, e],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: 0,
            maxX: 'maxAdj2',
            position: {
                x: 'x1',
                y: 't',
            },
            point: [c, 0],
        },
        ],
        path: [[['M', 0, 0], ['L', w, 0], ['L', d, e], ['L', c, e], ['L', c, f], ['L', 0, h], ['Z'], {},
        ]],
    },
    tear: {
        variables: {
            adj: 100000,
            a: '=MIN(MAX(0, V.adj), 200000)',
            r2: '=SQRT(2)',
            wd2: E,
            tw: '=V.wd2 * V.r2',
            hd2: F,
            th: '=V.hd2 * V.r2',
            sw: '=V.tw * V.a / 100000',
            sh: '=V.th * V.a / 100000',
            d2r: A,
            dx1: '=V.sw * COS(2700000 / V.d2r)',
            dy1: '=V.sh * SIN(2700000 / V.d2r)',
            hc: E,
            x1: '=V.hc + V.dx1',
            vc: F,
            y1: '=V.vc - V.dy1',
            x2: '=(V.hc + V.x1) / 2',
            y2: '=(V.vc + V.y1) / 2',
            idx: '=V.wd2 * COS(2700000 / V.d2r)',
            idy: '=V.hd2 * SIN(2700000 / V.d2r)',
            il: '=V.hc - V.idx',
            ir: '=V.hc + V.idx',
            it: '=V.vc - V.idy',
            ib: '=V.vc + V.idy',
            r: w,
            b: h,
            l: 0,
            t: 0,
            cd2: B,
            cd4: C,
            cx1: '=C(V.wd2,V.l,A(V.wd2,V.hd2,V.cd2),true)',
            cy1: '=C(V.hd2,V.vc,A(V.wd2,V.hd2,V.cd2))',
            cx2: '=C(V.wd2,V.r,A(V.wd2,V.hd2,0),true)',
            cy2: '=C(V.hd2,V.vc,A(V.wd2,V.hd2,0))',
            cx3: '=C(V.wd2,P(V.cx2,V.wd2,A(V.wd2,V.hd2,(V.cd4)),true),A(V.wd2,V.hd2,V.cd4),true)',
            cy3: '=C(V.hd2,P(V.cy2,V.hd2,A(V.wd2,V.hd2,(V.cd4))),A(V.wd2,V.hd2,V.cd4))',
        },
        adjustInfo: [['adj', 100000]],
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: '=V.ir',
            y: '=V.ib',
        }, {
            x: a,
            y: h,
        }, {
            x: '=V.il',
            y: '=V.ib',
        }, {
            x: 0,
            y: b,
        }, {
            x: '=V.il',
            y: '=V.it',
        }, {
            x: a,
            y: 0,
        }, {
            x: c,
            y: e,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefX: 'adj',
            minX: 0,
            maxX: 200000,
            position: {
                x: 'x1',
                y: 't',
            },
            point: [c, 0],
        },
        ],
        path: [[['M', 0, b], ['E', '=V.cx1', '=V.cy1', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V.cd2)', '=A(V.wd2,V.hd2,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['Q', d, 0, c, e], ['Q', w, f, w, b], ['E', '=V.cx2', '=V.cy2', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,0)', '=A(V.wd2,V.hd2,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['E', '=V.cx3', '=V.cy3', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V.cd4)', '=A(V.wd2,V.hd2,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.it',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    chord: {
        variables: {
            adj1: 2700000,
            adj2: D,
            stAng: '=MIN(MAX(0, V.adj1), 21599999)',
            enAng: '=MIN(MAX(0, V.adj2), 21599999)',
            sw1: '=V.enAng - V.stAng',
            sw2: '=V.sw1 + 21600000',
            swAng: '=IF(V.sw1 > 0, V.sw1, V.sw2)',
            wd2: E,
            d2r: A,
            wt1: '=V.wd2 * SIN(V.stAng / V.d2r)',
            hd2: F,
            ht1: '=V.hd2 * COS(V.stAng / V.d2r)',
            dx1: '=V.wd2 * COS(ATAN2(V.ht1,V.wt1))',
            dy1: '=V.hd2 * SIN(ATAN2(V.ht1,V.wt1))',
            wt2: '=V.wd2 * SIN(V.enAng / V.d2r)',
            ht2: '=V.hd2 * COS(V.enAng / V.d2r)',
            dx2: '=V.wd2 * COS(ATAN2(V.ht2,V.wt2))',
            dy2: '=V.hd2 * SIN(ATAN2(V.ht2,V.wt2))',
            hc: E,
            x1: '=V.hc + V.dx1',
            vc: F,
            y1: '=V.vc + V.dy1',
            x2: '=V.hc + V.dx2',
            y2: '=V.vc + V.dy2',
            x3: '=(V.x1 + V.x2) / 2',
            y3: '=(V.y1 + V.y2) / 2',
            midAng0: '=V.swAng / 2',
            cd2: B,
            midAng: '=V.stAng + V.midAng0 - V.cd2',
            idx: '=V.wd2 * COS(2700000 / V.d2r)',
            idy: '=V.hd2 * SIN(2700000 / V.d2r)',
            il: '=V.hc - V.idx',
            ir: '=V.hc + V.idx',
            it: '=V.vc - V.idy',
            ib: '=V.vc + V.idy',
            cx1: '=C(V.wd2,V.x1,A(V.wd2,V.hd2,V.stAng),true)',
            cy1: '=C(V.hd2,V.y1,A(V.wd2,V.hd2,V.stAng))',
        },
        adjustInfo: [['adj1', 2700000], ['adj2', 16200000]],
        connectionPoints: [{
            x: c,
            y: e,
        }, {
            x: d,
            y: f,
        }, {
            x: '=V.x3',
            y: '=V.y3',
        },
        ],
        controlsInfo: [{
            type: 'ahPolar',
            gdRefAng: 'adj1',
            minAng: 0,
            maxAng: 21599999,
            position: {
                x: 'x1',
                y: 'y1',
            },
            point: [c, e],
        }, {
            type: 'ahPolar',
            gdRefAng: 'adj2',
            minAng: 0,
            maxAng: 21599999,
            position: {
                x: 'x2',
                y: 'y2',
            },
            point: [d, f],
        },
        ],
        path: [[['M', c, e], ['E', '=V.cx1', '=V.cy1', '=V.wd2', '=V.hd2', 0, '=A(V.wd2,V.hd2,V.stAng)', '=A(V.wd2,V.hd2,(V.stAng + V.swAng))', '=IF(V.swAng > 0, FALSE, TRUE)'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.it',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    corner: {
        variables: {
            adj1: 50000,
            adj2: 50000,
            ss: s,
            maxAdj1: '=100000 * height / V.ss',
            maxAdj2: '=100000 * width / V.ss',
            a1: '=MIN(MAX(0, V.adj1), V.maxAdj1)',
            a2: '=MIN(MAX(0, V.adj2), V.maxAdj2)',
            x1: '=V.ss * V.a2 / 100000',
            dy1: '=V.ss * V.a1 / 100000',
            b: h,
            y1: '=height - V.dy1',
            cx1: '=V.x1 / 2',
            cy1: '=(V.y1 + V.b) / 2',
            d: '=width - height',
            t: 0,
            it: '=IF(V.d > 0, V.y1, V.t)',
            r: w,
            ir: '=IF(V.d > 0, V.r, V.x1)',
            hc: E,
            l: 0,
            vc: F,
        },
        adjustInfo: [['adj1', 50000], ['adj2', 50000]],
        connectionPoints: [{
            x: w,
            y: '=V.cy1',
        }, {
            x: a,
            y: h,
        }, {
            x: 0,
            y: b,
        }, {
            x: '=V.cx1',
            y: 0,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj1',
            minY: 0,
            maxY: 'maxAdj1',
            position: {
                x: 'l',
                y: 'y1',
            },
            point: [0, e],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: 0,
            maxX: 'maxAdj2',
            position: {
                x: 'x1',
                y: 't',
            },
            point: [c, 0],
        },
        ],
        path: [[['M', 0, 0], ['L', c, 0], ['L', c, e], ['L', w, e], ['L', w, h], ['L', 0, h], ['Z'], {},
        ]],
        textRect: {
            left: 0,
            top: '=V.it',
            right: '=V.ir',
            bottom: h,
        },
    },
    mathPlus: {
        variables: {
            adj1: 23520,
            a1: '=MIN(MAX(0, V.adj1), 73490)',
            dx1: '=width * 73490 / 200000',
            dy1: '=height * 73490 / 200000',
            ss: s,
            dx2: '=V.ss * V.a1 / 200000',
            hc: E,
            x1: '=V.hc - V.dx1',
            x2: '=V.hc - V.dx2',
            x3: '=V.hc + V.dx2',
            x4: '=V.hc + V.dx1',
            vc: F,
            y1: '=V.vc - V.dy1',
            y2: '=V.vc - V.dx2',
            y3: '=V.vc + V.dx2',
            y4: '=V.vc + V.dy1',
            l: 0,
        },
        adjustInfo: [['adj1', 23520]],
        connectionPoints: [{
            x: '=V.x4',
            y: b,
        }, {
            x: a,
            y: '=V.y4',
        }, {
            x: c,
            y: b,
        }, {
            x: a,
            y: e,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj1',
            minY: 0,
            maxY: 73490,
            position: {
                x: 'l',
                y: 'y2',
            },
            point: [0, f],
        },
        ],
        path: [[['M', c, f], ['L', d, f], ['L', d, e], ['L', '=V.x3', e], ['L', '=V.x3', f], ['L', '=V.x4', f], ['L', '=V.x4', '=V.y3'], ['L', '=V.x3', '=V.y3'], ['L', '=V.x3', '=V.y4'], ['L', d, '=V.y4'], ['L', d, '=V.y3'], ['L', c, '=V.y3'], ['Z'], {},
        ]],
        textRect: {
            left: c,
            top: f,
            right: '=V.x4',
            bottom: '=V.y3',
        },
    },
    mathMinus: {
        variables: {
            adj1: 23520,
            a1: '=MIN(MAX(0, V.adj1), 100000)',
            dy1: '=height * V.a1 / 200000',
            dx1: '=width * 73490 / 200000',
            vc: F,
            y1: '=V.vc - V.dy1',
            y2: '=V.vc + V.dy1',
            hc: E,
            x1: '=V.hc - V.dx1',
            x2: '=V.hc + V.dx1',
            l: 0,
        },
        adjustInfo: [['adj1', 23520]],
        connectionPoints: [{
            x: d,
            y: b,
        }, {
            x: a,
            y: f,
        }, {
            x: c,
            y: b,
        }, {
            x: a,
            y: e,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj1',
            minY: 0,
            maxY: 100000,
            position: {
                x: 'l',
                y: 'y1',
            },
            point: [0, e],
        },
        ],
        path: [[['M', c, e], ['L', d, e], ['L', d, f], ['L', c, f], ['Z'], {},
        ]],
        textRect: {
            left: c,
            top: e,
            right: d,
            bottom: f,
        },
    },
    mathMultiply: {
        variables: {
            adj1: 23520,
            a1: '=MIN(MAX(0, V.adj1), 51965)',
            ss: s,
            th: '=V.ss * V.a1 / 100000',
            d2r: A,
            a: '=(ATAN2(width,height) * V.d2r)',
            sa: '=SIN(V.a / V.d2r)',
            ca: '=COS(V.a / V.d2r)',
            ta: '=TAN(V.a / V.d2r)',
            dl: '=SQRT(width*width + height*height)',
            rw: '=V.dl * 51965 / 100000',
            lM: '=V.dl - V.rw',
            xM: '=V.ca * V.lM / 2',
            yM: '=V.sa * V.lM / 2',
            dxAM: '=V.sa * V.th / 2',
            dyAM: '=V.ca * V.th / 2',
            xA: '=V.xM - V.dxAM',
            yA: '=V.yM + V.dyAM',
            xB: '=V.xM + V.dxAM',
            yB: '=V.yM - V.dyAM',
            hc: E,
            xBC: '=V.hc - V.xB',
            yBC: '=V.xBC * V.ta',
            yC: '=V.yBC + V.yB',
            r: w,
            xD: '=width - V.xB',
            xE: '=width - V.xA',
            vc: F,
            yFE: '=V.vc - V.yA',
            xFE: '=V.yFE / V.ta',
            xF: '=V.xE - V.xFE',
            xL: '=V.xA + V.xFE',
            b: h,
            yG: '=height - V.yA',
            yH: '=height - V.yB',
            yI: '=height - V.yC',
            xC2: '=width - V.xM',
            yC3: '=height - V.yM',
            l: 0,
        },
        adjustInfo: [['adj1', 23520]],
        connectionPoints: [{
            x: '=V.xM',
            y: '=V.yM',
        }, {
            x: '=V.xC2',
            y: '=V.yM',
        }, {
            x: '=V.xC2',
            y: '=V.yC3',
        }, {
            x: '=V.xM',
            y: '=V.yC3',
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj1',
            minY: 0,
            maxY: 51965,
            position: {
                x: 'l',
                y: 'th',
            },
            point: [0, '=V.th'],
        },
        ],
        path: [[['M', '=V.xA', '=V.yA'], ['L', '=V.xB', '=V.yB'], ['L', a, '=V.yC'], ['L', '=V.xD', '=V.yB'], ['L', '=V.xE', '=V.yA'], ['L', '=V.xF', b], ['L', '=V.xE', '=V.yG'], ['L', '=V.xD', '=V.yH'], ['L', a, '=V.yI'], ['L', '=V.xB', '=V.yH'], ['L', '=V.xA', '=V.yG'], ['L', '=V.xL', b], ['Z'], {},
        ]],
        textRect: {
            left: '=V.xA',
            top: '=V.yB',
            right: '=V.xE',
            bottom: '=V.yH',
        },
    },
    mathDivide: {
        variables: {
            adj1: 23520,
            adj2: 5880,
            adj3: 11760,
            a1: '=MIN(MAX(1000, V.adj1), 36745)',
            ma1: '=0 - V.a1',
            ma3h: '=(73490 + V.ma1) / 4',
            ma3w: '=36745 * width / height',
            maxAdj3: '=MIN(V.ma3h, V.ma3w)',
            a3: '=MIN(MAX(1000, V.adj3), V.maxAdj3)',
            m4a3: '=-4 * V.a3',
            maxAdj2: '=73490 + V.m4a3 - V.a1',
            a2: '=MIN(MAX(0, V.adj2), V.maxAdj2)',
            dy1: '=height * V.a1 / 200000',
            yg: '=height * V.a2 / 100000',
            rad: '=height * V.a3 / 100000',
            dx1: '=width * 73490 / 200000',
            vc: F,
            y3: '=V.vc - V.dy1',
            y4: '=V.vc + V.dy1',
            a: '=V.yg + V.rad',
            y2: '=V.y3 - V.a',
            y1: '=V.y2 - V.rad',
            b: h,
            y5: '=height - V.y1',
            hc: E,
            x1: '=V.hc - V.dx1',
            x3: '=V.hc + V.dx1',
            x2: '=V.hc - V.rad',
            l: 0,
            r: w,
            t: 0,
            _3cd4: D,
            cx1: '=C(V.rad,V.hc,A(V.rad,V.rad,V._3cd4),true)',
            cy1: '=C(V.rad,V.y1,A(V.rad,V.rad,V._3cd4))',
            cd4: C,
            cx2: '=C(V.rad,V.hc,A(V.rad,V.rad,V.cd4),true)',
            cy2: '=C(V.rad,V.y5,A(V.rad,V.rad,V.cd4))',
        },
        adjustInfo: [['adj1', 23520], ['adj2', 5880], ['adj3', 11760]],
        connectionPoints: [{
            x: '=V.x3',
            y: b,
        }, {
            x: a,
            y: '=V.y5',
        }, {
            x: c,
            y: b,
        }, {
            x: a,
            y: e,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj1',
            minY: 1000,
            maxY: 36745,
            position: {
                x: 'l',
                y: 'y3',
            },
            point: [0, '=V.y3'],
        }, {
            type: 'ahXY',
            gdRefY: 'adj2',
            minY: 0,
            maxY: 'maxAdj2',
            position: {
                x: 'r',
                y: 'y2',
            },
            point: [w, f],
        }, {
            type: 'ahXY',
            gdRefX: 'adj3',
            minX: 1000,
            maxX: 'maxAdj3',
            position: {
                x: 'x2',
                y: 't',
            },
            point: [d, 0],
        },
        ],
        path: [[['M', a, e], ['E', '=V.cx1', '=V.cy1', '=V.rad', '=V.rad', 0, '=A(V.rad,V.rad,V._3cd4)', '=(A(V.rad,V.rad,V._3cd4)+ 2*PI())', '=IF(21600000 > 0, FALSE, TRUE)'], ['Z'], ['M', a, '=V.y5'], ['E', '=V.cx2', '=V.cy2', '=V.rad', '=V.rad', 0, '=A(V.rad,V.rad,V.cd4)', '=(A(V.rad,V.rad,V.cd4)+ 2*PI())', '=IF(21600000 > 0, FALSE, TRUE)'], ['Z'], ['M', c, '=V.y3'], ['L', '=V.x3', '=V.y3'], ['L', '=V.x3', '=V.y4'], ['L', c, '=V.y4'], ['Z'], {},
        ]],
        textRect: {
            left: c,
            top: '=V.y3',
            right: '=V.x3',
            bottom: '=V.y4',
        },
    },
    mathEqual: {
        variables: {
            adj1: 23520,
            adj2: 11760,
            a1: '=MIN(MAX(0, V.adj1), 36745)',
            '2a1': '=V.a1 * 2',
            mAdj2: '=100000 - V.2a1',
            a2: '=MIN(MAX(0, V.adj2), V.mAdj2)',
            dy1: '=height * V.a1 / 100000',
            dy2: '=height * V.a2 / 200000',
            dx1: '=width * 73490 / 200000',
            vc: F,
            y2: '=V.vc - V.dy2',
            y3: '=V.vc + V.dy2',
            y1: '=V.y2 - V.dy1',
            y4: '=V.y3 + V.dy1',
            hc: E,
            x1: '=V.hc - V.dx1',
            x2: '=V.hc + V.dx1',
            yC1: '=(V.y1 + V.y2) / 2',
            yC2: '=(V.y3 + V.y4) / 2',
            l: 0,
            r: w,
        },
        adjustInfo: [['adj1', 23520], ['adj2', 11760]],
        connectionPoints: [{
            x: d,
            y: '=V.yC1',
        }, {
            x: d,
            y: '=V.yC2',
        }, {
            x: a,
            y: '=V.y4',
        }, {
            x: c,
            y: '=V.yC1',
        }, {
            x: c,
            y: '=V.yC2',
        }, {
            x: a,
            y: e,
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj1',
            minY: 0,
            maxY: 36745,
            position: {
                x: 'l',
                y: 'y1',
            },
            point: [0, e],
        }, {
            type: 'ahXY',
            gdRefY: 'adj2',
            minY: 0,
            maxY: 'mAdj2',
            position: {
                x: 'r',
                y: 'y2',
            },
            point: [w, f],
        },
        ],
        path: [[['M', c, e], ['L', d, e], ['L', d, f], ['L', c, f], ['Z'], ['M', c, '=V.y3'], ['L', d, '=V.y3'], ['L', d, '=V.y4'], ['L', c, '=V.y4'], ['Z'], {},
        ]],
        textRect: {
            left: c,
            top: e,
            right: d,
            bottom: '=V.y4',
        },
    },
    mathNotEqual: {
        variables: {
            adj1: 23520,
            adj2: 6600000,
            adj3: 11760,
            a1: '=MIN(MAX(0, V.adj1), 50000)',
            crAng: '=MIN(MAX(4200000, V.adj2), 6600000)',
            '2a1': '=V.a1 * 2',
            maxAdj3: '=100000 - V.2a1',
            a3: '=MIN(MAX(0, V.adj3), V.maxAdj3)',
            dy1: '=height * V.a1 / 100000',
            dy2: '=height * V.a3 / 200000',
            dx1: '=width * 73490 / 200000',
            hc: E,
            x1: '=V.hc - V.dx1',
            x8: '=V.hc + V.dx1',
            vc: F,
            y2: '=V.vc - V.dy2',
            y3: '=V.vc + V.dy2',
            y1: '=V.y2 - V.dy1',
            y4: '=V.y3 + V.dy1',
            cd4: C,
            cadj2: '=V.crAng - V.cd4',
            hd2: F,
            d2r: A,
            xadj2: '=V.hd2 * TAN(V.cadj2 / V.d2r)',
            len: '=SQRT(V.xadj2*V.xadj2 + V.hd2*V.hd2)',
            bhw: '=V.len * V.dy1 / V.hd2',
            bhw2: '=V.bhw / 2',
            x7: '=V.hc + V.xadj2 - V.bhw2',
            dx67: '=V.xadj2 * V.y1 / V.hd2',
            x6: '=V.x7 - V.dx67',
            dx57: '=V.xadj2 * V.y2 / V.hd2',
            x5: '=V.x7 - V.dx57',
            dx47: '=V.xadj2 * V.y3 / V.hd2',
            x4: '=V.x7 - V.dx47',
            dx37: '=V.xadj2 * V.y4 / V.hd2',
            x3: '=V.x7 - V.dx37',
            dx27: '=V.xadj2 * 2',
            x2: '=V.x7 - V.dx27',
            rx7: '=V.x7 + V.bhw',
            rx6: '=V.x6 + V.bhw',
            rx5: '=V.x5 + V.bhw',
            rx4: '=V.x4 + V.bhw',
            rx3: '=V.x3 + V.bhw',
            rx2: '=V.x2 + V.bhw',
            dx7: '=V.dy1 * V.hd2 / V.len',
            rxt: '=V.x7 + V.dx7',
            lxt: '=V.rx7 - V.dx7',
            rx: '=IF(V.cadj2 > 0, V.rxt, V.rx7)',
            lx: '=IF(V.cadj2 > 0, V.x7, V.lxt)',
            dy3: '=V.dy1 * V.xadj2 / V.len',
            dy4: '=0 - V.dy3',
            t: 0,
            ry: '=IF(V.cadj2 > 0, V.dy3, V.t)',
            ly: '=IF(V.cadj2 > 0, V.t, V.dy4)',
            dlx: '=width - V.rx',
            drx: '=width - V.lx',
            dly: '=height - V.ry',
            dry: '=height - V.ly',
            xC1: '=(V.rx + V.lx) / 2',
            xC2: '=(V.drx + V.dlx) / 2',
            yC1: '=(V.ry + V.ly) / 2',
            yC2: '=(V.y1 + V.y2) / 2',
            yC3: '=(V.y3 + V.y4) / 2',
            yC4: '=(V.dry + V.dly) / 2',
            l: 0,
            r: w,
        },
        adjustInfo: [['adj1', 23520], ['adj2', 6600000], ['adj3', 11760]],
        connectionPoints: [{
            x: '=V.x8',
            y: '=V.yC2',
        }, {
            x: '=V.x8',
            y: '=V.yC3',
        }, {
            x: '=V.xC2',
            y: '=V.yC4',
        }, {
            x: c,
            y: '=V.yC2',
        }, {
            x: c,
            y: '=V.yC3',
        }, {
            x: '=V.xC1',
            y: '=V.yC1',
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj1',
            minY: 0,
            maxY: 50000,
            position: {
                x: 'l',
                y: 'y1',
            },
            point: [0, e],
        }, {
            type: 'ahPolar',
            gdRefAng: 'adj2',
            minAng: 4200000,
            maxAng: 6600000,
            position: {
                x: 'lx',
                y: 't',
            },
            point: ['=V.lx', 0],
        }, {
            type: 'ahXY',
            gdRefY: 'adj3',
            minY: 0,
            maxY: 'maxAdj3',
            position: {
                x: 'r',
                y: 'y2',
            },
            point: [w, f],
        },
        ],
        path: [[['M', c, e], ['L', '=V.x6', e], ['L', '=V.lx', '=V.ly'], ['L', '=V.rx', '=V.ry'], ['L', '=V.rx6', e], ['L', '=V.x8', e], ['L', '=V.x8', f], ['L', '=V.rx5', f], ['L', '=V.rx4', '=V.y3'], ['L', '=V.x8', '=V.y3'], ['L', '=V.x8', '=V.y4'], ['L', '=V.rx3', '=V.y4'], ['L', '=V.drx', '=V.dry'], ['L', '=V.dlx', '=V.dly'], ['L', '=V.x3', '=V.y4'], ['L', c, '=V.y4'], ['L', c, '=V.y3'], ['L', '=V.x4', '=V.y3'], ['L', '=V.x5', f], ['L', c, f], ['Z'], {},
        ]],
        textRect: {
            left: c,
            top: e,
            right: '=V.x8',
            bottom: '=V.y4',
        },
    },
    cornerTabs: {
        variables: {
            md: '=SQRT(width*width + height*height)',
            dx: '=V.md / 20',
            b: h,
            y1: '=height - V.dx',
            r: w,
            x1: '=width - V.dx',
            l: 0,
            t: 0,
        },
        connectionPoints: [{
            x: 0,
            y: 0,
        }, {
            x: 0,
            y: '=V.dx',
        }, {
            x: 0,
            y: e,
        }, {
            x: 0,
            y: h,
        }, {
            x: '=V.dx',
            y: 0,
        }, {
            x: c,
            y: 0,
        }, {
            x: '=V.dx',
            y: h,
        }, {
            x: c,
            y: h,
        }, {
            x: w,
            y: 0,
        }, {
            x: w,
            y: '=V.dx',
        }, {
            x: w,
            y: e,
        }, {
            x: w,
            y: h,
        },
        ],
        path: [[['M', 0, 0], ['L', '=V.dx', 0], ['L', 0, '=V.dx'], ['Z'], {},
        ], [['M', 0, e], ['L', '=V.dx', h], ['L', 0, h], ['Z'], {},
        ], [['M', c, 0], ['L', w, 0], ['L', w, '=V.dx'], ['Z'], {},
        ], [['M', w, e], ['L', w, h], ['L', c, h], ['Z'], {},
        ]],
        textRect: {
            left: '=V.dx',
            top: '=V.dx',
            right: c,
            bottom: e,
        },
    },
    squareTabs: {
        variables: {
            md: '=SQRT(width*width + height*height)',
            dx: '=V.md / 20',
            b: h,
            y1: '=height - V.dx',
            r: w,
            x1: '=width - V.dx',
            l: 0,
            t: 0,
        },
        connectionPoints: [{
            x: 0,
            y: 0,
        }, {
            x: 0,
            y: '=V.dx',
        }, {
            x: 0,
            y: e,
        }, {
            x: 0,
            y: h,
        }, {
            x: '=V.dx',
            y: '=V.dx',
        }, {
            x: '=V.dx',
            y: c,
        }, {
            x: '=V.dx',
            y: 0,
        }, {
            x: c,
            y: 0,
        }, {
            x: '=V.dx',
            y: h,
        }, {
            x: c,
            y: h,
        }, {
            x: w,
            y: 0,
        }, {
            x: w,
            y: '=V.dx',
        }, {
            x: w,
            y: e,
        }, {
            x: w,
            y: h,
        }, {
            x: c,
            y: '=V.dx',
        }, {
            x: c,
            y: e,
        },
        ],
        path: [[['M', 0, 0], ['L', '=V.dx', 0], ['L', '=V.dx', '=V.dx'], ['L', 0, '=V.dx'], ['Z'], {},
        ], [['M', 0, e], ['L', '=V.dx', e], ['L', '=V.dx', h], ['L', 0, h], ['Z'], {},
        ], [['M', c, 0], ['L', w, 0], ['L', w, '=V.dx'], ['L', c, '=V.dx'], ['Z'], {},
        ], [['M', c, e], ['L', w, e], ['L', w, h], ['L', c, h], ['Z'], {},
        ]],
        textRect: {
            left: '=V.dx',
            top: '=V.dx',
            right: c,
            bottom: e,
        },
    },
    plaqueTabs: {
        variables: {
            md: '=SQRT(width*width + height*height)',
            dx: '=V.md / 20',
            b: h,
            y1: '=height - V.dx',
            r: w,
            x1: '=width - V.dx',
            l: 0,
            t: 0,
            cd4: C,
            cx1: '=C(V.dx,V.dx,A(V.dx,V.dx,0),true)',
            cy1: '=C(V.dx,V.t,A(V.dx,V.dx,0))',
            _3cd4: D,
            cx2: '=C(V.dx,V.l,A(V.dx,V.dx,V._3cd4),true)',
            cy2: '=C(V.dx,V.y1,A(V.dx,V.dx,V._3cd4))',
            cx3: '=C(V.dx,V.r,A(V.dx,V.dx,V.cd4),true)',
            cy3: '=C(V.dx,V.dx,A(V.dx,V.dx,V.cd4))',
            cd2: B,
            cx4: '=C(V.dx,V.x1,A(V.dx,V.dx,V.cd2),true)',
            cy4: '=C(V.dx,V.b,A(V.dx,V.dx,V.cd2))',
        },
        connectionPoints: [{
            x: 0,
            y: 0,
        }, {
            x: 0,
            y: '=V.dx',
        }, {
            x: 0,
            y: e,
        }, {
            x: 0,
            y: h,
        }, {
            x: '=V.dx',
            y: 0,
        }, {
            x: c,
            y: 0,
        }, {
            x: '=V.dx',
            y: h,
        }, {
            x: c,
            y: h,
        }, {
            x: w,
            y: 0,
        }, {
            x: w,
            y: '=V.dx',
        }, {
            x: w,
            y: e,
        }, {
            x: w,
            y: h,
        },
        ],
        path: [[['M', 0, 0], ['L', '=V.dx', 0], ['E', '=V.cx1', '=V.cy1', '=V.dx', '=V.dx', 0, '=A(V.dx,V.dx,0)', '=A(V.dx,V.dx,(V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['Z'], {},
        ], [['M', 0, e], ['E', '=V.cx2', '=V.cy2', '=V.dx', '=V.dx', 0, '=A(V.dx,V.dx,V._3cd4)', '=A(V.dx,V.dx,(V._3cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', 0, h], ['Z'], {},
        ], [['M', w, 0], ['L', w, '=V.dx'], ['E', '=V.cx3', '=V.cy3', '=V.dx', '=V.dx', 0, '=A(V.dx,V.dx,V.cd4)', '=A(V.dx,V.dx,(V.cd4 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['Z'], {},
        ], [['M', c, h], ['E', '=V.cx4', '=V.cy4', '=V.dx', '=V.dx', 0, '=A(V.dx,V.dx,V.cd2)', '=A(V.dx,V.dx,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', w, h], ['Z'], {},
        ]],
        textRect: {
            left: '=V.dx',
            top: '=V.dx',
            right: c,
            bottom: e,
        },
    },
    gear6: {
        variables: {
            adj1: 15000,
            adj2: 3526,
            a1: '=MIN(MAX(0, V.adj1), 20000)',
            a2: '=MIN(MAX(0, V.adj2), 5358)',
            ss: s,
            th: '=V.ss * V.a1 / 100000',
            lFD: '=V.ss * V.a2 / 100000',
            th2: '=V.th / 2',
            l2: '=V.lFD / 2',
            l3: '=V.th2 + V.l2',
            hd2: F,
            rh: '=V.hd2 - V.th',
            wd2: E,
            rw: '=V.wd2 - V.th',
            dr: '=V.rw - V.rh',
            maxr: '=IF(V.dr > 0, V.rh, V.rw)',
            d2r: A,
            ha: '=(ATAN2(V.maxr,V.l3) * V.d2r)',
            aA1: '=19800000 - V.ha',
            aD1: '=19800000 + V.ha',
            ta11: '=V.rw * COS(V.aA1 / V.d2r)',
            ta12: '=V.rh * SIN(V.aA1 / V.d2r)',
            bA1: '=(ATAN2(V.ta11,V.ta12) * V.d2r)',
            cta1: '=V.rh * COS(V.bA1 / V.d2r)',
            sta1: '=V.rw * SIN(V.bA1 / V.d2r)',
            ma1: '=SQRT(V.cta1*V.cta1 + V.sta1*V.sta1)',
            na1: '=V.rw * V.rh / V.ma1',
            dxa1: '=V.na1 * COS(V.bA1 / V.d2r)',
            dya1: '=V.na1 * SIN(V.bA1 / V.d2r)',
            hc: E,
            xA1: '=V.hc + V.dxa1',
            vc: F,
            yA1: '=V.vc + V.dya1',
            td11: '=V.rw * COS(V.aD1 / V.d2r)',
            td12: '=V.rh * SIN(V.aD1 / V.d2r)',
            bD1: '=(ATAN2(V.td11,V.td12) * V.d2r)',
            ctd1: '=V.rh * COS(V.bD1 / V.d2r)',
            std1: '=V.rw * SIN(V.bD1 / V.d2r)',
            md1: '=SQRT(V.ctd1*V.ctd1 + V.std1*V.std1)',
            nd1: '=V.rw * V.rh / V.md1',
            dxd1: '=V.nd1 * COS(V.bD1 / V.d2r)',
            dyd1: '=V.nd1 * SIN(V.bD1 / V.d2r)',
            xD1: '=V.hc + V.dxd1',
            yD1: '=V.vc + V.dyd1',
            xAD1: '=V.xA1 - V.xD1',
            yAD1: '=V.yA1 - V.yD1',
            lAD1: '=SQRT(V.xAD1*V.xAD1 + V.yAD1*V.yAD1)',
            _a1: '=(ATAN2(V.yAD1,V.xAD1) * V.d2r)',
            dxF1: '=V.lFD * SIN(V._a1 / V.d2r)',
            dyF1: '=V.lFD * COS(V._a1 / V.d2r)',
            xF1: '=V.xD1 + V.dxF1',
            yF1: '=V.yD1 + V.dyF1',
            xE1: '=V.xA1 - V.dxF1',
            yE1: '=V.yA1 - V.dyF1',
            yC1t: '=V.th * SIN(V._a1 / V.d2r)',
            xC1t: '=V.th * COS(V._a1 / V.d2r)',
            yC1: '=V.yF1 + V.yC1t',
            xC1: '=V.xF1 - V.xC1t',
            yB1: '=V.yE1 + V.yC1t',
            xB1: '=V.xE1 - V.xC1t',
            _3cd4: D,
            aD6: '=V._3cd4 + V.ha',
            td61: '=V.rw * COS(V.aD6 / V.d2r)',
            td62: '=V.rh * SIN(V.aD6 / V.d2r)',
            bD6: '=(ATAN2(V.td61,V.td62) * V.d2r)',
            ctd6: '=V.rh * COS(V.bD6 / V.d2r)',
            std6: '=V.rw * SIN(V.bD6 / V.d2r)',
            md6: '=SQRT(V.ctd6*V.ctd6 + V.std6*V.std6)',
            nd6: '=V.rw * V.rh / V.md6',
            dxd6: '=V.nd6 * COS(V.bD6 / V.d2r)',
            dyd6: '=V.nd6 * SIN(V.bD6 / V.d2r)',
            xD6: '=V.hc + V.dxd6',
            yD6: '=V.vc + V.dyd6',
            xA6: '=V.hc - V.dxd6',
            xF6: '=V.xD6 - V.lFD',
            xE6: '=V.xA6 + V.lFD',
            yC6: '=V.yD6 - V.th',
            swAng1: '=V.bA1 - V.bD6',
            aA2: '=1800000 - V.ha',
            aD2: '=1800000 + V.ha',
            ta21: '=V.rw * COS(V.aA2 / V.d2r)',
            ta22: '=V.rh * SIN(V.aA2 / V.d2r)',
            bA2: '=(ATAN2(V.ta21,V.ta22) * V.d2r)',
            yA2: '=height - V.yD1',
            td21: '=V.rw * COS(V.aD2 / V.d2r)',
            td22: '=V.rh * SIN(V.aD2 / V.d2r)',
            bD2: '=(ATAN2(V.td21,V.td22) * V.d2r)',
            yD2: '=height - V.yA1',
            yC2: '=height - V.yB1',
            yB2: '=height - V.yC1',
            xB2: '=V.xC1',
            swAng2: '=V.bA2 - V.bD1',
            cd4: C,
            aD3: '=V.cd4 + V.ha',
            td31: '=V.rw * COS(V.aD3 / V.d2r)',
            td32: '=V.rh * SIN(V.aD3 / V.d2r)',
            bD3: '=(ATAN2(V.td31,V.td32) * V.d2r)',
            yD3: '=height - V.yD6',
            yB3: '=height - V.yC6',
            aD4: '=9000000 + V.ha',
            td41: '=V.rw * COS(V.aD4 / V.d2r)',
            td42: '=V.rh * SIN(V.aD4 / V.d2r)',
            bD4: '=(ATAN2(V.td41,V.td42) * V.d2r)',
            xD4: '=width - V.xD1',
            xC4: '=width - V.xC1',
            xB4: '=width - V.xB1',
            aD5: '=12600000 + V.ha',
            td51: '=V.rw * COS(V.aD5 / V.d2r)',
            td52: '=V.rh * SIN(V.aD5 / V.d2r)',
            bD5: '=(ATAN2(V.td51,V.td52) * V.d2r)',
            xD5: '=width - V.xA1',
            xC5: '=width - V.xB1',
            xB5: '=width - V.xC1',
            xCxn1: '=(V.xB1 + V.xC1) / 2',
            yCxn1: '=(V.yB1 + V.yC1) / 2',
            b: h,
            yCxn2: '=height - V.yCxn1',
            r: w,
            xCxn4: '=(width) / V.xCxn1',
            cx1: '=C(V.rw,V.xD1,A(V.rw,V.rh,V.bD1),true)',
            cy1: '=C(V.rh,V.yD1,A(V.rw,V.rh,V.bD1))',
            cx2: '=C(V.rw,V.xA1,A(V.rw,V.rh,V.bD2),true)',
            cy2: '=C(V.rh,V.yD2,A(V.rw,V.rh,V.bD2))',
            cx3: '=C(V.rw,V.xA6,A(V.rw,V.rh,V.bD3),true)',
            cy3: '=C(V.rh,V.yD3,A(V.rw,V.rh,V.bD3))',
            cx4: '=C(V.rw,V.xD4,A(V.rw,V.rh,V.bD4),true)',
            cy4: '=C(V.rh,V.yA2,A(V.rw,V.rh,V.bD4))',
            cx5: '=C(V.rw,V.xD5,A(V.rw,V.rh,V.bD5),true)',
            cy5: '=C(V.rh,V.yA1,A(V.rw,V.rh,V.bD5))',
            cx6: '=C(V.rw,V.xD6,A(V.rw,V.rh,V.bD6),true)',
            cy6: '=C(V.rh,V.yD6,A(V.rw,V.rh,V.bD6))',
        },
        adjustInfo: [['adj1', 15000], ['adj2', 3526]],
        connectionPoints: [{
            x: '=V.xCxn1',
            y: '=V.yCxn1',
        }, {
            x: '=V.xCxn1',
            y: '=V.yCxn2',
        }, {
            x: a,
            y: '=V.yB3',
        }, {
            x: '=V.xCxn4',
            y: '=V.yCxn2',
        }, {
            x: '=V.xCxn4',
            y: '=V.yCxn1',
        }, {
            x: a,
            y: '=V.yC6',
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj1',
            minY: 0,
            maxY: 20000,
            position: {
                x: 'xD6',
                y: 'yD6',
            },
            point: ['=V.xD6', '=V.yD6'],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: 0,
            maxX: 5358,
            position: {
                x: 'xA6',
                y: 'yD6',
            },
            point: ['=V.xA6', '=V.yD6'],
        },
        ],
        path: [[['M', '=V.xA1', '=V.yA1'], ['L', '=V.xB1', '=V.yB1'], ['L', '=V.xC1', '=V.yC1'], ['L', '=V.xD1', '=V.yD1'], ['E', '=V.cx1', '=V.cy1', '=V.rw', '=V.rh', 0, '=A(V.rw,V.rh,V.bD1)', '=A(V.rw,V.rh,(V.bD1 + V.swAng2))', '=IF(V.swAng2 > 0, FALSE, TRUE)'], ['L', '=V.xC1', '=V.yB2'], ['L', '=V.xB1', '=V.yC2'], ['L', '=V.xA1', '=V.yD2'], ['E', '=V.cx2', '=V.cy2', '=V.rw', '=V.rh', 0, '=A(V.rw,V.rh,V.bD2)', '=A(V.rw,V.rh,(V.bD2 + V.swAng1))', '=IF(V.swAng1 > 0, FALSE, TRUE)'], ['L', '=V.xF6', '=V.yB3'], ['L', '=V.xE6', '=V.yB3'], ['L', '=V.xA6', '=V.yD3'], ['E', '=V.cx3', '=V.cy3', '=V.rw', '=V.rh', 0, '=A(V.rw,V.rh,V.bD3)', '=A(V.rw,V.rh,(V.bD3 + V.swAng1))', '=IF(V.swAng1 > 0, FALSE, TRUE)'], ['L', '=V.xB4', '=V.yC2'], ['L', '=V.xC4', '=V.yB2'], ['L', '=V.xD4', '=V.yA2'], ['E', '=V.cx4', '=V.cy4', '=V.rw', '=V.rh', 0, '=A(V.rw,V.rh,V.bD4)', '=A(V.rw,V.rh,(V.bD4 + V.swAng2))', '=IF(V.swAng2 > 0, FALSE, TRUE)'], ['L', '=V.xB5', '=V.yC1'], ['L', '=V.xC5', '=V.yB1'], ['L', '=V.xD5', '=V.yA1'], ['E', '=V.cx5', '=V.cy5', '=V.rw', '=V.rh', 0, '=A(V.rw,V.rh,V.bD5)', '=A(V.rw,V.rh,(V.bD5 + V.swAng1))', '=IF(V.swAng1 > 0, FALSE, TRUE)'], ['L', '=V.xE6', '=V.yC6'], ['L', '=V.xF6', '=V.yC6'], ['L', '=V.xD6', '=V.yD6'], ['E', '=V.cx6', '=V.cy6', '=V.rw', '=V.rh', 0, '=A(V.rw,V.rh,V.bD6)', '=A(V.rw,V.rh,(V.bD6 + V.swAng1))', '=IF(V.swAng1 > 0, FALSE, TRUE)'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.xD5',
            top: '=V.yA1',
            right: '=V.xA1',
            bottom: '=V.yD2',
        },
    },
    gear9: {
        variables: {
            adj1: 10000,
            adj2: 1763,
            a1: '=MIN(MAX(0, V.adj1), 20000)',
            a2: '=MIN(MAX(0, V.adj2), 2679)',
            ss: s,
            th: '=V.ss * V.a1 / 100000',
            lFD: '=V.ss * V.a2 / 100000',
            th2: '=V.th / 2',
            l2: '=V.lFD / 2',
            l3: '=V.th2 + V.l2',
            hd2: F,
            rh: '=V.hd2 - V.th',
            wd2: E,
            rw: '=V.wd2 - V.th',
            dr: '=V.rw - V.rh',
            maxr: '=IF(V.dr > 0, V.rh, V.rw)',
            d2r: A,
            ha: '=(ATAN2(V.maxr,V.l3) * V.d2r)',
            aA1: '=18600000 - V.ha',
            aD1: '=18600000 + V.ha',
            ta11: '=V.rw * COS(V.aA1 / V.d2r)',
            ta12: '=V.rh * SIN(V.aA1 / V.d2r)',
            bA1: '=(ATAN2(V.ta11,V.ta12) * V.d2r)',
            cta1: '=V.rh * COS(V.bA1 / V.d2r)',
            sta1: '=V.rw * SIN(V.bA1 / V.d2r)',
            ma1: '=SQRT(V.cta1*V.cta1 + V.sta1*V.sta1)',
            na1: '=V.rw * V.rh / V.ma1',
            dxa1: '=V.na1 * COS(V.bA1 / V.d2r)',
            dya1: '=V.na1 * SIN(V.bA1 / V.d2r)',
            hc: E,
            xA1: '=V.hc + V.dxa1',
            vc: F,
            yA1: '=V.vc + V.dya1',
            td11: '=V.rw * COS(V.aD1 / V.d2r)',
            td12: '=V.rh * SIN(V.aD1 / V.d2r)',
            bD1: '=(ATAN2(V.td11,V.td12) * V.d2r)',
            ctd1: '=V.rh * COS(V.bD1 / V.d2r)',
            std1: '=V.rw * SIN(V.bD1 / V.d2r)',
            md1: '=SQRT(V.ctd1*V.ctd1 + V.std1*V.std1)',
            nd1: '=V.rw * V.rh / V.md1',
            dxd1: '=V.nd1 * COS(V.bD1 / V.d2r)',
            dyd1: '=V.nd1 * SIN(V.bD1 / V.d2r)',
            xD1: '=V.hc + V.dxd1',
            yD1: '=V.vc + V.dyd1',
            xAD1: '=V.xA1 - V.xD1',
            yAD1: '=V.yA1 - V.yD1',
            lAD1: '=SQRT(V.xAD1*V.xAD1 + V.yAD1*V.yAD1)',
            _a1: '=(ATAN2(V.yAD1,V.xAD1) * V.d2r)',
            dxF1: '=V.lFD * SIN(V._a1 / V.d2r)',
            dyF1: '=V.lFD * COS(V._a1 / V.d2r)',
            xF1: '=V.xD1 + V.dxF1',
            yF1: '=V.yD1 + V.dyF1',
            xE1: '=V.xA1 - V.dxF1',
            yE1: '=V.yA1 - V.dyF1',
            yC1t: '=V.th * SIN(V._a1 / V.d2r)',
            xC1t: '=V.th * COS(V._a1 / V.d2r)',
            yC1: '=V.yF1 + V.yC1t',
            xC1: '=V.xF1 - V.xC1t',
            yB1: '=V.yE1 + V.yC1t',
            xB1: '=V.xE1 - V.xC1t',
            aA2: '=21000000 - V.ha',
            aD2: '=21000000 + V.ha',
            ta21: '=V.rw * COS(V.aA2 / V.d2r)',
            ta22: '=V.rh * SIN(V.aA2 / V.d2r)',
            bA2: '=(ATAN2(V.ta21,V.ta22) * V.d2r)',
            cta2: '=V.rh * COS(V.bA2 / V.d2r)',
            sta2: '=V.rw * SIN(V.bA2 / V.d2r)',
            ma2: '=SQRT(V.cta2*V.cta2 + V.sta2*V.sta2)',
            na2: '=V.rw * V.rh / V.ma2',
            dxa2: '=V.na2 * COS(V.bA2 / V.d2r)',
            dya2: '=V.na2 * SIN(V.bA2 / V.d2r)',
            xA2: '=V.hc + V.dxa2',
            yA2: '=V.vc + V.dya2',
            td21: '=V.rw * COS(V.aD2 / V.d2r)',
            td22: '=V.rh * SIN(V.aD2 / V.d2r)',
            bD2: '=(ATAN2(V.td21,V.td22) * V.d2r)',
            ctd2: '=V.rh * COS(V.bD2 / V.d2r)',
            std2: '=V.rw * SIN(V.bD2 / V.d2r)',
            md2: '=SQRT(V.ctd2*V.ctd2 + V.std2*V.std2)',
            nd2: '=V.rw * V.rh / V.md2',
            dxd2: '=V.nd2 * COS(V.bD2 / V.d2r)',
            dyd2: '=V.nd2 * SIN(V.bD2 / V.d2r)',
            xD2: '=V.hc + V.dxd2',
            yD2: '=V.vc + V.dyd2',
            xAD2: '=V.xA2 - V.xD2',
            yAD2: '=V.yA2 - V.yD2',
            lAD2: '=SQRT(V.xAD2*V.xAD2 + V.yAD2*V.yAD2)',
            _a2: '=(ATAN2(V.yAD2,V.xAD2) * V.d2r)',
            dxF2: '=V.lFD * SIN(V._a2 / V.d2r)',
            dyF2: '=V.lFD * COS(V._a2 / V.d2r)',
            xF2: '=V.xD2 + V.dxF2',
            yF2: '=V.yD2 + V.dyF2',
            xE2: '=V.xA2 - V.dxF2',
            yE2: '=V.yA2 - V.dyF2',
            yC2t: '=V.th * SIN(V._a2 / V.d2r)',
            xC2t: '=V.th * COS(V._a2 / V.d2r)',
            yC2: '=V.yF2 + V.yC2t',
            xC2: '=V.xF2 - V.xC2t',
            yB2: '=V.yE2 + V.yC2t',
            xB2: '=V.xE2 - V.xC2t',
            swAng1: '=V.bA2 - V.bD1',
            aA3: '=1800000 - V.ha',
            aD3: '=1800000 + V.ha',
            ta31: '=V.rw * COS(V.aA3 / V.d2r)',
            ta32: '=V.rh * SIN(V.aA3 / V.d2r)',
            bA3: '=(ATAN2(V.ta31,V.ta32) * V.d2r)',
            cta3: '=V.rh * COS(V.bA3 / V.d2r)',
            sta3: '=V.rw * SIN(V.bA3 / V.d2r)',
            ma3: '=SQRT(V.cta3*V.cta3 + V.sta3*V.sta3)',
            na3: '=V.rw * V.rh / V.ma3',
            dxa3: '=V.na3 * COS(V.bA3 / V.d2r)',
            dya3: '=V.na3 * SIN(V.bA3 / V.d2r)',
            xA3: '=V.hc + V.dxa3',
            yA3: '=V.vc + V.dya3',
            td31: '=V.rw * COS(V.aD3 / V.d2r)',
            td32: '=V.rh * SIN(V.aD3 / V.d2r)',
            bD3: '=(ATAN2(V.td31,V.td32) * V.d2r)',
            ctd3: '=V.rh * COS(V.bD3 / V.d2r)',
            std3: '=V.rw * SIN(V.bD3 / V.d2r)',
            md3: '=SQRT(V.ctd3*V.ctd3 + V.std3*V.std3)',
            nd3: '=V.rw * V.rh / V.md3',
            dxd3: '=V.nd3 * COS(V.bD3 / V.d2r)',
            dyd3: '=V.nd3 * SIN(V.bD3 / V.d2r)',
            xD3: '=V.hc + V.dxd3',
            yD3: '=V.vc + V.dyd3',
            xAD3: '=V.xA3 - V.xD3',
            yAD3: '=V.yA3 - V.yD3',
            lAD3: '=SQRT(V.xAD3*V.xAD3 + V.yAD3*V.yAD3)',
            a3: '=(ATAN2(V.yAD3,V.xAD3) * V.d2r)',
            dxF3: '=V.lFD * SIN(V.a3 / V.d2r)',
            dyF3: '=V.lFD * COS(V.a3 / V.d2r)',
            xF3: '=V.xD3 + V.dxF3',
            yF3: '=V.yD3 + V.dyF3',
            xE3: '=V.xA3 - V.dxF3',
            yE3: '=V.yA3 - V.dyF3',
            yC3t: '=V.th * SIN(V.a3 / V.d2r)',
            xC3t: '=V.th * COS(V.a3 / V.d2r)',
            yC3: '=V.yF3 + V.yC3t',
            xC3: '=V.xF3 - V.xC3t',
            yB3: '=V.yE3 + V.yC3t',
            xB3: '=V.xE3 - V.xC3t',
            swAng2: '=V.bA3 - V.bD2',
            aA4: '=4200000 - V.ha',
            aD4: '=4200000 + V.ha',
            ta41: '=V.rw * COS(V.aA4 / V.d2r)',
            ta42: '=V.rh * SIN(V.aA4 / V.d2r)',
            bA4: '=(ATAN2(V.ta41,V.ta42) * V.d2r)',
            cta4: '=V.rh * COS(V.bA4 / V.d2r)',
            sta4: '=V.rw * SIN(V.bA4 / V.d2r)',
            ma4: '=SQRT(V.cta4*V.cta4 + V.sta4*V.sta4)',
            na4: '=V.rw * V.rh / V.ma4',
            dxa4: '=V.na4 * COS(V.bA4 / V.d2r)',
            dya4: '=V.na4 * SIN(V.bA4 / V.d2r)',
            xA4: '=V.hc + V.dxa4',
            yA4: '=V.vc + V.dya4',
            td41: '=V.rw * COS(V.aD4 / V.d2r)',
            td42: '=V.rh * SIN(V.aD4 / V.d2r)',
            bD4: '=(ATAN2(V.td41,V.td42) * V.d2r)',
            ctd4: '=V.rh * COS(V.bD4 / V.d2r)',
            std4: '=V.rw * SIN(V.bD4 / V.d2r)',
            md4: '=SQRT(V.ctd4*V.ctd4 + V.std4*V.std4)',
            nd4: '=V.rw * V.rh / V.md4',
            dxd4: '=V.nd4 * COS(V.bD4 / V.d2r)',
            dyd4: '=V.nd4 * SIN(V.bD4 / V.d2r)',
            xD4: '=V.hc + V.dxd4',
            yD4: '=V.vc + V.dyd4',
            xAD4: '=V.xA4 - V.xD4',
            yAD4: '=V.yA4 - V.yD4',
            lAD4: '=SQRT(V.xAD4*V.xAD4 + V.yAD4*V.yAD4)',
            a4: '=(ATAN2(V.yAD4,V.xAD4) * V.d2r)',
            dxF4: '=V.lFD * SIN(V.a4 / V.d2r)',
            dyF4: '=V.lFD * COS(V.a4 / V.d2r)',
            xF4: '=V.xD4 + V.dxF4',
            yF4: '=V.yD4 + V.dyF4',
            xE4: '=V.xA4 - V.dxF4',
            yE4: '=V.yA4 - V.dyF4',
            yC4t: '=V.th * SIN(V.a4 / V.d2r)',
            xC4t: '=V.th * COS(V.a4 / V.d2r)',
            yC4: '=V.yF4 + V.yC4t',
            xC4: '=V.xF4 - V.xC4t',
            yB4: '=V.yE4 + V.yC4t',
            xB4: '=V.xE4 - V.xC4t',
            swAng3: '=V.bA4 - V.bD3',
            aA5: '=6600000 - V.ha',
            aD5: '=6600000 + V.ha',
            ta51: '=V.rw * COS(V.aA5 / V.d2r)',
            ta52: '=V.rh * SIN(V.aA5 / V.d2r)',
            bA5: '=(ATAN2(V.ta51,V.ta52) * V.d2r)',
            td51: '=V.rw * COS(V.aD5 / V.d2r)',
            td52: '=V.rh * SIN(V.aD5 / V.d2r)',
            bD5: '=(ATAN2(V.td51,V.td52) * V.d2r)',
            xD5: '=width - V.xA4',
            xC5: '=width - V.xB4',
            xB5: '=width - V.xC4',
            swAng4: '=V.bA5 - V.bD4',
            aD6: '=9000000 + V.ha',
            td61: '=V.rw * COS(V.aD6 / V.d2r)',
            td62: '=V.rh * SIN(V.aD6 / V.d2r)',
            bD6: '=(ATAN2(V.td61,V.td62) * V.d2r)',
            xD6: '=width - V.xA3',
            xC6: '=width - V.xB3',
            xB6: '=width - V.xC3',
            aD7: '=11400000 + V.ha',
            td71: '=V.rw * COS(V.aD7 / V.d2r)',
            td72: '=V.rh * SIN(V.aD7 / V.d2r)',
            bD7: '=(ATAN2(V.td71,V.td72) * V.d2r)',
            xD7: '=width - V.xA2',
            xC7: '=width - V.xB2',
            xB7: '=width - V.xC2',
            aD8: '=13800000 + V.ha',
            td81: '=V.rw * COS(V.aD8 / V.d2r)',
            td82: '=V.rh * SIN(V.aD8 / V.d2r)',
            bD8: '=(ATAN2(V.td81,V.td82) * V.d2r)',
            xA8: '=width - V.xD1',
            xD8: '=width - V.xA1',
            xC8: '=width - V.xB1',
            xB8: '=width - V.xC1',
            _3cd4: D,
            aA9: '=V._3cd4 - V.ha',
            aD9: '=V._3cd4 + V.ha',
            td91: '=V.rw * COS(V.aD9 / V.d2r)',
            td92: '=V.rh * SIN(V.aD9 / V.d2r)',
            bD9: '=(ATAN2(V.td91,V.td92) * V.d2r)',
            ctd9: '=V.rh * COS(V.bD9 / V.d2r)',
            std9: '=V.rw * SIN(V.bD9 / V.d2r)',
            md9: '=SQRT(V.ctd9*V.ctd9 + V.std9*V.std9)',
            nd9: '=V.rw * V.rh / V.md9',
            dxd9: '=V.nd9 * COS(V.bD9 / V.d2r)',
            dyd9: '=V.nd9 * SIN(V.bD9 / V.d2r)',
            xD9: '=V.hc + V.dxd9',
            yD9: '=V.vc + V.dyd9',
            ta91: '=V.rw * COS(V.aA9 / V.d2r)',
            ta92: '=V.rh * SIN(V.aA9 / V.d2r)',
            bA9: '=(ATAN2(V.ta91,V.ta92) * V.d2r)',
            xA9: '=V.hc - V.dxd9',
            xF9: '=V.xD9 - V.lFD',
            xE9: '=V.xA9 + V.lFD',
            yC9: '=V.yD9 - V.th',
            swAng5: '=V.bA9 - V.bD8',
            xCxn1: '=(V.xB1 + V.xC1) / 2',
            yCxn1: '=(V.yB1 + V.yC1) / 2',
            xCxn2: '=(V.xB2 + V.xC2) / 2',
            yCxn2: '=(V.yB2 + V.yC2) / 2',
            xCxn3: '=(V.xB3 + V.xC3) / 2',
            yCxn3: '=(V.yB3 + V.yC3) / 2',
            xCxn4: '=(V.xB4 + V.xC4) / 2',
            yCxn4: '=(V.yB4 + V.yC4) / 2',
            r: w,
            xCxn5: '=(width) / V.xCxn4',
            xCxn6: '=(width) / V.xCxn3',
            xCxn7: '=(width) / V.xCxn2',
            xCxn8: '=(width) / V.xCxn1',
            cx1: '=C(V.rw,V.xD1,A(V.rw,V.rh,V.bD1),true)',
            cy1: '=C(V.rh,V.yD1,A(V.rw,V.rh,V.bD1))',
            cx2: '=C(V.rw,V.xD2,A(V.rw,V.rh,V.bD2),true)',
            cy2: '=C(V.rh,V.yD2,A(V.rw,V.rh,V.bD2))',
            cx3: '=C(V.rw,V.xD3,A(V.rw,V.rh,V.bD3),true)',
            cy3: '=C(V.rh,V.yD3,A(V.rw,V.rh,V.bD3))',
            cx4: '=C(V.rw,V.xD4,A(V.rw,V.rh,V.bD4),true)',
            cy4: '=C(V.rh,V.yD4,A(V.rw,V.rh,V.bD4))',
            cx5: '=C(V.rw,V.xD5,A(V.rw,V.rh,V.bD5),true)',
            cy5: '=C(V.rh,V.yA4,A(V.rw,V.rh,V.bD5))',
            cx6: '=C(V.rw,V.xD6,A(V.rw,V.rh,V.bD6),true)',
            cy6: '=C(V.rh,V.yA3,A(V.rw,V.rh,V.bD6))',
            cx7: '=C(V.rw,V.xD7,A(V.rw,V.rh,V.bD7),true)',
            cy7: '=C(V.rh,V.yA2,A(V.rw,V.rh,V.bD7))',
            cx8: '=C(V.rw,V.xD8,A(V.rw,V.rh,V.bD8),true)',
            cy8: '=C(V.rh,V.yA1,A(V.rw,V.rh,V.bD8))',
            cx9: '=C(V.rw,V.xD9,A(V.rw,V.rh,V.bD9),true)',
            cy9: '=C(V.rh,V.yD9,A(V.rw,V.rh,V.bD9))',
        },
        adjustInfo: [['adj1', 10000], ['adj2', 1763]],
        connectionPoints: [{
            x: '=V.xCxn1',
            y: '=V.yCxn1',
        }, {
            x: '=V.xCxn2',
            y: '=V.yCxn2',
        }, {
            x: '=V.xCxn3',
            y: '=V.yCxn3',
        }, {
            x: '=V.xCxn4',
            y: '=V.yCxn4',
        }, {
            x: '=V.xCxn5',
            y: '=V.yCxn4',
        }, {
            x: '=V.xCxn6',
            y: '=V.yCxn3',
        }, {
            x: '=V.xCxn7',
            y: '=V.yCxn2',
        }, {
            x: '=V.xCxn8',
            y: '=V.yCxn1',
        }, {
            x: a,
            y: '=V.yC9',
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj1',
            minY: 0,
            maxY: 20000,
            position: {
                x: 'xD9',
                y: 'yD9',
            },
            point: ['=V.xD9', '=V.yD9'],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: 0,
            maxX: 2679,
            position: {
                x: 'xA9',
                y: 'yD9',
            },
            point: ['=V.xA9', '=V.yD9'],
        },
        ],
        path: [[['M', '=V.xA1', '=V.yA1'], ['L', '=V.xB1', '=V.yB1'], ['L', '=V.xC1', '=V.yC1'], ['L', '=V.xD1', '=V.yD1'], ['E', '=V.cx1', '=V.cy1', '=V.rw', '=V.rh', 0, '=A(V.rw,V.rh,V.bD1)', '=A(V.rw,V.rh,(V.bD1 + V.swAng1))', '=IF(V.swAng1 > 0, FALSE, TRUE)'], ['L', '=V.xB2', '=V.yB2'], ['L', '=V.xC2', '=V.yC2'], ['L', '=V.xD2', '=V.yD2'], ['E', '=V.cx2', '=V.cy2', '=V.rw', '=V.rh', 0, '=A(V.rw,V.rh,V.bD2)', '=A(V.rw,V.rh,(V.bD2 + V.swAng2))', '=IF(V.swAng2 > 0, FALSE, TRUE)'], ['L', '=V.xB3', '=V.yB3'], ['L', '=V.xC3', '=V.yC3'], ['L', '=V.xD3', '=V.yD3'], ['E', '=V.cx3', '=V.cy3', '=V.rw', '=V.rh', 0, '=A(V.rw,V.rh,V.bD3)', '=A(V.rw,V.rh,(V.bD3 + V.swAng3))', '=IF(V.swAng3 > 0, FALSE, TRUE)'], ['L', '=V.xB4', '=V.yB4'], ['L', '=V.xC4', '=V.yC4'], ['L', '=V.xD4', '=V.yD4'], ['E', '=V.cx4', '=V.cy4', '=V.rw', '=V.rh', 0, '=A(V.rw,V.rh,V.bD4)', '=A(V.rw,V.rh,(V.bD4 + V.swAng4))', '=IF(V.swAng4 > 0, FALSE, TRUE)'], ['L', '=V.xB5', '=V.yC4'], ['L', '=V.xC5', '=V.yB4'], ['L', '=V.xD5', '=V.yA4'], ['E', '=V.cx5', '=V.cy5', '=V.rw', '=V.rh', 0, '=A(V.rw,V.rh,V.bD5)', '=A(V.rw,V.rh,(V.bD5 + V.swAng3))', '=IF(V.swAng3 > 0, FALSE, TRUE)'], ['L', '=V.xB6', '=V.yC3'], ['L', '=V.xC6', '=V.yB3'], ['L', '=V.xD6', '=V.yA3'], ['E', '=V.cx6', '=V.cy6', '=V.rw', '=V.rh', 0, '=A(V.rw,V.rh,V.bD6)', '=A(V.rw,V.rh,(V.bD6 + V.swAng2))', '=IF(V.swAng2 > 0, FALSE, TRUE)'], ['L', '=V.xB7', '=V.yC2'], ['L', '=V.xC7', '=V.yB2'], ['L', '=V.xD7', '=V.yA2'], ['E', '=V.cx7', '=V.cy7', '=V.rw', '=V.rh', 0, '=A(V.rw,V.rh,V.bD7)', '=A(V.rw,V.rh,(V.bD7 + V.swAng1))', '=IF(V.swAng1 > 0, FALSE, TRUE)'], ['L', '=V.xB8', '=V.yC1'], ['L', '=V.xC8', '=V.yB1'], ['L', '=V.xD8', '=V.yA1'], ['E', '=V.cx8', '=V.cy8', '=V.rw', '=V.rh', 0, '=A(V.rw,V.rh,V.bD8)', '=A(V.rw,V.rh,(V.bD8 + V.swAng5))', '=IF(V.swAng5 > 0, FALSE, TRUE)'], ['L', '=V.xE9', '=V.yC9'], ['L', '=V.xF9', '=V.yC9'], ['L', '=V.xD9', '=V.yD9'], ['E', '=V.cx9', '=V.cy9', '=V.rw', '=V.rh', 0, '=A(V.rw,V.rh,V.bD9)', '=A(V.rw,V.rh,(V.bD9 + V.swAng5))', '=IF(V.swAng5 > 0, FALSE, TRUE)'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.xA8',
            top: '=V.yD1',
            right: '=V.xD1',
            bottom: '=V.yD3',
        },
    },
    funnel: {
        variables: {
            ss: s,
            d: '=V.ss / 20',
            wd2: E,
            rw2: '=V.wd2 - V.d',
            hd4: '=height/4',
            rh2: '=V.hd4 - V.d',
            d2r: A,
            t1: '=V.wd2 * COS(480000 / V.d2r)',
            t2: '=V.hd4 * SIN(480000 / V.d2r)',
            da: '=(ATAN2(V.t1,V.t2) * V.d2r)',
            '2da': '=V.da * 2',
            cd2: B,
            stAng1: '=V.cd2 - V.da',
            swAng1: '=V.cd2 + V.2da',
            swAng3: '=V.cd2 - V.2da',
            rw3: '=V.wd2 / 4',
            rh3: '=V.hd4 / 4',
            ct1: '=V.hd4 * COS(V.stAng1 / V.d2r)',
            st1: '=V.wd2 * SIN(V.stAng1 / V.d2r)',
            m1: '=SQRT(V.ct1*V.ct1 + V.st1*V.st1)',
            n1: '=V.wd2 * V.hd4 / V.m1',
            dx1: '=V.n1 * COS(V.stAng1 / V.d2r)',
            dy1: '=V.n1 * SIN(V.stAng1 / V.d2r)',
            hc: E,
            x1: '=V.hc + V.dx1',
            y1: '=V.hd4 + V.dy1',
            ct3: '=V.rh3 * COS(V.da / V.d2r)',
            st3: '=V.rw3 * SIN(V.da / V.d2r)',
            m3: '=SQRT(V.ct3*V.ct3 + V.st3*V.st3)',
            n3: '=V.rw3 * V.rh3 / V.m3',
            dx3: '=V.n3 * COS(V.da / V.d2r)',
            dy3: '=V.n3 * SIN(V.da / V.d2r)',
            x3: '=V.hc + V.dx3',
            b: h,
            vc3: '=height - V.rh3',
            y2: '=V.vc3 + V.dy3',
            x2: '=V.wd2 - V.rw2',
            cd: '=V.cd2 * 2',
            cx1: '=C(V.wd2,V.x1,A(V.wd2,V.hd4,V.stAng1),true)',
            cy1: '=C(V.hd4,V.y1,A(V.wd2,V.hd4,V.stAng1))',
            cx2: '=C(V.rw3,V.x3,A(V.rw3,V.rh3,V.da),true)',
            cy2: '=C(V.rh3,V.y2,A(V.rw3,V.rh3,V.da))',
            cx3: '=C(V.rw2,V.x2,A(V.rw2,V.rh2,V.cd2),true)',
            cy3: '=C(V.rh2,V.hd4,A(V.rw2,V.rh2,V.cd2))',
        },
        path: [[['M', c, e], ['E', '=V.cx1', '=V.cy1', '=V.wd2', '=V.hd4', 0, '=A(V.wd2,V.hd4,V.stAng1)', '=A(V.wd2,V.hd4,(V.stAng1 + V.swAng1))', '=IF(V.swAng1 > 0, FALSE, TRUE)'], ['L', '=V.x3', f], ['E', '=V.cx2', '=V.cy2', '=V.rw3', '=V.rh3', 0, '=A(V.rw3,V.rh3,V.da)', '=A(V.rw3,V.rh3,(V.da + V.swAng3))', '=IF(V.swAng3 > 0, FALSE, TRUE)'], ['Z'], ['M', d, '=V.hd4'], ['E', '=V.cx3', '=V.cy3', '=V.rw2', '=V.rh2', 0, '=A(V.rw2,V.rh2,V.cd2)', '=A(V.rw2,V.rh2,(V.cd2 + -21600000))', '=IF(-21600000 > 0, FALSE, TRUE)'], ['Z'], {},
        ]],
    },
    pieWedge: {
        variables: {
            d2r: A,
            g1: '=width * COS(13500000 / V.d2r)',
            g2: '=height * SIN(13500000 / V.d2r)',
            r: w,
            x1: '=width + V.g1',
            b: h,
            y1: '=height + V.g2',
            vc: F,
            hc: E,
            l: 0,
            cd2: B,
            cd4: C,
            cx1: '=C(width,V.l,A(width,height,V.cd2),true)',
            cy1: '=C(height,V.b,A(width,height,V.cd2))',
        },
        connectionPoints: [{
            x: w,
            y: b,
        }, {
            x: a,
            y: h,
        },
        ],
        path: [[['M', 0, h], ['E', '=V.cx1', '=V.cy1', w, h, 0, '=A(width,height,V.cd2)', '=A(width,height,(V.cd2 + V.cd4))', '=IF(V.cd4 > 0, FALSE, TRUE)'], ['L', w, h], ['Z'], {},
        ]],
        textRect: {
            left: c,
            top: e,
            right: w,
            bottom: h,
        },
    },
    leftCircularArrow: {
        variables: {
            adj1: 12500,
            adj2: -1142319,
            adj3: 1142319,
            adj4: B,
            adj5: 12500,
            a5: '=MIN(MAX(0, V.adj5), 25000)',
            maxAdj1: '=V.a5 * 2',
            a1: '=MIN(MAX(0, V.adj1), V.maxAdj1)',
            enAng: '=MIN(MAX(1, V.adj3), 21599999)',
            stAng: '=MIN(MAX(0, V.adj4), 21599999)',
            ss: s,
            th: '=V.ss * V.a1 / 100000',
            thh: '=V.ss * V.a5 / 100000',
            th2: '=V.th / 2',
            wd2: E,
            rw1: '=V.wd2 + V.th2 - V.thh',
            hd2: F,
            rh1: '=V.hd2 + V.th2 - V.thh',
            rw2: '=V.rw1 - V.th',
            rh2: '=V.rh1 - V.th',
            rw3: '=V.rw2 + V.th2',
            rh3: '=V.rh2 + V.th2',
            d2r: A,
            wtH: '=V.rw3 * SIN(V.enAng / V.d2r)',
            htH: '=V.rh3 * COS(V.enAng / V.d2r)',
            dxH: '=V.rw3 * COS(ATAN2(V.htH,V.wtH))',
            dyH: '=V.rh3 * SIN(ATAN2(V.htH,V.wtH))',
            hc: E,
            xH: '=V.hc + V.dxH',
            vc: F,
            yH: '=V.vc + V.dyH',
            rI: '=MIN(V.rw2, V.rh2)',
            u1: '=V.dxH * V.dxH',
            u2: '=V.dyH * V.dyH',
            u3: '=V.rI * V.rI',
            u4: '=V.u1 - V.u3',
            u5: '=V.u2 - V.u3',
            u6: '=V.u4 * V.u5 / V.u1',
            u7: '=V.u6 / V.u2',
            u8: '=1 - V.u7',
            u9: '=SQRT(V.u8)',
            u10: '=V.u4 / V.dxH',
            u11: '=V.u10 / V.dyH',
            u12: '=(1 + V.u9) / V.u11',
            u13: '=(ATAN2(1,V.u12) * V.d2r)',
            u14: '=V.u13 + 21600000',
            u15: '=IF(V.u13 > 0, V.u13, V.u14)',
            u16: '=V.u15 - V.enAng',
            u17: '=V.u16 + 21600000',
            u18: '=IF(V.u16 > 0, V.u16, V.u17)',
            cd2: B,
            u19: '=V.u18 - V.cd2',
            u20: '=V.u18 - 21600000',
            u21: '=IF(V.u19 > 0, V.u20, V.u18)',
            u22: '=ABS(V.u21)',
            minAng: '=V.u22 * -1',
            u23: '=ABS(V.adj2)',
            a2: '=V.u23 * -1',
            aAng: '=MIN(MAX(V.minAng, V.a2), 0)',
            ptAng: '=V.enAng + V.aAng',
            wtA: '=V.rw3 * SIN(V.ptAng / V.d2r)',
            htA: '=V.rh3 * COS(V.ptAng / V.d2r)',
            dxA: '=V.rw3 * COS(ATAN2(V.htA,V.wtA))',
            dyA: '=V.rh3 * SIN(ATAN2(V.htA,V.wtA))',
            xA: '=V.hc + V.dxA',
            yA: '=V.vc + V.dyA',
            wtE: '=V.rw1 * SIN(V.stAng / V.d2r)',
            htE: '=V.rh1 * COS(V.stAng / V.d2r)',
            dxE: '=V.rw1 * COS(ATAN2(V.htE,V.wtE))',
            dyE: '=V.rh1 * SIN(ATAN2(V.htE,V.wtE))',
            xE: '=V.hc + V.dxE',
            yE: '=V.vc + V.dyE',
            wtD: '=V.rw2 * SIN(V.stAng / V.d2r)',
            htD: '=V.rh2 * COS(V.stAng / V.d2r)',
            dxD: '=V.rw2 * COS(ATAN2(V.htD,V.wtD))',
            dyD: '=V.rh2 * SIN(ATAN2(V.htD,V.wtD))',
            xD: '=V.hc + V.dxD',
            yD: '=V.vc + V.dyD',
            dxG: '=V.thh * COS(V.ptAng / V.d2r)',
            dyG: '=V.thh * SIN(V.ptAng / V.d2r)',
            xG: '=V.xH + V.dxG',
            yG: '=V.yH + V.dyG',
            dxB: '=V.thh * COS(V.ptAng / V.d2r)',
            dyB: '=V.thh * SIN(V.ptAng / V.d2r)',
            xB: '=V.xH - V.dxB',
            yB: '=V.yH - V.dyB',
            sx1: '=V.xB - V.hc',
            sy1: '=V.yB - V.vc',
            sx2: '=V.xG - V.hc',
            sy2: '=V.yG - V.vc',
            rO: '=MIN(V.rw1, V.rh1)',
            x1O: '=V.sx1 * V.rO / V.rw1',
            y1O: '=V.sy1 * V.rO / V.rh1',
            x2O: '=V.sx2 * V.rO / V.rw1',
            y2O: '=V.sy2 * V.rO / V.rh1',
            dxO: '=V.x2O - V.x1O',
            dyO: '=V.y2O - V.y1O',
            dO: '=SQRT(V.dxO*V.dxO + V.dyO*V.dyO)',
            q1: '=V.x1O * V.y2O',
            q2: '=V.x2O * V.y1O',
            DO: '=V.q1 - V.q2',
            q3: '=V.rO * V.rO',
            q4: '=V.dO * V.dO',
            q5: '=V.q3 * V.q4',
            q6: '=V.DO * V.DO',
            q7: '=V.q5 - V.q6',
            q8: '=MAX(V.q7, 0)',
            sdelO: '=SQRT(V.q8)',
            ndyO: '=V.dyO * -1',
            sdyO: '=IF(V.ndyO > 0, -1, 1)',
            q9: '=V.sdyO * V.dxO',
            q10: '=V.q9 * V.sdelO',
            q11: '=V.DO * V.dyO',
            dxF1: '=(V.q11 + V.q10) / V.q4',
            q12: '=V.q11 - V.q10',
            dxF2: '=V.q12 / V.q4',
            adyO: '=ABS(V.dyO)',
            q13: '=V.adyO * V.sdelO',
            q14: '=V.DO * V.dxO / -1',
            dyF1: '=(V.q14 + V.q13) / V.q4',
            q15: '=V.q14 - V.q13',
            dyF2: '=V.q15 / V.q4',
            q16: '=V.x2O - V.dxF1',
            q17: '=V.x2O - V.dxF2',
            q18: '=V.y2O - V.dyF1',
            q19: '=V.y2O - V.dyF2',
            q20: '=SQRT(V.q16*V.q16 + V.q18*V.q18)',
            q21: '=SQRT(V.q17*V.q17 + V.q19*V.q19)',
            q22: '=V.q21 - V.q20',
            dxF: '=IF(V.q22 > 0, V.dxF1, V.dxF2)',
            dyF: '=IF(V.q22 > 0, V.dyF1, V.dyF2)',
            sdxF: '=V.dxF * V.rw1 / V.rO',
            sdyF: '=V.dyF * V.rh1 / V.rO',
            xF: '=V.hc + V.sdxF',
            yF: '=V.vc + V.sdyF',
            x1I: '=V.sx1 * V.rI / V.rw2',
            y1I: '=V.sy1 * V.rI / V.rh2',
            x2I: '=V.sx2 * V.rI / V.rw2',
            y2I: '=V.sy2 * V.rI / V.rh2',
            dxI: '=V.x2I - V.x1I',
            dyI: '=V.y2I - V.y1I',
            dI: '=SQRT(V.dxI*V.dxI + V.dyI*V.dyI)',
            v1: '=V.x1I * V.y2I',
            v2: '=V.x2I * V.y1I',
            DI: '=V.v1 - V.v2',
            v3: '=V.rI * V.rI',
            v4: '=V.dI * V.dI',
            v5: '=V.v3 * V.v4',
            v6: '=V.DI * V.DI',
            v7: '=V.v5 - V.v6',
            v8: '=MAX(V.v7, 0)',
            sdelI: '=SQRT(V.v8)',
            v9: '=V.sdyO * V.dxI',
            v10: '=V.v9 * V.sdelI',
            v11: '=V.DI * V.dyI',
            dxC1: '=(V.v11 + V.v10) / V.v4',
            v12: '=V.v11 - V.v10',
            dxC2: '=V.v12 / V.v4',
            adyI: '=ABS(V.dyI)',
            v13: '=V.adyI * V.sdelI',
            v14: '=V.DI * V.dxI / -1',
            dyC1: '=(V.v14 + V.v13) / V.v4',
            v15: '=V.v14 - V.v13',
            dyC2: '=V.v15 / V.v4',
            v16: '=V.x1I - V.dxC1',
            v17: '=V.x1I - V.dxC2',
            v18: '=V.y1I - V.dyC1',
            v19: '=V.y1I - V.dyC2',
            v20: '=SQRT(V.v16*V.v16 + V.v18*V.v18)',
            v21: '=SQRT(V.v17*V.v17 + V.v19*V.v19)',
            v22: '=V.v21 - V.v20',
            dxC: '=IF(V.v22 > 0, V.dxC1, V.dxC2)',
            dyC: '=IF(V.v22 > 0, V.dyC1, V.dyC2)',
            sdxC: '=V.dxC * V.rw2 / V.rI',
            sdyC: '=V.dyC * V.rh2 / V.rI',
            xC: '=V.hc + V.sdxC',
            yC: '=V.vc + V.sdyC',
            ist0: '=(ATAN2(V.sdxC,V.sdyC) * V.d2r)',
            ist1: '=V.ist0 + 21600000',
            istAng0: '=IF(V.ist0 > 0, V.ist0, V.ist1)',
            isw1: '=V.stAng - V.istAng0',
            isw2: '=V.isw1 + 21600000',
            iswAng0: '=IF(V.isw1 > 0, V.isw1, V.isw2)',
            istAng: '=V.istAng0 + V.iswAng0',
            iswAng: '=0 - V.iswAng0',
            p1: '=V.xF - V.xC',
            p2: '=V.yF - V.yC',
            p3: '=SQRT(V.p1*V.p1 + V.p2*V.p2)',
            p4: '=V.p3 / 2',
            p5: '=V.p4 - V.thh',
            xGp: '=IF(V.p5 > 0, V.xF, V.xG)',
            yGp: '=IF(V.p5 > 0, V.yF, V.yG)',
            xBp: '=IF(V.p5 > 0, V.xC, V.xB)',
            yBp: '=IF(V.p5 > 0, V.yC, V.yB)',
            en0: '=(ATAN2(V.sdxF,V.sdyF) * V.d2r)',
            en1: '=V.en0 + 21600000',
            en2: '=IF(V.en0 > 0, V.en0, V.en1)',
            sw0: '=V.en2 - V.stAng',
            sw1: '=V.sw0 - 21600000',
            swAng: '=IF(V.sw0 > 0, V.sw1, V.sw0)',
            stAng0: '=V.stAng + V.swAng',
            swAng0: '=0 - V.swAng',
            wtI: '=V.rw3 * SIN(V.stAng / V.d2r)',
            htI: '=V.rh3 * COS(V.stAng / V.d2r)',
            _dxI: '=V.rw3 * COS(ATAN2(V.htI,V.wtI))',
            _dyI: '=V.rh3 * SIN(ATAN2(V.htI,V.wtI))',
            xI: '=V.hc + V._dxI',
            yI: '=V.vc + V._dyI',
            cd4: C,
            aI: '=V.stAng + V.cd4',
            aA: '=V.ptAng - V.cd4',
            aB: '=V.ptAng + V.cd2',
            idx: '=V.rw1 * COS(2700000 / V.d2r)',
            idy: '=V.rh1 * SIN(2700000 / V.d2r)',
            il: '=V.hc - V.idx',
            ir: '=V.hc + V.idx',
            it: '=V.vc - V.idy',
            ib: '=V.vc + V.idy',
            cx1: '=C(V.rw2,V.xD,A(V.rw2,V.rh2,V.istAng),true)',
            cy1: '=C(V.rh2,V.yD,A(V.rw2,V.rh2,V.istAng))',
            cx2: '=C(V.rw1,V.xF,A(V.rw1,V.rh1,V.stAng0),true)',
            cy2: '=C(V.rh1,V.yF,A(V.rw1,V.rh1,V.stAng0))',
        },
        adjustInfo: [['adj1', 12500], ['adj2', -1142319], ['adj3', 1142319], ['adj4', 10800000], ['adj5', 12500]],
        connectionPoints: [{
            x: '=V.xI',
            y: '=V.yI',
        }, {
            x: '=V.xGp',
            y: '=V.yGp',
        }, {
            x: '=V.xA',
            y: '=V.yA',
        }, {
            x: '=V.xBp',
            y: '=V.yBp',
        },
        ],
        controlsInfo: [{
            type: 'ahPolar',
            gdRefAng: 'adj2',
            minAng: 'minAng',
            maxAng: 0,
            position: {
                x: 'xA',
                y: 'yA',
            },
            point: ['=V.xA', '=V.yA'],
        }, {
            type: 'ahPolar',
            gdRefAng: 'adj4',
            minAng: 0,
            maxAng: 21599999,
            position: {
                x: 'xE',
                y: 'yE',
            },
            point: ['=V.xE', '=V.yE'],
        }, {
            type: 'ahPolar',
            gdRefR: 'adj1',
            minR: 0,
            maxR: 'maxAdj1',
            gdRefAng: 'adj3',
            minAng: 0,
            maxAng: 21599999,
            position: {
                x: 'xF',
                y: 'yF',
            },
            point: ['=V.xF', '=V.yF'],
        }, {
            type: 'ahPolar',
            gdRefR: 'adj5',
            minR: 0,
            maxR: 25000,
            position: {
                x: 'xB',
                y: 'yB',
            },
            point: ['=V.xB', '=V.yB'],
        },
        ],
        path: [[['M', '=V.xE', '=V.yE'], ['L', '=V.xD', '=V.yD'], ['E', '=V.cx1', '=V.cy1', '=V.rw2', '=V.rh2', 0, '=A(V.rw2,V.rh2,V.istAng)', '=A(V.rw2,V.rh2,(V.istAng + V.iswAng))', '=IF(V.iswAng > 0, FALSE, TRUE)'], ['L', '=V.xBp', '=V.yBp'], ['L', '=V.xA', '=V.yA'], ['L', '=V.xGp', '=V.yGp'], ['L', '=V.xF', '=V.yF'], ['E', '=V.cx2', '=V.cy2', '=V.rw1', '=V.rh1', 0, '=A(V.rw1,V.rh1,V.stAng0)', '=A(V.rw1,V.rh1,(V.stAng0 + V.swAng0))', '=IF(V.swAng0 > 0, FALSE, TRUE)'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.it',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    leftRightCircularArrow: {
        variables: {
            adj1: 12500,
            adj2: 1142319,
            adj3: 20457681,
            adj4: 11942319,
            adj5: 12500,
            a5: '=MIN(MAX(0, V.adj5), 25000)',
            maxAdj1: '=V.a5 * 2',
            a1: '=MIN(MAX(0, V.adj1), V.maxAdj1)',
            enAng: '=MIN(MAX(1, V.adj3), 21599999)',
            stAng: '=MIN(MAX(0, V.adj4), 21599999)',
            ss: s,
            th: '=V.ss * V.a1 / 100000',
            thh: '=V.ss * V.a5 / 100000',
            th2: '=V.th / 2',
            wd2: E,
            rw1: '=V.wd2 + V.th2 - V.thh',
            hd2: F,
            rh1: '=V.hd2 + V.th2 - V.thh',
            rw2: '=V.rw1 - V.th',
            rh2: '=V.rh1 - V.th',
            rw3: '=V.rw2 + V.th2',
            rh3: '=V.rh2 + V.th2',
            d2r: A,
            wtH: '=V.rw3 * SIN(V.enAng / V.d2r)',
            htH: '=V.rh3 * COS(V.enAng / V.d2r)',
            dxH: '=V.rw3 * COS(ATAN2(V.htH,V.wtH))',
            dyH: '=V.rh3 * SIN(ATAN2(V.htH,V.wtH))',
            hc: E,
            xH: '=V.hc + V.dxH',
            vc: F,
            yH: '=V.vc + V.dyH',
            rI: '=MIN(V.rw2, V.rh2)',
            u1: '=V.dxH * V.dxH',
            u2: '=V.dyH * V.dyH',
            u3: '=V.rI * V.rI',
            u4: '=V.u1 - V.u3',
            u5: '=V.u2 - V.u3',
            u6: '=V.u4 * V.u5 / V.u1',
            u7: '=V.u6 / V.u2',
            u8: '=1 - V.u7',
            u9: '=SQRT(V.u8)',
            u10: '=V.u4 / V.dxH',
            u11: '=V.u10 / V.dyH',
            u12: '=(1 + V.u9) / V.u11',
            u13: '=(ATAN2(1,V.u12) * V.d2r)',
            u14: '=V.u13 + 21600000',
            u15: '=IF(V.u13 > 0, V.u13, V.u14)',
            u16: '=V.u15 - V.enAng',
            u17: '=V.u16 + 21600000',
            u18: '=IF(V.u16 > 0, V.u16, V.u17)',
            cd2: B,
            u19: '=V.u18 - V.cd2',
            u20: '=V.u18 - 21600000',
            u21: '=IF(V.u19 > 0, V.u20, V.u18)',
            maxAng: '=ABS(V.u21)',
            aAng: '=MIN(MAX(0, V.adj2), V.maxAng)',
            ptAng: '=V.enAng + V.aAng',
            wtA: '=V.rw3 * SIN(V.ptAng / V.d2r)',
            htA: '=V.rh3 * COS(V.ptAng / V.d2r)',
            dxA: '=V.rw3 * COS(ATAN2(V.htA,V.wtA))',
            dyA: '=V.rh3 * SIN(ATAN2(V.htA,V.wtA))',
            xA: '=V.hc + V.dxA',
            yA: '=V.vc + V.dyA',
            dxG: '=V.thh * COS(V.ptAng / V.d2r)',
            dyG: '=V.thh * SIN(V.ptAng / V.d2r)',
            xG: '=V.xH + V.dxG',
            yG: '=V.yH + V.dyG',
            dxB: '=V.thh * COS(V.ptAng / V.d2r)',
            dyB: '=V.thh * SIN(V.ptAng / V.d2r)',
            xB: '=V.xH - V.dxB',
            yB: '=V.yH - V.dyB',
            sx1: '=V.xB - V.hc',
            sy1: '=V.yB - V.vc',
            sx2: '=V.xG - V.hc',
            sy2: '=V.yG - V.vc',
            rO: '=MIN(V.rw1, V.rh1)',
            x1O: '=V.sx1 * V.rO / V.rw1',
            y1O: '=V.sy1 * V.rO / V.rh1',
            x2O: '=V.sx2 * V.rO / V.rw1',
            y2O: '=V.sy2 * V.rO / V.rh1',
            dxO: '=V.x2O - V.x1O',
            dyO: '=V.y2O - V.y1O',
            dO: '=SQRT(V.dxO*V.dxO + V.dyO*V.dyO)',
            q1: '=V.x1O * V.y2O',
            q2: '=V.x2O * V.y1O',
            DO: '=V.q1 - V.q2',
            q3: '=V.rO * V.rO',
            q4: '=V.dO * V.dO',
            q5: '=V.q3 * V.q4',
            q6: '=V.DO * V.DO',
            q7: '=V.q5 - V.q6',
            q8: '=MAX(V.q7, 0)',
            sdelO: '=SQRT(V.q8)',
            ndyO: '=V.dyO * -1',
            sdyO: '=IF(V.ndyO > 0, -1, 1)',
            q9: '=V.sdyO * V.dxO',
            q10: '=V.q9 * V.sdelO',
            q11: '=V.DO * V.dyO',
            dxF1: '=(V.q11 + V.q10) / V.q4',
            q12: '=V.q11 - V.q10',
            dxF2: '=V.q12 / V.q4',
            adyO: '=ABS(V.dyO)',
            q13: '=V.adyO * V.sdelO',
            q14: '=V.DO * V.dxO / -1',
            dyF1: '=(V.q14 + V.q13) / V.q4',
            q15: '=V.q14 - V.q13',
            dyF2: '=V.q15 / V.q4',
            q16: '=V.x2O - V.dxF1',
            q17: '=V.x2O - V.dxF2',
            q18: '=V.y2O - V.dyF1',
            q19: '=V.y2O - V.dyF2',
            q20: '=SQRT(V.q16*V.q16 + V.q18*V.q18)',
            q21: '=SQRT(V.q17*V.q17 + V.q19*V.q19)',
            q22: '=V.q21 - V.q20',
            dxF: '=IF(V.q22 > 0, V.dxF1, V.dxF2)',
            dyF: '=IF(V.q22 > 0, V.dyF1, V.dyF2)',
            sdxF: '=V.dxF * V.rw1 / V.rO',
            sdyF: '=V.dyF * V.rh1 / V.rO',
            xF: '=V.hc + V.sdxF',
            yF: '=V.vc + V.sdyF',
            x1I: '=V.sx1 * V.rI / V.rw2',
            y1I: '=V.sy1 * V.rI / V.rh2',
            x2I: '=V.sx2 * V.rI / V.rw2',
            y2I: '=V.sy2 * V.rI / V.rh2',
            dxI: '=V.x2I - V.x1I',
            dyI: '=V.y2I - V.y1I',
            dI: '=SQRT(V.dxI*V.dxI + V.dyI*V.dyI)',
            v1: '=V.x1I * V.y2I',
            v2: '=V.x2I * V.y1I',
            DI: '=V.v1 - V.v2',
            v3: '=V.rI * V.rI',
            v4: '=V.dI * V.dI',
            v5: '=V.v3 * V.v4',
            v6: '=V.DI * V.DI',
            v7: '=V.v5 - V.v6',
            v8: '=MAX(V.v7, 0)',
            sdelI: '=SQRT(V.v8)',
            v9: '=V.sdyO * V.dxI',
            v10: '=V.v9 * V.sdelI',
            v11: '=V.DI * V.dyI',
            dxC1: '=(V.v11 + V.v10) / V.v4',
            v12: '=V.v11 - V.v10',
            dxC2: '=V.v12 / V.v4',
            adyI: '=ABS(V.dyI)',
            v13: '=V.adyI * V.sdelI',
            v14: '=V.DI * V.dxI / -1',
            dyC1: '=(V.v14 + V.v13) / V.v4',
            v15: '=V.v14 - V.v13',
            dyC2: '=V.v15 / V.v4',
            v16: '=V.x1I - V.dxC1',
            v17: '=V.x1I - V.dxC2',
            v18: '=V.y1I - V.dyC1',
            v19: '=V.y1I - V.dyC2',
            v20: '=SQRT(V.v16*V.v16 + V.v18*V.v18)',
            v21: '=SQRT(V.v17*V.v17 + V.v19*V.v19)',
            v22: '=V.v21 - V.v20',
            dxC: '=IF(V.v22 > 0, V.dxC1, V.dxC2)',
            dyC: '=IF(V.v22 > 0, V.dyC1, V.dyC2)',
            sdxC: '=V.dxC * V.rw2 / V.rI',
            sdyC: '=V.dyC * V.rh2 / V.rI',
            xC: '=V.hc + V.sdxC',
            yC: '=V.vc + V.sdyC',
            wtI: '=V.rw3 * SIN(V.stAng / V.d2r)',
            htI: '=V.rh3 * COS(V.stAng / V.d2r)',
            _dxI: '=V.rw3 * COS(ATAN2(V.htI,V.wtI))',
            _dyI: '=V.rh3 * SIN(ATAN2(V.htI,V.wtI))',
            xI: '=V.hc + V._dxI',
            yI: '=V.vc + V._dyI',
            lptAng: '=V.stAng - V.aAng',
            wtL: '=V.rw3 * SIN(V.lptAng / V.d2r)',
            htL: '=V.rh3 * COS(V.lptAng / V.d2r)',
            dxL: '=V.rw3 * COS(ATAN2(V.htL,V.wtL))',
            dyL: '=V.rh3 * SIN(ATAN2(V.htL,V.wtL))',
            xL: '=V.hc + V.dxL',
            yL: '=V.vc + V.dyL',
            dxK: '=V.thh * COS(V.lptAng / V.d2r)',
            dyK: '=V.thh * SIN(V.lptAng / V.d2r)',
            xK: '=V.xI + V.dxK',
            yK: '=V.yI + V.dyK',
            dxJ: '=V.thh * COS(V.lptAng / V.d2r)',
            dyJ: '=V.thh * SIN(V.lptAng / V.d2r)',
            xJ: '=V.xI - V.dxJ',
            yJ: '=V.yI - V.dyJ',
            p1: '=V.xF - V.xC',
            p2: '=V.yF - V.yC',
            p3: '=SQRT(V.p1*V.p1 + V.p2*V.p2)',
            p4: '=V.p3 / 2',
            p5: '=V.p4 - V.thh',
            xGp: '=IF(V.p5 > 0, V.xF, V.xG)',
            yGp: '=IF(V.p5 > 0, V.yF, V.yG)',
            xBp: '=IF(V.p5 > 0, V.xC, V.xB)',
            yBp: '=IF(V.p5 > 0, V.yC, V.yB)',
            en0: '=(ATAN2(V.sdxF,V.sdyF) * V.d2r)',
            en1: '=V.en0 + 21600000',
            en2: '=IF(V.en0 > 0, V.en0, V.en1)',
            od0: '=V.en2 - V.enAng',
            od1: '=V.od0 + 21600000',
            od2: '=IF(V.od0 > 0, V.od0, V.od1)',
            st0: '=V.stAng - V.od2',
            st1: '=V.st0 + 21600000',
            st2: '=IF(V.st0 > 0, V.st0, V.st1)',
            sw0: '=V.en2 - V.st2',
            sw1: '=V.sw0 + 21600000',
            swAng: '=IF(V.sw0 > 0, V.sw0, V.sw1)',
            ist0: '=(ATAN2(V.sdxC,V.sdyC) * V.d2r)',
            ist1: '=V.ist0 + 21600000',
            istAng: '=IF(V.ist0 > 0, V.ist0, V.ist1)',
            id0: '=V.istAng - V.enAng',
            id1: '=V.id0 - 21600000',
            id2: '=IF(V.id0 > 0, V.id1, V.id0)',
            ien0: '=V.stAng - V.id2',
            ien1: '=V.ien0 - 21600000',
            ien2: '=IF(V.ien1 > 0, V.ien1, V.ien0)',
            isw1: '=V.ien2 - V.istAng',
            isw2: '=V.isw1 - 21600000',
            iswAng: '=IF(V.isw1 > 0, V.isw2, V.isw1)',
            wtE: '=V.rw1 * SIN(V.st2 / V.d2r)',
            htE: '=V.rh1 * COS(V.st2 / V.d2r)',
            dxE: '=V.rw1 * COS(ATAN2(V.htE,V.wtE))',
            dyE: '=V.rh1 * SIN(ATAN2(V.htE,V.wtE))',
            xE: '=V.hc + V.dxE',
            yE: '=V.vc + V.dyE',
            wtD: '=V.rw2 * SIN(V.ien2 / V.d2r)',
            htD: '=V.rh2 * COS(V.ien2 / V.d2r)',
            dxD: '=V.rw2 * COS(ATAN2(V.htD,V.wtD))',
            dyD: '=V.rh2 * SIN(ATAN2(V.htD,V.wtD))',
            xD: '=V.hc + V.dxD',
            yD: '=V.vc + V.dyD',
            xKp: '=IF(V.p5 > 0, V.xE, V.xK)',
            yKp: '=IF(V.p5 > 0, V.yE, V.yK)',
            xJp: '=IF(V.p5 > 0, V.xD, V.xJ)',
            yJp: '=IF(V.p5 > 0, V.yD, V.yJ)',
            cd4: C,
            aL: '=V.lptAng - V.cd4',
            aA: '=V.ptAng + V.cd4',
            aB: '=V.ptAng + V.cd2',
            aJ: '=V.lptAng + V.cd2',
            idx: '=V.rw1 * COS(2700000 / V.d2r)',
            idy: '=V.rh1 * SIN(2700000 / V.d2r)',
            il: '=V.hc - V.idx',
            ir: '=V.hc + V.idx',
            it: '=V.vc - V.idy',
            ib: '=V.vc + V.idy',
            cx1: '=C(V.rw1,V.xE,A(V.rw1,V.rh1,V.st2),true)',
            cy1: '=C(V.rh1,V.yE,A(V.rw1,V.rh1,V.st2))',
            cx2: '=C(V.rw2,V.xC,A(V.rw2,V.rh2,V.istAng),true)',
            cy2: '=C(V.rh2,V.yC,A(V.rw2,V.rh2,V.istAng))',
        },
        adjustInfo: [['adj1', 12500], ['adj2', 1142319], ['adj3', 20457681], ['adj4', 11942319], ['adj5', 12500]],
        connectionPoints: [{
            x: '=V.xL',
            y: '=V.yL',
        }, {
            x: '=V.xKp',
            y: '=V.yKp',
        }, {
            x: '=V.xGp',
            y: '=V.yGp',
        }, {
            x: '=V.xA',
            y: '=V.yA',
        }, {
            x: '=V.xBp',
            y: '=V.yBp',
        }, {
            x: '=V.xJp',
            y: '=V.yJp',
        },
        ],
        controlsInfo: [{
            type: 'ahPolar',
            gdRefAng: 'adj2',
            minAng: 0,
            maxAng: 'maxAng',
            position: {
                x: 'xA',
                y: 'yA',
            },
            point: ['=V.xA', '=V.yA'],
        }, {
            type: 'ahPolar',
            gdRefAng: 'adj4',
            minAng: 0,
            maxAng: 21599999,
            position: {
                x: 'xE',
                y: 'yE',
            },
            point: ['=V.xE', '=V.yE'],
        }, {
            type: 'ahPolar',
            gdRefR: 'adj1',
            minR: 0,
            maxR: 'maxAdj1',
            gdRefAng: 'adj3',
            minAng: 0,
            maxAng: 21599999,
            position: {
                x: 'xF',
                y: 'yF',
            },
            point: ['=V.xF', '=V.yF'],
        }, {
            type: 'ahPolar',
            gdRefR: 'adj5',
            minR: 0,
            maxR: 25000,
            position: {
                x: 'xB',
                y: 'yB',
            },
            point: ['=V.xB', '=V.yB'],
        },
        ],
        path: [[['M', '=V.xL', '=V.yL'], ['L', '=V.xKp', '=V.yKp'], ['L', '=V.xE', '=V.yE'], ['E', '=V.cx1', '=V.cy1', '=V.rw1', '=V.rh1', 0, '=A(V.rw1,V.rh1,V.st2)', '=A(V.rw1,V.rh1,(V.st2 + V.swAng))', '=IF(V.swAng > 0, FALSE, TRUE)'], ['L', '=V.xGp', '=V.yGp'], ['L', '=V.xA', '=V.yA'], ['L', '=V.xBp', '=V.yBp'], ['L', '=V.xC', '=V.yC'], ['E', '=V.cx2', '=V.cy2', '=V.rw2', '=V.rh2', 0, '=A(V.rw2,V.rh2,V.istAng)', '=A(V.rw2,V.rh2,(V.istAng + V.iswAng))', '=IF(V.iswAng > 0, FALSE, TRUE)'], ['L', '=V.xJp', '=V.yJp'], ['Z'], {},
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.it',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    swooshArrow: {
        variables: {
            adj1: 25000,
            adj2: 16667,
            a1: '=MIN(MAX(1, V.adj1), 75000)',
            ss: s,
            maxAdj2: '=70000 * width / V.ss',
            a2: '=MIN(MAX(0, V.adj2), V.maxAdj2)',
            ad1: '=height * V.a1 / 100000',
            ad2: '=V.ss * V.a2 / 100000',
            r: w,
            xB: '=width - V.ad2',
            t: 0,
            ssd8: '=V.ss / 8',
            yB: '=V.ssd8',
            cd4: C,
            alfa: '=V.cd4 / 14',
            d2r: A,
            dx0: '=V.ssd8 * TAN(V.alfa / V.d2r)',
            xC: '=V.xB - V.dx0',
            dx1: '=V.ad1 * TAN(V.alfa / V.d2r)',
            yF: '=V.yB + V.ad1',
            xF: '=V.xB + V.dx1',
            xE: '=V.xF + V.dx0',
            yE: '=V.yF + V.ssd8',
            dy2: '=V.yE',
            dy22: '=V.dy2 / 2',
            dy3: '=height / 20',
            yD: '=V.dy22 - V.dy3',
            hd6: '=height/6',
            dy4: '=V.hd6',
            yP1: '=V.hd6 + V.dy4',
            wd6: '=width/6',
            xP1: '=V.wd6',
            dy5: '=V.hd6 / 2',
            yP2: '=V.yF + V.dy5',
            wd4: '=width/4',
            xP2: '=V.wd4',
            l: 0,
            b: h,
        },
        adjustInfo: [['adj1', 25000], ['adj2', 16667]],
        connectionPoints: [{
            x: 0,
            y: h,
        }, {
            x: '=V.xC',
            y: 0,
        }, {
            x: w,
            y: '=V.yD',
        }, {
            x: '=V.xE',
            y: '=V.yE',
        },
        ],
        controlsInfo: [{
            type: 'ahXY',
            gdRefY: 'adj1',
            minY: 1,
            maxY: 75000,
            position: {
                x: 'xF',
                y: 'yF',
            },
            point: ['=V.xF', '=V.yF'],
        }, {
            type: 'ahXY',
            gdRefX: 'adj2',
            minX: 0,
            maxX: 'maxAdj2',
            position: {
                x: 'xB',
                y: 'yB',
            },
            point: ['=V.xB', '=V.yB'],
        },
        ],
        path: [[['M', 0, h], ['Q', '=V.xP1', '=V.yP1', '=V.xB', '=V.yB'], ['L', '=V.xC', 0], ['L', w, '=V.yD'], ['L', '=V.xE', '=V.yE'], ['L', '=V.xF', '=V.yF'], ['Q', '=V.xP2', '=V.yP2', 0, h], ['Z'], {},
        ]],
    },
    cloud: {
        variables: {
            il: '=width * 4477 / 21600',
            it: '=height * 3262 / 21600',
            ir: '=width * 18587 / 21600',
            ib: '=height * 17337 / 21600',
            g27: '=width * 67 / 21600',
            g28: '=height * 21577 / 21600',
            g29: '=width * 21582 / 21600',
            g30: '=height * 1235 / 21600',
            vc: F,
            hc: E,
            _scaleX1: '= width / 43200',
            _scaleY1: '= height / 43200',
            cx1: '=C(6753,3900,A(6753,9190,-11429249),true)',
            cy1: '=C(9190,14370,A(6753,9190,-11429249))',
            cx2: '=C(5333,P(V.cx1,6753,A(6753,9190,(-11429249 + 7426832)),true),A(5333,7267,-8646143),true)',
            cy2: '=C(7267,P(V.cy1,9190,A(6753,9190,(-11429249 + 7426832))),A(5333,7267,-8646143))',
            cx3: '=C(4365,P(V.cx2,5333,A(5333,7267,(-8646143 + 5396714)),true),A(4365,5945,-8748475),true)',
            cy3: '=C(5945,P(V.cy2,7267,A(5333,7267,(-8646143 + 5396714))),A(4365,5945,-8748475))',
            cx4: '=C(4857,P(V.cx3,4365,A(4365,5945,(-8748475 + 5983381)),true),A(4857,6595,-7859164),true)',
            cy4: '=C(6595,P(V.cy3,5945,A(4365,5945,(-8748475 + 5983381))),A(4857,6595,-7859164))',
            cx5: '=C(5333,P(V.cx4,4857,A(4857,6595,(-7859164 + 7034504)),true),A(5333,7273,-4722533),true)',
            cy5: '=C(7273,P(V.cy4,6595,A(4857,6595,(-7859164 + 7034504))),A(5333,7273,-4722533))',
            cx6: '=C(6775,P(V.cx5,5333,A(5333,7273,(-4722533 + 6541615)),true),A(6775,9220,-2776035),true)',
            cy6: '=C(9220,P(V.cy5,7273,A(5333,7273,(-4722533 + 6541615))),A(6775,9220,-2776035))',
            cx7: '=C(5785,P(V.cx6,6775,A(6775,9220,(-2776035 + 7816140)),true),A(5785,7867,37501),true)',
            cy7: '=C(7867,P(V.cy6,9220,A(6775,9220,(-2776035 + 7816140))),A(5785,7867,37501))',
            cx8: '=C(6752,P(V.cx7,5785,A(5785,7867,(37501 + 6842000)),true),A(6752,9215,1347096),true)',
            cy8: '=C(9215,P(V.cy7,7867,A(5785,7867,(37501 + 6842000))),A(6752,9215,1347096))',
            cx9: '=C(7720,P(V.cx8,6752,A(6752,9215,(1347096 + 6910353)),true),A(7720,10543,3974558),true)',
            cy9: '=C(10543,P(V.cy8,9215,A(6752,9215,(1347096 + 6910353))),A(7720,10543,3974558))',
            cx10: '=C(4360,P(V.cx9,7720,A(7720,10543,(3974558 + 4542661)),true),A(4360,5918,-16496525),true)',
            cy10: '=C(5918,P(V.cy9,10543,A(7720,10543,(3974558 + 4542661))),A(4360,5918,-16496525))',
            cx11: '=C(4345,P(V.cx10,4360,A(4360,5918,(-16496525 + 8804134)),true),A(4345,5945,-14809710),true)',
            cy11: '=C(5945,P(V.cy10,5918,A(4360,5918,(-16496525 + 8804134))),A(4345,5945,-14809710))',
            _scaleX2: '= width / 43200',
            _scaleY2: '= height / 43200',
            cx12: '=C(4345,4693,A(4345,5945,5204520),true)',
            cy12: '=C(5945,26177,A(4345,5945,5204520))',
            cx13: '=C(4360,6928,A(4360,5918,4416628),true)',
            cy13: '=C(5918,34899,A(4360,5918,4416628))',
            cx14: '=C(6752,16478,A(6752,9215,8257449),true)',
            cy14: '=C(9215,39090,A(6752,9215,8257449))',
            cx15: '=C(6752,28827,A(6752,9215,387196),true)',
            cy15: '=C(9215,34751,A(6752,9215,387196))',
            cx16: '=C(5785,34129,A(5785,7867,-4217541),true)',
            cy16: '=C(7867,22954,A(5785,7867,-4217541))',
            cx17: '=C(5333,41798,A(5333,7273,1819082),true)',
            cy17: '=C(7273,15354,A(5333,7273,1819082))',
            cx18: '=C(4857,38324,A(4857,6595,-824660),true)',
            cy18: '=C(6595,5426,A(4857,6595,-824660))',
            cx19: '=C(4857,29078,A(4857,6595,-8950887),true)',
            cy19: '=C(6595,3952,A(4857,6595,-8950887))',
            cx20: '=C(4365,22141,A(4365,5945,-9809656),true)',
            cy20: '=C(5945,4720,A(4365,5945,-9809656))',
            cx21: '=C(6753,14000,A(6753,9190,-4002417),true)',
            cy21: '=C(9190,5192,A(6753,9190,-4002417))',
            cx22: '=C(6753,4127,A(6753,9190,9459261),true)',
            cy22: '=C(9190,15789,A(6753,9190,9459261))',
        },
        connectionPoints: [{
            x: '=V.g29',
            y: b,
        }, {
            x: a,
            y: '=V.g28',
        }, {
            x: '=V.g27',
            y: b,
        }, {
            x: a,
            y: '=V.g30',
        },
        ],
        path: [[['M', '=3900 * V._scaleX1', '=14370 * V._scaleY1'], ['E', '=V.cx1 * V._scaleX1', '=V.cy1 * V._scaleY1', '=6753 * V._scaleX1', '=9190 * V._scaleY1', 0, '=A(6753,9190,-11429249)', '=A(6753,9190,(-11429249 + 7426832))', '=IF(7426832 > 0, FALSE, TRUE)'], ['E', '=V.cx2 * V._scaleX1', '=V.cy2 * V._scaleY1', '=5333 * V._scaleX1', '=7267 * V._scaleY1', 0, '=A(5333,7267,-8646143)', '=A(5333,7267,(-8646143 + 5396714))', '=IF(5396714 > 0, FALSE, TRUE)'], ['E', '=V.cx3 * V._scaleX1', '=V.cy3 * V._scaleY1', '=4365 * V._scaleX1', '=5945 * V._scaleY1', 0, '=A(4365,5945,-8748475)', '=A(4365,5945,(-8748475 + 5983381))', '=IF(5983381 > 0, FALSE, TRUE)'], ['E', '=V.cx4 * V._scaleX1', '=V.cy4 * V._scaleY1', '=4857 * V._scaleX1', '=6595 * V._scaleY1', 0, '=A(4857,6595,-7859164)', '=A(4857,6595,(-7859164 + 7034504))', '=IF(7034504 > 0, FALSE, TRUE)'], ['E', '=V.cx5 * V._scaleX1', '=V.cy5 * V._scaleY1', '=5333 * V._scaleX1', '=7273 * V._scaleY1', 0, '=A(5333,7273,-4722533)', '=A(5333,7273,(-4722533 + 6541615))', '=IF(6541615 > 0, FALSE, TRUE)'], ['E', '=V.cx6 * V._scaleX1', '=V.cy6 * V._scaleY1', '=6775 * V._scaleX1', '=9220 * V._scaleY1', 0, '=A(6775,9220,-2776035)', '=A(6775,9220,(-2776035 + 7816140))', '=IF(7816140 > 0, FALSE, TRUE)'], ['E', '=V.cx7 * V._scaleX1', '=V.cy7 * V._scaleY1', '=5785 * V._scaleX1', '=7867 * V._scaleY1', 0, '=A(5785,7867,37501)', '=A(5785,7867,(37501 + 6842000))', '=IF(6842000 > 0, FALSE, TRUE)'], ['E', '=V.cx8 * V._scaleX1', '=V.cy8 * V._scaleY1', '=6752 * V._scaleX1', '=9215 * V._scaleY1', 0, '=A(6752,9215,1347096)', '=A(6752,9215,(1347096 + 6910353))', '=IF(6910353 > 0, FALSE, TRUE)'], ['E', '=V.cx9 * V._scaleX1', '=V.cy9 * V._scaleY1', '=7720 * V._scaleX1', '=10543 * V._scaleY1', 0, '=A(7720,10543,3974558)', '=A(7720,10543,(3974558 + 4542661))', '=IF(4542661 > 0, FALSE, TRUE)'], ['E', '=V.cx10 * V._scaleX1', '=V.cy10 * V._scaleY1', '=4360 * V._scaleX1', '=5918 * V._scaleY1', 0, '=A(4360,5918,-16496525)', '=A(4360,5918,(-16496525 + 8804134))', '=IF(8804134 > 0, FALSE, TRUE)'], ['E', '=V.cx11 * V._scaleX1', '=V.cy11 * V._scaleY1', '=4345 * V._scaleX1', '=5945 * V._scaleY1', 0, '=A(4345,5945,-14809710)', '=A(4345,5945,(-14809710 + 9151131))', '=IF(9151131 > 0, FALSE, TRUE)'], ['Z'], {},
        ], [['M', '=4693 * V._scaleX2', '=26177 * V._scaleY2'], ['E', '=V.cx12 * V._scaleX2', '=V.cy12 * V._scaleY2', '=4345 * V._scaleX2', '=5945 * V._scaleY2', 0, '=A(4345,5945,5204520)', '=A(4345,5945,(5204520 + 1585770))', '=IF(1585770 > 0, FALSE, TRUE)'], ['M', '=6928 * V._scaleX2', '=34899 * V._scaleY2'], ['E', '=V.cx13 * V._scaleX2', '=V.cy13 * V._scaleY2', '=4360 * V._scaleX2', '=5918 * V._scaleY2', 0, '=A(4360,5918,4416628)', '=A(4360,5918,(4416628 + 686848))', '=IF(686848 > 0, FALSE, TRUE)'], ['M', '=16478 * V._scaleX2', '=39090 * V._scaleY2'], ['E', '=V.cx14 * V._scaleX2', '=V.cy14 * V._scaleY2', '=6752 * V._scaleX2', '=9215 * V._scaleY2', 0, '=A(6752,9215,8257449)', '=A(6752,9215,(8257449 + 844866))', '=IF(844866 > 0, FALSE, TRUE)'], ['M', '=28827 * V._scaleX2', '=34751 * V._scaleY2'], ['E', '=V.cx15 * V._scaleX2', '=V.cy15 * V._scaleY2', '=6752 * V._scaleX2', '=9215 * V._scaleY2', 0, '=A(6752,9215,387196)', '=A(6752,9215,(387196 + 959901))', '=IF(959901 > 0, FALSE, TRUE)'], ['M', '=34129 * V._scaleX2', '=22954 * V._scaleY2'], ['E', '=V.cx16 * V._scaleX2', '=V.cy16 * V._scaleY2', '=5785 * V._scaleX2', '=7867 * V._scaleY2', 0, '=A(5785,7867,-4217541)', '=A(5785,7867,(-4217541 + 4255042))', '=IF(4255042 > 0, FALSE, TRUE)'], ['M', '=41798 * V._scaleX2', '=15354 * V._scaleY2'], ['E', '=V.cx17 * V._scaleX2', '=V.cy17 * V._scaleY2', '=5333 * V._scaleX2', '=7273 * V._scaleY2', 0, '=A(5333,7273,1819082)', '=A(5333,7273,(1819082 + 1665090))', '=IF(1665090 > 0, FALSE, TRUE)'], ['M', '=38324 * V._scaleX2', '=5426 * V._scaleY2'], ['E', '=V.cx18 * V._scaleX2', '=V.cy18 * V._scaleY2', '=4857 * V._scaleX2', '=6595 * V._scaleY2', 0, '=A(4857,6595,-824660)', '=A(4857,6595,(-824660 + 891534))', '=IF(891534 > 0, FALSE, TRUE)'], ['M', '=29078 * V._scaleX2', '=3952 * V._scaleY2'], ['E', '=V.cx19 * V._scaleX2', '=V.cy19 * V._scaleY2', '=4857 * V._scaleX2', '=6595 * V._scaleY2', 0, '=A(4857,6595,-8950887)', '=A(4857,6595,(-8950887 + 1091722))', '=IF(1091722 > 0, FALSE, TRUE)'], ['M', '=22141 * V._scaleX2', '=4720 * V._scaleY2'], ['E', '=V.cx20 * V._scaleX2', '=V.cy20 * V._scaleY2', '=4365 * V._scaleX2', '=5945 * V._scaleY2', 0, '=A(4365,5945,-9809656)', '=A(4365,5945,(-9809656 + 1061181))', '=IF(1061181 > 0, FALSE, TRUE)'], ['M', '=14000 * V._scaleX2', '=5192 * V._scaleY2'], ['E', '=V.cx21 * V._scaleX2', '=V.cy21 * V._scaleY2', '=6753 * V._scaleX2', '=9190 * V._scaleY2', 0, '=A(6753,9190,-4002417)', '=A(6753,9190,(-4002417 + 739161))', '=IF(739161 > 0, FALSE, TRUE)'], ['M', '=4127 * V._scaleX2', '=15789 * V._scaleY2'], ['E', '=V.cx22 * V._scaleX2', '=V.cy22 * V._scaleY2', '=6753 * V._scaleX2', '=9190 * V._scaleY2', 0, '=A(6753,9190,9459261)', '=A(6753,9190,(9459261 + 711490))', '=IF(711490 > 0, FALSE, TRUE)'], {
            fillMode: 'none',
        },
        ]],
        textRect: {
            left: '=V.il',
            top: '=V.it',
            right: '=V.ir',
            bottom: '=V.ib',
        },
    },
    chartX: {
        variables: {
            _scaleX1: '= width / 10',
            _scaleY1: '= height / 10',
            _scaleX2: '= width / 10',
            _scaleY2: '= height / 10',
        },
        path: [[['M', 0, 0], ['L', w, h], ['M', 0, h], ['L', w, 0], {
            fillMode: 'none',
        },
        ], [['M', 0, 0], ['L', 0, h], ['L', w, h], ['L', w, 0], ['Z'], {
            strokeMode: 'false',
        },
        ]],
    },
    chartStar: {
        variables: {
            _scaleX1: '= width / 10',
            _scaleY1: '= height / 10',
            _scaleX2: '= width / 10',
            _scaleY2: '= height / 10',
        },
        path: [[['M', 0, 0], ['L', w, h], ['M', 0, h], ['L', w, 0], ['M', E, 0], ['L', E, h], {
            fillMode: 'none',
        },
        ], [['M', 0, 0], ['L', 0, h], ['L', w, h], ['L', w, 0], ['Z'], {
            strokeMode: 'false',
        },
        ]],
    },
    chartPlus: {
        variables: {
            _scaleX1: '= width / 10',
            _scaleY1: '= height / 10',
            _scaleX2: '= width / 10',
            _scaleY2: '= height / 10',
        },
        path: [[['M', E, 0], ['L', E, h], ['M', 0, F], ['L', w, F], {
            fillMode: 'none',
        },
        ], [['M', 0, 0], ['L', 0, h], ['L', w, h], ['L', w, 0], ['Z'], {
            strokeMode: 'false',
        },
        ]],
    },
    lineInverse: {
        variables: {
            l: 0,
            b: h,
            r: w,
            t: 0,
        },
        connectionPoints: [{
            x: 0,
            y: h,
        }, {
            x: w,
            y: 0,
        },
        ],
        path: [[['M', 0, h], ['L', w, 0], { fillMode: 'none' },
        ]],
    },
};

// 预设操作shapeType
export const AutoShapeType = {

    none: 0,

    rectangle: 1,

    parallelogram: 2,

    trapezoid: 3,

    diamond: 4,

    roundedRectangle: 5,

    octagon: 6,

    isoscelesTriangle: 7,

    rightTriangle: 8,

    oval: 9,

    hexagon: 10,

    cross: 11,

    regularPentagon: 12,

    can: 13,

    cube: 14,

    bevel: 15,

    foldedCorner: 16,

    smileyFace: 17,

    donut: 18,

    noSymbol: 19,

    blockArc: 20,

    heart: 21,

    lightningBolt: 22,

    sun: 23,

    moon: 24,

    arc: 25,

    doubleBracket: 26,

    doubleBrace: 27,

    plaque: 28,

    leftBracket: 29,

    rightBracket: 30,

    leftBrace: 31,

    rightBrace: 32,

    rightArrow: 33,

    leftArrow: 34,

    upArrow: 35,

    downArrow: 36,

    leftRightArrow: 37,

    upDownArrow: 38,

    quadArrow: 39,

    leftRightUpArrow: 40,

    bentArrow: 41,

    uTurnArrow: 42,

    leftUpArrow: 43,

    bentUpArrow: 44,

    curvedRightArrow: 45,

    curvedLeftArrow: 46,

    curvedUpArrow: 47,

    curvedDownArrow: 48,

    stripedRightArrow: 49,

    notchedRightArrow: 50,

    pentagon: 51,

    chevron: 52,

    rightArrowCallout: 53,

    leftArrowCallout: 54,

    upArrowCallout: 55,

    downArrowCallout: 56,

    leftRightArrowCallout: 57,

    upDownArrowCallout: 58,

    quadArrowCallout: 59,

    circularArrow: 60,

    flowchartProcess: 61,

    flowchartAlternateProcess: 62,

    flowchartDecision: 63,

    flowchartData: 64,

    flowchartPredefinedProcess: 65,

    flowchartInternalStorage: 66,

    flowchartDocument: 67,

    flowchartMultidocument: 68,

    flowchartTerminator: 69,

    flowchartPreparation: 70,

    flowchartManualInput: 71,

    flowchartManualOperation: 72,

    flowchartConnector: 73,

    flowchartOffpageConnector: 74,

    flowchartCard: 75,

    flowchartPunchedTape: 76,

    flowchartSummingJunction: 77,

    flowchartOr: 78,

    flowchartCollate: 79,

    flowchartSort: 80,

    flowchartExtract: 81,

    flowchartMerge: 82,

    flowchartStoredData: 83,

    flowchartDelay: 84,

    flowchartSequentialAccessStorage: 85,

    flowchartMagneticDisk: 86,

    flowchartDirectAccessStorage: 87,

    flowchartDisplay: 88,

    explosion1: 89,

    explosion2: 90,

    shape4pointStar: 91,

    shape5pointStar: 92,

    shape8pointStar: 93,

    shape16pointStar: 94,

    shape24pointStar: 95,

    shape32pointStar: 96,

    upRibbon: 97,

    downRibbon: 98,

    curvedUpRibbon: 99,

    curvedDownRibbon: 100,

    verticalScroll: 101,

    horizontalScroll: 102,

    wave: 103,

    doubleWave: 104,

    rectangularCallout: 105,

    roundedRectangularCallout: 106,

    ovalCallout: 107,

    cloudCallout: 108,

    lineCallout1: 109,

    lineCallout2: 110,

    lineCallout3: 111,

    lineCallout4: 112,

    lineCallout1AccentBar: 113,

    lineCallout2AccentBar: 114,

    lineCallout3AccentBar: 115,

    lineCallout4AccentBar: 116,

    lineCallout1NoBorder: 117,

    lineCallout2NoBorder: 118,

    lineCallout3NoBorder: 119,

    lineCallout4NoBorder: 120,

    lineCallout1BorderandAccentBar: 121,

    lineCallout2BorderandAccentBar: 122,

    lineCallout3BorderandAccentBar: 123,

    lineCallout4BorderandAccentBar: 124,

    actionButtonCustom: 125,

    actionButtonHome: 126,

    actionButtonHelp: 127,

    actionButtonInformation: 128,

    actionButtonBackorPrevious: 129,

    actionButtonForwardorNext: 130,

    actionButtonBeginning: 131,

    actionButtonEnd: 132,

    actionButtonReturn: 133,

    actionButtonDocument: 134,

    actionButtonSound: 135,

    actionButtonMovie: 136,

    balloon: 137,

    flowchartOfflineStorage: 138,

    leftRightRibbon: 139,

    diagonalStripe: 140,

    pie: 141,

    nonIsoscelesTrapezoid: 142,

    decagon: 143,

    heptagon: 144,

    dodecagon: 145,

    star6Point: 146,

    star7Point: 147,

    star10Point: 148,

    star12Point: 149,

    round1Rectangle: 150,

    round2SameRectangle: 151,

    round2DiagRectangle: 152,

    snipRoundRectangle: 153,

    snip1Rectangle: 154,

    snip2SameRectangle: 155,

    snip2DiagRectangle: 156,

    frame: 157,

    halfFrame: 158,

    tear: 159,

    chord: 160,

    corner: 161,

    mathPlus: 162,

    mathMinus: 163,

    mathMultiply: 164,

    mathDivide: 165,

    mathEqual: 166,

    mathNotEqual: 167,

    cornerTabs: 168,

    squareTabs: 169,

    plaqueTabs: 170,

    gear6: 171,

    gear9: 172,

    funnel: 173,

    pieWedge: 174,

    leftCircularArrow: 175,

    leftRightCircularArrow: 176,

    swooshArrow: 177,

    cloud: 178,

    chartX: 179,

    chartStar: 180,

    chartPlus: 181,

    lineInverse: 182,
};

// PPT原始shapeType
/* eslint-disable camelcase */
export const ST_ShapeType = {
/* eslint-enable camelcase */
    line: 0,
    lineInv: 1,
    triangle: 2,
    rtTriangle: 3,
    rect: 4,
    diamond: 5,
    parallelogram: 6,
    trapezoid: 7,
    nonIsoscelesTrapezoid: 8,
    pentagon: 9,
    hexagon: 10,
    heptagon: 11,
    octagon: 12,
    decagon: 13,
    dodecagon: 14,
    star4: 15,
    star5: 16,
    star6: 17,
    star7: 18,
    star8: 19,
    star10: 20,
    star12: 21,
    star16: 22,
    star24: 23,
    star32: 24,
    roundRect: 25,
    round1Rect: 26,
    round2SameRect: 27,
    round2DiagRect: 28,
    snipRoundRect: 29,
    snip1Rect: 30,
    snip2SameRect: 31,
    snip2DiagRect: 32,
    plaque: 33,
    ellipse: 34,
    teardrop: 35,
    homePlate: 36,
    chevron: 37,
    pieWedge: 38,
    pie: 39,
    blockArc: 40,
    donut: 41,
    noSmoking: 42,
    rightArrow: 43,
    leftArrow: 44,
    upArrow: 45,
    downArrow: 46,
    stripedRightArrow: 47,
    notchedRightArrow: 48,
    bentUpArrow: 49,
    leftRightArrow: 50,
    upDownArrow: 51,
    leftUpArrow: 52,
    leftRightUpArrow: 53,
    quadArrow: 54,
    leftArrowCallout: 55,
    rightArrowCallout: 56,
    upArrowCallout: 57,
    downArrowCallout: 58,
    leftRightArrowCallout: 59,
    upDownArrowCallout: 60,
    quadArrowCallout: 61,
    bentArrow: 62,
    uturnArrow: 63,
    circularArrow: 64,
    leftCircularArrow: 65,
    leftRightCircularArrow: 66,
    curvedRightArrow: 67,
    curvedLeftArrow: 68,
    curvedUpArrow: 69,
    curvedDownArrow: 70,
    swooshArrow: 71,
    cube: 72,
    can: 73,
    lightningBolt: 74,
    heart: 75,
    sun: 76,
    moon: 77,
    smileyFace: 78,
    irregularSeal1: 79,
    irregularSeal2: 80,
    foldedCorner: 81,
    bevel: 82,
    frame: 83,
    halfFrame: 84,
    corner: 85,
    diagStripe: 86,
    chord: 87,
    arc: 88,
    leftBracket: 89,
    rightBracket: 90,
    leftBrace: 91,
    rightBrace: 92,
    bracketPair: 93,
    bracePair: 94,
    straightConnector1: 95,
    bentConnector2: 96,
    bentConnector3: 97,
    bentConnector4: 98,
    bentConnector5: 99,
    curvedConnector2: 100,
    curvedConnector3: 101,
    curvedConnector4: 102,
    curvedConnector5: 103,
    callout1: 104,
    callout2: 105,
    callout3: 106,
    accentCallout1: 107,
    accentCallout2: 108,
    accentCallout3: 109,
    borderCallout1: 110,
    borderCallout2: 111,
    borderCallout3: 112,
    accentBorderCallout1: 113,
    accentBorderCallout2: 114,
    accentBorderCallout3: 115,
    wedgeRectCallout: 116,
    wedgeRoundRectCallout: 117,
    wedgeEllipseCallout: 118,
    cloudCallout: 119,
    cloud: 120,
    ribbon: 121,
    ribbon2: 122,
    ellipseRibbon: 123,
    ellipseRibbon2: 124,
    leftRightRibbon: 125,
    verticalScroll: 126,
    horizontalScroll: 127,
    wave: 128,
    doubleWave: 129,
    plus: 130,
    flowChartProcess: 131,
    flowChartDecision: 132,
    flowChartInputOutput: 133,
    flowChartPredefinedProcess: 134,
    flowChartInternalStorage: 135,
    flowChartDocument: 136,
    flowChartMultidocument: 137,
    flowChartTerminator: 138,
    flowChartPreparation: 139,
    flowChartManualInput: 140,
    flowChartManualOperation: 141,
    flowChartConnector: 142,
    flowChartPunchedCard: 143,
    flowChartPunchedTape: 144,
    flowChartSummingJunction: 145,
    flowChartOr: 146,
    flowChartCollate: 147,
    flowChartSort: 148,
    flowChartExtract: 149,
    flowChartMerge: 150,
    flowChartOfflineStorage: 151,
    flowChartOnlineStorage: 152,
    flowChartMagneticTape: 153,
    flowChartMagneticDisk: 154,
    flowChartMagneticDrum: 155,
    flowChartDisplay: 156,
    flowChartDelay: 157,
    flowChartAlternateProcess: 158,
    flowChartOffpageConnector: 159,
    actionButtonBlank: 160,
    actionButtonHome: 161,
    actionButtonHelp: 162,
    actionButtonInformation: 163,
    actionButtonForwardNext: 164,
    actionButtonBackPrevious: 165,
    actionButtonEnd: 166,
    actionButtonBeginning: 167,
    actionButtonReturn: 168,
    actionButtonDocument: 169,
    actionButtonSound: 170,
    actionButtonMovie: 171,
    gear6: 172,
    gear9: 173,
    funnel: 174,
    mathPlus: 175,
    mathMinus: 176,
    mathMultiply: 177,
    mathDivide: 178,
    mathEqual: 179,
    mathNotEqual: 180,
    cornerTabs: 181,
    squareTabs: 182,
    plaqueTabs: 183,
    chartX: 184,
    chartStar: 185,
    chartPlus: 186,
};


export const toAutoMap = {
    4: 1,
    6: 2,
    7: 3,
    5: 4,
    25: 5,
    12: 6,
    2: 7,
    3: 8,
    34: 9,
    10: 10,
    130: 11,
    9: 12,
    73: 13,
    72: 14,
    82: 15,
    81: 16,
    78: 17,
    41: 18,
    42: 19,
    40: 20,
    75: 21,
    74: 22,
    76: 23,
    77: 24,
    88: 25,
    93: 26,
    94: 27,
    33: 28,
    89: 29,
    90: 30,
    91: 31,
    92: 32,
    43: 33,
    44: 34,
    45: 35,
    46: 36,
    50: 37,
    51: 38,
    54: 39,
    53: 40,
    62: 41,
    63: 42,
    52: 43,
    49: 44,
    67: 45,
    68: 46,
    69: 47,
    70: 48,
    47: 49,
    48: 50,
    36: 51,
    37: 52,
    56: 53,
    55: 54,
    57: 55,
    58: 56,
    59: 57,
    60: 58,
    61: 59,
    64: 60,
    131: 61,
    158: 62,
    132: 63,
    133: 64,
    134: 65,
    135: 66,
    136: 67,
    137: 68,
    138: 69,
    139: 70,
    140: 71,
    141: 72,
    142: 73,
    159: 74,
    143: 75,
    144: 76,
    145: 77,
    146: 78,
    147: 79,
    148: 80,
    149: 81,
    150: 82,
    152: 83,
    157: 84,
    153: 85,
    154: 86,
    155: 87,
    156: 88,
    79: 89,
    80: 90,
    15: 91,
    16: 92,
    19: 93,
    22: 94,
    23: 95,
    24: 96,
    122: 97,
    121: 98,
    124: 99,
    123: 100,
    126: 101,
    127: 102,
    128: 103,
    129: 104,
    116: 105,
    117: 106,
    118: 107,
    119: 108,
    110: 109,
    111: 111,
    112: 112,
    104: 113,
    107: 114,
    108: 115,
    109: 116,
    105: 119,
    106: 120,
    113: 122,
    114: 123,
    115: 124,
    160: 125,
    161: 126,
    162: 127,
    163: 128,
    165: 129,
    164: 130,
    167: 131,
    166: 132,
    168: 133,
    169: 134,
    170: 135,
    171: 136,
    151: 138,
    125: 139,
    86: 140,
    39: 141,
    8: 142,
    13: 143,
    11: 144,
    14: 145,
    17: 146,
    18: 147,
    20: 148,
    21: 149,
    26: 150,
    27: 151,
    28: 152,
    29: 153,
    30: 154,
    31: 155,
    32: 156,
    83: 157,
    84: 158,
    35: 159,
    87: 160,
    85: 161,
    175: 162,
    176: 163,
    177: 164,
    178: 165,
    179: 166,
    180: 167,
    181: 168,
    182: 169,
    183: 170,
    172: 171,
    173: 172,
    174: 173,
    38: 174,
    65: 175,
    66: 176,
    71: 177,
    120: 178,
    184: 179,
    185: 180,
    186: 181,
    1: 182,
};
export function ToAutoShapeType(type) {
    if (Object.prototype.hasOwnProperty.call(toAutoMap, type)) {
        return toAutoMap[type];
    }
    return 0;
}

export const toSTMap = {
    1: 4,
    2: 6,
    3: 7,
    4: 5,
    5: 25,
    6: 12,
    7: 2,
    8: 3,
    9: 34,
    10: 10,
    11: 130,
    12: 9,
    13: 73,
    14: 72,
    15: 82,
    16: 81,
    17: 78,
    18: 41,
    19: 42,
    20: 40,
    21: 75,
    22: 74,
    23: 76,
    24: 77,
    25: 88,
    26: 93,
    27: 94,
    28: 33,
    29: 89,
    30: 90,
    31: 91,
    32: 92,
    33: 43,
    34: 44,
    35: 45,
    36: 46,
    37: 50,
    38: 51,
    39: 54,
    40: 53,
    41: 62,
    42: 63,
    43: 52,
    44: 49,
    45: 67,
    46: 68,
    47: 69,
    48: 70,
    49: 47,
    50: 48,
    51: 36,
    52: 37,
    53: 56,
    54: 55,
    55: 57,
    56: 58,
    57: 59,
    58: 60,
    59: 61,
    60: 64,
    61: 131,
    62: 158,
    63: 132,
    64: 133,
    65: 134,
    66: 135,
    67: 136,
    68: 137,
    69: 138,
    70: 139,
    71: 140,
    72: 141,
    73: 142,
    74: 159,
    75: 143,
    76: 144,
    77: 145,
    78: 146,
    79: 147,
    80: 148,
    81: 149,
    82: 150,
    83: 152,
    84: 157,
    85: 153,
    86: 154,
    87: 155,
    88: 156,
    89: 79,
    90: 80,
    91: 15,
    92: 16,
    93: 19,
    94: 22,
    95: 23,
    96: 24,
    97: 122,
    98: 121,
    99: 124,
    100: 123,
    101: 126,
    102: 127,
    103: 128,
    104: 129,
    105: 116,
    106: 117,
    107: 118,
    108: 119,
    109: 110,
    110: 110,
    111: 111,
    112: 112,
    113: 104,
    114: 107,
    115: 108,
    116: 109,
    117: 104,
    118: 104,
    119: 105,
    120: 106,
    121: 110,
    122: 113,
    123: 114,
    124: 115,
    125: 160,
    126: 161,
    127: 162,
    128: 163,
    129: 165,
    130: 164,
    131: 167,
    132: 166,
    133: 168,
    134: 169,
    135: 170,
    136: 171,
    137: 117,
    138: 151,
    139: 125,
    140: 86,
    141: 39,
    142: 8,
    143: 13,
    144: 11,
    145: 14,
    146: 17,
    147: 18,
    148: 20,
    149: 21,
    150: 26,
    151: 27,
    152: 28,
    153: 29,
    154: 30,
    155: 31,
    156: 32,
    157: 83,
    158: 84,
    159: 35,
    160: 87,
    161: 85,
    162: 175,
    163: 176,
    164: 177,
    165: 178,
    166: 179,
    167: 180,
    168: 181,
    169: 182,
    170: 183,
    171: 172,
    172: 173,
    173: 174,
    174: 38,
    175: 65,
    176: 66,
    177: 71,
    178: 120,
    179: 184,
    180: 185,
    181: 186,
    182: 1,
};

export function toSTShapeType(type) {
    if (Object.hasOwnProperty.call(toSTMap, type)) {
        return toSTMap[type];
    }
    return 0;
}
